// @ts-nocheck
import { useState, useEffect, useCallback, useRef } from "react";
import { initializeApp } from "firebase/app";
import {
  getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged,
} from "firebase/auth";
import {
  getFirestore, doc, getDoc, setDoc, collection, getDocs, deleteDoc,
  query, where, updateDoc, deleteField, runTransaction, orderBy, limit, serverTimestamp,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyABHlCAsw4fC6Ri_cJ0iBICJqlNnNq1W1c",
  authDomain: "store-manager-f5a05.firebaseapp.com",
  projectId: "store-manager-f5a05",
  storageBucket: "store-manager-f5a05.firebasestorage.app",
  messagingSenderId: "880450137074",
  appId: "1:880450137074:web:682995e4ff6c3c79cd196b",
  measurementId: "G-0WJY2H7MG7",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// 아이폰 크롬·사파리가 이 앱을 외국어 페이지로 오인해 자동 번역하면서 한국어를 엉뚱한 한국어로 바꿔 놓던 문제
// (「매출」→「사용」, 「재고」→「존재」, 입력칸 안내문 줄바꿈 사라짐). 한국어 페이지이고 번역하지 말라고 못 박는다
if (typeof document !== "undefined") {
  const h = document.documentElement;
  h.setAttribute("lang", "ko");
  h.setAttribute("translate", "no");
  h.classList.add("notranslate");
  if (!document.querySelector('meta[name="google"]')) {
    const m = document.createElement("meta");
    m.setAttribute("name", "google"); m.setAttribute("content", "notranslate");
    document.head.appendChild(m);
  }
}

// ══ 장사도구 이용권 접근 제어 ══════════════════════════════════════
const ADMIN_EMAILS = ["sfmaster@naver.com"];
// 이용권 1개당 매장 수 · 프랜차이즈형(toolAccess.unlimitedStores)과 관리자는 제한 없음
const STORE_LIMIT = 10;
const PURCHASE_LINKS = {
  year: "https://danggum.net/shop_view/?idx=16",
};
const _todayStr = () => new Date().toISOString().slice(0, 10);
const _addDays = (base, days) => { const d = new Date(base); d.setDate(d.getDate() + days); return d.toISOString().slice(0, 10); };
const _daysBetween = (from, to) => Math.ceil((new Date(to).getTime() - new Date(from).getTime()) / 86400000);

async function checkToolAccess(email, uid) {
  if (!email) return { allowed: false, isAdmin: false };
  const lower = email.toLowerCase();
  if (ADMIN_EMAILS.includes(lower)) return { allowed: true, isAdmin: true };
  let base = { allowed: false, isAdmin: false };
  try {
    const snap = await getDoc(doc(db, "toolAccess", lower));
    if (snap.exists()) {
      const data = snap.data();
      if (data.banned === true) return { allowed: false, isAdmin: false, banned: true };
      const expires = data.expires;
      if (expires) {
        const daysLeft = _daysBetween(_todayStr(), expires);
        const unlimitedStores = data.unlimitedStores === true;
        base = daysLeft < 0
          ? { allowed: false, isAdmin: false, expires, daysLeft, unlimitedStores }
          : { allowed: true, isAdmin: false, expires, daysLeft, unlimitedStores };
      }
    }
  } catch {}
  if (base.allowed) return base;
  // 공유 매니저: 참여 중인 매장이 있으면 (본인 이용권 없이도) 입력용 접근 허용
  try {
    if (uid) {
      const g = await getDocs(query(collection(db, "grants"), where("managerUid", "==", uid)));
      if (!g.empty) return { allowed: true, isAdmin: false, viaShare: true };
    }
  } catch {}
  // 초대받은 계정: 수락 전에도 초대 카드를 보고 수락할 수 있어야 한다(수락하면 위 grants 로 통과)
  try {
    const inv = await getDoc(doc(db, "invites", lower));
    if (inv.exists() && Object.keys(inv.data().items || {}).length > 0) return { allowed: true, isAdmin: false, viaShare: true, viaInvite: true };
  } catch {}
  return base;
}

// 로그인 기록: 이용권 기록이 있는 회원만 · 가입일(구글 계정 생성일)과 최근 접속 시각
// 규칙에서 joinedAt·lastLogin 두 칸만, lastLogin은 서버 시각으로만 쓸 수 있게 막는다
const _localDate = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
async function recordLogin(u, access) {
  if (!u || !u.email || !access || access.isAdmin || access.banned || !access.expires) return;
  try {
    const created = u.metadata && u.metadata.creationTime ? new Date(u.metadata.creationTime) : null;
    const payload = { lastLogin: serverTimestamp() };
    if (created && !isNaN(created)) payload.joinedAt = _localDate(created);
    await updateDoc(doc(db, "toolAccess", u.email.toLowerCase()), payload);
  } catch { /* 규칙 미적용이면 조용히 넘어간다 */ }
}

async function redeemToolCode(email, inputCode) {
  // 보안: 코드 대조는 Firestore 규칙에서 수행. 클라이언트는 toolConfig를 읽지 않는다.
  const lower = email.toLowerCase();
  const code = (inputCode || "").trim();
  if (!code) return { ok: false, message: "코드를 입력해주세요" };
  const days = 365; // 1년권 단일 상품
  const today = _todayStr();
  let base = today;
  let hasSince = false;
  try {
    const cur = await getDoc(doc(db, "toolAccess", lower));
    if (cur.exists()) {
      hasSince = !!cur.data().since;
      if (cur.data().banned === true) return { ok: false, message: "이용이 제한된 계정입니다. 문의: danggum.net" };
      const curExp = cur.data().expires;
      if (curExp && curExp > today) base = curExp;
    }
  } catch { /* 신규 */ }
  const newExpires = _addDays(base, days);
  try {
    await setDoc(doc(db, "toolAccess", lower), { expires: newExpires, plan: String(days), code, updatedAt: new Date(), ...(hasSince ? {} : { since: today }) }, { merge: true });
  } catch {
    return { ok: false, message: "입장코드가 올바르지 않습니다. 회원 페이지의 코드를 확인해주세요" };
  }
  return { ok: true, message: "이용권이 등록됐습니다", expires: newExpires };
}

// ── 이용권 게이트 화면 ──
function ToolAccessGate({ user, access, onRedeemed, onClose }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [redeemedExpires, setRedeemedExpires] = useState(null);
  const expired = access && access.expires && (access.daysLeft ?? 0) < 0;
  const banned = access && access.banned === true;

  async function handleRedeem() {
    if (!user.email || busy) return;
    setBusy(true); setMsg(null);
    const r = await redeemToolCode(user.email, code);
    setBusy(false);
    if (r.ok) setRedeemedExpires(r.expires || "");
    else setMsg(r.message);
  }

  const inputStyle = { width:"100%", background:"#152536", border:"1px solid #2a3f55", borderRadius:8, padding:"11px 12px", color:"#e8eef4", fontSize:14, outline:"none", fontFamily:"'Noto Sans KR',sans-serif" };

  if (redeemedExpires !== null) {
    return (
      <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"100vh", padding:"32px 24px", background:"#0D1B2A", fontFamily:"'Noto Sans KR',sans-serif" }}>
        <div style={{ background:"#132234", borderRadius:20, padding:"44px 30px 32px", width:"100%", maxWidth:400, boxShadow:"0 8px 40px rgba(0,0,0,0.4)", textAlign:"center" }}>
          <div style={{ fontSize:20, fontWeight:900, color:"#e8eef4", marginBottom:10 }}>이용권이 등록됐습니다!</div>
          <div style={{ fontSize:13, color:"#8ba3b8", marginBottom:6 }}>{user.email}</div>
          <div style={{ display:"inline-block", background:"rgba(13,148,136,0.12)", border:"1px solid rgba(13,148,136,0.45)", borderRadius:10, padding:"10px 20px", margin:"10px 0 26px" }}>
            <span style={{ fontSize:12, color:"#8ba3b8" }}>이용 기간 </span>
            <span style={{ fontSize:15, fontWeight:700, color:"#2dd4bf" }}>{redeemedExpires}</span>
            <span style={{ fontSize:12, color:"#8ba3b8" }}> 까지</span>
          </div>
          <button onClick={onRedeemed} style={{ width:"100%", padding:14, borderRadius:10, border:"none", background:"#0d9488", color:"#fff", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"'Noto Sans KR',sans-serif" }}>시작하기 →</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"100vh", padding:"32px 24px", background:"#0D1B2A", fontFamily:"'Noto Sans KR',sans-serif" }}>
      <div style={{ background:"#132234", borderRadius:20, padding:"40px 30px 30px", width:"100%", maxWidth:400, boxShadow:"0 8px 40px rgba(0,0,0,0.4)" }}>
        <div style={{ textAlign:"center", marginBottom:26 }}>
          <div style={{ fontSize:20, fontWeight:900, color:"#e8eef4", marginBottom:8 }}>
            {banned ? "이용이 제한된 계정입니다" : expired ? "이용 기간이 종료됐습니다" : "이용권이 필요합니다"}
          </div>
          <div style={{ fontSize:13, color:"#8ba3b8", lineHeight:1.7 }}>
            {banned
              ? <>이 계정은 이용이 제한됐습니다.<br/>문의: danggum.net</>
              : expired
              ? <>이용권이 {access.expires}에 만료됐어요.<br/>연장하고 계속 이용하세요.</>
              : <>단꿈 장사도구는 이용권 회원 전용입니다.<br/>구매 후 회원 페이지의 입장코드를 입력하세요.</>}
          </div>
          <div style={{ fontSize:11, color:"#8ba3b8", marginTop:10, opacity:0.7 }}>로그인 계정: {user.email}</div>
        </div>
        <div style={{ marginBottom:22 }}>
          <a href={PURCHASE_LINKS.year} target="_blank" rel="noreferrer" style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:10, background:"rgba(13,148,136,0.12)", border:"1px solid rgba(13,148,136,0.5)", borderRadius:12, padding:"16px 8px", textDecoration:"none" }}>
            <span style={{ fontSize:14, fontWeight:700, color:"#2dd4bf" }}>이용권 구매</span>
            <span style={{ fontSize:13, color:"#2dd4bf" }}>1년 198,000원</span>
          </a>
        </div>
        <div style={{ fontSize:11, fontWeight:700, color:"#8ba3b8", letterSpacing:"0.05em", marginBottom:8 }}>이미 구매하셨나요? 입장코드 입력</div>
        <div style={{ display:"flex", gap:8, marginBottom:10 }}>
          <input style={{ ...inputStyle, flex:1, letterSpacing:"0.05em" }} placeholder="입장코드" value={code}
            onChange={e => setCode(e.target.value)} onKeyDown={e => e.key === "Enter" && handleRedeem()} />
          <button onClick={handleRedeem} disabled={busy}
            style={{ padding:"11px 18px", borderRadius:8, border:"none", background:"#0d9488", color:"#fff", fontSize:13, fontWeight:700, cursor:"pointer", opacity: busy ? 0.6 : 1, fontFamily:"'Noto Sans KR',sans-serif" }}>
            {busy ? "확인 중..." : "등록"}
          </button>
        </div>
        {msg && <div style={{ fontSize:12, color:"#f87171", marginBottom:6, lineHeight:1.5 }}><span style={{ display:"inline-flex", width:14, height:14, borderRadius:"50%", background:"currentColor", color:"#0D1B2A", fontSize:10, fontWeight:700, alignItems:"center", justifyContent:"center", marginRight:5, flexShrink:0 }}>!</span>{msg}</div>}
        <div style={{ fontSize:11, color:"#8ba3b8", lineHeight:1.7, marginTop:8 }}>
          입장코드는 구매 완료 후 <strong style={{ color:"#e8eef4" }}>회원 전용 페이지</strong>에서 확인할 수 있어요.
        </div>
        <div style={{ height:1, background:"#2a3f55", margin:"20px 0 14px" }} />
        {onClose && (
          <button onClick={onClose} style={{ width:"100%", padding:11, marginBottom:8, borderRadius:8, border:"1px solid #0d9488", background:"transparent", color:"#2dd4bf", fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"'Noto Sans KR', sans-serif" }}>
            공유받은 매장으로 돌아가기
          </button>
        )}
        <button onClick={() => signOut(auth)} style={{ width:"100%", padding:11, borderRadius:8, border:"1px solid #2a3f55", background:"transparent", color:"#8ba3b8", fontSize:12, cursor:"pointer", fontFamily:"'Noto Sans KR',sans-serif" }}>다른 계정으로 로그인</button>
      </div>
    </div>
  );
}

// ── 이용권 회원 관리 (관리자 전용) ──
// toolAccess/{이메일} 문서: { expires:"YYYY-MM-DD", plan:"365", banned:true|false, updatedAt }
// Firestore 규칙에서 관리자 이메일에 toolAccess 전체 읽기·쓰기가 열려 있어야 한다
function memberStatus(m, today) {
  if (m.banned === true) return "banned";
  if (!m.expires) return "none";
  return m.expires >= today ? "active" : "expired";
}
function AdminMembersScreen({ onBack }) {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(null);
  const [q, setQ] = useState("");
  const today = _todayStr();

  const load = useCallback(async () => {
    setLoading(true); setErr(null);
    try {
      const snap = await getDocs(collection(db, "toolAccess"));
      const list = [];
      snap.forEach((d) => list.push({ id: d.id, ...d.data() }));
      setMembers(list);
    } catch {
      setErr("회원 목록을 불러오지 못했습니다. Firestore 규칙에서 관리자 권한을 확인하세요.");
    }
    setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load]);

  async function extend(target, days) {
    const em = (target || "").trim().toLowerCase();
    if (!em || !em.includes("@")) { alert("이메일을 정확히 입력하세요"); return; }
    setBusy(em + days);
    try {
      const cur = members.find((m) => m.id === em);
      const base = cur && cur.expires && cur.expires > today ? cur.expires : today;
      const expires = _addDays(base, days);
      await setDoc(doc(db, "toolAccess", em), { expires, plan: String(days), updatedAt: new Date(), manual: true, ...(cur && cur.since ? {} : { since: today }) }, { merge: true });
      if (target === email) setEmail("");
      await load();
    } catch { alert("저장에 실패했습니다. 관리자 권한을 확인하세요."); }
    setBusy(null);
  }
  async function toggleBan(m) {
    const next = m.banned !== true;
    if (next && !window.confirm(`${m.id}\n차단하면 바로 이용할 수 없습니다. 차단할까요?`)) return;
    setBusy(m.id + "ban");
    try { await setDoc(doc(db, "toolAccess", m.id), { banned: next, updatedAt: new Date() }, { merge: true }); await load(); }
    catch { alert("변경에 실패했습니다."); }
    setBusy(null);
  }
  async function toggleFranchise(m) {
    const next = m.unlimitedStores !== true;
    if (!window.confirm(next
      ? `${m.id}\n프랜차이즈형으로 바꿀까요? 매장을 제한 없이 등록할 수 있습니다.`
      : `${m.id}\n일반형으로 되돌릴까요? 매장 ${STORE_LIMIT}곳을 넘으면 새 매장을 추가할 수 없습니다. (기존 매장은 그대로 남습니다)`)) return;
    setBusy(m.id + "fr");
    try { await setDoc(doc(db, "toolAccess", m.id), { unlimitedStores: next, updatedAt: new Date() }, { merge: true }); await load(); }
    catch { alert("변경에 실패했습니다."); }
    setBusy(null);
  }
  async function remove(m) {
    if (!window.confirm(`${m.id}\n이용권 기록을 삭제할까요? 되돌릴 수 없습니다.`)) return;
    setBusy(m.id + "del");
    try { await deleteDoc(doc(db, "toolAccess", m.id)); await load(); }
    catch { alert("삭제에 실패했습니다."); }
    setBusy(null);
  }

  const withStatus = members.map((m) => ({ ...m, st: memberStatus(m, today) }));
  const count = (st) => withStatus.filter((m) => m.st === st).length;
  const rank = { active: 0, expired: 1, none: 2, banned: 3 };
  const shown = withStatus
    .filter((m) => !q.trim() || m.id.includes(q.trim().toLowerCase()))
    .sort((a, b) => (rank[a.st] - rank[b.st]) || String(b.expires || "").localeCompare(String(a.expires || "")));

  const card = { background:"#132234", border:"1px solid #1e3448", borderRadius:12 };
  const smallBtn = { fontSize:12, fontWeight:700, padding:"6px 10px", borderRadius:7, border:"none", background:"#1e3448", color:"#e8eef4", cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" };
  const bigBtn = { fontSize:13, fontWeight:700, padding:"0 16px", minHeight:40, borderRadius:8, border:"none", background:"#0d9488", color:"#fff", cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" };
  const stLabel = { active:["이용중","#34d399"], expired:["만료","#94a3b8"], none:["기간 없음","#94a3b8"], banned:["차단","#f87171"] };

  return (
    <div style={{ minHeight:"100vh", background:"#0D1B2A", color:"#e8eef4", fontFamily:"'Noto Sans KR', sans-serif" }}>
      <div style={{ maxWidth:760, margin:"0 auto", padding:"28px 16px 80px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:22 }}>
          <button onClick={onBack} aria-label="뒤로" style={{ width:40, height:36, borderRadius:9, border:"none", background:"#1e3448", color:"#e8eef4", fontSize:18, cursor:"pointer" }}>←</button>
          <div>
            <div style={{ fontSize:19, fontWeight:800 }}>이용권 회원 관리</div>
            <div style={{ fontSize:12, color:"#8ba3b8", marginTop:2 }}>등록·연장·차단을 여기서 처리하세요</div>
          </div>
        </div>

        <div className="dg-g4" style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:10, marginBottom:14 }}>
          {[["전체", withStatus.length, "#e8eef4"], ["이용중", count("active"), "#34d399"], ["만료", count("expired") + count("none"), "#94a3b8"], ["차단", count("banned"), "#f87171"]].map(([l, n, c]) => (
            <div key={l} style={{ ...card, padding:"14px 10px", textAlign:"center" }}>
              <div style={{ fontSize:11, color:"#8ba3b8", fontWeight:600 }}>{l}</div>
              <div style={{ fontSize:22, fontWeight:800, color:c, marginTop:4 }}>{loading ? "–" : n}</div>
            </div>
          ))}
        </div>

        <div style={{ ...card, padding:"16px 18px", marginBottom:14 }}>
          <div style={{ fontSize:12, color:"#8ba3b8", fontWeight:600, marginBottom:8 }}>수동 등록 (이메일 입력 후 기간 선택)</div>
          <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
            <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="이메일" type="email" autoCapitalize="none"
              style={{ flex:"1 1 220px", minWidth:0, background:"#0f1f30", border:"1px solid #2a3f55", borderRadius:8, padding:"10px 12px", color:"#e8eef4", fontSize:14, outline:"none", fontFamily:"inherit" }} />
            <button disabled={!!busy} onClick={() => extend(email, 30)} style={bigBtn}>+30일</button>
            <button disabled={!!busy} onClick={() => extend(email, 365)} style={bigBtn}>+365일</button>
          </div>
          <div style={{ fontSize:11, color:"#64748b", marginTop:8 }}>이미 기간이 남아 있으면 남은 기간 뒤로 더해집니다</div>
        </div>

        {withStatus.length > 8 && (
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="이메일 검색"
            style={{ width:"100%", boxSizing:"border-box", background:"#132234", border:"1px solid #1e3448", borderRadius:10, padding:"10px 12px", color:"#e8eef4", fontSize:13, outline:"none", fontFamily:"inherit", marginBottom:10 }} />
        )}

        {err && <div style={{ ...card, padding:14, color:"#fca5a5", fontSize:13, marginBottom:10 }}>{err}</div>}
        {loading && <div style={{ color:"#8ba3b8", fontSize:13, padding:10 }}>불러오는 중...</div>}
        {!loading && !err && shown.length === 0 && <div style={{ color:"#8ba3b8", fontSize:13, padding:10 }}>회원이 없습니다</div>}

        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          {shown.map((m) => {
            const [label, color] = stLabel[m.st];
            return (
              <div key={m.id} style={{ ...card, padding:"13px 16px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap" }}>
                <div style={{ minWidth:0, flex:"1 1 220px" }}>
                  <div style={{ fontSize:14, fontWeight:700, overflowWrap:"anywhere" }}>{m.id}</div>
                  <div style={{ fontSize:12, marginTop:3, color:"#8ba3b8" }}>
                    <span style={{ color, fontWeight:700 }}>{label}</span>
                    <span style={{ marginLeft:6, fontSize:10, fontWeight:700, padding:"1px 6px", borderRadius:5, background: m.unlimitedStores ? "rgba(167,139,250,0.18)" : "#1e3448", color: m.unlimitedStores ? "#c4b5fd" : "#8ba3b8" }}>{m.unlimitedStores ? "프랜차이즈형 · 매장 무제한" : `일반형 · 매장 ${STORE_LIMIT}곳`}</span>
                    {m.expires && <span> · ~{m.expires}</span>}
                    {m.expires && (() => {
                      const left = _daysBetween(today, m.expires);
                      if (m.st === "banned") return null;
                      if (left < 0) return <span> · {Math.abs(left)}일 지남</span>;
                      const soon = left <= 30;
                      return <span style={{ color: soon ? "#fbbf24" : undefined, fontWeight: soon ? 700 : 400 }}> · {left === 0 ? "오늘 만료" : `${left}일 남음`}</span>;
                    })()}
                    {m.manual && <span> · 수동</span>}
                  </div>
                  <div style={{ fontSize:11, marginTop:3, color:"#64748b" }}>
                    {(() => {
                      // 등록일 기록이 없던 기존 회원: 1년권이면 만료일에서 1년을 빼 등록일로 본다
                      const est = !m.since && m.plan === "365" && m.expires ? _addDays(m.expires, -365) : null;
                      const parts = [];
                      if (m.joinedAt) parts.push(<span key="j">가입 {m.joinedAt}</span>);
                      if (m.since) parts.push(<span key="s">등록 {m.since}</span>);
                      else if (est) parts.push(<span key="e">등록 {est}</span>);
                      if (!parts.length) parts.push(<span key="n">가입일 모름</span>);
                      return parts.map((p, i) => <span key={i}>{i > 0 ? " · " : ""}{p}</span>);
                    })()}
                    <span> · </span>
                    {(() => {
                      const t = m.lastLogin && m.lastLogin.toDate ? m.lastLogin.toDate() : null;
                      if (!t) return <span>접속 기록 없음</span>;
                      const days = Math.floor((Date.now() - t.getTime()) / 86400000);
                      const when = days <= 0 ? `오늘 ${String(t.getHours()).padStart(2,"0")}:${String(t.getMinutes()).padStart(2,"0")}` : days === 1 ? "어제" : `${days}일 전`;
                      const idle = m.st === "active" && days >= 30;
                      return <span style={{ color: idle ? "#fbbf24" : undefined, fontWeight: idle ? 700 : 400 }}>최근 접속 {when}{idle ? " · 한 달 넘게 안 들어옴" : ""}</span>;
                    })()}
                  </div>
                </div>
                <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                  <button disabled={!!busy} onClick={() => extend(m.id, 30)} style={smallBtn}>+30일</button>
                  <button disabled={!!busy} onClick={() => extend(m.id, 365)} style={smallBtn}>+365일</button>
                  <button disabled={!!busy} onClick={() => toggleFranchise(m)} style={{ ...smallBtn, color: m.unlimitedStores ? "#8ba3b8" : "#c4b5fd" }}>{m.unlimitedStores ? "일반형으로" : "프랜차이즈형"}</button>
                  <button disabled={!!busy} onClick={() => toggleBan(m)} style={{ ...smallBtn, color: m.banned ? "#34d399" : "#f87171" }}>{m.banned ? "차단 해제" : "차단"}</button>
                  <button disabled={!!busy} onClick={() => remove(m)} style={smallBtn}>삭제</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}


const MONTHS = ["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"];
const TODAY = new Date();
// 이 달이 아직 진행 중인가(오늘이 속한 달) — 손익분석 탭이 순이익을 숨기는 조건과 매장 카드 기준 달 판정이 같이 쓴다
const monthKeyOf = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
const isOngoingMonthKey = (mk, now = new Date()) => mk === monthKeyOf(now);
// 매장 카드 기준 달 — 정산 완료된 가장 최근 달(매출이 있는 달)만 순이익·순이익률을 보인다. 진행 중인 달은 매출만.
// 달별 요약(store.summaries[mk])이 없던 예전 매장은 summary 한 건을 그 달 요약으로 본다.
const storeCardMonths = (store, now = new Date()) => {
  const sums = { ...((store && store.summaries) || {}) };
  const legacy = store && store.summary;
  if (legacy && legacy.mk && !sums[legacy.mk]) sums[legacy.mk] = legacy;
  const nowKey = monthKeyOf(now);
  const closedKey = Object.keys(sums)
    .filter((k) => k < nowKey && !isOngoingMonthKey(k, now) && (sums[k].totalRev || 0) > 0)
    .sort()
    .pop() || null;
  const cur = sums[nowKey];
  const ongoingRev = cur ? Math.round((cur.ongoingRev != null ? cur.ongoingRev : cur.totalRev) || 0) : 0;
  return { closedKey, closed: closedKey ? sums[closedKey] : null, ongoingKey: nowKey, ongoingRev, sums };
};
const fmtW = (n) => `${Math.round(n).toLocaleString("ko-KR")}원`;
const fmtMan = (n) => {
  const v = Math.round(Number(n) || 0);
  const abs = Math.abs(v);
  const sign = v < 0 ? "-" : "";
  if (abs >= 100000000) {
    const eok = Math.floor(abs / 100000000);
    const man = Math.round((abs % 100000000) / 10000);
    return man > 0 ? `${sign}${eok}억 ${man.toLocaleString("ko-KR")}만` : `${sign}${eok}억`;
  }
  if (abs >= 10000) return `${sign}${Math.round(abs / 10000).toLocaleString("ko-KR")}만`;
  return `${sign}${abs.toLocaleString("ko-KR")}원`;
};
const pct = (v, b) => (b > 0 ? ((v / b) * 100).toFixed(1) + "%" : "–");
const pctNum = (v, b) => (b > 0 ? (v / b) * 100 : 0);
const getDays = (y, m) => new Date(y, m + 1, 0).getDate();

// 사장님 인건비: 월별 저장. 그 달 값이 없으면 최근 12개월 내 마지막 입력값을 이어받는다.
// (한 번 넣으면 매달 다시 넣을 필요 없게 · 바꾸면 그 달부터 새 값)
function ownerWageAt(map, mk) {
  if (!map || !mk) return 0;
  if (map[mk] !== undefined && map[mk] !== null) return Math.max(0, Number(map[mk]) || 0);
  let [y, m] = mk.split("-").map(Number);
  for (let i = 0; i < 12; i++) {
    m -= 1; if (m < 1) { m = 12; y -= 1; }
    const k = `${y}-${String(m).padStart(2, "0")}`;
    if (map[k] !== undefined && map[k] !== null) return Math.max(0, Number(map[k]) || 0);
  }
  return Math.max(0, Number(map._legacy) || 0);   // 구버전 단일값 폴백
}
// 구버전 단일값(ownerWage)만 있는 문서도 같은 헬퍼로 읽는다
const ownerWageMapOf = (d) => d.monthlyOwnerWage || (d.ownerWage ? { _legacy: d.ownerWage } : null);

// 오프라인 감지 배너
function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  if (!offline) return null;
  return (
    <div style={{ margin:"0 0 16px", padding:"10px 16px", background:"rgba(248,113,113,0.1)", border:"1px solid rgba(248,113,113,0.3)", borderRadius:10, display:"flex", alignItems:"center", gap:8 }}>
      <p style={{ margin:0, fontSize:12, color:"#f87171", fontWeight:600 }}>오프라인 상태예요. 인터넷 연결을 확인해주세요. 데이터가 저장되지 않을 수 있어요.</p>
    </div>
  );
}

// 금액 입력 시 콤마 포맷 + 큰 금액 확인
function MoneyInput({ value, onChange, placeholder, style, onKeyDown, autoFocus }) {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);
  const formatHint = (v) => {
    if (!v || v < 10000) return null;
    if (v >= 100000000) return `${(v/100000000).toFixed(1)}억원`;
    if (v >= 10000000) return `${(v/10000000).toFixed(1)}천만원`;
    if (v >= 1000000) return `${(v/1000000).toFixed(0)}백만원`;
    if (v >= 10000) return `${(v/10000).toFixed(0)}만원`;
    return null;
  };
  const hint = focused ? formatHint(value) : null;
  return (
    <div style={{ position:"relative", width:"100%" }}>
      <input
        ref={inputRef}
        type={focused ? "number" : "text"}
        autoFocus={autoFocus}
        value={focused ? (value || "") : (value > 0 ? value.toLocaleString("ko-KR") : "")}
        placeholder={placeholder || "0"}
        onFocus={() => setFocused(true)}
        onChange={(e) => onChange(Math.max(0, Number(e.target.value) || 0))}
        onBlur={() => setFocused(false)}
        onKeyDown={onKeyDown}
        style={{...style, width:"100%"}}
      />
      {hint && (
        <span style={{ position:"absolute", right:0, top:-18, fontSize:10, color:"#6366f1", fontWeight:600, whiteSpace:"nowrap" }}>
          = {hint}
        </span>
      )}
    </div>
  );
}

// 증감 배지
function DiffBadge({ cur, prev, inverse }) {
  if (prev === undefined || prev === null) return null;
  const diff = cur - prev;
  if (diff === 0) return null;
  // inverse: 비용은 증가가 나쁨(빨강), 수익은 감소가 나쁨
  const isGood = inverse ? diff < 0 : diff > 0;
  return (
    <span style={{ fontSize: 10, color: isGood ? "#10b981" : "#ef4444", marginLeft: 6, whiteSpace: "nowrap" }}>
      {diff > 0 ? "▲" : "▼"}{Math.abs(diff).toLocaleString("ko-KR")}
    </span>
  );
}

// 순이익률 원형 게이지
function RateRing({ rate, hasData }) {
  const R = 21, CIRC = 2 * Math.PI * R;
  if (!hasData) {
    return (
      <svg width="52" height="52" viewBox="0 0 52 52" style={{ flexShrink:0 }}>
        <circle cx="26" cy="26" r={R} fill="none" stroke="#1e3448" strokeWidth="4" />
        <text x="26" y="30" textAnchor="middle" fontSize="11" fill="#64748b" fontFamily="inherit">-</text>
      </svg>
    );
  }
  const clamped = Math.max(-30, Math.min(30, rate));
  const filled = Math.min(1, Math.abs(clamped) / 30);
  const color = rate >= 10 ? "#34d399" : rate >= 0 ? "#fbbf24" : "#f87171";
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" style={{ flexShrink:0 }}>
      <circle cx="26" cy="26" r={R} fill="none" stroke="#1e3448" strokeWidth="4" />
      <circle cx="26" cy="26" r={R} fill="none" stroke={color} strokeWidth="4" strokeLinecap="round"
        strokeDasharray={CIRC} strokeDashoffset={CIRC * (1 - filled)} transform="rotate(-90 26 26)" />
      <text x="26" y="24" textAnchor="middle" fontSize={Math.abs(rate) >= 100 ? 10 : 12} fontWeight="700" fill={color} fontFamily="inherit">{Math.abs(rate) >= 999 ? (rate > 0 ? "+999" : "-999") : `${rate >= 0 ? "" : "-"}${Math.abs(rate).toFixed(Math.abs(rate) >= 100 ? 0 : 1)}`}</text>
      <text x="26" y="34" textAnchor="middle" fontSize="8" fill="#64748b" fontFamily="inherit">순익률</text>
    </svg>
  );
}

const splitName = (name) => {
  const nm = (name || "").trim();
  const iu = nm.indexOf("_");
  const isp = nm.indexOf(" ");
  let cut = -1;
  if (iu > 0 && isp > 0) cut = Math.min(iu, isp);
  else if (iu > 0) cut = iu;
  else if (isp > 0) cut = isp;
  return cut > 0
    ? { brand: nm.slice(0, cut), branch: nm.slice(cut + 1).trim() }
    : { brand: "", branch: nm || "매장" };
};
const brandOf = (name) => splitName(name).brand;
const branchOf = (name) => splitName(name).branch;
// 매장을 「브랜드_지점」의 브랜드로 묶는다 — 매장 선택 화면과 매장별 비교 보기가 같은 판정을 쓴다.
// 키는 브랜드(형식이 아니면 이름 그대로) · 처음 나온 순서 · [{ brand, items }]
const groupStoresByBrand = (items, nameOf) => {
  const out = [];
  const byKey = new Map();
  items.forEach((it) => {
    const sp = splitName(nameOf(it));
    const key = sp.brand || sp.branch;
    let g = byKey.get(key);
    if (!g) { g = { brand: key, items: [] }; byKey.set(key, g); out.push(g); }
    g.items.push(it);
  });
  return out;
};

const STORE_COLORS = [
  { id: "teal", hex: "#0d9488" },{ id: "indigo", hex: "#6366f1" },{ id: "rose", hex: "#f43f5e" },
  { id: "amber", hex: "#f59e0b" },{ id: "green", hex: "#22c55e" },{ id: "blue", hex: "#3b82f6" },
  { id: "purple", hex: "#a855f7" },{ id: "orange", hex: "#f97316" },{ id: "pink", hex: "#ec4899" },
  { id: "slate", hex: "#64748b" },
];
// 플랫폼 색 — 브랜드는 알아보되 다크 배경에서 눈이 편한 톤으로 낮췄다
// 탭 목록과 공유 권한 기본값 — 매니저에게는 입력 탭만 연다. 손익·급여·비용은 사장님이 골라 열어준다
// 화면 하단에 표시된다. 기능이 바뀌면 번호를, 배포할 때마다 날짜를 올린다
// v2.0 BEP 변동비 · v2.1 월별 사장님급여·간이세액표 · v2.2 재고조사 탭
// v2.3 탭 단위 공유 권한 · 일일 매출보고 붙여넣기 · 홈 화면 설치
// v2.4 주휴시간 직접 입력 · 급여 계좌 · 월별 추이 재고 반영
// v2.5 근로계약서 작성·서명·이메일 교부
// v2.6 은행·계좌 분리와 복사 · 브랜드별 진단(메인 브랜드 포함·합계 검증) · 정산자료 바로가기
// v2.7 진행 중인 달: 일일 보고 배달 반영 · 마지막 보고일 기준 월말 예상 · 마감 전 손익 카드 숨김
// v2.7.1 추세 경고: 연속 개월 수를 실제로 세고, 출발 달까지 표시 (「N개월 연속」 = 숫자 N+1개)
// v2.7.2 브랜드별 비교 표: 「수수료」 열 이름을 「수수료+배달비」로 (배민배달 배달비가 들어 있음)
// v2.7.3 배민 브랜드별 진단: 배민클럽은 파트너부담만 넣도록 칸 이름·안내 변경 (배민지원분 제외)
// v2.7.4 브랜드별 진단 할인에 부가세 10%를 얹지 않음 · 즉시할인·한그릇도 파트너부담 기준
// v2.7.5 지표 카드: 영업이익률 → 배달비용률 (배달 매출 대비 · 기준선 없이 값과 전월 변화만)
// v2.7.6 인건비 직원 표: 모바일에서 카드형으로 (사업주부담 세로 쪼개짐 해결)
// v2.7.7 초대받은 계정은 이용권 없이 초대 수락 · 공유 매장만 사용(새 매장은 이용권 안내) · 매장 선택 화면 브랜드 묶음(「브랜드 N개점」)
// v2.7.8 매장 카드: 정산 완료된 가장 최근 달의 매출·순이익·순이익률 · 진행 중인 달은 「N월 진행 중 · 매출」 한 줄만
// v2.7.9 매장 선택 헤더도 정산 완료 달 기준 · 매장별 비교 보기를 손익분석 탭과 같은 계산(재고조사 반영)으로
// v2.8.0 저장 충돌 P0: 열기만으로 저장 안 함 · 로드 실패 시 저장 차단 · 바뀐 필드만 저장(공유는 허용 탭 필드만) · 연속 실패 시 입력 잠금 · 「내 입력 유지」
// v2.8.1 저장 직전 버전 자동 보관(data/main/history · 최근 10개) · 재고·매출 탭 「되돌리기」 · 공유 계정 「내 탭 내보내기」(CSV)
// v2.8.2 이용권 회원 관리 화면 (관리자 전용): 수동 등록 +30일·+365일 · 연장 · 차단 · 삭제
// v2.8.3 회원 관리: 가입일 · 이용권 첫 등록일 · 최근 접속 (30일 넘게 미접속 이용중 회원 노란색) · 이용권 가격 표시 198,000원
// v2.8.4 회원 관리: 「365일권」 대신 남은 기간 (30일 이하 노란색 · 만료는 「N일 지남」) · 등록일 기록 없는 1년권 회원은 만료일 − 1년으로 추정
// v2.8.5 매장 수 제한: 일반형 10곳 · 프랜차이즈형(회원 관리에서 전환) 무제한 · 매장 추가 버튼에 N/10 표시
// v2.8.6 홈 화면 설치 안내: 카톡 등 앱 안 브라우저(크롬·사파리로 열기·주소 복사) · 아이폰 크롬 · 안드로이드 메뉴 안내 · 「나중에」는 7일만
// v2.8.7 일일 보고: 「1.088.800」처럼 점으로 끊은 금액을 0으로 읽던 문제 · 날짜 앞 매장 이름 줄을 「못 읽음」으로 띄우지 않음
// v2.8.8 아이폰 브라우저 자동 번역 차단 (lang=ko · translate=no) — 메뉴·안내문이 엉뚱한 말로 바뀌던 문제
const APP_VERSION = "v2.8.8";
const APP_BUILD = "2026.10.11";
const ALL_TABS = ["매출","배달","인건비","재고","비용","손익분석"];
const SHARE_DEFAULT_TABS = ["매출","배달","재고"];
const normTabs = (arr) => Array.isArray(arr) && arr.length ? ALL_TABS.filter((t) => arr.includes(t)) : SHARE_DEFAULT_TABS;

// 매장 데이터 문서(data/main)의 최상위 필드 ↔ 그 필드를 고치는 탭. 공유 세션은 열린 탭의 필드만 저장한다
// (firestore.rules 의 탭 ↔ 필드 대응도 이 표와 같게 유지)
// 매출: 일일 보고 붙여넣기가 「현장 현금지출」 판관비(sga · monthlySgaAmounts)를 함께 채운다
// 인건비: employees 는 monthlyEmployees 이전의 옛 필드 — monthlyEmployees 를 저장할 때 지운다
const TAB_FIELDS = {
  매출: ["salesData", "dailyReports", "sga", "monthlySgaAmounts"],
  배달: ["deliveryData", "platforms"],
  인건비: ["monthlyEmployees", "monthlyOwnerWage", "payDay", "bizInfo", "employees"],
  재고: ["inventoryItems", "monthlyInventory"],
  비용: ["sga", "monthlySgaAmounts", "other", "monthlyOtherAmounts", "monthlyCogs", "vendors", "dailyExpense"],
  손익분석: ["monthlyGoal"],
};
const STORE_FIELDS = ["sga", "monthlySgaAmounts", "other", "monthlyOtherAmounts", "monthlyCogs", "salesData", "deliveryData", "platforms", "monthlyGoal", "monthlyEmployees", "monthlyOwnerWage", "vendors", "dailyExpense", "payDay", "inventoryItems", "monthlyInventory", "dailyReports", "bizInfo"];
// 판관비 거래처 이관(migrateSgaVendors)은 네 필드를 함께 바꾼다 — 일부만 저장하면 다음 로드에서 금액이 두 번 옮겨진다
const SGA_VENDOR_GROUP = ["vendors", "dailyExpense", "sga", "monthlySgaAmounts"];
const fieldsForTabs = (tabs) => new Set(tabs.flatMap((t) => TAB_FIELDS[t] || []));
const sameVal = (a, b) => a === b || JSON.stringify(a) === JSON.stringify(b);
// 세션(페이지 로드)마다 새로 — 같은 계정 다른 기기·탭의 저장을 구분한다
const CLIENT_ID = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
const SAVE_FAIL_LIMIT = 3;   // 연속 실패가 이 횟수를 넘으면 입력을 잠근다
// 탭이 「자기 것」으로 가진 필드 — 내 탭 내보내기 · 되돌리기 범위.
// TAB_FIELDS(저장 허용)와 달리 매출에 sga·monthlySgaAmounts 를 넣지 않는다(비용 탭 판관비 전체가 딸려 나가거나 되돌려지지 않게)
const TAB_OWN_FIELDS = {
  매출: ["salesData", "dailyReports"],
  배달: ["deliveryData", "platforms"],
  인건비: ["monthlyEmployees", "monthlyOwnerWage", "payDay", "bizInfo"],
  재고: ["inventoryItems", "monthlyInventory"],
  비용: ["sga", "monthlySgaAmounts", "other", "monthlyOtherAmounts", "monthlyCogs", "vendors", "dailyExpense"],
  손익분석: ["monthlyGoal"],
};
// 저장 직전 버전 보관(data/main/history/{savedAt})
const HISTORY_KEEP = 10;                  // 최근 N개만 남긴다(초과분은 소유자 저장 때 삭제)
const HISTORY_MIN_GAP = 10 * 60 * 1000;   // 같은 세션이 10분 안에 이어서 저장하면 보관하지 않는다(연속 입력에 10개가 금방 밀려나지 않게)

const DEFAULT_PLATFORMS = [
  { id: "baemin", name: "배민", fixed: true, color: "#37a89c" },
  { id: "coupang", name: "쿠팡이츠", fixed: true, color: "#d97a45" },
];
// id를 아는 플랫폼은 브랜드 계열 색을 고정한다
const PLATFORM_BRAND = {
  baemin: "#37a89c",    // 민트
  coupang: "#d97a45",   // 오렌지
  yogiyo: "#cf5b66",    // 레드
  ddangyo: "#c56a92",   // 핑크
};
// 예전에 쓰던 쨍한 색 → 차분한 톤 (한 번 보정되면 그대로 유지된다)
const PLATFORM_TONE = {
  "#00c2a8": "#37a89c", "#ff6000": "#d97a45",
  "#e74c3c": "#cf6a62", "#e67e22": "#cc8a4e", "#f1c40f": "#c9b055",
  "#2ecc71": "#5fb87f", "#1abc9c": "#45b09b", "#3498db": "#5f96c4",
  "#9b59b6": "#9a72b3", "#e91e63": "#cb5f80", "#00bcd4": "#3fa8b8",
  "#8bc34a": "#93b56f", "#ff5722": "#d17a5e", "#607d8b": "#75868f",
  "#fa0050": "#cf5b66", "#ff1e50": "#cf5b66",
};
// 이름으로 브랜드를 알아채 색을 맞춘다 (요기요·땡겨요는 직접 추가하는 경우가 많다)
const NAME_BRAND = [
  [/요기요/, "#cf5b66"], [/땡겨/, "#c56a92"], [/배달특급/, "#5f96c4"],
  [/먹깨비/, "#cc8a4e"], [/위메프|위메프오/, "#9a72b3"], [/배민|배달의민족/, "#37a89c"], [/쿠팡/, "#d97a45"],
];
function platformColorOf(p) {
  if (PLATFORM_BRAND[p.id]) return PLATFORM_BRAND[p.id];
  const hit = NAME_BRAND.find(([re]) => re.test((p.name || "").replace(/\s/g, "")));
  if (hit) return hit[1];
  const cur = (p.color || "").toLowerCase();
  return PLATFORM_TONE[cur] || p.color || "#75868f";
}
const C = {
  store: "#0d9488", delivery: "#818cf8", other: "#fbbf24", profit: "#34d399",
  loss: "#f87171", labor: "#a78bfa",
  bg: "#0D1B2A", bgSub: "#112236", bgCard: "#1a2e42",
  border: "#1e3448", borderLight: "#243d54",
  text: "#f1f5f9", textSub: "#94a3b8", textHint: "#64748b",
};
// 음식점에서 실제로 나가는 순서대로 배치한다 (금액 큰 것 · 매달 나가는 것 우선)
// id는 기존 저장 데이터와 맞물리므로 절대 재사용하지 않는다. 신규 항목은 16번부터.
const DEFAULT_SGA = [
  // ① 매달 반드시 · 금액 큼
  { id: 1, name: "인건비", amount: 0 },
  { id: 3, name: "임차료", amount: 0 },
  { id: 6, name: "전기요금", amount: 0 },
  { id: 7, name: "가스요금", amount: 0 },
  { id: 5, name: "수도요금", amount: 0 },
  { id: 4, name: "건물관리비", amount: 0 },
  // ② 매출에 비례해 붙는 비용
  { id: 16, name: "카드수수료", amount: 0 },
  { id: 17, name: "로열티·가맹수수료", amount: 0 },
  { id: 14, name: "광고선전비", amount: 0 },
  // ③ 매달 고정으로 빠지는 소액
  { id: 12, name: "포스·테이블오더", amount: 0 },
  { id: 8, name: "통신비", amount: 0 },
  { id: 10, name: "렌탈료 (정수기·기기)", amount: 0 },
  { id: 18, name: "방역·위생", amount: 0 },
  { id: 9, name: "소모품비", amount: 0 },
  { id: 19, name: "세무기장료", amount: 0 },
  // ④ 가끔 발생
  { id: 2, name: "복리후생비", amount: 0 },
  { id: 11, name: "보험료", amount: 0 },
  { id: 20, name: "수선비", amount: 0 },
  { id: 13, name: "지급수수료", amount: 0 },
  { id: 15, name: "감가상각비", amount: 0 },
];
const EXPENSE_KINDS = [
  { id: "food", name: "식자재", color: "#2dd4bf" },
  { id: "drink", name: "주류·음료", color: "#a78bfa" },
  { id: "sga", name: "판관비", color: "#818cf8" },
];
// 거래처는 ② 매출원가(식자재·주류음료) 전용이다.
// 판관비성 지출은 ③ 판관비의 항목으로 관리한다 (전월 비교·부가세 대상 체크가 되므로)
const DEFAULT_VENDORS = [
  { id: "v_food", name: "식자재", kind: "food" },
  { id: "v_drink", name: "음료", kind: "drink" },
  { id: "v_liquor", name: "주류", kind: "drink" },
];


// ══ 재고조사 ══════════════════════════════════════════════════════
// 품목 마스터: { id, name, cat: food|drink|supply, unit, price(단위당 원, 선택), order }
// 월별 실사:   monthlyInventory[mk] = { qty:{itemId:수량}, amt:{itemId:직접금액}, skipped, countedAt }
// 식자재+음료 재고 합계 → 그 달 기말재고(monthlyCogs[mk].end)로 자동 기록 · 포장·소모품은 별도 표시
const INV_CATS = [
  { id: "food",   name: "식자재",     color: "#2dd4bf" },
  { id: "drink",  name: "음료·주류",  color: "#a78bfa" },
  { id: "supply", name: "포장·소모품", color: "#fbbf24" },
];
const INV_SUPPLY_RE = /용기|뚜껑|컵|홀더|비닐|유산지|포장|크린콜|봉투|랩$|호일|젓가락|수저|냅킨|빨대|장갑|행주|세제|키친타올|앞치마|위생|물티슈/;
const INV_DRINK_RE  = /콜라|사이다|탄산|우유|아이스티|말차|시럽|자몽|레몬|청포도|한라봉|열대과일|구아바|쿨다방|주스|맥주|소주|막걸리|음료|커피|원두|티백|에이드|생수|와인|하이볼/;
const invCatOf = (name) => INV_SUPPLY_RE.test(name) ? "supply" : INV_DRINK_RE.test(name) ? "drink" : "food";
const invNorm = (name) => (name || "").replace(/\s+/g, "").toLowerCase();

// "이름 수량 단위" 한 줄씩 파싱. 단위는 자유 텍스트, 없어도 된다. "삼겹살 5kg", "돈까스용기 1", "순대 29 팩" 모두 처리
function parseInventoryText(text) {
  const rows = [], bad = [];
  (text || "").split(/\r?\n/).forEach((raw) => {
    const line = raw.replace(/[·•-]\s*/, "").trim();
    if (!line) return;
    // 수량: 3 · 3.5 · 3,5 · 3½ · 3개반 · 2통 반 · 반박스(0.5) 모두 허용
    let m = line.match(/^(.+?)\s*[:：]?\s+(\d+(?:[.,]\d+)?)\s*(½)?\s*([^\d\s]*?)\s*(반)?$/);
    if (!m) {
      // 숫자 없이 "반"으로 시작하는 수량 — "김 반박스" → 0.5박스
      const h = line.match(/^(.+?)\s+반\s*([^\d\s]*)$/);
      if (h) m = [line, h[1], "0.5", null, h[2] || "", null];
    }
    if (!m) { bad.push(raw); return; }
    const name = m[1].trim();
    let qty = Number(m[2].replace(",", "."));
    const half = !!(m[3] || m[5]);
    if (half && Number.isInteger(qty)) qty += 0.5;    // "3개반" → 3.5
    const unit = (m[4] || "").trim();
    if (!name || !isFinite(qty)) { bad.push(raw); return; }
    rows.push({ name, qty, unit });
  });
  return { rows, bad };
}
// "이름 단가" 또는 "이름 단가원" 한 줄씩 — 단가 일괄 등록용
function parsePriceText(text) {
  const rows = [], bad = [];
  (text || "").split(/\r?\n/).forEach((raw) => {
    const line = raw.trim();
    if (!line) return;
    const m = line.match(/^(.+?)\s*[:：]?\s+([\d,]+)\s*원?$/);
    if (!m) { bad.push(raw); return; }
    rows.push({ name: m[1].trim(), price: Number(m[2].replace(/,/g, "")) || 0 });
  });
  return { rows, bad };
}
// 그 달의 기초·기말재고를 결정한다 (저장하지 않고 필요할 때 계산)
// 기말: 실사 있으면 식자재+음료 합계 · 실사 안 함이면 기초와 동일 · 실사 없으면 직접 입력값
// 기초: 저장된 값이 있으면 그 값, 없으면 전월 기말을 이어받는다
function resolveStock(monthlyCogs, monthlyInventory, items, mk, depth) {
  const d = depth || 0;
  const raw = (monthlyCogs && monthlyCogs[mk]) || {};
  const inv = monthlyInventory && monthlyInventory[mk];
  let begin;
  if (raw.begin !== undefined && raw.begin !== null) begin = raw.begin;
  else if (d < 12) {
    const [y, m] = mk.split("-").map(Number);
    const pk = m === 1 ? `${y - 1}-12` : `${y}-${String(m - 1).padStart(2, "0")}`;
    begin = resolveStock(monthlyCogs, monthlyInventory, items, pk, d + 1).end;
  } else begin = 0;
  let end, source;
  if (inv && inv.skipped) { end = begin; source = "skip"; }
  else if (inv) { end = Math.round(invSummary(items, inv).endStock); source = "inventory"; }
  else { end = raw.end || 0; source = null; }
  return { begin, end, source };
}
// 그 달의 단가: 월별 스냅샷(inv.price)이 있으면 그 값, 없으면 품목 마스터 단가
// 스냅샷 덕분에 단가를 바꿔도 지난달 재고 금액이 흔들리지 않고, 전월 대비 단가 변동을 볼 수 있다
function invPriceOf(item, inv) {
  const snap = inv && inv.price && inv.price[item.id];
  if (snap !== undefined && snap !== null) return Math.max(0, Number(snap) || 0);
  return Math.max(0, Number(item.price) || 0);
}
// 품목별 금액: 직접금액(amt) 우선 → 수량×단가 → 없으면 0
function invItemAmount(item, inv) {
  const q = Number((inv && inv.qty && inv.qty[item.id]) || 0);
  const direct = inv && inv.amt && inv.amt[item.id];
  if (direct !== undefined && direct !== null && direct !== "") return Math.max(0, Number(direct) || 0);
  const price = invPriceOf(item, inv);
  if (price > 0) return Math.round(q * price);
  return 0;
}
function invHasValue(item, inv) {
  const direct = inv && inv.amt && inv.amt[item.id];
  return (direct !== undefined && direct !== null && direct !== "") || invPriceOf(item, inv) > 0;
}
// 분류별 합계 + 커버율(금액이 잡히는 품목의 수량 비중)
function invSummary(items, inv) {
  const out = { food: 0, drink: 0, supply: 0, total: 0, priced: 0, unpriced: 0, countedItems: 0 };
  (items || []).forEach((it) => {
    const q = Number((inv && inv.qty && inv.qty[it.id]) || 0);
    if (q > 0) out.countedItems += 1;
    const a = invItemAmount(it, inv);
    out[it.cat || "food"] += a;
    out.total += a;
    if (q > 0) { if (invHasValue(it, inv)) out.priced += 1; else out.unpriced += 1; }
  });
  out.endStock = out.food + out.drink;   // 기말재고로 가는 값 (포장재 제외)
  out.coverage = out.countedItems > 0 ? out.priced / out.countedItems : 0;
  return out;
}

// ══ 일일 매출 보고 붙여넣기 ═══════════════════════════════════════
// 매니저 카톡 보고를 그대로 붙여넣으면 날짜별로 쪼개 읽는다. 누적 항목은 무시(앱이 더한다)
// dailyReports[mk][day] = { total, cash, card, gift, hall, tables, delivRev, delivCnt, plat:{baemin,coupang,yogiyo,ddangyo}, cashExp, cashMemo }
// 금액은 원 단위 정수다. 「1.088.800」처럼 점을 천 단위 구분으로 쓰는 보고도 있어서
// 첫 숫자 덩어리만 잡고 점·쉼표·공백을 모두 지운다 (예전: 점을 소수점으로 읽어 0이 됐다)
const DR_NUM = (v) => {
  const m = String(v || "").match(/-?\s*\d[\d.,\s]*/);
  if (!m) return 0;
  const n = Number(m[0].replace(/[.,\s]/g, ""));
  return isFinite(n) ? n : 0;
};
const DR_LABELS = [
  // [정규식, 필드] — 누적/단가/시제 줄은 아래에서 먼저 걸러낸다
  [/^일\s*매출/, "total"], [/^총\s*매출/, "total"],
  [/^현금\s*지출/, "cashExp"],            // 현금보다 먼저 검사해야 한다
  [/^현금$/, "cash"], [/^현금\s*매출/, "cash"],
  [/^카드/, "card"], [/^상품권/, "gift"],
  [/^매장\s*매출/, "hall"], [/^홀\s*매출/, "hall"],
  [/^테이블\s*수/, "tables"], [/^테이블수/, "tables"],
  [/^배달\s*매출/, "delivRev"], [/^배달\s*건수/, "delivCnt"],
  [/^배민/, "p_baemin"], [/^쿠팡/, "p_coupang"], [/^요기요/, "p_yogiyo"], [/^땡겨요|^땡겨/, "p_ddangyo"],
];
function parseDailyReports(text) {
  const reports = [], bad = [];
  const src = (text || "").replace(/\r/g, "");
  // "9월 13일" 같은 날짜 헤더로 블록을 나눈다
  const parts = src.split(/(?=(?:^|\n)\s*\d{1,2}\s*월\s*\d{1,2}\s*일)/);
  parts.forEach((chunk) => {
    const head = chunk.match(/(\d{1,2})\s*월\s*(\d{1,2})\s*일/);
    if (!head) {
      // 날짜 앞의 매장 이름 같은 머리말은 무시한다. 숫자 항목(「일매출: …」)이 있는데 날짜가 없을 때만 못 읽음으로 알린다
      const body = chunk.trim();
      if (body && /[:：]\s*[\d-]/.test(body)) bad.push(body.split("\n")[0].slice(0, 30));
      return;
    }
    const r = { month: Number(head[1]), day: Number(head[2]), total:0, cash:0, card:0, gift:0, hall:0, tables:0, delivRev:0, delivCnt:0, plat:{ baemin:0, coupang:0, yogiyo:0, ddangyo:0 }, cashExp:0, cashMemo:"" };
    let hit = 0;
    chunk.split("\n").forEach((line) => {
      const t = line.trim();
      if (!t || /^누적|단가|시제/.test(t)) return;
      const m = t.match(/^([^:：]+)[:：]\s*(.*)$/);
      if (!m) return;
      const label = m[1].trim(), val = m[2].trim();
      const f = DR_LABELS.find(([re]) => re.test(label));
      if (!f) return;
      const key = f[1];
      if (key === "cashExp") {
        r.cashExp = DR_NUM(val.split("(")[0]);
        const memo = val.match(/\(([^)]*)\)/); r.cashMemo = memo ? memo[1].trim() : "";
      } else if (key.startsWith("p_")) {
        r.plat[key.slice(2)] = DR_NUM(val);
      } else {
        r[key] = DR_NUM(val);
      }
      hit += 1;
    });
    if (hit === 0) { bad.push(`${r.month}월 ${r.day}일 (읽을 항목 없음)`); return; }
    if (!r.total) r.total = r.hall + r.delivRev;          // 일매출 줄이 없으면 홀+배달로
    if (!r.hall && r.total && !r.delivRev) r.hall = r.total;  // 홀만 있는 매장: 일매출 = 홀
    reports.push(r);
  });
  return { reports, bad };
}
const drSum = (days, key) => Object.values(days || {}).reduce((a, d) => a + (Number(d && d[key]) || 0), 0);
const drPlatSum = (days, pid) => Object.values(days || {}).reduce((a, d) => a + (Number(d && d.plat && d.plat[pid]) || 0), 0);

// ══ 근로계약서 ═════════════════════════════════════════════════
// 사업장 정보는 매장에 한 번, 근로조건은 매장 기본값을 두고 직원별로 다를 때만 덮어쓴다
const DEFAULT_BIZ = {
  bizNo: "", ceo: "", address: "", phone: "",
  // 근로조건 기본값 — 직원에게 값이 없으면 이걸 쓴다
  workPlace: "", jobDesc: "주방업무 및 매장업무 전반",
  // 음식점은 요일 고정이 드물다. 주 몇 일 근무 + 휴무 방식으로 적는다
  workType: "shift",              // shift(교대·輪番) | fixed(요일 고정)
  daysPerWeek: 5,                 // 주 근무일수
  workDays: "",                   // fixed일 때만 쓴다
  workTime: "09:00~18:00", restTime: "12:00~13:00",
  probation: 3,                   // 수습기간(개월) · 0이면 없음
  probationRate: 90,              // 수습기간 급여 비율 — 법이 허용하는 하한
  clauseDamage: true,             // 손해배상 조항 (관행상 넣는 조항)
  clauseResign: true,             // 사직서 1개월 전 조항
};
const WD_LIST = ["월","화","수","목","금","토","일"];
// 계좌는 은행명과 번호를 따로 둔다. 이체할 때 번호만 복사해 붙일 수 있어야 한다
// 예전 데이터는 "우리은행 209-07-024343" 한 칸에 들어 있어서 쪼개 읽는다
function bankOf(emp) {
  if (!emp) return { name: "", no: "" };
  if (emp.bankName !== undefined && emp.bankName !== null) return { name: emp.bankName || "", no: emp.bankAccount || "" };
  const raw = (emp.bankAccount || "").trim();
  if (!raw) return { name: "", no: "" };
  const m = raw.match(/^([^\d\s]+)\s*(.*)$/);   // 앞의 한글 덩어리를 은행명으로
  return m && m[2] ? { name: m[1].trim(), no: m[2].trim() } : { name: "", no: raw };
}
const bankText = (emp) => { const b = bankOf(emp); return b.name ? `${b.name} ${b.no}` : b.no; };
// 직원의 근로조건 — 없으면 매장 기본값
const contractOf = (emp, biz) => ({
  startDate: (emp && emp.cStart) || "",
  endDate: (emp && emp.cEnd) || "",
  workPlace: (emp && emp.cPlace) || (biz && biz.workPlace) || "",
  jobDesc: (emp && emp.cJob) || (biz && biz.jobDesc) || "",
  workType: (emp && emp.cType) || (biz && biz.workType) || "shift",
  daysPerWeek: (emp && emp.cDpw) || (biz && biz.daysPerWeek) || 5,
  workDays: (emp && emp.cDays) || (biz && biz.workDays) || "",
  workTime: (emp && emp.cTime) || (biz && biz.workTime) || "",
  restTime: (emp && emp.cRest) || (biz && biz.restTime) || "",
  // 수습은 직원마다 다르다. 직원 값이 있으면 그걸, 없으면 매장 기본값
  probation: (emp && emp.cProb !== undefined && emp.cProb !== null && emp.cProb !== "") ? Number(emp.cProb) : (biz ? Number(biz.probation) : 0),
  probationRate: 90,   // 수습 감액은 법정 하한 90%만 쓴다
});
// 근무일·휴일 문장 — 주 7일에서 근무일을 빼면 휴무일수가 나온다
// 그중 주휴일 1일은 유급, 나머지는 무급휴무다
function workDayText(c) {
  const days = c.workType === "fixed"
    ? (c.workDays || "").split(",").map((x) => x.trim()).filter(Boolean).length
    : Number(c.daysPerWeek) || 0;
  const off = Math.max(0, 7 - days);
  const offTxt = off <= 0 ? "" : off === 1 ? "주휴일 1일 (유급)" : `휴무 ${off}일 (주휴일 1일 유급 · 무급휴무 ${off - 1}일)`;
  const base = c.workType === "fixed"
    ? `매주 ${c.workDays} 근무`
    : `주 ${days}일 근무 (근무표에 따름)`;
  return offTxt ? `${base} · ${offTxt}` : base;
}

const DEFAULT_OTHER = [{ id: 1, name: "이자비용", amount: 0 },{ id: 2, name: "세금", amount: 0 }];

// ── 거래처 판관비 → 판관비 항목으로 통합 ──
// 예전 버전은 마케팅비·소모품·현금지출을 "거래처"로 두었다. 이제 판관비는 전부 항목이다.
// sga 거래처마다 같은 이름의 항목을 만들고(없으면), 월별 금액을 monthlySgaAmounts로 옮긴 뒤 거래처를 지운다.
const CASH_SGA_ID = 21;   // "현장 현금지출" 항목 고정 id (일일 보고 현금지출이 여기로 들어간다)
function migrateSgaVendors(vendors, dailyExpense, sga, monthlySgaAmounts) {
  const vs = Array.isArray(vendors) ? vendors : [];
  const sgaVendors = vs.filter((v) => v.kind === "sga");
  if (sgaVendors.length === 0) return null;
  let items = [...(sga || [])];
  const msa = JSON.parse(JSON.stringify(monthlySgaAmounts || {}));
  const dex = JSON.parse(JSON.stringify(dailyExpense || {}));
  const keyOf = (n) => (n || "").replace(/\s/g, "").replace(/비$/, "");   // "소모품" = "소모품비"
  const byName = new Map(items.map((x) => [keyOf(x.name), x]));
  sgaVendors.forEach((v) => {
    const nm = (v.name || "").trim();
    let item = byName.get(keyOf(nm));
    if (!item) {
      const id = v.id === "v_cash" || /현금\s*지출/.test(nm) ? CASH_SGA_ID : Date.now() + Math.floor(Math.random() * 1000);
      item = { id: items.some((x) => x.id === id) ? Date.now() + Math.floor(Math.random() * 1000) : id, name: nm || "기타 판관비", amount: 0 };
      items.push(item); byName.set(keyOf(nm), item);
    }
    // 모든 달의 거래처 금액을 항목 금액으로 합산 이동
    Object.keys(dex).forEach((k) => {
      const days = dex[k] || {};
      let sum = 0;
      Object.keys(days).forEach((d) => { const amt = Number((days[d] || {})[v.id]) || 0; sum += amt; if (days[d]) delete days[d][v.id]; });
      if (sum > 0) { msa[k] = msa[k] || {}; msa[k][item.id] = (Number(msa[k][item.id]) || 0) + sum; }
    });
  });
  return { vendors: vs.filter((v) => v.kind !== "sga"), dailyExpense: dex, sga: items, monthlySgaAmounts: msa };
}

// ── 판관비 항목 마이그레이션 ──
// 금액은 monthlySgaAmounts[월][id]에 따로 저장되므로 여기서는 "정의 배열"만 손댄다.
// 원칙: ① id를 절대 바꾸지 않는다 ② 사장님이 고친 이름은 건드리지 않는다 ③ 삭제하지 않는다
function migrateSga(list) {
  if (!Array.isArray(list) || list.length === 0) return list;
  const byId = new Map(list.map((x) => [x.id, x]));
  const usedNames = new Set(list.map((x) => (x.name || "").trim()));

  // 기본 이름 그대로인 항목만 새 라벨로 갱신 (이름을 바꿔 쓰던 분은 그대로 유지)
  const out = list.map((x) =>
    x.id === 10 && (x.name || "").trim() === "정수기"
      ? { ...x, name: "렌탈료 (정수기·기기)" }
      : x
  );

  // 빠진 기본 항목 보강 — 같은 id나 같은 이름이 이미 있으면 추가하지 않는다
  DEFAULT_SGA.forEach((d) => {
    if (byId.has(d.id) || usedNames.has(d.name)) return;
    out.push({ ...d });
  });

  // 기본 항목은 정해진 순서로, 사장님이 직접 만든 항목은 뒤에 원래 순서대로
  const order = new Map(DEFAULT_SGA.map((d, i) => [d.id, i]));
  return out
    .map((x, i) => ({ x, i }))
    .sort((a, b) => {
      const oa = order.has(a.x.id) ? order.get(a.x.id) : 10000 + a.i;
      const ob = order.has(b.x.id) ? order.get(b.x.id) : 10000 + b.i;
      return oa - ob;
    })
    .map((o) => o.x);
}

// 주휴수당: 시급제 · 주15시간 이상 · holidayPay 켠 직원만
// 주소정근로 = 월 총근무 ÷ 4.345, 주휴 = (주소정÷40)×8×시급 (40시간 상한), 월 환산 ×4.345
const WEEKS_PER_MONTH = 4.345;

// 연도별 법정 최저시급 (입력 안내용 표시. 실제 계산은 입력한 시급 기준)
const MIN_WAGE = { 2025: 10030, 2026: 10320, 2027: 10700 };
const minWageOf = (y) => {
  const years = Object.keys(MIN_WAGE).map(Number).sort((a, b) => a - b);
  let v = MIN_WAGE[years[0]];
  years.forEach((yr) => { if (y >= yr) v = MIN_WAGE[yr]; });
  return v;
};
// 만근 기준 주휴시간 — 결근이 없을 때 그달에 붙는 주휴 시간. 입력칸의 기본값으로 쓴다
function suggestHolidayHours(emp) {
  if (!emp || emp.payType !== "hourly") return 0;
  const monthlyHours = Number(emp.totalHours) || 0;
  if (!monthlyHours) return 0;
  const weeklyHours = monthlyHours / WEEKS_PER_MONTH;
  if (weeklyHours < 15) return 0;                       // 주 15시간 미만은 대상 아님
  const capped = Math.min(weeklyHours, 40);
  return Math.round((capped / 40) * 8 * WEEKS_PER_MONTH * 10) / 10;   // 월 환산 주휴시간
}
// 주휴수당 = 주휴시간 × 시급. 시간은 사장님이 직접 넣는다
// 결근한 주는 주휴수당이 발생하지 않으므로 자동 계산에 맡기면 과다 계상된다
function calcHolidayPay(emp) {
  if (!emp || emp.payType !== "hourly" || !emp.holidayPay) return 0;
  const hourly = Number(emp.hourlyWage) || 0;
  if (!hourly) return 0;
  // holidayHours가 없으면(구버전 데이터) 만근 기준으로 계산해 기존 금액을 유지한다
  const hours = (emp.holidayHours === undefined || emp.holidayHours === null || emp.holidayHours === "")
    ? suggestHolidayHours(emp)
    : Math.max(0, Number(emp.holidayHours) || 0);
  return Math.round(hours * hourly);
}

// 인건비 공제 계산
function calcEmployerCost(emp) {
  const base = calcBase(emp);
  if (emp.deductionType === "insurance") return Math.round(base * 1.105);
  return base; // none, withholding: 사업주 부담 = 세전
}
function calcNetPay(emp) {
  // 명세서와 동일한 항목별 공제 합계 기준
  const base = calcBase(emp);
  return base - deductionRows(emp).reduce((a, r) => a + r.amount, 0);
}
function calcBase(emp) {
  const raw = emp.payType === "hourly"
    ? (emp.hourlyWage || 0) * (emp.totalHours || 0)
    : (emp.monthlySalary || 0);
  return raw + calcHolidayPay(emp);
}

const SIMPLE_TAX_ROWS = [
  [1060,1040,0,0,0],
  [1065,1110,0,0,0],
  [1070,1180,0,0,0],
  [1075,1250,0,0,0],
  [1080,1320,0,0,0],
  [1085,1390,0,0,0],
  [1090,1460,0,0,0],
  [1095,1530,0,0,0],
  [1100,1600,0,0,0],
  [1105,1670,0,0,0],
  [1110,1740,0,0,0],
  [1115,1810,0,0,0],
  [1120,1880,0,0,0],
  [1125,1950,0,0,0],
  [1130,2020,0,0,0],
  [1135,2090,0,0,0],
  [1140,2160,0,0,0],
  [1145,2230,0,0,0],
  [1150,2300,0,0,0],
  [1155,2370,0,0,0],
  [1160,2440,0,0,0],
  [1165,2500,0,0,0],
  [1170,2570,0,0,0],
  [1175,2640,0,0,0],
  [1180,2710,0,0,0],
  [1185,2780,0,0,0],
  [1190,2850,0,0,0],
  [1195,2920,0,0,0],
  [1200,2990,0,0,0],
  [1205,3060,0,0,0],
  [1210,3130,0,0,0],
  [1215,3200,0,0,0],
  [1220,3270,0,0,0],
  [1225,3340,0,0,0],
  [1230,3410,0,0,0],
  [1235,3480,0,0,0],
  [1240,3550,0,0,0],
  [1245,3620,0,0,0],
  [1250,3700,0,0,0],
  [1255,3810,0,0,0],
  [1260,3910,0,0,0],
  [1265,4010,0,0,0],
  [1270,4120,0,0,0],
  [1275,4220,0,0,0],
  [1280,4320,0,0,0],
  [1285,4430,0,0,0],
  [1290,4530,0,0,0],
  [1295,4630,0,0,0],
  [1300,4740,0,0,0],
  [1305,4840,0,0,0],
  [1310,4940,0,0,0],
  [1315,5050,0,0,0],
  [1320,5150,0,0,0],
  [1325,5250,0,0,0],
  [1330,5360,0,0,0],
  [1335,5460,0,0,0],
  [1340,5560,1060,0,0],
  [1345,5670,1170,0,0],
  [1350,5770,1270,0,0],
  [1355,5870,1370,0,0],
  [1360,5980,1480,0,0],
  [1365,6080,1580,0,0],
  [1370,6180,1680,0,0],
  [1375,6290,1790,0,0],
  [1380,6390,1890,0,0],
  [1385,6490,1990,0,0],
  [1390,6600,2100,0,0],
  [1395,6700,2200,0,0],
  [1400,6800,2300,0,0],
  [1405,6910,2410,0,0],
  [1410,7010,2510,0,0],
  [1415,7110,2610,0,0],
  [1420,7210,2710,0,0],
  [1425,7320,2820,0,0],
  [1430,7420,2920,0,0],
  [1435,7520,3020,0,0],
  [1440,7630,3130,0,0],
  [1445,7730,3230,0,0],
  [1450,7830,3330,0,0],
  [1455,7940,3440,0,0],
  [1460,8040,3540,0,0],
  [1465,8140,3640,0,0],
  [1470,8250,3750,0,0],
  [1475,8350,3850,0,0],
  [1480,8450,3950,0,0],
  [1485,8560,4060,0,0],
  [1490,8660,4160,0,0],
  [1495,8760,4260,0,0],
  [1500,8920,4420,0,0],
  [1510,9120,4620,0,0],
  [1520,9330,4830,0,0],
  [1530,9540,5040,0,0],
  [1540,9740,5240,0,0],
  [1550,9950,5450,0,0],
  [1560,10160,5660,0,0],
  [1570,10360,5860,0,0],
  [1580,10570,6070,0,0],
  [1590,10780,6280,0,0],
  [1600,10980,6480,0,0],
  [1610,11190,6690,0,0],
  [1620,11400,6900,0,0],
  [1630,11600,7100,0,0],
  [1640,11810,7310,0,0],
  [1650,12020,7520,0,0],
  [1660,12220,7720,0,0],
  [1670,12430,7930,0,0],
  [1680,12640,8140,0,0],
  [1690,12840,8340,0,0],
  [1700,13050,8550,0,0],
  [1710,13260,8760,0,0],
  [1720,13460,8960,1040,0],
  [1730,13670,9170,1240,0],
  [1740,13880,9380,1440,0],
  [1750,14080,9580,1640,0],
  [1760,14290,9790,1830,0],
  [1770,14500,10000,2030,0],
  [1780,14700,10200,2230,0],
  [1790,14910,10410,2430,0],
  [1800,15110,10610,2630,0],
  [1810,15320,10820,2830,0],
  [1820,15530,11030,3020,0],
  [1830,15730,11230,3220,0],
  [1840,15940,11440,3420,0],
  [1850,16150,11650,3620,0],
  [1860,16350,11850,3820,0],
  [1870,16560,12060,4020,0],
  [1880,16770,12270,4220,0],
  [1890,16970,12470,4410,1040],
  [1900,17180,12680,4610,1240],
  [1910,17390,12890,4810,1440],
  [1920,17590,13090,5010,1630],
  [1930,17800,13300,5210,1830],
  [1940,18010,13510,5410,2030],
  [1950,18210,13710,5600,2230],
  [1960,18420,13920,5800,2430],
  [1970,18630,14130,6000,2630],
  [1980,18880,14330,6200,2820],
  [1990,19200,14540,6400,3020],
  [2000,19520,14750,6600,3220],
  [2010,19850,14950,6800,3420],
  [2020,20170,15160,6990,3620],
  [2030,20490,15370,7190,3820],
  [2040,20810,15570,7390,4020],
  [2050,21130,15780,7590,4210],
  [2060,21450,15990,7790,4410],
  [2070,21770,16190,7990,4610],
  [2080,22090,16400,8180,4810],
  [2090,22420,16600,8380,5010],
  [2100,22740,16810,8580,5210],
  [2110,23060,17020,8780,5400],
  [2120,23380,17220,8980,5600],
  [2130,23700,17430,9180,5800],
  [2140,24020,17640,9380,6000],
  [2150,24340,17840,9570,6200],
  [2160,24660,18050,9770,6400],
  [2170,24990,18260,9970,6600],
  [2180,25310,18460,10170,6790],
  [2190,25630,18670,10370,6990],
  [2200,25950,18950,10570,7190],
  [2210,26270,19270,10760,7390],
  [2220,26590,19590,10960,7590],
  [2230,26910,19910,11160,7790],
  [2240,27240,20240,11360,7980],
  [2250,27560,20560,11560,8180],
  [2260,27880,20880,11760,8380],
  [2270,28200,21200,11960,8580],
  [2280,28520,21520,12150,8780],
  [2290,28840,21840,12350,8980],
  [2300,29160,22160,12550,9180],
  [2310,29480,22480,12750,9370],
  [2320,29810,22810,12950,9570],
  [2330,30130,23130,13150,9770],
  [2340,30450,23450,13340,9970],
  [2350,30770,23770,13540,10170],
  [2360,31090,24090,13740,10370],
  [2370,31410,24410,13940,10560],
  [2380,31730,24730,14140,10760],
  [2390,32050,25050,14340,10960],
  [2400,32380,25380,14530,11160],
  [2410,32700,25700,14730,11360],
  [2420,33020,26020,14930,11560],
  [2430,33340,26340,15130,11760],
  [2440,33660,26660,15330,11950],
  [2450,33980,26980,15530,12150],
  [2460,34300,27300,15730,12350],
  [2470,34630,27630,15920,12550],
  [2480,34950,27950,16120,12750],
  [2490,35270,28270,16320,12950],
  [2500,35600,28600,16530,13150],
  [2510,35940,28940,16740,13360],
  [2520,36280,29280,16950,13580],
  [2530,36630,29630,17160,13790],
  [2540,36970,29970,17370,14000],
  [2550,37310,30310,17590,14210],
  [2560,37650,30650,17800,14420],
  [2570,38000,31000,18010,14630],
  [2580,38340,31340,18220,14850],
  [2590,38830,31680,18430,15060],
  [2600,39690,32020,18650,15270],
  [2610,40540,32360,18920,15480],
  [2620,41400,32710,19250,15690],
  [2630,42260,33050,19580,15910],
  [2640,43110,33390,19910,16120],
  [2650,43970,33730,20240,16330],
  [2660,44820,34080,20570,16540],
  [2670,45680,34420,20900,16750],
  [2680,46540,34760,21230,16970],
  [2690,47390,35100,21560,17180],
  [2700,48250,35450,21890,17390],
  [2710,49100,35790,22220,17600],
  [2720,49960,36130,22550,17810],
  [2730,50810,36470,22880,18030],
  [2740,51670,36810,23210,18240],
  [2750,52530,37160,23540,18450],
  [2760,53380,37500,23870,18660],
  [2770,54240,37840,24200,18950],
  [2780,55090,38180,24520,19270],
  [2790,55950,38530,24850,19600],
  [2800,56800,39300,25180,19930],
  [2810,57660,40160,25510,20260],
  [2820,58520,41020,25840,20590],
  [2830,59370,41870,26170,20920],
  [2840,60230,42730,26500,21250],
  [2850,61080,43580,26830,21580],
  [2860,61940,44440,27160,21910],
  [2870,62790,45290,27490,22240],
  [2880,63650,46150,27820,22570],
  [2890,64510,47010,28150,22900],
  [2900,65360,47860,28480,23230],
  [2910,66220,48720,28810,23560],
  [2920,67070,49570,29140,23890],
  [2930,67930,50430,29470,24220],
  [2940,68780,51280,29800,24550],
  [2950,69640,52140,30130,24880],
  [2960,70500,53000,30460,25210],
  [2970,71350,53850,30790,25540],
  [2980,72210,54710,31120,25870],
  [2990,73060,55560,31450,26200],
  [3000,74350,56850,31940,26690],
  [3020,76060,58560,32600,27350],
  [3040,77770,60270,33260,28010],
  [3060,79480,61980,33920,28670],
  [3080,81190,63690,34580,29330],
  [3100,82900,65400,35240,29990],
  [3120,84620,67120,35900,30650],
  [3140,86330,68830,36560,31310],
  [3160,88040,70540,37220,31970],
  [3180,89750,72250,37880,32630],
  [3200,91460,73960,38540,33290],
  [3220,93170,75670,40120,33950],
  [3240,95430,77380,41770,34610],
  [3260,97880,79100,43420,35270],
  [3280,100320,80810,45070,35920],
  [3300,102770,82520,46720,36580],
  [3320,105210,84230,48370,37240],
  [3340,107660,85940,49940,37870],
  [3360,110100,87650,51510,38500],
  [3380,112550,89370,53070,39950],
  [3400,114990,91080,54640,41510],
  [3420,117440,92790,56200,43080],
  [3440,119880,94880,57770,44640],
  [3460,122330,97330,59330,46210],
  [3480,124770,99770,60900,47770],
  [3500,127220,102220,62460,49340],
  [3520,129660,104660,64030,50900],
  [3540,132110,107110,65590,52460],
  [3560,134550,109550,67150,54030],
  [3580,137000,112000,68720,55590],
  [3600,139440,114440,70280,57160],
  [3620,141890,116890,71850,58720],
  [3640,144330,119330,73410,60290],
  [3660,146780,121780,74980,61850],
  [3680,149220,124220,76540,63420],
  [3700,151670,126670,78110,64980],
  [3720,154110,129110,79670,66550],
  [3740,156560,131560,81230,68110],
  [3760,163920,136090,84260,71130],
  [3780,166590,138740,85970,72850],
  [3800,169260,141400,87680,74560],
  [3820,171930,144050,89390,76270],
  [3840,174600,146710,91100,77980],
  [3860,177270,149360,92820,79690],
  [3880,179940,152020,94920,81400],
  [3900,182610,154670,97370,83110],
  [3920,185280,157330,99810,84830],
  [3940,187950,159980,102260,86540],
  [3960,190620,162640,104700,88250],
  [3980,193290,165290,107150,89960],
  [4000,195960,167950,109590,91670],
  [4020,198630,170600,112040,93380],
  [4040,201300,173260,114480,95730],
  [4060,203970,175910,116930,98180],
  [4080,206640,178570,119370,100620],
  [4100,209310,181220,121820,103070],
  [4120,211980,183880,124260,105510],
  [4140,214650,186530,126710,107960],
  [4160,217320,189190,129150,110400],
  [4180,219990,191840,131600,112850],
  [4200,222660,194500,134040,115290],
  [4220,225330,197150,136490,117740],
  [4240,228000,199810,138930,120180],
  [4260,230670,202460,141380,122630],
  [4280,233340,205120,143820,125070],
  [4300,236010,207770,146270,127520],
  [4320,238680,210430,148710,129960],
  [4340,241350,213080,151160,132410],
  [4360,244020,215740,153600,134850],
  [4380,246690,218390,156050,137300],
  [4400,249360,221050,158490,139740],
  [4420,252030,223700,160940,142190],
  [4440,254700,226360,163380,144630],
  [4460,257370,229010,165830,147080],
  [4480,260040,231670,168270,149520],
  [4500,262840,234460,170850,152100],
  [4520,265650,237250,173430,154680],
  [4540,268450,240040,176010,157260],
  [4560,271260,242830,178590,159840],
  [4580,276560,248120,183670,164920],
  [4600,279370,250910,186250,167500],
  [4620,282170,253700,188830,170080],
  [4640,284980,256490,191410,172660],
  [4660,287780,259280,193990,175240],
  [4680,290590,262070,196570,177820],
  [4700,293390,264860,199150,180400],
  [4720,296200,267650,201730,182980],
  [4740,299000,270440,204310,185560],
  [4760,301810,273230,206890,188140],
  [4780,304610,276020,209470,190720],
  [4800,307420,278810,212050,193300],
  [4820,310220,281600,214630,195880],
  [4840,313030,284390,217210,198460],
  [4860,315830,287180,219790,201040],
  [4880,318640,289970,222370,203620],
  [4900,321440,292760,224950,206200],
  [4920,324250,295550,227530,208780],
  [4940,327050,298340,230110,211360],
  [4960,329860,301130,232690,213940],
  [4980,332660,303920,235270,216520],
  [5000,335470,306710,237850,219100],
  [5200,363520,334610,263650,244900],
  [5400,391570,362510,289450,270700],
  [5600,419620,390410,315250,296500],
  [5800,447670,418310,341050,322300],
  [5840,470380,441000,372100,353350],
  [6000,505900,466060,395720,376970],
  [6200,551260,503810,422120,403370],
  [6400,596620,548930,448520,429770],
  [6600,641980,594050,474920,456170],
  [6800,687340,639170,515110,485110],
  [7000,732700,684290,557350,527350],
  [7200,778060,729410,599590,569590],
  [7400,823420,774530,641830,611830],
  [7600,868780,819650,684070,654070],
  [7800,914140,864770,726310,696310],
  [8000,959500,909890,768550,738550],
  [8200,1004860,955010,810790,780790],
  [8400,1050780,1000680,853580,823580],
  [8600,1097580,1047240,897260,867260],
  [8800,1144380,1093800,940940,910940],
  [9000,1191180,1140360,984620,954620],
  [9200,1237980,1186920,1028300,998300],
  [9400,1306070,1233480,1071980,1041980],
  [9600,1374320,1299160,1115660,1085660],
  [9800,1442570,1367060,1159340,1129340],
  [9980,1503990,1428170,1198650,1168650]
];

// 근로소득 간이세액 (소득세법 시행령 별표2 · 2026.2.27 개정 · 2026.3.1 지급분부터)
// income: 월급여(비과세 제외) · deps: 공제대상가족 수(본인 포함, 1~11) · children: 8세이상 20세이하 자녀 수
// 106만~500만은 표 원본 그대로, 500만~1,000만은 20만 간격 앵커 보간, 1,000만 초과는 법정 산식
function simpleIncomeTax(income, deps = 1, children = 0) {
  const t = (Number(income) || 0) / 1000;               // 천원 단위
  if (t < 1060) return 0;
  const col = Math.min(4, Math.max(1, Number(deps) || 1));   // 5명 이상은 4명 열로 근사(약간 과대)
  let tax;
  if (t >= 10000) {
    const base10 = [1507400, 1431570, 1200840, 1170840][col - 1];
    const ex = (t - 10000) * 1000;
    if (ex === 0) tax = base10;                             // 정확히 1,000만원: 표의 "10,000천원" 행
    else if (t <= 14000) tax = base10 + ex * 0.98 * 0.35 + 25000;
    else if (t <= 28000) tax = base10 + 1397000 + (ex - 4000000) * 0.98 * 0.38;
    else if (t <= 30000) tax = base10 + 6610600 + (ex - 18000000) * 0.98 * 0.40;
    else if (t <= 45000) tax = base10 + 7394600 + (ex - 20000000) * 0.40;
    else if (t <= 87000) tax = base10 + 13394600 + (ex - 35000000) * 0.42;
    else tax = base10 + 31034600 + (ex - 77000000) * 0.45;
  } else {
    const R = SIMPLE_TAX_ROWS;
    let i = R.length - 1;
    while (i > 0 && R[i][0] > t) i--;
    const cur = R[i], nxt = R[i + 1];
    if (!nxt || cur[0] < 5000 || nxt[0] - cur[0] <= 20) {
      tax = cur[col];                                    // 표 원본 구간: 그대로
    } else {
      const f = (t - cur[0]) / (nxt[0] - cur[0]);        // 앵커 구간: 선형 보간
      tax = cur[col] + (nxt[col] - cur[col]) * f;
    }
  }
  const n = Math.max(0, Number(children) || 0);
  const childDed = n === 0 ? 0 : n === 1 ? 20830 : n === 2 ? 45830 : 45830 + (n - 2) * 33330;
  return Math.max(0, Math.round((tax - childDed) / 10) * 10);
}

// 소득세: 4대보험 직원은 간이세액표로 자동 계산. 직접 입력(incomeTaxManual)했으면 그 값을 쓴다
function incomeTaxOf(emp) {
  if (!emp || emp.deductionType !== "insurance") return 0;
  if (emp.incomeTaxManual) return Math.max(0, Number(emp.incomeTax) || 0);
  return simpleIncomeTax(calcBase(emp), emp.dependents || 1, emp.children || 0);
}
// 임금명세서용 공제 항목별 내역 (근로자 부담분)
const INS_RATE = { pension: 0.045, health: 0.03545, care: 0.1295, employ: 0.009 };
function deductionRows(emp) {
  const base = calcBase(emp);
  if (emp.deductionType === "withholding") {
    const income = Math.round(base * 0.03);
    const local = Math.round(base * 0.003);
    return [
      { name: "소득세", formula: "지급총액의 3%", amount: income },
      { name: "지방소득세", formula: "소득세의 10%", amount: local },
    ];
  }
  if (emp.deductionType === "insurance") {
    const pension = Math.round(base * INS_RATE.pension);
    const health = Math.round(base * INS_RATE.health);
    const care = Math.round(health * INS_RATE.care);
    const employ = Math.round(base * INS_RATE.employ);
    const rows = [
      { name: "국민연금", formula: "지급총액의 4.5%", amount: pension },
      { name: "건강보험", formula: "지급총액의 3.545%", amount: health },
      { name: "장기요양보험", formula: "건강보험의 12.95%", amount: care },
      { name: "고용보험", formula: "지급총액의 0.9%", amount: employ },
    ];
    const it = incomeTaxOf(emp);
    if (it > 0) {
      const deps = Math.max(1, Number(emp.dependents) || 1), kids = Math.max(0, Number(emp.children) || 0);
      rows.push({ name: "소득세", formula: emp.incomeTaxManual ? "직접 입력" : `간이세액표 · 가족 ${deps}명${kids>0?` · 8~20세 자녀 ${kids}명`:""}`, amount: it });
      rows.push({ name: "지방소득세", formula: "소득세의 10%", amount: Math.round(it * 0.1) });
    }
    return rows;
  }
  return [];
}
// 지급 항목별 내역
function paymentRows(emp) {
  const rows = [];
  if (emp.payType === "hourly") {
    const raw = (emp.hourlyWage || 0) * (emp.totalHours || 0);
    rows.push({
      name: "기본급",
      formula: `${(emp.hourlyWage||0).toLocaleString("ko-KR")}원 × ${emp.totalHours||0}시간`,
      amount: raw,
    });
    const hol = calcHolidayPay(emp);
    if (hol > 0) {
      const hrs = (emp.holidayHours === undefined || emp.holidayHours === null || emp.holidayHours === "")
        ? suggestHolidayHours(emp) : (Number(emp.holidayHours) || 0);
      rows.push({
        name: "주휴수당",
        formula: `주휴 ${hrs}h × ${(emp.hourlyWage||0).toLocaleString("ko-KR")}원`,
        amount: hol,
      });
    }
  } else {
    rows.push({ name: "기본급", formula: "월 정액", amount: emp.monthlySalary || 0 });
  }
  return rows;
}

// ── 로그인 ──
function LoginScreen() {
  const [loading, setLoading] = useState(false);
  const login = async () => {
    setLoading(true);
    try { await signInWithPopup(auth, new GoogleAuthProvider()); } catch { setLoading(false); }
  };
  return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Noto Sans KR', sans-serif", background:"#0D1B2A" }}>
      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;500;600;700&display=swap" rel="stylesheet" />
      <div style={{ textAlign:"center", padding:"40px 32px", background:"#112236", borderRadius:24, maxWidth:360, width:"100%", boxShadow:"0 8px 40px rgba(0,0,0,0.4)", border:"1px solid #1e3448" }}>
        {/* 로고 + 앱명 */}
        <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:12, marginBottom:8 }}>
          <img src="data:image/png;base64,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" alt="단꿈" style={{ width:56, height:56, objectFit:"contain" }} />
          <h1 style={{ margin:0, fontSize:22, fontWeight:700, color:"#f1f5f9" }}>단꿈 손익분석기</h1>
        </div>
        <p style={{ margin:"0 0 28px", fontSize:13, color:"#94a3b8", lineHeight:1.7 }}>손익분석이 장사의 첫걸음<br />지금 바로 내 가게 손익을 확인하세요</p>
        <button onClick={login} disabled={loading} style={{ width:"100%", padding:"14px", border:"1px solid #1e3448", borderRadius:12, background:"#1a2e42", cursor:"pointer", fontSize:15, fontWeight:600, fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:10, color:"#f1f5f9" }}>
          <svg width="20" height="20" viewBox="0 0 48 48">
            <path fill="#FFC107" d="M43.6 20H24v8h11.3C33.6 33.1 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.8 2.9l5.7-5.7C34.1 6.5 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 20-8.9 20-20 0-1.3-.1-2.7-.4-4z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.7 1.1 7.8 2.9l5.7-5.7C34.1 6.5 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5.2 0 9.9-1.9 13.5-5l-6.2-5.2C29.4 35.6 26.8 36 24 36c-5.2 0-9.6-3-11.3-7.3l-6.5 5C9.6 39.6 16.3 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20H24v8h11.3c-.9 2.5-2.6 4.6-4.8 6l6.2 5.2C40.5 35.7 44 30.3 44 24c0-1.3-.1-2.7-.4-4z"/>
          </svg>
          {loading ? "로그인 중..." : "Google로 로그인"}
        </button>
        <p style={{ marginTop:10, fontSize:11, color:"#cbd5e1", lineHeight:1.6 }}>카카오톡·네이버 앱에서는 로그인이 안 될 수 있어요.<br />크롬 또는 사파리로 열어주세요.</p>

      </div>
    </div>
  );
}

// ── 다점포: 한 매장의 특정 월 손익 계산 (손익분석 탭과 동일 공식) ──
// 플랫폼별 샵인샵 입력 항목 정의 — 항목이 바뀌면 여기만 고치면 된다
const SHOP_SPEC = {
  baemin: {
    orderTitle: "주문금액 화면",
    orderHint: "배민배달·가게배달·픽업의 금액과 건수",
    orderFields: [["bm","배민배달 금액"],["bmc","배민배달 건수"],["gd","가게배달 금액"],["gdc","가게배달 건수"],["pk","픽업 금액"],["pkc","픽업 건수"]],
    costTitle: "성과 화면 · 비용 열",
    costHint: "가게통계 → 마케팅 성과에서 항목별 비용을 넣습니다 · 할인은 비용 전체가 아니라 파트너부담만 (배민지원·배민분담은 사장님 돈이 아닙니다)",
    costs: [["dc1","즉시할인 파트너부담"],["dc2","배민클럽 파트너부담"],["ad","우리가게클릭"],["dc3","한그릇 파트너부담"]],
    portal: "배민 셀프서비스 → 가게통계 (합계는 부가세 신고자료)",
    rateHint: "배민배달 7.8% · 가게배달 6.8% + 건당 배달비",
    map: [["주문금액","배민배달·가게배달·픽업의 금액과 건수"],
          ["마케팅 성과","우리가게클릭 비용 · 즉시할인·배민클럽·한그릇은 파트너부담만"]],
  },
  coupang: {
    orderTitle: "매출 관리 화면",
    orderHint: "매출액과 주문 수 · 포장이 있으면 따로",
    orderFields: [["bm","배달 매출액"],["bmc","배달 주문 수"],["pk","포장 매출액"],["pkc","포장 주문 수"]],
    costTitle: "광고 관리 · 부가세 신고자료",
    costHint: "광고 관리에서 광고 비용, 부가세 신고자료에서 상점 부담 할인 금액을 넣으세요",
    costs: [["ad","광고 비용"],["dc1","상점 부담 할인 금액"]],
    portal: "쿠팡이츠 사장님 포털",
    rateHint: "배달 7.8% · 포장 6.8% + 건당 배달비",
    map: [["매출 관리","매장별 매출액과 주문 수"],
          ["광고 관리","매장별 광고 비용"],
          ["부가세 신고자료","상점 부담 할인 금액"]],
  },
  yogiyo: {
    orderTitle: "정산 내역 화면",
    orderHint: "배달·포장의 금액과 건수",
    orderFields: [["bm","배달 금액"],["bmc","배달 건수"],["pk","포장 금액"],["pkc","포장 건수"]],
    costTitle: "광고·할인 화면",
    costHint: "사장님사이트 추천광고와 비즈센터 광고를 합쳐 넣고, 점주 부담 할인액을 넣으세요",
    costs: [["ad","광고비 (추천광고+비즈센터)"],["dc1","점주 부담 할인"]],
    portal: "요기요 사장님사이트 · 비즈센터",
    rateHint: "중개이용료 + 건당 배달비 · 정산 상세내역 기준",
    map: [["정산 내역","매장별 금액과 건수"],
          ["광고","추천광고 + 비즈센터 광고비"]],
  },
  _default: {
    orderTitle: "주문·매출 화면",
    orderHint: "배달·포장의 금액과 건수",
    orderFields: [["bm","배달 금액"],["bmc","배달 건수"],["pk","포장 금액"],["pkc","포장 건수"]],
    costTitle: "광고·할인 화면",
    costHint: "앱 통계에서 광고비와 점주 부담 할인액을 넣으세요",
    costs: [["ad","광고비"],["dc1","점주 부담 할인"]],
    portal: "앱 통계",
    rateHint: "배달 7.8% · 포장 6.8% + 건당 배달비",
    map: [["주문·매출","배달·포장의 금액과 건수"],["광고·할인","광고비와 점주 부담 할인액"]],
  },
};
// id로 먼저 찾고, 직접 추가한 플랫폼이면 이름으로 찾는다
const SHOP_SPEC_BY_NAME = [[/배민|배달의민족/, "baemin"], [/쿠팡/, "coupang"], [/요기요/, "yogiyo"]];
function shopSpecKeyOf(plat) {
  if (SHOP_SPEC[plat.id]) return plat.id;
  const nm = (plat.name || "").replace(/\s/g, "");
  const hit = SHOP_SPEC_BY_NAME.find(([re]) => re.test(nm));
  return hit ? hit[1] : null;
}
const shopSpecOf = (plat) => SHOP_SPEC[shopSpecKeyOf(plat)] || SHOP_SPEC._default;

// 부가세 자료가 사업자 단위로 합산돼 나오는 플랫폼 — 샵인샵을 쓰면 브랜드별로 쪼개 봐야 한다
// 쿠팡이츠는 매장(스토어)별로 자료가 따로 나오므로 플랫폼을 나눠 넣는 편이 정확하다
const VAT_MERGED = { baemin: true, yogiyo: true, coupang: false };
const isVatMerged = (plat) => {
  const k = shopSpecKeyOf(plat);
  return k ? VAT_MERGED[k] !== false : true;   // 모르는 앱은 합산으로 본다
};

// 정산 자료를 여는 주소 — 로그인돼 있으면 그 화면으로 바로 간다
const PLAT_LINK = {
  baemin:  { url: "https://self.baemin.com/orders/tax", label: "배민 부가세신고내역 열기" },
  coupang: { url: "https://store.coupangeats.com/merchant/management/vat/", label: "쿠팡이츠 부가세 자료 열기" },
  yogiyo:  { url: "https://ceo.yogiyo.co.kr/tax-invoice/settlement", label: "요기요 정산 자료 열기" },
};
// 직접 추가한 플랫폼도 이름으로 찾는다
function platLinkOf(plat) {
  if (PLAT_LINK[plat.id]) return PLAT_LINK[plat.id];
  const nm = (plat.name || "").replace(/\s/g, "");
  if (/배민|배달의민족/.test(nm)) return PLAT_LINK.baemin;
  if (/쿠팡/.test(nm)) return PLAT_LINK.coupang;
  if (/요기요/.test(nm)) return PLAT_LINK.yogiyo;
  return null;
}

// 배달 카드 입력칸 문구·구성 — 플랫폼이 늘어나도 여기만 고치면 된다
// keys: 그 플랫폼에서 실제로 쓰는 비용 항목만 나열 (없는 항목은 화면에서 감춘다)
const PLAT_FIELD = {
  baemin: {
    // 셀프서비스 → 부가세 신고자료 한 장에 매출·수수료·광고비·배민부담금액이 다 있다 (조회기간을 한 달로)
    revenue: "부가세 신고자료 → 매출 합계 (할인 차감된 결제금액)",
    orders: "가게통계 → 주문금액 화면",
    keys: ["fee", "ad", "agency", "disc", "adj"],
    fee: "부가세 신고자료 → 음식배달수수료 + 배민보정금액 (합계 열)",
    adLabel: "광고비 (우리가게클릭)",
    ad: "부가세 신고자료 → 우리가게클릭 광고이용료 (합계 열)",
    agency: "가게배달 대행사 비용 (바로고·생각대로 등) · 배민 자료엔 없음",
    disc: "부가세 신고자료 매출은 이미 할인 차감 후 · 여기는 0",
    adj: "부가세 신고자료 → 배민부담금액 · 마이너스 부호는 빼고 숫자만",
  },
  coupang: {
    revenue: "매출 관리 → 매출액 · 할인 차감 후 금액",
    orders: "매출 관리 → 주문 수",
    keys: ["fee", "ad", "disc", "adj"],           // 자체배달이라 배달대행비 없음
    fee: "세금계산서 합계 · 중개이용료 + 배달비",
    adLabel: "광고비",
    ad: "주문연동형 · 광고로 들어온 주문에만 과금 (광고 관리 → 광고 비용)",
    disc: "부가세 신고자료 → 상점 부담 할인 금액",
    adj: "쿠팡이츠가 부담해 돌려주는 금액",
  },
  yogiyo: {
    revenue: "정산 내역 매출 · 할인 차감 후 금액",
    orders: "사장님사이트 → 통계 · 지난 주문내역",
    keys: ["fee", "ad", "agency", "disc", "adj"],
    fee: "세금계산서 합계 · 중개이용료 + 배달비",
    adLabel: "광고비",
    ad: "사장님사이트 추천광고 + 비즈센터 광고(우리동네플러스·포커스·요타임딜) 합계 · 충전액 말고 그달 소진액",
    agency: "가게배달 대행사 비용 (요기배달이면 0)",
    disc: "쿠폰·즉시할인 중 점주 부담분",
    adj: "요기요가 부담해 돌려주는 금액",
  },
  _default: {
    revenue: "세금계산서 매출 · 할인 차감 후 금액",
    orders: "앱 통계의 주문 건수",
    keys: ["fee", "ad", "agency", "disc", "adj"],
    fee: "세금계산서 합계 · 중개이용료 + 배달비",
    adLabel: "광고비",
    ad: "해당 앱의 광고 집행 금액",
    agency: "직접배달 대행사 비용",
    disc: "쿠폰·즉시할인 중 점주 부담분",
    adj: "플랫폼이 부담해 돌려주는 금액",
  },
};
const COST_LABEL = { fee: "수수료 합계", ad: "광고비", agency: "배달대행비", disc: "점주 부담 할인", adj: "부담금액 (차감)" };
const fieldSpecOf = (plat) => PLAT_FIELD[plat.id] || PLAT_FIELD._default;
// 규격에 없는 항목이라도 이미 입력된 값이 있으면 감추지 않는다 (데이터 유실 방지)
const costKeysOf = (plat, pd) => {
  const sp = fieldSpecOf(plat);
  return ["fee", "ad", "agency", "disc", "adj"].filter(
    (k) => sp.keys.includes(k) || ((pd || {})[k] || 0) > 0
  );
};

// 샵인샵 배분 계산 — 배민 요율 기반 비율로 실측 총액을 나눈다
// 구버전(월 단위 shops) → 신버전(플랫폼별 shops) 자동 이전
// 부가세 매입세액 공제 대상이 아닌 판관비 항목 (기본 추정)
// 신용카드·현금영수증 발행세액공제 (부가가치세법 제46조)
// 2026년까지 한시 우대 1.3%·연 1,000만원 → 2027년부터 1.2%·연 500만원 (세제개편안)
const cardCreditOf = (y) => (y <= 2026 ? { rate: 0.013, cap: 10000000 } : { rate: 0.012, cap: 5000000 });

const NO_VAT_KEYWORDS = ["인건비","보험","감가상각","수도","세금","이자","급여","퇴직","카드수수료","현금지출"];
function isVatDeductible(item) {
  if (item && item.vat !== undefined) return !!item.vat;
  const n = (item && item.name) || "";
  return !NO_VAT_KEYWORDS.some(k => n.includes(k));
}

function migrateDeliv(dd) {
  if (!dd) return dd;
  let changed = false;
  const out = {};
  Object.entries(dd).forEach(([k, v]) => {
    if (v && Array.isArray(v.shops) && v.shops.length) {
      const bm = { ...(v.baemin || {}) };
      if (!Array.isArray(bm.shops) || !bm.shops.length) { bm.shops = v.shops; }
      const rest = { ...v };
      delete rest.shops;
      out[k] = { ...rest, baemin: bm };
      changed = true;
    } else {
      out[k] = v;
    }
  });
  return changed ? out : dd;
}

function calcShops(list, feeTotal, agencyTotal, unitDeliv) {
  const UD = (+unitDeliv > 0) ? +unitDeliv : 3400;   // 기본값: 서울·경기 상위 35% 기준
  const rows = (list||[]).map((x) => {
    const bm=+x.bm||0, bmc=+x.bmc||0, gd=+x.gd||0, gdc=+x.gdc||0, pk=+x.pk||0, pkc=+x.pkc||0;
    const tot=bm+gd+pk, cnt=bmc+gdc+pkc;
    // 배민배달 7.8% · 가게배달/픽업 6.8% · 배달비 unitDeliv(건당, 기본 3,400원) · 결제정산 2.65%
    const est = bm*0.078 + (gd+pk)*0.068 + bmc*UD + tot*0.0265;
    const discSum = (+x.dc1||0)+(+x.dc2||0)+(+x.dc3||0);
    const discRaw = discSum>0 ? discSum : (+x.disc||0);   // 구버전 단일 필드 호환
    return { name:(x.name||"").trim()||"이름 없음", bm, bmc, gd, gdc, pk, pkc, tot, cnt, est,
             // 할인은 고객이 덜 낸 금액 그대로다 (2,000원 할인 × 254건 ≈ 할인비용). 수수료가 아니라 부가세를 얹지 않는다
             // 광고(우리가게클릭)는 배민에 내는 이용료라 부가세 10%를 더한다
             disc:discRaw, ad:(+x.ad||0)*1.1 };
  });
  const tEst = rows.reduce((a,r)=>a+r.est,0);
  const tGdc = rows.reduce((a,r)=>a+r.gdc,0);
  rows.forEach((r) => {
    r.fee = tEst>0 ? (feeTotal||0)*r.est/tEst : 0;
    r.ag  = tGdc>0 ? (agencyTotal||0)*r.gdc/tGdc : 0;
    r.net = r.tot - r.disc - r.fee - r.ad - r.ag;
    r.avg = r.cnt>0 ? r.tot/r.cnt : 0;
    r.netRate = r.tot>0 ? r.net/r.tot*100 : 0;
  });
  return rows;
}

// 매장 데이터 정규화 — 매장을 열 때(load)와 매장별 비교 보기가 같은 규칙으로 읽는다(예전 형식 이관 · 빈 값 기본값)
function normalizeStoreData(raw) {
  const out = {
    sga: DEFAULT_SGA, monthlySgaAmounts: {}, other: DEFAULT_OTHER, monthlyOtherAmounts: {},
    monthlyCogs: {}, salesData: {}, deliveryData: {}, platforms: DEFAULT_PLATFORMS, monthlyGoal: {},
    vendors: DEFAULT_VENDORS, dailyExpense: {}, payDay: 10, bizInfo: DEFAULT_BIZ,
    inventoryItems: [], monthlyInventory: {}, dailyReports: {}, monthlyEmployees: {}, monthlyOwnerWage: {},
  };
  if (!raw) return out;
  let d = raw;
  // 거래처 판관비가 남아 있으면 항목으로 통합한다
  const mv = migrateSgaVendors(d.vendors, d.dailyExpense, migrateSga(d.sga || DEFAULT_SGA), d.monthlySgaAmounts);
  if (mv) { d = { ...d, vendors: mv.vendors, dailyExpense: mv.dailyExpense, sga: mv.sga, monthlySgaAmounts: mv.monthlySgaAmounts }; }
  if (d.sga) out.sga = migrateSga(d.sga);
  if (d.monthlySgaAmounts) out.monthlySgaAmounts = d.monthlySgaAmounts;
  if (d.other) out.other = d.other;
  if (d.monthlyOtherAmounts) out.monthlyOtherAmounts = d.monthlyOtherAmounts;
  if (d.monthlyCogs) out.monthlyCogs = d.monthlyCogs;
  if (d.salesData) out.salesData = d.salesData;
  if (d.deliveryData) out.deliveryData = migrateDeliv(d.deliveryData);
  if (d.platforms) {
    // 요기요는 기본 생성에서 제외. 기존 데이터는 유지하되 삭제 가능하게 전환
    out.platforms = d.platforms.map(x => ({
      ...x,
      fixed: x.id==="yogiyo" ? false : x.fixed,
      color: platformColorOf(x),      // 쨍한 옛 색을 차분한 톤으로 보정
    }));
  }
  if (d.monthlyGoal) out.monthlyGoal = d.monthlyGoal;
  if (d.vendors) out.vendors = d.vendors;
  if (d.dailyExpense) out.dailyExpense = d.dailyExpense;
  if (d.payDay) out.payDay = d.payDay;
  if (d.bizInfo) out.bizInfo = { ...DEFAULT_BIZ, ...d.bizInfo };
  if (d.inventoryItems) out.inventoryItems = d.inventoryItems;
  if (d.monthlyInventory) out.monthlyInventory = d.monthlyInventory;
  if (d.dailyReports) out.dailyReports = d.dailyReports;
  if (d.monthlyEmployees && Object.keys(d.monthlyEmployees).length > 0) {
    out.monthlyEmployees = d.monthlyEmployees;
  } else if (d.employees && d.employees.length > 0) {
    const curMk = `${TODAY.getFullYear()}-${String(TODAY.getMonth()+1).padStart(2,"0")}`;
    out.monthlyEmployees = { [curMk]: d.employees };
  }
  if (d.monthlyOwnerWage) out.monthlyOwnerWage = d.monthlyOwnerWage;
  else if (d.ownerWage) out.monthlyOwnerWage = { _legacy: d.ownerWage };
  return out;
}

// 한 달 손익 — 손익분석 탭과 매장별 비교 보기가 같은 함수를 쓴다(재고조사 반영 기초·기말 · 거래처 매입 · 배달비용 · 인건비).
// d = normalizeStoreData 결과(또는 손익분석 탭 상태) · viewed = 손익분석 탭이 보고 있는 달(기타비용 기본값을 쓴다)
function calcMonthPnl(d, mk, viewed) {
  const platforms = d.platforms || [];
  const vendors = d.vendors || DEFAULT_VENDORS;
  // 매출
  const daySales = (d.salesData && d.salesData[mk]) || {};
  const rev = Object.values(daySales).reduce((a,x) => ({ food:a.food+(x.food||0), drink:a.drink+(x.drink||0) }), { food:0, drink:0 });
  // 일별 마감(거래처별 지출)
  const dailyExpByVendor = {};
  Object.values((d.dailyExpense && d.dailyExpense[mk]) || {}).forEach((day) => {
    Object.entries(day || {}).forEach(([vid, v]) => { dailyExpByVendor[vid] = (dailyExpByVendor[vid] || 0) + (Number(v) || 0); });
  });
  const vendorKind = (vid) => (vendors.find((v) => v.id === vid) || {}).kind || "food";
  const dailyExpSum = { food: 0, drink: 0, sga: 0 };
  Object.entries(dailyExpByVendor).forEach(([vid, amt]) => { dailyExpSum[vendorKind(vid)] = (dailyExpSum[vendorKind(vid)] || 0) + amt; });
  // 배달 — 배달 탭 월 입력(세금계산서·정산 기준)만
  const dm = (d.deliveryData && d.deliveryData[mk]) || {};
  const sumP = (f) => platforms.reduce((a,p) => a+(dm[p.id]?.[f]||0), 0);
  const delivRevenue = sumP("revenue");
  const delivFee = sumP("fee"), delivAd = sumP("ad"), delivAgency = sumP("agency"), delivAdj = sumP("adj"), delivDisc = sumP("disc");
  const delivCost = delivFee + delivAd + delivAgency + delivDisc - delivAdj;
  const hallRev = rev.food;
  const totalRev = hallRev + delivRevenue;
  // 매출원가 — 기초·기말은 재고조사 결과와 전월 승계(resolveStock)
  const stock = resolveStock(d.monthlyCogs, d.monthlyInventory, d.inventoryItems, mk);
  const cogsRaw = (d.monthlyCogs && d.monthlyCogs[mk]) || {};
  const cogsFood = Math.max(0, (stock.begin||0)+(cogsRaw.purchase||0)+dailyExpSum.food+dailyExpSum.drink-(stock.end||0));
  const cogsOther = cogsRaw.other||0;
  const totalCogs = cogsFood + cogsOther;
  // 인건비
  const employees = (d.monthlyEmployees && d.monthlyEmployees[mk]) || [];
  const employeeCost = employees.reduce((a,e) => a + calcEmployerCost(e), 0);
  const laborCost = employeeCost + (ownerWageAt(d.monthlyOwnerWage || {}, mk) || 0);
  // 판관비
  const totalSga = (d.sga || []).reduce((a,c) => {
    if (c.name==="인건비") return a + laborCost;
    return a + (d.monthlySgaAmounts?.[mk]?.[c.id] ?? c.amount ?? 0);
  }, 0) + dailyExpSum.sga;
  const opProfit = totalRev - totalCogs - totalSga - delivCost;
  // 기타비용 — 보고 있는 달은 항목 기본값, 다른 달은 그 달 입력값만
  const totalOther = (d.other || []).reduce((a,c) => {
    const ov = d.monthlyOtherAmounts?.[mk]?.[c.id];
    return a + ((viewed ? (ov ?? c.amount) : ov) ?? 0);
  }, 0);
  const netProfit = opProfit - totalOther;
  return {
    rev, hallRev, dailyExpByVendor, dailyExpSum,
    delivRevenue, delivFee, delivAd, delivAgency, delivAdj, delivDisc, delivCost,
    totalRev, stock, cogsFood, cogsOther, totalCogs, employeeCost, laborCost, totalSga, opProfit, totalOther, netProfit,
  };
}

// 매장별 비교 보기 한 줄 — 손익분석 탭과 같은 계산(calcMonthPnl)
function calcStoreMonth(d, mk, viewed = true) {
  if (!d) return null;
  const p = calcMonthPnl(normalizeStoreData(d), mk, viewed);
  return {
    totalRev: p.totalRev, netProfit: p.netProfit,
    netRate: p.totalRev > 0 ? (p.netProfit / p.totalRev) * 100 : 0,
    cogsRate: p.totalRev > 0 ? (p.totalCogs / p.totalRev) * 100 : 0,
    laborRate: p.totalRev > 0 ? (p.laborCost / p.totalRev) * 100 : 0,
    hasInput: p.totalRev > 0,
  };
}

// ── 다점포 통합 대시보드 ──
function DashboardPanel({ user, stores, onSelect }) {
  const [dataMap, setDataMap] = useState(null);
  const [year, setYear] = useState(TODAY.getFullYear());
  const [month, setMonth] = useState(TODAY.getMonth());
  const [sortBy, setSortBy] = useState("rev");

  useEffect(() => {
    let alive = true;
    (async () => {
      const out = {};
      await Promise.all(stores.map(async (s) => {
        try {
          const snap = await getDoc(doc(db, "users", user.uid, "stores", s.id, "data", "main"));
          out[s.id] = snap.exists() ? snap.data() : null;
        } catch { out[s.id] = null; }
      }));
      if (alive) setDataMap(out);
    })();
    return () => { alive = false; };
  }, [user, stores]);

  const mk = `${year}-${String(month + 1).padStart(2, "0")}`;
  const prevMk = month === 0 ? `${year - 1}-12` : `${year}-${String(month).padStart(2, "0")}`;
  const prevNav = () => { if (month === 0) { setYear((y) => y - 1); setMonth(11); } else setMonth((m) => m - 1); };
  const nextNav = () => { if (month === 11) { setYear((y) => y + 1); setMonth(0); } else setMonth((m) => m + 1); };

  if (!dataMap) {
    return <p style={{ textAlign:"center", padding:"24px 0", color:C.textHint, fontSize:13, margin:0 }}>매장 데이터 불러오는 중...</p>;
  }

  const rows = stores.map((s) => {
    const sp = splitName(s.name);
    return {
      store: s,
      brand: sp.brand || sp.branch,
      branch: sp.branch,
      m: calcStoreMonth(dataMap[s.id], mk),
      pm: calcStoreMonth(dataMap[s.id], prevMk, false),
    };
  });
  const inputRows = rows.filter((r) => r.m && r.m.hasInput);
  const totRev = inputRows.reduce((a, r) => a + r.m.totalRev, 0);
  const totNet = inputRows.reduce((a, r) => a + r.m.netProfit, 0);
  const prevRows = rows.filter((r) => r.pm && r.pm.hasInput);
  const prevRev = prevRows.reduce((a, r) => a + r.pm.totalRev, 0);
  const prevNet = prevRows.reduce((a, r) => a + r.pm.netProfit, 0);
  const noInputCnt = rows.length - inputRows.length;
  const lossCnt = inputRows.filter((r) => r.m.netProfit < 0).length;
  const cogsWarnCnt = inputRows.filter((r) => r.m.cogsRate >= 40).length;

  const kpiDiff = (cur, prev) => {
    if (!prev) return null;
    const df = cur - prev;
    if (df === 0) return null;
    const rt = Math.abs((df / Math.abs(prev)) * 100).toFixed(1);
    return <span style={{ fontSize:10, color:df >= 0 ? "#34d399" : "#f87171", marginLeft:4 }}>{df >= 0 ? "▲" : "▼"}{rt}%</span>;
  };

  const brandGroups = groupStoresByBrand(rows, (r) => r.store.name);
  const brandOrder = brandGroups.map((g) => g.brand);
  const groups = Object.fromEntries(brandGroups.map((g) => [g.brand, g.items]));
  const sortRows = (arr) => [...arr].sort((a, b) => {
    const ai = a.m && a.m.hasInput, bi = b.m && b.m.hasInput;
    if (!ai && !bi) return 0;
    if (!ai) return 1;
    if (!bi) return -1;
    return sortBy === "rev" ? b.m.totalRev - a.m.totalRev : b.m.netRate - a.m.netRate;
  });

  const chip = (label, val, danger, warn) => (
    <span style={{ color: danger ? "#f87171" : warn ? "#fbbf24" : "#64748b" }}>{label} {val.toFixed(0)}%</span>
  );

  return (
    <div>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:12, marginBottom:14 }}>
          <button onClick={prevNav} style={NAV_BTN}>‹</button>
          <span style={{ fontSize:17, fontWeight:700 }}>{year}년 {MONTHS[month]}</span>
          <button onClick={nextNav} style={NAV_BTN}>›</button>
        </div>

        <div style={{ display:"flex", gap:8, marginBottom:10 }}>
          <div style={{ flex:1, background:"#112236", borderRadius:10, padding:"10px 12px" }}>
            <p style={{ margin:0, fontSize:10, color:C.textHint }}>총매출</p>
            <p style={{ margin:"3px 0 0", fontSize:16, fontWeight:700 }}>{fmtMan(totRev)}{kpiDiff(totRev, prevRev)}</p>
          </div>
          <div style={{ flex:1, background:"#112236", borderRadius:10, padding:"10px 12px" }}>
            <p style={{ margin:0, fontSize:10, color:C.textHint }}>총순이익</p>
            <p style={{ margin:"3px 0 0", fontSize:16, fontWeight:700, color:totNet >= 0 ? C.profit : C.loss }}>{totNet >= 0 ? "+" : "−"}{fmtMan(Math.abs(totNet))}{kpiDiff(totNet, prevNet)}</p>
          </div>
          <div style={{ flex:1, background:"#112236", borderRadius:10, padding:"10px 12px" }}>
            <p style={{ margin:0, fontSize:10, color:C.textHint }}>순이익률</p>
            <p style={{ margin:"3px 0 0", fontSize:16, fontWeight:700 }}>{totRev > 0 ? ((totNet / totRev) * 100).toFixed(1) : "0.0"}%</p>
          </div>
        </div>

        {(noInputCnt > 0 || lossCnt > 0 || cogsWarnCnt > 0) && (
          <div style={{ background:"rgba(251,191,36,0.08)", border:"1px solid rgba(251,191,36,0.35)", borderRadius:9, padding:"8px 12px", marginBottom:12, fontSize:11, color:"#fbbf24", fontWeight:600 }}>
            <span style={{ display:"inline-flex", width:14, height:14, borderRadius:"50%", background:"currentColor", color:"#0D1B2A", fontSize:10, fontWeight:700, alignItems:"center", justifyContent:"center", marginRight:5, flexShrink:0 }}>!</span>{[noInputCnt > 0 ? `미입력 ${noInputCnt}곳` : null, lossCnt > 0 ? `적자 ${lossCnt}곳` : null, cogsWarnCnt > 0 ? `식자재비율 위험 ${cogsWarnCnt}곳` : null].filter(Boolean).join(" · ")}
          </div>
        )}

        <div style={{ display:"flex", justifyContent:"flex-end", gap:6, marginBottom:8 }}>
          {[["rev","매출순"],["rate","순이익률순"]].map(([v, lbl]) => (
            <button key={v} onClick={() => setSortBy(v)} style={{ fontSize:11, padding:"5px 10px", borderRadius:7, border:`1px solid ${sortBy === v ? "#0d9488" : C.border}`, background:sortBy === v ? "rgba(13,148,136,0.15)" : "transparent", color:sortBy === v ? "#2dd4bf" : C.textSub, cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>{lbl}</button>
          ))}
        </div>

        {brandOrder.map((brand) => {
          const g = groups[brand];
          const gi = g.filter((r) => r.m && r.m.hasInput);
          const gRev = gi.reduce((a, r) => a + r.m.totalRev, 0);
          const gNet = gi.reduce((a, r) => a + r.m.netProfit, 0);
          return (
            <div key={brand} style={{ marginBottom:12 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"7px 10px", background:"#0f2438", borderRadius:"8px 8px 0 0" }}>
                <span style={{ fontSize:12, fontWeight:700, color:"#2dd4bf" }}>{brand} · {g.length}개점</span>
                <span style={{ fontSize:11, color:C.textSub }}>{gi.length > 0 ? <>소계 {fmtMan(gRev)} · <span style={{ color:gNet >= 0 ? C.profit : C.loss }}>{gNet >= 0 ? "+" : "−"}{fmtMan(Math.abs(gNet))}</span></> : "미입력"}</span>
              </div>
              <div style={{ background:"#112236", borderRadius:"0 0 10px 10px" }}>
                {sortRows(g).map((r, i, arr) => (
                  <div key={r.store.id} onClick={() => onSelect(r.store, "손익분석")}
                    style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px", cursor:"pointer", borderBottom:i < arr.length - 1 ? "0.5px solid #1e3448" : "none" }}>
                    {r.m && r.m.hasInput ? (
                      <>
                        <div style={{ minWidth:0 }}>
                          <p style={{ margin:0, fontSize:13, color:C.text, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{r.branch}</p>
                          <p style={{ margin:"2px 0 0", fontSize:10 }}>
                            {chip("식자재", r.m.cogsRate, r.m.cogsRate >= 40, r.m.cogsRate >= 35)}
                            <span style={{ color:"#64748b" }}> · </span>
                            {chip("인건", r.m.laborRate, r.m.laborRate >= 35, r.m.laborRate >= 30)}
                          </p>
                        </div>
                        <div style={{ textAlign:"right", flexShrink:0 }}>
                          <p style={{ margin:0, fontSize:13, color:C.text }}>{fmtMan(r.m.totalRev)}</p>
                          <p style={{ margin:"2px 0 0", fontSize:11, color:r.m.netProfit >= 0 ? C.profit : C.loss }}>{r.m.netProfit >= 0 ? "+" : "−"}{fmtMan(Math.abs(r.m.netProfit))} ({r.m.netRate.toFixed(1)}%)</p>
                        </div>
                      </>
                    ) : (
                      <>
                        <p style={{ margin:0, fontSize:13, color:C.textSub }}>{r.branch}</p>
                        <span style={{ fontSize:11, color:"#fbbf24", fontWeight:600 }}>미입력</span>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      <p style={{ margin:"4px 0 0", fontSize:10, color:C.textHint }}>매장 줄을 탭하면 해당 매장 손익분석으로 이동합니다.</p>
    </div>
  );
}

// ── 매장 선택 ──
function StoreSelectScreen({ user, onSelect, viaShare, access, onRedeemed, onAdmin }) {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [newName, setNewName] = useState("");
  const [newColor, setNewColor] = useState(STORE_COLORS[0].id);
  const [delConfirm, setDelConfirm] = useState(null);
  const [editingStore, setEditingStore] = useState(null);
  const [sharedStores, setSharedStores] = useState([]);
  const [inviteItems, setInviteItems] = useState([]);
  const [myGrants, setMyGrants] = useState([]);
  const [shareTarget, setShareTarget] = useState(null);
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteTabs, setInviteTabs] = useState(SHARE_DEFAULT_TABS);
  const [shareBusy, setShareBusy] = useState(false);
  const emailLower = (user.email || "").toLowerCase();
  const [dashOpen, setDashOpen] = useState(false);
  const [showPaywall, setShowPaywall] = useState(false); // 이용권 없는 계정이 「매장 추가」를 눌렀을 때만
  const [limitNotice, setLimitNotice] = useState(false);
  const storeLimit = access && (access.isAdmin || access.unlimitedStores) ? Infinity : STORE_LIMIT;
  const atStoreLimit = !viaShare && stores.length >= storeLimit;
  useEffect(() => { if (!viaShare) setShowPaywall(false); }, [viaShare]); // 입장코드 등록 후 이용권 계정이 되면 닫는다
  const colorHex = (id) => STORE_COLORS.find((c) => c.id === id)?.hex || "#0d9488";

  const loadStores = useCallback(async () => {
    setLoading(true);
    try {
      const snap = await getDocs(collection(db, "users", user.uid, "stores"));
      const list = [];
      snap.forEach((d) => list.push({ id: d.id, ...d.data() }));
      list.sort((a, b) => (a.createdAt || 0) - (b.createdAt || 0));
      setStores(list);
    } catch {}
    // 공유받은 매장
    try {
      const gq = await getDocs(query(collection(db, "grants"), where("managerUid", "==", user.uid)));
      const shared = [];
      for (const g of gq.docs) {
        const gd = g.data();
        try {
          const s = await getDoc(doc(db, "users", gd.ownerUid, "stores", gd.storeId));
          if (s.exists()) shared.push({ id: gd.storeId, ownerUid: gd.ownerUid, grantId: g.id, tabs: normTabs(gd.tabs), ...s.data() });
        } catch {}
      }
      setSharedStores(shared);
    } catch {}
    // 받은 초대
    try {
      const inv = await getDoc(doc(db, "invites", emailLower));
      const items = inv.exists() ? (inv.data().items || {}) : {};
      setInviteItems(Object.entries(items).map(([key, v]) => ({ key, ...v })));
    } catch { setInviteItems([]); }
    // 내가 초대해 참여 중인 사람들 (내 매장 전체)
    try {
      const og = await getDocs(query(collection(db, "grants"), where("ownerUid", "==", user.uid)));
      setMyGrants(og.docs.map((g) => ({ id: g.id, ...g.data() })));
    } catch {}
    setLoading(false);
  }, [user, emailLower]);
  useEffect(() => { loadStores(); }, [loadStores]);
  async function addStore() {
    if (viaShare) { setShowPaywall(true); return; } // 이용권 없는 계정은 새 매장을 만들 수 없다
    if (atStoreLimit) { setShowAdd(false); setLimitNotice(true); return; } // 일반 이용권은 매장 10곳까지
    if (!newName.trim()) return;
    const id = `store_${Date.now()}`;
    const store = { name: newName.trim(), color: newColor, createdAt: Date.now() };
    await setDoc(doc(db, "users", user.uid, "stores", id), store);
    setStores((p) => [...p, { id, ...store }]);
    setNewName(""); setNewColor(STORE_COLORS[0].id); setShowAdd(false);
  }
  async function updateStore() {
    if (!editingStore || !editingStore.name.trim()) return;
    const { id, name, color } = editingStore;
    await setDoc(doc(db, "users", user.uid, "stores", id), { name: name.trim(), color }, { merge: true });
    setStores((p) => p.map((s) => s.id === id ? { ...s, name: name.trim(), color } : s));
    setEditingStore(null);
  }
  async function deleteStore(storeId) {
    try { await deleteDoc(doc(db, "users", user.uid, "stores", storeId, "data", "main")); } catch {}
    await deleteDoc(doc(db, "users", user.uid, "stores", storeId));
    setStores((p) => p.filter((s) => s.id !== storeId));
    setDelConfirm(null);
  }

  async function acceptInvite(item) {
    if (shareBusy) return;
    setShareBusy(true);
    try {
      const grantId = `${item.ownerUid}_${item.storeId}_${user.uid}`;
      await setDoc(doc(db, "grants", grantId), {
        ownerUid: item.ownerUid, storeId: item.storeId, managerUid: user.uid,
        managerEmail: emailLower, storeName: item.storeName || "", createdAt: Date.now(),
        tabs: normTabs(item.tabs),
      });
      await updateDoc(doc(db, "invites", emailLower), { [`items.${item.key}`]: deleteField() });
    } catch { alert("초대 수락에 실패했습니다. 잠시 후 다시 시도해주세요."); }
    setShareBusy(false);
    loadStores();
  }
  async function declineInvite(item) {
    try { await updateDoc(doc(db, "invites", emailLower), { [`items.${item.key}`]: deleteField() }); } catch {}
    loadStores();
  }
  async function sendInvite(store) {
    const em = inviteEmail.trim().toLowerCase();
    if (!em.includes("@")) { alert("이메일 주소를 확인해주세요."); return; }
    if (em === emailLower) { alert("본인 계정입니다. 다른 사람의 구글 이메일을 입력해주세요."); return; }
    if (shareBusy) return;
    setShareBusy(true);
    try {
      const key = `${user.uid}_${store.id}`;
      await setDoc(doc(db, "invites", em), {
        items: { [key]: { ownerUid: user.uid, storeId: store.id, storeName: store.name || "", ownerName: user.displayName || "", invitedAt: Date.now(), tabs: inviteTabs } },
        k: key,
      }, { merge: true });
      const prevList = store.invitedEmails || [];
      if (!prevList.includes(em)) {
        await setDoc(doc(db, "users", user.uid, "stores", store.id), { invitedEmails: [...prevList, em] }, { merge: true });
      }
      setInviteEmail("");
      alert(`${em} 계정으로 초대를 보냈습니다.\n상대방이 이 앱에 해당 구글 계정으로 로그인하면 초대가 보입니다.`);
    } catch { alert("초대 전송에 실패했습니다. 잠시 후 다시 시도해주세요."); }
    setShareBusy(false);
    loadStores();
  }
  async function cancelInvite(store, em) {
    try {
      const key = `${user.uid}_${store.id}`;
      await updateDoc(doc(db, "invites", em), { [`items.${key}`]: deleteField(), k: key });
    } catch {}
    try {
      await setDoc(doc(db, "users", user.uid, "stores", store.id), { invitedEmails: (store.invitedEmails || []).filter((x) => x !== em) }, { merge: true });
    } catch {}
    loadStores();
  }
  async function setGrantTabs(gid, tabs) {
    try { await updateDoc(doc(db, "grants", gid), { tabs: normTabs(tabs) }); }
    catch { alert("권한 변경에 실패했습니다. 잠시 후 다시 시도해주세요."); }
    loadStores();
  }
  async function revokeGrant(gid) {
    try { await deleteDoc(doc(db, "grants", gid)); } catch {}
    loadStores();
  }


  if (showPaywall) return <ToolAccessGate user={user} access={access} onRedeemed={onRedeemed} onClose={() => setShowPaywall(false)} />;

  return (
    <div style={{ minHeight:"100vh", background:"#0D1B2A", color:C.text, fontFamily:"'Noto Sans KR', sans-serif", maxWidth:480, margin:"0 auto", padding:"0 0 100px" }}>
      <div style={{ padding:"0 20px" }}><UpdateBanner /><InstallBanner /></div>
      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;500;600;700;900&display=swap" rel="stylesheet" />

      {/* 통합 헤더 + 전 매장 합산 요약 */}
      {(() => {
        // 매장 카드와 같은 규칙(storeCardMonths) — 정산 완료된 가장 최근 달의 합계 · 진행 중인 달은 매출만
        const cards = stores.map((s) => storeCardMonths(s));
        const headKey = cards.map((c) => c.closedKey).filter(Boolean).sort().pop() || null;
        const summarized = headKey ? cards.map((c) => c.sums[headKey]).filter((x) => x && (x.totalRev || 0) > 0) : [];
        const sumRev = summarized.reduce((a, x) => a + (x.totalRev || 0), 0);
        const sumNet = summarized.reduce((a, x) => a + (x.netProfit || 0), 0);
        const missing = stores.length - summarized.length;
        const ongoingRevAll = cards.reduce((a, c) => a + (c.ongoingRev || 0), 0);
        const ongoingMonth = cards.length ? Number(cards[0].ongoingKey.split("-")[1]) : TODAY.getMonth() + 1;
        return (
          <div style={{ margin:"16px 20px 16px", padding:"15px 17px", background:"linear-gradient(135deg,#0d9488 0%,#0f766e 100%)", borderRadius:16 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <span style={{ fontSize:11, color:"rgba(255,255,255,0.8)", fontWeight:600 }}>단꿈 손익분석기 · {headKey ? Number(headKey.split("-")[1]) : TODAY.getMonth()+1}월</span>
              <div style={{ display:"flex", alignItems:"center", gap:7 }}>
                <img src={user.photoURL} alt="" style={{ width:24, height:24, borderRadius:"50%" }} onError={(e)=>{e.target.style.display="none"}} />
                {access && access.isAdmin && onAdmin && <button onClick={onAdmin} style={{ fontSize:10, color:"#0f766e", background:"#fff", border:"none", borderRadius:7, padding:"4px 9px", cursor:"pointer", fontFamily:"inherit", fontWeight:700 }}>회원 관리</button>}
                <button onClick={() => signOut(auth)} style={{ fontSize:10, color:"rgba(255,255,255,0.9)", background:"rgba(255,255,255,0.15)", border:"none", borderRadius:7, padding:"4px 9px", cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>로그아웃</button>
              </div>
            </div>
            {summarized.length > 0 ? (
              <div style={{ display:"flex", gap:20, marginTop:10, flexWrap:"wrap" }}>
                <div><p style={{ margin:0, fontSize:10, color:"rgba(255,255,255,0.7)" }}>총매출</p><p style={{ margin:"2px 0 0", fontSize:20, fontWeight:800, color:"#fff" }}>{fmtMan(sumRev)}</p></div>
                <div><p style={{ margin:0, fontSize:10, color:"rgba(255,255,255,0.7)" }}>순이익</p><p style={{ margin:"2px 0 0", fontSize:20, fontWeight:800, color:sumNet>=0?"#a7f3d0":"#fecaca" }}>{sumNet>=0?"+":"−"}{fmtMan(Math.abs(sumNet))}</p></div>
              </div>
            ) : (
              <p style={{ margin:"10px 0 0", fontSize:14, fontWeight:700, color:"#fff" }}>정산 완료된 달이 아직 없습니다</p>
            )}
            {ongoingRevAll > 0 && (
              <p style={{ margin:"6px 0 0", fontSize:11, color:"rgba(255,255,255,0.75)", fontWeight:600 }}>{ongoingMonth}월 진행 중 · 매출 {fmtMan(ongoingRevAll)}</p>
            )}
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:10, marginTop:11, paddingTop:10, borderTop:"1px solid rgba(255,255,255,0.2)" }}>
              <span style={{ fontSize:11, color:missing > 0 ? "#fde68a" : "rgba(255,255,255,0.85)", fontWeight:600 }}>
                매장 {stores.length}곳{missing > 0 ? ` · 미입력 ${missing}곳` : " · 전체 입력 완료"}
              </span>
              {stores.length > 0 && (
                <button onClick={() => setDashOpen((o) => !o)} style={{ fontSize:11, color:"#0f766e", fontWeight:800, background:"#fff", border:"none", borderRadius:99, padding:"6px 13px", whiteSpace:"nowrap", cursor:"pointer", fontFamily:"inherit", boxShadow:"0 1px 4px rgba(0,0,0,0.15)" }}>{dashOpen ? "접기 ▴" : "매장별 비교 보기 ▾"}</button>
              )}
            </div>
          </div>
        );
      })()}

      {/* 통합 대시보드 (접이식) */}
      {dashOpen && stores.length > 0 && (
        <div style={{ margin:"0 20px 20px" }}>
          <DashboardPanel user={user} stores={stores} onSelect={onSelect} />
        </div>
      )}

      {/* 받은 초대 */}
      {inviteItems.length > 0 && (
        <div style={{ margin:"0 20px 16px", display:"flex", flexDirection:"column", gap:8 }}>
          {inviteItems.map((it) => (
            <div key={it.key} style={{ padding:"14px 16px", background:"rgba(13,148,136,0.08)", border:"1px solid rgba(13,148,136,0.4)", borderRadius:14 }}>
              <p style={{ margin:"0 0 4px", fontSize:13, fontWeight:700 }}>매장 공유 초대</p>
              <p style={{ margin:"0 0 10px", fontSize:12, color:C.textSub }}>{it.ownerName || "매장 사장님"} 님이 "{it.storeName || "매장"}" 입력에 초대했습니다.</p>
              <div style={{ display:"flex", gap:8 }}>
                <button onClick={() => acceptInvite(it)} disabled={shareBusy} style={{ flex:1, padding:"9px", background:"#0d9488", color:"#fff", border:"none", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>수락</button>
                <button onClick={() => declineInvite(it)} disabled={shareBusy} style={{ flex:1, padding:"9px", background:"transparent", color:C.textSub, border:"1px solid #1e3448", borderRadius:8, fontSize:12, cursor:"pointer", fontFamily:"inherit" }}>거절</button>
              </div>
            </div>
          ))}
        </div>
      )}
      {loading ? <p style={{ color:"#f1f5f9", textAlign:"center", marginTop:40 }}>불러오는 중...</p> : (
        <>
          <div style={{ display:"flex", flexDirection:"column", gap:10, padding:"0 20px" }}>
            {(() => { const renderStoreCard = (s) => {
              const sum = s.summary; // 마지막 입력 시각(어느 달이든)
              const card = storeCardMonths(s);
              const cm = card.closed; // 정산 완료된 가장 최근 달
              const gCount = myGrants.filter((g) => g.storeId === s.id).length;
              const sumMonth = card.closedKey ? Number(card.closedKey.split("-")[1]) : 0;
              const daysAgo = sum && sum.updatedAt ? Math.floor((Date.now() - sum.updatedAt) / 86400000) : null;
              const lastLabel = daysAgo === null ? null : daysAgo <= 0 ? "오늘" : daysAgo === 1 ? "어제" : `${daysAgo}일 전`;
              const stale = daysAgo !== null && daysAgo >= 5;
              const sumRate = cm && (cm.totalRev || 0) > 0 ? ((cm.netProfit || 0) / cm.totalRev) * 100 : 0;
              return (
              <div key={s.id}
                style={{ display:"flex", background:"#112236", borderRadius:14, border:"1px solid #1e3448", overflow:"hidden", cursor:"pointer", boxShadow:"0 2px 16px rgba(0,0,0,0.3)" }}
                onClick={() => onSelect(s)}
              >
                <div style={{ width:4, background:colorHex(s.color), flexShrink:0 }} />
                <div style={{ flex:1, minWidth:0, padding:"13px 14px 11px" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:6, minWidth:0 }}>
                        {brandOf(s.name) && <span style={{ fontSize:11, color:colorHex(s.color), whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{brandOf(s.name)}</span>}
                        {gCount > 0 && <span onClick={(e) => { e.stopPropagation(); setInviteEmail(""); setShareTarget(s); }} style={{ fontSize:10, fontWeight:700, color:"#2dd4bf", background:"rgba(13,148,136,0.15)", borderRadius:4, padding:"1px 6px", flexShrink:0, cursor:"pointer" }}>공유 {gCount}</span>}
                      </div>
                      <p style={{ margin:"1px 0 0", fontSize:16, fontWeight:700, color:"#f1f5f9", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{branchOf(s.name)}</p>
                      {cm ? (
                        <p style={{ margin:"4px 0 0", fontSize:12, color:"#94a3b8", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                          {sumMonth}월 매출 <span style={{ color:"#f1f5f9", fontWeight:600 }}>{fmtMan(cm.totalRev || 0)}</span> · 순익 <span style={{ color:(cm.netProfit || 0) >= 0 ? "#34d399" : "#f87171", fontWeight:600 }}>{(cm.netProfit || 0) >= 0 ? "+" : "−"}{fmtMan(Math.abs(cm.netProfit || 0))}</span>
                        </p>
                      ) : (
                        <p style={{ margin:"4px 0 0", fontSize:12, color:"#64748b" }}>{card.ongoingRev > 0 ? "정산 완료된 달 없음" : "입력 후 매출·순익 표시"}</p>
                      )}
                      {card.ongoingRev > 0 && (
                        <p style={{ margin:"2px 0 0", fontSize:11, color:"#64748b", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                          {Number(card.ongoingKey.split("-")[1])}월 진행 중 · 매출 <span style={{ color:"#94a3b8", fontWeight:600 }}>{fmtMan(card.ongoingRev)}</span>
                        </p>
                      )}
                    </div>
                    <RateRing rate={sumRate} hasData={!!cm} />
                  </div>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:9, paddingTop:8, borderTop:"0.5px solid #1e3448" }}>
                    <span style={{ fontSize:12, fontWeight:600, color:"#fbbf24", display:"flex", alignItems:"center", gap:4 }}>
                      {stale && <span style={{ display:"inline-flex", width:13, height:13, borderRadius:"50%", background:"#fbbf24", color:"#0D1B2A", fontSize:10, fontWeight:700, alignItems:"center", justifyContent:"center" }}>!</span>}
                      {lastLabel ? `마지막 입력 ${lastLabel}` : "아직 입력 없음"}
                    </span>
                    <span style={{ display:"flex", gap:10, flexShrink:0 }}>
                      <button onClick={(e) => { e.stopPropagation(); setInviteEmail(""); setShareTarget(s); }} style={{ background:"transparent", border:"none", color:"#2dd4bf", fontSize:11, fontWeight:600, cursor:"pointer", fontFamily:"inherit", padding:"2px 0" }}>{gCount > 0 ? `공유 ${gCount}명` : "공유"}</button>
                      <button onClick={(e) => { e.stopPropagation(); setEditingStore({ id:s.id, name:s.name, color:s.color }); }} style={{ background:"transparent", border:"none", color:"#64748b", fontSize:11, cursor:"pointer", fontFamily:"inherit", padding:"2px 0" }}>수정 ›</button>
                    </span>
                  </div>
                </div>
              </div>
            );};
            return groupStoresByBrand(viaShare ? [] : stores, (s) => s.name).map((g) => {
              const branded = g.items.filter((s) => brandOf(s.name));
              if (branded.length < 2) return g.items.map(renderStoreCard);
              return (
                <div key={"brand:" + g.brand} style={{ display:"flex", flexDirection:"column", gap:8 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8, padding:"4px 2px 0" }}>
                    <span style={{ fontSize:13, fontWeight:700, color:"#2dd4bf" }}>{g.brand}</span>
                    <span style={{ fontSize:12, fontWeight:600, color:"#94a3b8" }}>{branded.length}개점</span>
                    <span style={{ flex:1, height:1, background:"#1e3448" }} />
                  </div>
                  {g.items.map(renderStoreCard)}
                </div>
              );
            }); })()}
            {!showAdd && (
              <button onClick={() => (viaShare ? setShowPaywall(true) : atStoreLimit ? setLimitNotice(true) : setShowAdd(true))} style={{ padding:"18px", border:"2px dashed #1e3448", borderRadius:20, background:"transparent", cursor:"pointer", fontSize:14, color:"#64748b", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:8, transition:"all 0.15s" }}
                onMouseEnter={e=>{e.currentTarget.style.borderColor="#0d9488";e.currentTarget.style.color="#0d9488";e.currentTarget.style.background="rgba(13,148,136,0.1)"}}
                onMouseLeave={e=>{e.currentTarget.style.borderColor="#1e3448";e.currentTarget.style.color="#64748b";e.currentTarget.style.background="transparent"}}
              >
                <span style={{ width:28, height:28, borderRadius:8, background:"#1a2e42", display:"flex", alignItems:"center", justifyContent:"center", fontSize:18 }}>+</span>
                <span style={{ fontWeight:600 }}>매장 추가</span>
                {!viaShare && isFinite(storeLimit) && <span style={{ fontSize:12, color: atStoreLimit ? "#fbbf24" : "#64748b" }}>{stores.length}/{storeLimit}</span>}
              </button>
            )}
            {limitNotice && atStoreLimit && (
              <div style={{ padding:"16px 18px", borderRadius:16, background:"rgba(251,191,36,0.08)", border:"1px solid rgba(251,191,36,0.4)" }}>
                <p style={{ margin:0, fontSize:14, fontWeight:700, color:"#fbbf24" }}>매장은 {storeLimit}곳까지 등록할 수 있습니다</p>
                <p style={{ margin:"6px 0 0", fontSize:12, color:C.textSub, lineHeight:1.6 }}>
                  매장이 더 필요하시면 매장 수 제한이 없는 <strong style={{ color:"#e8eef4" }}>프랜차이즈형</strong>으로 바꿔 드립니다.<br/>문의: danggum.net
                </p>
                <button onClick={() => setLimitNotice(false)} style={{ marginTop:10, fontSize:12, padding:"6px 12px", borderRadius:8, border:"1px solid #1e3448", background:"transparent", color:C.textSub, cursor:"pointer", fontFamily:"inherit" }}>닫기</button>
              </div>
            )}
          </div>
          {showAdd && (
            <div style={{ marginTop:10, padding:"20px", background:"#112236", borderRadius:20, border:"1.5px solid #1e3448", margin:"10px 20px 0", boxShadow:"0 4px 20px rgba(0,0,0,0.4)" }}>
              <p style={{ margin:"0 0 14px", fontSize:14, fontWeight:700 }}>새 매장 추가</p>
              <input autoFocus value={newName} onChange={(e) => setNewName(e.target.value)} onKeyDown={(e) => e.key==="Enter" && addStore()} placeholder="매장 이름" style={{ width:"100%", fontSize:15, padding:"10px 12px", border:"1px solid #1e3448", borderRadius:10, background:"#112236", color:"#f1f5f9", fontFamily:"inherit", outline:"none", boxSizing:"border-box", marginBottom:14 }} />
              <p style={{ margin:"0 0 8px", fontSize:12, color:C.textSub, fontWeight:600 }}>색상</p>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:16 }}>
                {STORE_COLORS.map((c) => <div key={c.id} onClick={() => setNewColor(c.id)} style={{ width:32, height:32, borderRadius:8, background:c.hex, cursor:"pointer", border:newColor===c.id?"3px solid #1e293b":"3px solid transparent", boxSizing:"border-box" }} />)}
              </div>
              <div style={{ display:"flex", gap:8 }}>
                <button onClick={addStore} disabled={!newName.trim()} style={{ flex:1, padding:"11px", background:colorHex(newColor), color:"#fff", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>추가</button>
                <button onClick={() => { setShowAdd(false); setNewName(""); }} style={{ flex:1, padding:"11px", background:"#112236", border:"1px solid #1e3448", borderRadius:10, fontSize:14, cursor:"pointer", fontFamily:"inherit" }}>취소</button>
              </div>
            </div>
          )}
          {/* 공유받은 매장 */}
          {sharedStores.length > 0 && (
            <div style={{ marginTop:24, padding:"0 20px" }}>
              <p style={{ margin:"0 0 10px", fontSize:12, fontWeight:700, color:C.textSub, letterSpacing:1 }}>공유받은 매장</p>
              <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                {sharedStores.map((s) => (
                  <div key={s.grantId}
                    style={{ display:"flex", background:"#112236", borderRadius:14, border:"1px dashed #0d9488", overflow:"hidden", cursor:"pointer" }}
                    onClick={() => onSelect({ id:s.id, ownerUid:s.ownerUid, name:s.name, color:s.color, shared:true, tabs:s.tabs })}>
                    <div style={{ width:4, background:colorHex(s.color), flexShrink:0 }} />
                    <div style={{ flex:1, minWidth:0, padding:"13px 14px" }}>
                      {brandOf(s.name) && <p style={{ margin:0, fontSize:11, color:colorHex(s.color) }}>{brandOf(s.name)}</p>}
                      <p style={{ margin:"1px 0 0", fontSize:16, fontWeight:700, color:"#f1f5f9", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{branchOf(s.name)}</p>
                      <p style={{ margin:"4px 0 0", fontSize:11, color:"#2dd4bf", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>공유받은 매장 · {(s.tabs || SHARE_DEFAULT_TABS).join("·")} 입력</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
      {editingStore && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:999, padding:"0 20px" }}>
          <div style={{ background:"#112236", borderRadius:16, padding:"24px", maxWidth:340, width:"100%", maxHeight:"80vh", overflowY:"auto" }}>
            <p style={{ margin:"0 0 14px", fontSize:16, fontWeight:700 }}>매장 정보 수정</p>
            <input autoFocus value={editingStore.name} onChange={(e) => setEditingStore((p) => ({ ...p, name:e.target.value }))} placeholder="매장 이름" style={{ width:"100%", fontSize:15, padding:"10px 12px", border:"1px solid #1e3448", borderRadius:10, background:"#1a2e42", color:"#f1f5f9", fontFamily:"inherit", outline:"none", boxSizing:"border-box", marginBottom:14 }} />
            <p style={{ margin:"0 0 8px", fontSize:12, color:C.textSub, fontWeight:600 }}>색상</p>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:16 }}>
              {STORE_COLORS.map((c) => <div key={c.id} onClick={() => setEditingStore((p) => ({ ...p, color:c.id }))} style={{ width:32, height:32, borderRadius:8, background:c.hex, cursor:"pointer", border:editingStore.color===c.id?"3px solid #1e293b":"3px solid transparent", boxSizing:"border-box" }} />)}
            </div>
            <div style={{ display:"flex", gap:8 }}>
              <button onClick={updateStore} style={{ flex:1, padding:"11px", background:STORE_COLORS.find((c)=>c.id===editingStore.color)?.hex||"#0d9488", color:"#fff", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>저장</button>
              <button onClick={() => setEditingStore(null)} style={{ flex:1, padding:"11px", background:"#112236", border:"1px solid #1e3448", borderRadius:10, fontSize:14, cursor:"pointer", fontFamily:"inherit" }}>취소</button>
            </div>
            <button onClick={() => { setDelConfirm(editingStore.id); setEditingStore(null); }} style={{ width:"100%", marginTop:10, padding:"10px", background:"rgba(239,68,68,0.08)", border:"1px solid rgba(239,68,68,0.3)", borderRadius:10, fontSize:12, color:"#f87171", cursor:"pointer", fontFamily:"inherit" }}>이 매장 삭제</button>
          </div>
        </div>
      )}
      {shareTarget && (() => {
        const st = stores.find((x) => x.id === shareTarget.id) || shareTarget;
        const grants = myGrants.filter((g) => g.storeId === st.id);
        const grantedEmails = grants.map((g) => g.managerEmail);
        const pending = (st.invitedEmails || []).filter((em) => !grantedEmails.includes(em));
        return (
          <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:999, padding:"0 20px" }}>
            <div style={{ background:"#112236", borderRadius:16, padding:"24px", maxWidth:360, width:"100%", maxHeight:"80vh", overflowY:"auto" }}>
              <p style={{ margin:"0 0 4px", fontSize:16, fontWeight:700 }}>매장 공유 관리</p>
              <p style={{ margin:"0 0 16px", fontSize:12, color:C.textSub }}>"{st.name}" 입력을 함께할 사람을 초대합니다.</p>
              <div style={{ marginBottom:10, padding:"10px 12px", background:"#0D1B2A", borderRadius:9, border:"1px solid #1e3448" }}>
                <p style={{ margin:"0 0 6px", fontSize:11, fontWeight:700, color:C.textSub }}>열어줄 탭 <span style={{ fontWeight:400, color:C.textHint }}>· 기본은 입력 탭만 · 손익·급여는 체크해야 보입니다</span></p>
                <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                  {ALL_TABS.map((t) => {
                    const on = inviteTabs.includes(t);
                    const sens = ["인건비","비용","손익분석"].includes(t);
                    return (
                      <button key={t} onClick={() => setInviteTabs((p) => on ? p.filter((x) => x !== t) : [...p, t])}
                        style={{ fontSize:11, padding:"4px 10px", borderRadius:7, border:`1px solid ${on ? (sens ? "#fbbf24" : "#0d9488") : C.border}`, background: on ? (sens ? "rgba(251,191,36,0.15)" : "rgba(13,148,136,0.15)") : "transparent", color: on ? (sens ? "#fbbf24" : "#2dd4bf") : C.textHint, cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>
                        {t}
                      </button>
                    );
                  })}
                </div>
              </div>
              <div style={{ display:"flex", gap:8, marginBottom:14 }}>
                <input value={inviteEmail} onChange={(e) => setInviteEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && sendInvite(st)} placeholder="상대방 구글 이메일" style={{ flex:1, minWidth:0, fontSize:13, padding:"10px 12px", border:"1px solid #1e3448", borderRadius:10, background:"#1a2e42", color:"#f1f5f9", fontFamily:"inherit", outline:"none" }} />
                <button onClick={() => sendInvite(st)} disabled={shareBusy} style={{ padding:"10px 14px", background:"#0d9488", color:"#fff", border:"none", borderRadius:10, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" }}>초대</button>
              </div>
              {grants.length > 0 && (
                <div style={{ marginBottom:12 }}>
                  <p style={{ margin:"0 0 6px", fontSize:11, fontWeight:700, color:C.textSub }}>참여 중</p>
                  {grants.map((g) => {
                    const gt = normTabs(g.tabs);
                    return (
                    <div key={g.id} style={{ padding:"8px 10px", background:"#1a2e42", borderRadius:8, marginBottom:6 }}>
                      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:8 }}>
                        <span style={{ fontSize:12, color:"#f1f5f9", overflow:"hidden", textOverflow:"ellipsis" }}>{g.managerEmail}</span>
                        <button onClick={() => revokeGrant(g.id)} style={{ fontSize:11, color:"#f87171", background:"transparent", border:"1px solid rgba(248,113,113,0.4)", borderRadius:6, padding:"4px 8px", cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" }}>해제</button>
                      </div>
                      <div style={{ display:"flex", gap:5, flexWrap:"wrap", marginTop:6 }}>
                        {ALL_TABS.map((t) => {
                          const on = gt.includes(t);
                          const sens = ["인건비","비용","손익분석"].includes(t);
                          return (
                            <button key={t} onClick={() => setGrantTabs(g.id, on ? gt.filter((x) => x !== t) : [...gt, t])}
                              style={{ fontSize:10, padding:"3px 8px", borderRadius:6, border:`1px solid ${on ? (sens ? "#fbbf24" : "#0d9488") : C.border}`, background: on ? (sens ? "rgba(251,191,36,0.15)" : "rgba(13,148,136,0.15)") : "transparent", color: on ? (sens ? "#fbbf24" : "#2dd4bf") : C.textHint, cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>
                              {t}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                    );
                  })}
                </div>
              )}
              {pending.length > 0 && (
                <div style={{ marginBottom:12 }}>
                  <p style={{ margin:"0 0 6px", fontSize:11, fontWeight:700, color:C.textSub }}>수락 대기</p>
                  {pending.map((em) => (
                    <div key={em} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, padding:"8px 10px", background:"#1a2e42", borderRadius:8, marginBottom:6 }}>
                      <span style={{ fontSize:12, color:C.textSub, overflow:"hidden", textOverflow:"ellipsis" }}>{em}</span>
                      <button onClick={() => cancelInvite(st, em)} style={{ fontSize:11, color:C.textSub, background:"transparent", border:"1px solid #1e3448", borderRadius:6, padding:"4px 8px", cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" }}>취소</button>
                    </div>
                  ))}
                </div>
              )}
              <p style={{ margin:"0 0 14px", fontSize:11, color:C.textHint, lineHeight:1.6 }}>초대받은 사람은 이 앱에 자기 구글 계정으로 로그인하면 초대 카드가 보입니다. 수락하면 열어준 탭만 보이고, 권한은 여기서 언제든 바꾸거나 해제할 수 있습니다.</p>
              <button onClick={() => setShareTarget(null)} style={{ width:"100%", padding:"11px", background:"#1a2e42", border:"1px solid #1e3448", borderRadius:10, fontSize:14, cursor:"pointer", fontFamily:"inherit", color:"#f1f5f9" }}>닫기</button>
            </div>
          </div>
        );
      })()}
      {delConfirm && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:999, padding:"0 20px" }}>
          <div style={{ background:"#112236", borderRadius:16, padding:"24px", maxWidth:320, width:"100%" }}>
            <p style={{ margin:"0 0 8px", fontSize:16, fontWeight:700 }}>매장을 삭제할까요?</p>
            <p style={{ margin:"0 0 20px", fontSize:13, color:C.textSub }}>"{stores.find((s)=>s.id===delConfirm)?.name}" 매장의 모든 데이터가 삭제됩니다.</p>
            <div style={{ display:"flex", gap:8 }}>
              <button onClick={() => deleteStore(delConfirm)} style={{ flex:1, padding:"11px", background:"#ef4444", color:"#fff", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>삭제</button>
              <button onClick={() => setDelConfirm(null)} style={{ flex:1, padding:"11px", background:"#112236", border:"1px solid #1e3448", borderRadius:10, fontSize:14, cursor:"pointer", fontFamily:"inherit" }}>취소</button>
            </div>
          </div>
        </div>
      )}
      <div style={{ marginTop:32, padding:"0 20px 8px", textAlign:"center" }}>
        <span style={{ fontSize:10, color:"#334155" }}>단꿈 손익분석기 {APP_VERSION} · {APP_BUILD}</span>
      </div>
    </div>
  );
}

// ── 메인 앱 ──
// 글로벌 다크 배경 주입
if (typeof document !== 'undefined') {
  document.body.style.background = '#0D1B2A';
  document.body.style.margin = '0';
  document.documentElement.style.background = '#0D1B2A';
  document.documentElement.style.colorScheme = 'dark';

  // 모바일 대응 전역 스타일 (인라인 스타일을 덮어써야 하므로 !important 사용)
  if (!document.getElementById('dg-responsive')) {
    const st = document.createElement('style');
    st.id = 'dg-responsive';
    st.textContent = `
      /* 한글이 글자 단위로 쪼개지는 것을 막는다 */
      body, body * { word-break: keep-all; overflow-wrap: break-word; }
      .dg-num { white-space: nowrap; }
      /* 표는 가로 스크롤로 처리 — 열을 뭉개지 않는다 */
      .dg-t { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; }
      /* 스크롤 표 안에서는 줄바꿈 대신 가로 스크롤로 처리한다 */
      .dg-t table th, .dg-t table td { white-space: nowrap; }
      /* 입력칸이 든 셀은 nowrap 예외 — 편집 중 세로로 쌓여야 한다 */
      .dg-t table td:has(input), .dg-t table td:has(select) { white-space: normal; }
      @media (max-width: 640px) {
        .dg-app { padding-left: 14px !important; padding-right: 14px !important; }
        .dg-t > table { min-width: 460px; }
        .dg-g2 { grid-template-columns: repeat(2, 1fr) !important; }
        .dg-g3, .dg-g4, .dg-g5 { grid-template-columns: repeat(2, 1fr) !important; }
        .dg-gemp { grid-template-columns: repeat(2, 1fr) !important; }
        .dg-nowrap-off { white-space: normal !important; }
        .dg-t > table.dg-emp { min-width: 0; }
        .dg-emp thead { display: none; }
        .dg-emp, .dg-emp tbody { display: block; width: 100%; }
        .dg-emp tr { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); grid-template-areas: "name name name" "base net emp" "act act act"; column-gap: 8px; row-gap: 10px; padding: 14px 2px; }
        .dg-emp tr.dg-emp-edit { grid-template-columns: repeat(2, minmax(0, 1fr)); grid-template-areas: "name name" "base base" "net emp" "act act"; }
        .dg-emp td { display: block; padding: 0 !important; text-align: left !important; white-space: normal !important; }
        .dg-emp td.c-name { grid-area: name; }
        .dg-emp td.c-base { grid-area: base; }
        .dg-emp td.c-net { grid-area: net; }
        .dg-emp td.c-emp { grid-area: emp; }
        .dg-emp td.c-act { grid-area: act; display: flex; flex-wrap: wrap; gap: 6px; align-items: center; }
        .dg-emp td.c-act > button { margin-right: 0 !important; }
        .dg-emp td.c-act > button:last-child { margin-left: auto; }
        .dg-emp tr.dg-emp-edit td.c-act > button:last-child { margin-left: 0; width: 100%; }
        .dg-emp td[data-label]::before { content: attr(data-label); display: block; font-size: 10px; font-weight: 600; color: #64748b; margin-bottom: 3px; }
        .dg-emp tr:not(.dg-emp-edit) td.c-base, .dg-emp td.c-net, .dg-emp td.c-emp { white-space: nowrap !important; }
        .dg-emp tr.dg-emp-edit td.c-base > div { align-items: flex-start !important; }
      }
      @media (max-width: 400px) {
        .dg-g5 { grid-template-columns: 1fr !important; }
      }
    `;
    document.head.appendChild(st);
  }
}

export default function App() {
  const [user, setUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [tab, setTab] = useState("매출");
  const [sga, setSga] = useState(DEFAULT_SGA);
  const [monthlySgaAmounts, setMonthlySgaAmounts] = useState({});
  const [other, setOther] = useState(DEFAULT_OTHER);
  const [monthlyOtherAmounts, setMonthlyOtherAmounts] = useState({});
  const [monthlyCogs, setMonthlyCogs] = useState({});
  const [salesData, setSalesData] = useState({});
  const [deliveryData, setDeliveryData] = useState({});
  const saveTimer = useRef(null);
  const [platforms, setPlatforms] = useState(DEFAULT_PLATFORMS);
  const [monthlyGoal, setMonthlyGoal] = useState({});
  const [vendors, setVendors] = useState(DEFAULT_VENDORS);
  const [dailyExpense, setDailyExpense] = useState({}); // { "2026-08": { 3: { v_food: 340000 } } }
  const [newVendor, setNewVendor] = useState({ name: "", kind: "food" });
  const [editVendor, setEditVendor] = useState(null);
  const [year, setYear] = useState(TODAY.getFullYear());
  const [month, setMonth] = useState(TODAY.getMonth());
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [newSga, setNewSga] = useState({ name:"", amount:"" });
  const [newOther, setNewOther] = useState({ name:"", amount:"" });
  const [newPlatform, setNewPlatform] = useState("");
  const [shopOpen, setShopOpen] = useState({});
  const [vatOpen, setVatOpen] = useState(false);
  const [hideZeroSga, setHideZeroSga] = useState(true);
  // 인건비
  const [monthlyEmployees, setMonthlyEmployees] = useState({});
  const [monthlyOwnerWage, setMonthlyOwnerWage] = useState({});   // { "2026-06": 3000000 }
  const [payDay, setPayDay] = useState(10);
  const [bizInfo, setBizInfo] = useState(DEFAULT_BIZ);
  const [contractEmp, setContractEmp] = useState(null);   // 근로계약서를 열고 있는 직원 id
  const [justAdded, setJustAdded] = useState(null);      // 방금 추가한 직원 — 계약서로 이어가기 안내
  const [copiedId, setCopiedId] = useState(null);        // 계좌번호를 방금 복사한 직원
  // 계좌번호만 복사한다. 은행 이름이 섞이면 이체 앱에 그대로 못 붙인다
  const copyAccount = (no, id) => {
    const txt = String(no || "").trim();
    if (!txt) return;
    const done = () => { setCopiedId(id); setTimeout(() => setCopiedId(null), 1500); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(txt).then(done).catch(() => {});
      return;
    }
    const ta = document.createElement("textarea");
    ta.value = txt; ta.style.position = "fixed"; ta.style.opacity = "0";
    document.body.appendChild(ta); ta.select();
    try { document.execCommand("copy"); done(); } catch {}
    ta.remove();
  };
  const [inventoryItems, setInventoryItems] = useState([]);       // 품목 마스터
  const [monthlyInventory, setMonthlyInventory] = useState({});   // { "2026-08": { qty:{}, amt:{}, skipped, countedAt } }
  const [dailyReports, setDailyReports] = useState({});           // { "2026-09": { 13: {...} } }
  const [newEmployee, setNewEmployee] = useState({ name:"", birth:"", payType:"hourly", hourlyWage:"", totalHours:"", workDays:"", monthlySalary:"", deductionType:"none", holidayPay:false, holidayHours:"", bankName:"", bankAccount:"", phone:"", address:"", email:"", incomeTax:"", incomeTaxManual:false, dependents:1, children:0 });
  const [editingEmployee, setEditingEmployee] = useState(null);
  // 직원 편집은 확인 버튼 없이도 닫힌다 — 행 밖을 누르거나 Esc를 누르면 접힌다
  useEffect(() => {
    if (!editingEmployee) return;
    const onDown = (ev) => { if (!ev.target.closest || !ev.target.closest("[data-emp-edit]")) setEditingEmployee(null); };
    const onKey = (ev) => { if (ev.key === "Escape") setEditingEmployee(null); };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("touchstart", onDown, { passive: true });
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("touchstart", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [editingEmployee]);
  const loadStamp = useRef(0);
  const [conflict, setConflict] = useState(false);
  const [loadError, setLoadError] = useState(false);     // 로드 도중 예외 — 저장 차단
  const [saveLocked, setSaveLocked] = useState(false);   // 저장 연속 실패 — 입력 잠금(새로고침으로만 해제)
  const saveFails = useRef(0);
  const savedBase = useRef(null);   // 서버와 일치하는 마지막 값(로드본 + 저장 성공분) — 이것과 다른 필드만 저장한다
  const loadGen = useRef(0);        // 매장을 (다시) 열 때마다 +1 — 이전 매장에서 걸어 둔 저장이 새 매장에 쓰지 않게
  const loadMeta = useRef({});      // 로드한 원본 문서의 모양(옛 필드 · 이관 대상)
  const reapplyRef = useRef(null);  // 「내 입력 유지」: 서버본을 받은 뒤 다시 얹을 내 변경 필드
  const forceArchiveRef = useRef(false);   // 되돌리기 후 첫 저장은 직전 버전을 반드시 보관

  const [toolAccess, setToolAccess] = useState(null);
  const [adminOpen, setAdminOpen] = useState(false);
  const [accessReady, setAccessReady] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (u) {
        setAccessReady(false);
        const a = await checkToolAccess(u.email, u.uid);
        recordLogin(u, a);
        setToolAccess(a);
        setAccessReady(true);
      } else {
        setToolAccess(null);
        setAccessReady(true);
      }
      setAuthReady(true);
    });
    return unsub;
  }, []);

  async function refreshToolAccess() {
    if (!user) return;
    const a = await checkToolAccess(user.email, user.uid);
    setToolAccess(a);
  }

  useEffect(() => {
    if (!user || !selectedStore) return;
    const gen = ++loadGen.current;
    let alive = true;
    const setters = {
      sga: setSga, monthlySgaAmounts: setMonthlySgaAmounts, other: setOther, monthlyOtherAmounts: setMonthlyOtherAmounts,
      monthlyCogs: setMonthlyCogs, salesData: setSalesData, deliveryData: setDeliveryData, platforms: setPlatforms,
      monthlyGoal: setMonthlyGoal, monthlyEmployees: setMonthlyEmployees, monthlyOwnerWage: setMonthlyOwnerWage,
      vendors: setVendors, dailyExpense: setDailyExpense, payDay: setPayDay, inventoryItems: setInventoryItems,
      monthlyInventory: setMonthlyInventory, dailyReports: setDailyReports, bizInfo: setBizInfo,
    };
    const put = (vals) => Object.keys(vals).forEach((k) => { if (setters[k]) setters[k](vals[k]); });
    const pending = reapplyRef.current;   // 비우는 건 로드가 끝난 뒤(StrictMode 이중 실행에도 남도록)
    setLoaded(false);
    setConflict(false);
    setLoadError(false);
    loadStamp.current = 0;
    savedBase.current = null;
    loadMeta.current = {};
    if (saveTimer.current) clearTimeout(saveTimer.current);
    const blank = normalizeStoreData(null);
    put(blank);
    async function load() {
      try {
        const dataOwner = selectedStore.ownerUid || user.uid;
        const snap = await getDoc(doc(db, "users", dataOwner, "stores", selectedStore.id, "data", "main"));
        if (!alive) return;
        reapplyRef.current = null;
        let base = blank;
        let stamp = 0;
        let meta = {};
        if (snap.exists()) {
          const d = snap.data();
          const n = normalizeStoreData(d);
          base = {};
          STORE_FIELDS.forEach((k) => { base[k] = n[k]; });
          stamp = d.savedAt || 0;
          meta = {
            exists: true,
            legacyEmployees: d.employees !== undefined,
            sgaVendorMigrated: Array.isArray(d.vendors) && d.vendors.some((v) => v && v.kind === "sga"),
          };
        }
        // 모든 필드 반영이 끝난 뒤에 기준값·stamp 를 세팅한다 (중간 예외면 저장 기준이 생기지 않는다)
        put(base);
        savedBase.current = base;
        loadMeta.current = meta;
        loadStamp.current = stamp;
        if (pending) put(pending);   // 「내 입력 유지」 — 서버본 위에 내 변경 필드만 다시 얹는다(바뀐 필드라 자동저장된다)
      } catch (err) {
        if (!alive) return;
        console.error("[손익분석기] 매장 데이터를 불러오지 못했습니다", err);
        setLoadError(true);
        if (pending) put(pending);   // 저장은 막히지만 화면의 내 입력은 남긴다
      }
      if (alive && gen === loadGen.current) setLoaded(true);
    }
    load();
    return () => { alive = false; };
  }, [user, selectedStore]);

  // data: STORE_FIELDS 값 · gen: 이 값을 만든 로드 세대
  const save = useCallback(async (data, summary, gen) => {
    if (!user || !selectedStore) return;
    if (loadError || saveLocked) return;                   // 로드 실패 · 잠금 — 쓰지 않는다
    if (gen !== loadGen.current || !savedBase.current) return;   // 다른 매장(또는 다시 연 매장)의 값
    const base = savedBase.current;
    const meta = loadMeta.current;
    // 마지막 저장본과 달라진 최상위 필드만
    let keys = STORE_FIELDS.filter((k) => !sameVal(data[k], base[k]));
    if (!keys.length) return;
    if (meta.sgaVendorMigrated && keys.some((k) => SGA_VENDOR_GROUP.includes(k))) {
      keys = [...new Set([...keys, ...SGA_VENDOR_GROUP])];
    }
    if (selectedStore.shared) {
      const allowed = fieldsForTabs(normTabs(selectedStore.tabs));
      let blocked = keys.filter((k) => !allowed.has(k));
      // 거래처 이관 묶음은 전부 쓰거나 전부 안 쓴다
      if (meta.sgaVendorMigrated && SGA_VENDOR_GROUP.some((k) => blocked.includes(k))) {
        blocked = [...new Set([...blocked, ...SGA_VENDOR_GROUP.filter((k) => keys.includes(k))])];
      }
      if (blocked.length) console.warn("[손익분석기] 공유 권한 밖 필드는 저장하지 않습니다:", blocked.join(", "));
      keys = keys.filter((k) => !blocked.includes(k));
      if (!keys.length) return;
    }
    const payload = {};
    keys.forEach((k) => { payload[k] = data[k]; });
    if (keys.includes("monthlyEmployees") && meta.legacyEmployees) payload.employees = deleteField();
    setSaving(true);
    setSaveError(false);
    let committed = 0;
    let archived = false;
    const force = forceArchiveRef.current;   // 되돌리기 직후 저장 — 같은 세션이어도 덮이는 버전을 보관
    try {
      const dataOwner = selectedStore.ownerUid || user.uid;
      const ref = doc(db,"users",dataOwner,"stores",selectedStore.id,"data","main");
      await runTransaction(db, async (tx) => {
        const cur = await tx.get(ref);
        const remoteStamp = cur.exists() ? (cur.data().savedAt || 0) : 0;
        if (remoteStamp > loadStamp.current) {
          const e = new Error("conflict"); e.isConflict = true; throw e;
        }
        const stamp = Date.now();
        // 저장 직전 버전 보관 — 덮어쓰기 전 서버본을 data/main/history/{그 버전의 savedAt} 에(같은 트랜잭션).
        // 공유 세션은 자기 허용 탭 필드만 보관한다(규칙: 공유자는 허용 탭 필드 create 만)
        let archiveRef = null;
        let archive = null;
        if (cur.exists()) {
          const prev = cur.data();
          const prevAt = Number(prev.savedAt) || 0;
          const sameRun = prev.clientId === CLIENT_ID && stamp - prevAt < HISTORY_MIN_GAP;
          if (!sameRun || force) {
            archiveRef = doc(ref, "history", String(prevAt));
            const had = await tx.get(archiveRef);   // 트랜잭션 읽기는 쓰기보다 먼저
            if (!had.exists()) {
              if (selectedStore.shared) {
                const ok = fieldsForTabs(normTabs(selectedStore.tabs));
                archive = {};
                Object.keys(prev).forEach((k) => { if (ok.has(k)) archive[k] = prev[k]; });
                if (!STORE_FIELDS.some((k) => k in archive)) archive = null;   // 보관할 내 탭 데이터가 없다
              } else {
                archive = { ...prev };
              }
              if (archive) {
                ["savedBy", "appVersion", "clientId"].forEach((k) => { if (prev[k] !== undefined) archive[k] = prev[k]; });
                archive.savedAt = prevAt;
                archive.archivedAt = stamp;
                archive.archivedBy = user.email || "";
              }
            }
          }
        }
        const fields = { ...payload, savedAt: stamp, savedBy: user.email || "", appVersion: APP_VERSION, clientId: CLIENT_ID };
        if (archive) tx.set(archiveRef, archive);
        // 문서가 있으면 바뀐 필드만 update(나머지 필드는 그대로) · 없으면 새로 만든다
        if (cur.exists()) tx.update(ref, fields);
        else {
          delete fields.employees;
          tx.set(ref, fields);
        }
        if (summary) {
          // 달별 요약 — 보고 있는 달과 그 전달(손익분석 탭의 전월 값). 매장 카드가 「정산 완료된 가장 최근 달」을 고른다
          const monthSum = (rev, net, extra) => ({ totalRev: Math.round(rev || 0), netProfit: Math.round(net || 0), updatedAt: stamp, ...extra });
          const summaries = { [summary.mk]: monthSum(summary.totalRev, summary.netProfit, summary.ongoingRev != null ? { ongoingRev: Math.round(summary.ongoingRev) } : {}) };
          if (summary.prevMk && (summary.prevTotalRev || 0) > 0) summaries[summary.prevMk] = monthSum(summary.prevTotalRev, summary.prevNetProfit);
          tx.set(doc(db,"users",dataOwner,"stores",selectedStore.id), {
            summary: {
              mk: summary.mk,
              totalRev: Math.round(summary.totalRev || 0),
              netProfit: Math.round(summary.netProfit || 0),
              updatedAt: stamp,
              updatedBy: user.email || "",
            },
            summaries,
          }, { merge: true });
        }
        committed = stamp;
        archived = !!archive;
      });
      // 커밋된 뒤에만 기준을 옮긴다 — 보낸 필드는 이제 서버와 같다
      if (gen === loadGen.current) {
        loadStamp.current = committed;
        savedBase.current = { ...savedBase.current, ...Object.fromEntries(keys.map((k) => [k, data[k]])) };
      }
      saveFails.current = 0;
      if (force) forceArchiveRef.current = false;
      // 보관본은 최근 HISTORY_KEEP 개만 — 삭제는 소유자만 할 수 있다(규칙). 실패해도 저장은 끝난 것
      if (archived && !selectedStore.shared) {
        try {
          const hs = await getDocs(query(collection(ref, "history"), orderBy("savedAt", "desc")));
          await Promise.all(hs.docs.slice(HISTORY_KEEP).map((d) => deleteDoc(d.ref)));
        } catch (e) { console.warn("[손익분석기] 이전 보관본 정리 실패", e); }
      }
    } catch (err) {
      if (err && err.isConflict) setConflict(true);
      else {
        console.error("[손익분석기] 저장 실패", err && err.code, err);
        setSaveError(true);
        saveFails.current += 1;
        if (saveFails.current > SAVE_FAIL_LIMIT) setSaveLocked(true);
      }
    }
    setTimeout(() => setSaving(false), 800);
  }, [user, selectedStore, loadError, saveLocked]);

  // 저장 시점에 필요한 값 중 자주 바뀌는 것(월·요약·save 함수)은 ref로 넘긴다.
  // 의존성 배열에 넣으면 달을 넘길 때마다 저장이 걸려 매장 요약이 0으로 덮인다.
  // 로드·탭 전환·포커스 복귀는 데이터 상태를 바꾸지 않는다 → save() 의 diff 가 0 이면 쓰기 없이 끝난다(열기만으로 저장 안 함)
  const saveMetaRef = useRef({});
  const saveQueue = useRef(Promise.resolve());   // 저장은 한 번에 하나씩 — 앞 저장의 stamp·기준값이 반영된 뒤 다음 diff
  useEffect(() => {
    if (!loaded || conflict || loadError || saveLocked) return;
    if (saveTimer.current) clearTimeout(saveTimer.current);
    const snapshot = { sga, monthlySgaAmounts, other, monthlyOtherAmounts, monthlyCogs, salesData, deliveryData, platforms, monthlyGoal, monthlyEmployees, monthlyOwnerWage, vendors, dailyExpense, payDay, inventoryItems, monthlyInventory, dailyReports, bizInfo };
    const gen = loadGen.current;
    saveTimer.current = setTimeout(() => {
      saveQueue.current = saveQueue.current.then(() => {
        const m = saveMetaRef.current;
        return m.save(snapshot, { mk: m.mk, totalRev: m.totalRev, netProfit: m.netProfit, ongoingRev: m.ongoingRev, prevMk: m.prevMk, prevTotalRev: m.prevTotalRev, prevNetProfit: m.prevNetProfit }, gen);
      }).catch(() => {});
    }, 1500);
  }, [sga, monthlySgaAmounts, other, monthlyOtherAmounts, monthlyCogs, salesData, deliveryData, platforms, monthlyGoal, monthlyEmployees, monthlyOwnerWage, vendors, dailyExpense, payDay, inventoryItems, monthlyInventory, dailyReports, bizInfo, loaded, conflict, loadError, saveLocked]);

  // 저장 잠금 — 입력칸에 포커스가 가지 않게 막는다(해제는 새로고침)
  useEffect(() => {
    if (!saveLocked) return;
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    const onFocus = (ev) => {
      const t = ev.target;
      if (t && t.closest && t.closest("[data-save-lock]")) return;
      if (t && t.blur) t.blur();
    };
    document.addEventListener("focusin", onFocus, true);
    return () => document.removeEventListener("focusin", onFocus, true);
  }, [saveLocked]);

  const mk = `${year}-${String(month+1).padStart(2,"0")}`;
  const prevMk = month===0 ? `${year-1}-12` : `${year}-${String(month).padStart(2,"0")}`;
  // 사장님 인건비 — 이 달 값(없으면 최근 입력값 승계) · 전월 값 · 이 달에 쓰는 setter
  const ownerWage = ownerWageAt(monthlyOwnerWage, mk);
  const prevOwnerWage = ownerWageAt(monthlyOwnerWage, prevMk);
  const ownerWageExplicit = monthlyOwnerWage[mk] !== undefined && monthlyOwnerWage[mk] !== null;
  const setOwnerWage = (v) => setMonthlyOwnerWage((p) => ({ ...p, [mk]: Math.max(0, Number(v) || 0) }));

  if (!authReady) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"100vh", background:"#0D1B2A", fontFamily:"'Noto Sans KR', sans-serif" }}><p style={{ color:C.textHint }}>불러오는 중...</p></div>;
  if (!user) return <LoginScreen />;
  if (!accessReady) return <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"100vh", background:"#0D1B2A", fontFamily:"'Noto Sans KR', sans-serif" }}><p style={{ color:"#8ba3b8" }}>이용권 확인 중...</p></div>;
  if (!toolAccess || !toolAccess.allowed) return <ToolAccessGate user={user} access={toolAccess} onRedeemed={refreshToolAccess} />;
  if (adminOpen && toolAccess && toolAccess.isAdmin) return <AdminMembersScreen onBack={() => setAdminOpen(false)} />;
  if (!selectedStore) return <StoreSelectScreen user={user} viaShare={!!(toolAccess && toolAccess.viaShare)} access={toolAccess} onRedeemed={refreshToolAccess} onAdmin={() => setAdminOpen(true)} onSelect={(s, tabName) => { const allowed = s.shared ? normTabs(s.tabs) : ALL_TABS; setSelectedStore(s); setLoaded(false); setTab(allowed.includes(tabName) ? tabName : allowed[0]); }} />;

  const storeColor = STORE_COLORS.find((c) => c.id === selectedStore.color)?.hex || "#0d9488";
  // 공유받은 매장이면 사장님이 열어준 탭만 · 내 매장이면 전부
  const allowedTabs = selectedStore.shared ? normTabs(selectedStore.tabs) : ALL_TABS;
  const canSee = (t) => allowedTabs.includes(t);
  if (!canSee(tab) && allowedTabs.length) setTab(allowedTabs[0]);

  // 현재 월 직원 목록
  const employees = monthlyEmployees[mk] || [];
  const days = getDays(year, month);
  const daySales = salesData[mk] || {};
  const prevDaySales = salesData[prevMk] || {};
  const prevCogsRaw = monthlyCogs[prevMk] || {};
  const cogsRaw = monthlyCogs[mk] || {};
  // 기초·기말재고는 재고조사 결과와 전월 승계를 반영해 계산한다 (저장값은 직접 입력한 달에만 쓰임)
  const stockThis = resolveStock(monthlyCogs, monthlyInventory, inventoryItems, mk);
  const stockPrev = resolveStock(monthlyCogs, monthlyInventory, inventoryItems, prevMk);
  const prevCogs = { ...prevCogsRaw, begin: stockPrev.begin, end: stockPrev.end };
  const cogs = {
    begin: stockThis.begin,
    purchase: cogsRaw.purchase || 0,
    end: stockThis.end,
    other: cogsRaw.other || 0,
    taxfree: cogsRaw.taxfree || 0,
    cardSales: cogsRaw.cardSales || 0,
  };

  // sga 월별 금액 헬퍼
  const getSgaAmt = (item, monthKey) => {
    if (monthKey === mk) return monthlySgaAmounts[mk]?.[item.id] ?? item.amount;
    return monthlySgaAmounts[monthKey]?.[item.id] ?? item.amount;
  };
  const setCurrSgaAmt = (id, amount) => {
    setMonthlySgaAmounts(prev => ({ ...prev, [mk]: { ...(prev[mk]||{}), [id]: amount } }));
    setSga(prev => prev.map(x => x.id===id ? { ...x, amount } : x));
  };

  // other 월별 금액 헬퍼
  const getOtherAmt = (item, monthKey) => {
    if (monthKey === mk) return monthlyOtherAmounts[mk]?.[item.id] ?? item.amount;
    return monthlyOtherAmounts[monthKey]?.[item.id];
  };
  const setCurrOtherAmt = (id, amount) => {
    setMonthlyOtherAmounts(prev => ({ ...prev, [mk]: { ...(prev[mk]||{}), [id]: amount } }));
    setOther(prev => prev.map(x => x.id===id ? { ...x, amount } : x));
  };

  // 매출 · 비용 합계 — 매장별 비교 보기와 같은 함수(calcMonthPnl)
  const storeData = { sga, monthlySgaAmounts, other, monthlyOtherAmounts, monthlyCogs, salesData, deliveryData, platforms, monthlyEmployees, monthlyOwnerWage, vendors, dailyExpense, inventoryItems, monthlyInventory };
  const pnl = calcMonthPnl(storeData, mk, true);
  const prevPnl = calcMonthPnl(storeData, prevMk, false);
  const rev = pnl.rev;
  const prevRev = prevPnl.rev;

  // 일별 마감 집계
  const dailyExpMonth = dailyExpense[mk] || {}; // 비용 탭 거래처 칸(입력 화면용 원자료)
  const dailyExpByVendor = pnl.dailyExpByVendor;
  const dailyExpSum = pnl.dailyExpSum;
  // 식자재·주류음료 거래처별 집계
  const foodItemRows = Object.entries(dailyExpByVendor)
    .filter(([vid, a]) => {
      const v = vendors.find((x) => x.id === vid);
      return a > 0 && v && (v.kind === "food" || v.kind === "drink");
    })
    .map(([vid, a]) => [(vendors.find((x) => x.id === vid) || {}).name || "기타", a])
    .sort((a, b) => b[1] - a[1]);
  // 판관비성 지출처별 집계

  // 배달
  const delivMonthData = deliveryData[mk] || {};
  const prevDelivData = deliveryData[prevMk] || {};
  // 배달 매출은 배달 탭 월 입력(세금계산서·정산 기준)만 사용한다
  const platRevenue = (pid) => delivMonthData[pid]?.revenue || 0;
  const totalDelivRevenue = pnl.delivRevenue;
  const totalDelivFee = pnl.delivFee;
  const totalDelivAd = pnl.delivAd;
  const totalDelivAgency = pnl.delivAgency;
  const totalDelivAdj = pnl.delivAdj;
  const totalDelivDisc = pnl.delivDisc;
  const totalDelivCost = pnl.delivCost;
  const totalDelivNet = totalDelivRevenue - totalDelivCost;
  const prevDelivRevenue = prevPnl.delivRevenue;

  // ── 샵인샵 진단 (배민 요율 기반 배분) ──

  const hallRev = rev.food;
  // 일일 보고 → 홀 매출·현금지출 반영. 저장값(salesData·dailyExpense)에 쓰므로 대시보드·차트·손익이 같은 숫자를 본다
  const dailyThis = dailyReports[mk];
  const dailyHallOn = !!(dailyThis && dailyThis.useHall !== false && Object.keys(dailyThis.days || {}).length > 0);
  const syncDailyHall = (k, sum) => setSalesData((prev) => ({ ...prev, [k]: { 0: { food: Math.round(sum) } } }));
  const syncDailyCash = (k, sum) => {
    // "현장 현금지출" 판관비 항목이 없으면 만들고, 그 달 금액을 넣는다
    setSga((p) => p.some((x) => x.id === CASH_SGA_ID || (x.name || "").replace(/\s/g, "") === "현장현금지출") ? p : [...p, { id: CASH_SGA_ID, name: "현장 현금지출", amount: 0 }]);
    setMonthlySgaAmounts((prev) => {
      const cur = { ...(prev[k] || {}) };
      const target = (sga.find((x) => (x.name || "").replace(/\s/g, "") === "현장현금지출") || { id: CASH_SGA_ID }).id;
      cur[target] = Math.round(sum);
      return { ...prev, [k]: cur };
    });
  };
  // 일일 보고의 플랫폼별 건수 합 (배달 탭 주문건수 힌트용)
  const dailyPlatCnt = (plat) => {
    const dm = (dailyThis && dailyThis.days) || {};
    const pid = ["baemin","coupang","yogiyo"].includes(plat.id) ? plat.id
      : /땡겨/.test(plat.name || "") ? "ddangyo" : /요기요/.test(plat.name || "") ? "yogiyo" : /쿠팡/.test(plat.name || "") ? "coupang" : /배민/.test(plat.name || "") ? "baemin" : null;
    return pid ? drPlatSum(dm, pid) : 0;
  };
  const totalRev = pnl.totalRev;
  const prevTotalRev = prevPnl.totalRev;

  const cogsFood = pnl.cogsFood;
  const cogsOther = pnl.cogsOther;
  const totalCogs = pnl.totalCogs;
  // 전월 — 이번달과 같은 함수(보고 있지 않은 달)
  const prevExpSum = prevPnl.dailyExpSum;
  const prevCogsFood = prevPnl.cogsFood;
  const prevTotalCogs = prevPnl.totalCogs;

  // 인건비
  const totalEmployeeCost = pnl.employeeCost;
  const totalLaborCost = pnl.laborCost;

  // 판관비 합계
  const totalSga = pnl.totalSga;

  const opProfit = pnl.opProfit;
  const totalOther = pnl.totalOther;
  const netProfit = pnl.netProfit;
  // 전월비: 전월의 판관비·기타비용·인건비 기준으로 계산 (이번달 값 사용 금지)
  const prevMonthEmployees = monthlyEmployees[prevMk] || []; // 손익계산서 전월 열(직원 인건비)
  const prevLaborCost = prevPnl.laborCost;
  const prevTotalSga = prevPnl.totalSga;
  const prevTotalOther = prevPnl.totalOther;
  const prevTotalDelivCost = prevPnl.delivCost;
  const prevOpProfit = prevPnl.opProfit;
  const prevNetProfit = prevPnl.netProfit;

  // ── 순이익 증감 원인 분해 ──
  // 순이익 = 매출 − 매출원가 − 판관비 − 배달비용 − 기타비용 이므로
  // 증감분도 다섯 항목의 기여도로 정확히 쪼개진다 (합계가 반드시 일치한다)
  const netDelta = netProfit - prevNetProfit;
  const netDeltaParts = [
    { key:"rev",   label:"매출",     effect: totalRev - prevTotalRev,             cur: totalRev,        prev: prevTotalRev },
    { key:"cogs",  label:"매출원가", effect: -(totalCogs - prevTotalCogs),        cur: totalCogs,       prev: prevTotalCogs },
    { key:"sga",   label:"판관비",   effect: -(totalSga - prevTotalSga),          cur: totalSga,        prev: prevTotalSga },
    { key:"deliv", label:"배달비용", effect: -(totalDelivCost - prevTotalDelivCost), cur: totalDelivCost, prev: prevTotalDelivCost },
    { key:"other", label:"기타비용", effect: -(totalOther - prevTotalOther),      cur: totalOther,      prev: prevTotalOther },
  ].filter(p => Math.round(p.effect) !== 0)
   .sort((a,b) => Math.abs(b.effect) - Math.abs(a.effect));
  const hasPrevMonth = prevTotalRev > 0;

  // ── 손익분기점 ──
  // 변동비 = 식자재비 + 배달비용. 배달 수수료·광고·할인은 매출에 붙어 나가는 변동비다.
  // 고정비로 취급하면 배달 비중이 높을수록 BEP가 실제보다 크게(15~20%) 나온다.
  const varRate = totalRev > 0 ? (totalCogs + totalDelivCost) / totalRev : 0;
  const fixedCost = totalSga + totalOther;
  const bep = varRate < 1 ? fixedCost / (1 - varRate) : Infinity;
  // 목표 순이익 역산: 필요매출 = (고정비 + 목표순이익) ÷ (1 − 변동비율)
  const revForProfit = (target) => varRate < 1 ? (fixedCost + target) / (1 - varRate) : Infinity;
  // 월 단위 입력이므로 일평균은 월 매출 ÷ 해당 월 일수
  const avgDailyHall = hallRev>0 ? hallRev/days : 0;
  const avgDailyDeliv = totalDelivRevenue>0 ? totalDelivRevenue/days : 0;
  // 전월 지표 — 손익분기점·일평균은 전월 일수 기준으로 따로 계산한다
  const prevDays = getDays(month===0 ? year-1 : year, month===0 ? 11 : month-1);
  const prevVarRate = prevTotalRev > 0 ? (prevTotalCogs+prevTotalDelivCost)/prevTotalRev : 0;
  const prevBep = (prevTotalRev > 0 && prevVarRate < 1) ? (prevTotalSga+prevTotalOther)/(1-prevVarRate) : null;
  const prevAvgDailyHall = prevRev.food>0 ? prevRev.food/prevDays : 0;
  const prevAvgDailyDeliv = prevDelivRevenue>0 ? prevDelivRevenue/prevDays : 0;
  const goal = monthlyGoal[mk]||0;
  // 그날 배달 합계 (마감 탭 입력 우선, 없으면 옛 drink 필드)
  function setCogs(key, val) {
    setMonthlyCogs(prev => ({ ...prev, [mk]:{...(prev[mk]||{}), [key]:Math.max(0,Number(val)||0)} }));
  }
  function setSgaVat(id, v) { setSga(prev => prev.map(x => x.id===id ? { ...x, vat: !!v } : x)); }
  function updateSga(id, field, val) {
    if (field === "amount") {
      setMonthlySgaAmounts(prev => ({ ...prev, [mk]: { ...(prev[mk]||{}), [id]: Math.max(0,Number(val)||0) } }));
    } else {
      setSga(prev => prev.map(x => x.id===id ? { ...x, [field]:val } : x));
    }
  }
  function setDelivField(platId, field, val) {
    setDeliveryData(prev => ({ ...prev, [mk]:{ ...(prev[mk]||{}), [platId]:{...(prev[mk]?.[platId]||{}), [field]:Math.max(0,Number(val)||0)} } }));
  }
  function addPlatform() {
    if (!newPlatform.trim()) return;
    const colors = ["#cf6a62","#cc8a4e","#c9b055","#5fb87f","#45b09b","#5f96c4","#9a72b3","#cb5f80","#3fa8b8","#93b56f","#d17a5e","#75868f"];
    const nm = newPlatform.trim();
    // 이름으로 아는 브랜드면 그 색, 아니면 팔레트에서 아직 안 쓴 색
    const known = NAME_BRAND.find(([re]) => re.test(nm.replace(/\s/g, "")));
    const used = new Set(platforms.map(x => x.color));
    const pick = colors.find(c => !used.has(c)) || colors[Math.floor(Math.random() * colors.length)];
    setPlatforms(p => [...p, { id:`plat_${Date.now()}`, name:nm, fixed:false, color: known ? known[1] : pick }]);
    setNewPlatform("");
  }
  function deletePlatform(id) {
    // 어느 달이든 입력된 데이터가 있으면 확인을 받는다 — 삭제하면 ① 매출에서도 그 금액이 빠진다
    const hasData = Object.values(deliveryData).some(m2 => {
      const pd2 = (m2 || {})[id];
      return pd2 && ((pd2.revenue||0)>0 || (pd2.fee||0)>0 || (pd2.ad||0)>0 || (pd2.agency||0)>0 || (pd2.disc||0)>0 || (pd2.shops||[]).length>0);
    });
    const nm = (platforms.find(x=>x.id===id)||{}).name || "이 플랫폼";
    if (hasData && !window.confirm(`"${nm}"에 입력된 모든 달의 데이터가 함께 삭제됩니다.\n매출과 손익에서도 빠집니다. 계속할까요?`)) return;
    setPlatforms(p => p.filter(x => x.id!==id));
    setDeliveryData(prev => {
      const next = {};
      Object.entries(prev).forEach(([mkKey, byPlat]) => {
        const cp = { ...byPlat };
        delete cp[id];
        next[mkKey] = cp;
      });
      return next;
    });
  }
  function renamePlatform(id, name) {
    setPlatforms(p => p.map(x => {
      if (x.id !== id) return x;
      const nx = { ...x, name };
      const known = NAME_BRAND.find(([re]) => re.test((name || "").replace(/\s/g, "")));
      return known ? { ...nx, color: known[1] } : nx;
    }));
  }

  // ── 샵인샵 (플랫폼별) ──
  const EMPTY_SHOP = { name:"", bm:0, bmc:0, gd:0, gdc:0, pk:0, pkc:0, dc1:0, dc2:0, dc3:0, ad:0 };
  function updShops(platId, fn) {
    setDeliveryData(prev => {
      const cur = prev[mk] || {};
      const pdCur = cur[platId] || {};
      return { ...prev, [mk]: { ...cur, [platId]: { ...pdCur, shops: fn(pdCur.shops || []) } } };
    });
  }
  function setShopField(platId, i, field, val) {
    updShops(platId, arr => {
      const next = [...arr];
      next[i] = { ...(next[i]||{}), [field]: field==="name" ? val : Math.max(0, Number(val)||0) };
      return next;
    });
  }
  function addShop(platId) {
    updShops(platId, arr => [...arr, { ...EMPTY_SHOP }]);
    setShopOpen(o => ({ ...o, [platId]: true }));
  }
  function deleteShop(platId, i) {
    updShops(platId, arr => arr.filter((_,j)=>j!==i));
  }
  function copyPrevShops(platId) {
    const src = ((prevDelivData[platId]||{}).shops || []).filter(x => (x.name||"").trim());
    if (!src.length) return;
    updShops(platId, arr => arr.length ? arr : src.map(x => ({ ...EMPTY_SHOP, name:x.name })));
    setShopOpen(o => ({ ...o, [platId]: true }));
  }

  // 가장 가까운 과거 달의 직원 명단 찾기 (최대 12개월)
  const findPrevEmployees = () => {
    let y = year, m = month;
    for (let i = 0; i < 12; i++) {
      m -= 1; if (m < 0) { m = 11; y -= 1; }
      const k = `${y}-${String(m+1).padStart(2,"0")}`;
      const list = monthlyEmployees[k];
      if (list && list.length > 0) return { key: k, list };
    }
    return null;
  };
  const copyPrevEmployees = () => {
    const found = findPrevEmployees();
    if (!found) return [];
    return found.list.map(e => ({ ...e, id: `emp_${Date.now()}_${Math.random().toString(36).substr(2,5)}` }));
  };

  // 직원 함수
  function addEmployee() {
    const { name, birth, payType, hourlyWage, totalHours, workDays, monthlySalary, deductionType, holidayPay, holidayHours, bankName, bankAccount, phone, address, email, incomeTax, incomeTaxManual, dependents, children } = newEmployee;
    if (!name.trim()) return;
    if (payType==="hourly" && (!hourlyWage || !totalHours)) return;
    if (payType==="monthly" && !monthlySalary) return;
    const emp = { id:`emp_${Date.now()}`, name:name.trim(), payType, hourlyWage:Math.max(0,Number(hourlyWage)||0), totalHours:Math.max(0,Number(totalHours)||0), workDays:Math.max(0,Number(workDays)||0), monthlySalary:Math.max(0,Number(monthlySalary)||0), deductionType, holidayPay: payType==="hourly" ? !!holidayPay : false, holidayHours: payType==="hourly" && holidayPay ? Math.max(0,Number(holidayHours)||0) : 0, bankName:(bankName||"").trim(), bankAccount:(bankAccount||"").trim(), phone:(phone||"").trim(), address:(address||"").trim(), email:(email||"").trim(), birth:(birth||"").trim(), incomeTax:Math.max(0,Number(incomeTax)||0), incomeTaxManual:!!incomeTaxManual, dependents:Math.max(1,Number(dependents)||1), children:Math.max(0,Number(children)||0) };
    const seeded = monthlyEmployees[mk] === undefined ? copyPrevEmployees() : null;
    setMonthlyEmployees(prev => {
      const cur = prev[mk] !== undefined ? prev[mk] : (seeded || []);
      return {...prev, [mk]: [...cur, emp]};
    });
    setJustAdded(emp.id);
    setNewEmployee({ name:"", birth:"", payType:"hourly", hourlyWage:"", totalHours:"", workDays:"", monthlySalary:"", deductionType:"none", holidayPay:false, holidayHours:"", bankName:"", bankAccount:"", phone:"", address:"", email:"", incomeTax:"", incomeTaxManual:false, dependents:1, children:0 });
  }
  function deleteEmployee(id) {
    setMonthlyEmployees(prev => ({...prev, [mk]: (prev[mk]||[]).filter(e => e.id!==id)}));
  }
  function updateEmployee(id, field, val) {
    setMonthlyEmployees(prev => ({...prev, [mk]: (prev[mk]||[]).map(e => e.id===id ? { ...e, [field]:["name","payType","deductionType","birth","bankName","bankAccount","phone","email","address","cStart","cEnd","cPlace","cJob","cDays","cTime","cRest","cType","cProb","sigOwner","sigEmp","signedAt"].includes(field)?val:(["holidayPay","incomeTaxManual"].includes(field)?!!val:(field==="holidayHours"?(val===""?"":Math.max(0,Number(val)||0)):Math.max(0,Number(val)||0))) } : e)}));
  }

  // 일별 마감 입력 함수
  function setDailyExpVal(day, vendorId, val) {
    setDailyExpense(prev => ({ ...prev, [mk]: { ...(prev[mk]||{}), [day]: { ...((prev[mk]||{})[day]||{}), [vendorId]: Math.max(0, Number(val)||0) } } }));
  }
  function addVendor() {
    if (!newVendor.name.trim()) return;
    setVendors(p => [...p, { id: `v_${Date.now()}`, name: newVendor.name.trim(), kind: newVendor.kind }]);
    setNewVendor({ name: "", kind: "food" });
  }
  function updateVendor(id, field, val) {
    setVendors(p => p.map(v => v.id === id ? { ...v, [field]: val } : v));
  }
  function deleteVendor(id) {
    setVendors(p => p.filter(v => v.id !== id));
    setDailyExpense(prev => {
      const next = { ...prev };
      Object.keys(next).forEach(k => {
        const days = { ...next[k] };
        Object.keys(days).forEach(dd2 => { if (days[dd2] && days[dd2][id] !== undefined) { days[dd2] = { ...days[dd2] }; delete days[dd2][id]; } });
        next[k] = days;
      });
      return next;
    });
  }

  const pC = (v) => v>=0 ? C.profit : C.loss;

  // 판관비에서 이번달·전월 모두 0원인 항목 수 · 접기 버튼 (표 위아래 양쪽에 쓴다)
  const zeroSgaCount = sga.filter(c => c.name!=="인건비" && (getSgaAmt(c,mk)??0)===0 && (getSgaAmt(c,prevMk)??0)===0).length;
  const zeroToggle = (pos) => zeroSgaCount===0 ? null : (
    <div style={{ display:"flex", justifyContent:"flex-end", marginBottom: pos==="top"?8:0, marginTop: pos==="top"?0:10 }}>
      <button onClick={()=>setHideZeroSga(v=>!v)} style={{ ...ADD_BTN, fontSize:11, padding:"5px 11px" }}>
        {hideZeroSga
          ? `안 쓰는 항목 ${zeroSgaCount}개 펼치기 ▾`
          : `안 쓰는 항목 ${zeroSgaCount}개 접기 ▴`}
      </button>
    </div>
  );

  // ===== 데이터 가져오기 / 내보내기 =====
  const IE_BTN = (clr) => ({
    flex: "1 1 auto",
    minWidth: 120,
    padding: "10px 14px",
    background: `${clr}18`,
    border: `1px solid ${clr}55`,
    borderRadius: 10,
    color: clr,
    fontSize: 12,
    fontWeight: 700,
    cursor: "pointer",
    fontFamily: "inherit",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
  });
  const downloadJson = (obj, filename) => {
    const blob = new Blob([JSON.stringify(obj, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  // 엑셀(CSV) 내보내기 — 손익계산서 한 장
  const exportCsv = () => {
    const safeName = (selectedStore.name || "매장").replace(/[\\/:*?"<>|]/g, "_");
    const q = (v) => {
      const t = String(v ?? "");
      return /[",\n]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t;
    };
    const rows = [];
    rows.push([`${selectedStore.name} 손익계산서`, `${year}년 ${MONTHS[month]}`]);
    rows.push([]);
    rows.push(["구분", "항목", "금액(원)", "매출 대비"]);
    rows.push(["매출", "홀 매출", Math.round(hallRev), pct(hallRev, totalRev)]);
    rows.push(["매출", "배달 플랫폼 주문금액", Math.round(totalDelivRevenue), pct(totalDelivRevenue, totalRev)]);
    rows.push(["매출", "합계", Math.round(totalRev), "100.0%"]);
    rows.push([]);
    rows.push(["매출원가", "식재료비(기초+매입-기말)", Math.round(cogsFood), pct(cogsFood, totalRev)]);
    rows.push(["매출원가", "기타 식자재", Math.round(cogsOther), pct(cogsOther, totalRev)]);
    rows.push(["매출원가", "합계", Math.round(totalCogs), pct(totalCogs, totalRev)]);
    rows.push([]);
    if (totalLaborCost > 0) {
      rows.push(["판관비", "인건비(직원)", Math.round(totalEmployeeCost), pct(totalEmployeeCost, totalRev)]);
      rows.push(["판관비", "인건비(사장님)", Math.round(ownerWage), pct(ownerWage, totalRev)]);
    }
    sga.filter((c) => c.name !== "인건비").forEach((c) => {
      const amt = getSgaAmt(c, mk) ?? 0;
      if (amt > 0) rows.push(["판관비", c.name, Math.round(amt), pct(amt, totalRev)]);
    });
    rows.push(["판관비", "합계", Math.round(totalSga), pct(totalSga, totalRev)]);
    rows.push([]);
    platforms.forEach((p) => {
      const pd = delivMonthData[p.id] || {};
      const t = (pd.fee || 0) + (pd.ad || 0) + (pd.agency || 0) + (pd.disc || 0) - (pd.adj || 0);
      if (t > 0) rows.push(["배달비용", `${p.name} 수수료+광고+대행비`, Math.round(t), pct(t, totalRev)]);
    });
    const delivTotal = totalDelivCost;
    if (delivTotal > 0) rows.push(["배달비용", "합계", Math.round(delivTotal), pct(delivTotal, totalRev)]);
    rows.push([]);
    rows.push(["영업이익", "① − ② − ③" + (delivTotal > 0 ? " − ③-1" : ""), Math.round(opProfit), pct(opProfit, totalRev)]);
    other.forEach((c) => {
      const amt = getOtherAmt(c, mk) ?? 0;
      if (amt > 0) rows.push(["기타비용", c.name, Math.round(amt), pct(amt, totalRev)]);
    });
    if (totalOther > 0) rows.push(["기타비용", "합계", Math.round(totalOther), pct(totalOther, totalRev)]);
    rows.push(["순이익", "④ − ⑤", Math.round(netProfit), pct(netProfit, totalRev)]);
    rows.push([]);
    rows.push(["지표", "손익분기점", isFinite(bep) ? Math.round(bep) : "", ""]);
    rows.push(["지표", "식자재비율", "", pct(totalCogs, totalRev)]);
    rows.push(["지표", "인건비율", "", pct(totalLaborCost, totalRev)]);
    const csv = "\uFEFF" + rows.map((r) => r.map(q).join(",")).join("\r\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `단꿈손익_${safeName}_${mk}.csv`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  // 공유 계정 「내 탭 내보내기」 — 열린 탭이 가진 필드(TAB_OWN_FIELDS)만 CSV 로. 행 = 탭 · 필드 · 경로 · 값
  const exportMyTabsCsv = () => {
    const safeName = (selectedStore.name || "매장").replace(/[\\/:*?"<>|]/g, "_");
    const q = (v) => {
      const t = String(v ?? "");
      return /[",\n]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t;
    };
    const cur = { sga, monthlySgaAmounts, other, monthlyOtherAmounts, monthlyCogs, salesData, deliveryData, platforms, monthlyGoal, monthlyEmployees, monthlyOwnerWage, vendors, dailyExpense, payDay, inventoryItems, monthlyInventory, dailyReports, bizInfo };
    const rows = [];
    const now = new Date();
    rows.push([`${selectedStore.name} 내 탭 데이터`, now.toLocaleString("ko-KR")]);
    rows.push(["열린 탭", allowedTabs.join(" · ")]);
    rows.push([]);
    rows.push(["탭", "필드", "경로", "값"]);
    const walk = (t, f, v, path) => {
      if (v !== null && typeof v === "object") {
        const ks = Object.keys(v);
        if (!ks.length) { rows.push([t, f, path, Array.isArray(v) ? "[]" : "{}"]); return; }
        ks.forEach((k) => walk(t, f, v[k], Array.isArray(v) ? `${path}[${k}]` : (path ? `${path}.${k}` : k)));
        return;
      }
      rows.push([t, f, path, v]);
    };
    allowedTabs.forEach((t) => (TAB_OWN_FIELDS[t] || []).forEach((f) => walk(t, f, cur[f], "")));
    const csv = "﻿" + rows.map((r) => r.map(q).join(",")).join("\r\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `단꿈손익_${safeName}_내탭_${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}.csv`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  // 되돌리기 — 보관본 목록(최근 HISTORY_KEEP 개) · 탭 필드만 복원(바뀐 필드라 자동저장되고, 덮이는 지금 버전은 보관된다)
  const loadHistory = async () => {
    const col = collection(db, "users", selectedStore.ownerUid || user.uid, "stores", selectedStore.id, "data", "main", "history");
    const hs = await getDocs(query(col, orderBy("savedAt", "desc"), limit(HISTORY_KEEP)));
    return hs.docs.map((d) => ({ id: d.id, ...d.data() }));
  };
  const restoreBlocked = !loaded || conflict || loadError || saveLocked;
  const restoreTab = (tabName, snap) => {
    const setters = { inventoryItems: setInventoryItems, monthlyInventory: setMonthlyInventory, salesData: setSalesData, dailyReports: setDailyReports };
    const fields = (TAB_OWN_FIELDS[tabName] || []).filter((k) => setters[k] && snap[k] !== undefined);
    if (restoreBlocked || !fields.length) return false;
    forceArchiveRef.current = true;
    fields.forEach((k) => setters[k](snap[k]));
    return true;
  };

  // 손익계산서 이미지 저장 (canvas 직접 렌더 — 외부 라이브러리 없음)
  const saveImage = () => {
    const W = 760, PAD = 40;
    const won = (v) => `${Math.round(v).toLocaleString("ko-KR")}원`;
    const L = [];
    L.push({ t: "hero" });
    L.push({ t: "gap", h: 18 });

    L.push({ t: "group", a: "① 매출", b: won(totalRev) });
    L.push({ t: "sub", a: "홀 매출", b: won(hallRev), c: pct(hallRev, totalRev) });
    L.push({ t: "sub", a: "배달 플랫폼 주문금액", b: won(totalDelivRevenue), c: pct(totalDelivRevenue, totalRev) });

    L.push({ t: "group", a: "② 매출원가", b: `−${won(totalCogs)}` });
    L.push({ t: "sub", a: "식재료비 (기초+매입−기말)", b: won(cogsFood), c: pct(cogsFood, totalRev) });
    if (cogsOther > 0) L.push({ t: "sub", a: "기타 식자재", b: won(cogsOther), c: pct(cogsOther, totalRev) });

    L.push({ t: "group", a: "③ 판매비와 관리비", b: `−${won(totalSga)}` });
    if (totalEmployeeCost > 0) L.push({ t: "sub", a: "인건비 (직원)", b: won(totalEmployeeCost), c: pct(totalEmployeeCost, totalRev) });
    if (ownerWage > 0) L.push({ t: "sub", a: "인건비 (사장님)", b: won(ownerWage), c: pct(ownerWage, totalRev) });
    sga.filter((c) => c.name !== "인건비").forEach((c) => {
      const amt = getSgaAmt(c, mk) ?? 0;
      if (amt > 0) L.push({ t: "sub", a: c.name, b: won(amt), c: pct(amt, totalRev) });
    });

    const delivTotal = totalDelivCost;
    if (delivTotal > 0) {
      L.push({ t: "group", a: "③-1 배달 수수료·광고·대행비", b: `−${won(delivTotal)}` });
      platforms.forEach((p) => {
        const pd = delivMonthData[p.id] || {};
        const t = (pd.fee || 0) + (pd.ad || 0) + (pd.agency || 0) + (pd.disc || 0) - (pd.adj || 0);
        if (t > 0) L.push({ t: "sub", a: `${p.name} 수수료+광고+대행비`, b: won(t), c: pct(t, totalRev) });
      });
    }

    L.push({ t: "op", a: "④ 영업이익", b: `${opProfit >= 0 ? "+" : "−"}${won(Math.abs(opProfit))}`, c: pct(opProfit, totalRev), pos: opProfit >= 0 });

    if (totalOther > 0) {
      L.push({ t: "group", a: "⑤ 기타 비용", b: `−${won(totalOther)}` });
      other.forEach((c) => {
        const amt = getOtherAmt(c, mk) ?? 0;
        if (amt > 0) L.push({ t: "sub", a: c.name, b: won(amt), c: pct(amt, totalRev) });
      });
    }

    L.push({ t: "op", a: "⑥ 월 순이익", b: `${netProfit >= 0 ? "+" : "−"}${won(Math.abs(netProfit))}`, c: pct(netProfit, totalRev), pos: netProfit >= 0, big: true });
    L.push({ t: "gap", h: 22 });
    L.push({ t: "kpi" });

    const HSUB = 34, HGROUP = 38, HOP = 54, HHERO = 104, HKPI = 96;
    const bodyH = L.reduce((a, l) => a + (l.t === "gap" ? (l.h || 16) : l.t === "hero" ? HHERO : l.t === "kpi" ? HKPI : l.t === "op" ? HOP : l.t === "group" ? HGROUP : HSUB), 0);
    const H = 96 + bodyH + 46;

    const cv = document.createElement("canvas");
    const S = 2;
    cv.width = W * S; cv.height = H * S;
    const x = cv.getContext("2d");
    x.scale(S, S);
    x.fillStyle = "#0D1B2A"; x.fillRect(0, 0, W, H);
    const F = "'Noto Sans KR', sans-serif";
    const CW = W - PAD * 2;

    let y = PAD + 6;
    x.fillStyle = "#94a3b8"; x.font = `500 13px ${F}`;
    x.fillText("단꿈 손익분석기", PAD, y);
    y += 28;
    x.fillStyle = "#f1f5f9"; x.font = `700 24px ${F}`;
    x.fillText(selectedStore.name, PAD, y);
    x.fillStyle = "#94a3b8"; x.font = `400 15px ${F}`;
    x.textAlign = "right"; x.fillText(`${year}년 ${MONTHS[month]}`, W - PAD, y); x.textAlign = "left";
    y += 30;

    L.forEach((l) => {
      if (l.t === "gap") { y += (l.h || 16); return; }

      if (l.t === "hero") {
        const pos = netProfit >= 0;
        x.fillStyle = pos ? "rgba(52,211,153,0.10)" : "rgba(248,113,113,0.10)";
        x.fillRect(PAD, y, CW, 92);
        x.fillStyle = pos ? "#34d399" : "#f87171";
        x.font = `600 13px ${F}`; x.fillText("월 순이익", PAD + 22, y + 30);
        x.font = `700 36px ${F}`;
        x.fillText(`${pos ? "+" : "−"}${won(Math.abs(netProfit))}`, PAD + 22, y + 72);
        x.font = `400 13px ${F}`; x.textAlign = "right";
        x.fillText(totalRev > 0 ? `순이익률 ${pct(netProfit, totalRev)}` : "매출 미입력", W - PAD - 22, y + 72);
        x.textAlign = "left";
        y += HHERO;
        return;
      }

      if (l.t === "kpi") {
        const items = [
          ["손익분기점", isFinite(bep) && bep > 0 ? won(bep) : "–"],
          ["식자재비율", totalRev > 0 ? pct(totalCogs, totalRev) : "–"],
          ["인건비율", totalRev > 0 ? pct(totalLaborCost, totalRev) : "–"],
          ["영업이익률", totalRev > 0 ? pct(opProfit, totalRev) : "–"],
        ];
        const bw = (CW - 12 * 3) / 4;
        items.forEach(([lb, vl], i) => {
          const bx = PAD + i * (bw + 12);
          x.fillStyle = "rgba(255,255,255,0.04)";
          x.fillRect(bx, y, bw, 74);
          x.fillStyle = "#64748b"; x.font = `400 12px ${F}`;
          x.fillText(lb, bx + 14, y + 26);
          x.fillStyle = "#f1f5f9"; x.font = `700 16px ${F}`;
          x.fillText(vl, bx + 14, y + 54);
        });
        y += HKPI;
        return;
      }

      const isOp = l.t === "op", isGroup = l.t === "group";
      const rowH = isOp ? HOP : isGroup ? HGROUP : HSUB;
      if (isOp) {
        x.fillStyle = l.pos ? "rgba(52,211,153,0.07)" : "rgba(248,113,113,0.07)";
        x.fillRect(PAD, y, CW, rowH - 6);
      }
      const midY = y + (rowH - 6) / 2 + 5;
      x.fillStyle = isOp ? (l.pos ? "#34d399" : "#f87171") : isGroup ? "#cbd5e1" : "#94a3b8";
      x.font = `${isOp ? 700 : isGroup ? 600 : 400} ${isOp ? (l.big ? 17 : 16) : isGroup ? 14 : 13}px ${F}`;
      x.fillText(l.a, PAD + (isGroup || isOp ? 16 : 36), midY);
      x.textAlign = "right";
      if (l.c) {
        x.fillStyle = "#64748b"; x.font = `400 12px ${F}`;
        x.fillText(l.c, W - PAD - 16, midY);
      }
      x.fillStyle = isOp ? (l.pos ? "#34d399" : "#f87171") : isGroup ? "#cbd5e1" : "#94a3b8";
      x.font = `${isOp ? 700 : isGroup ? 600 : 400} ${isOp ? (l.big ? 20 : 17) : isGroup ? 14 : 13}px ${F}`;
      x.fillText(l.b, W - PAD - (l.c ? 78 : 16), midY);
      x.textAlign = "left";
      x.strokeStyle = "#1e3448"; x.lineWidth = 0.5;
      x.beginPath(); x.moveTo(PAD, y + rowH - 6); x.lineTo(W - PAD, y + rowH - 6); x.stroke();
      y += rowH;
    });

    x.fillStyle = "#64748b"; x.font = `400 12px ${F}`;
    x.fillText(`총매출 ${won(totalRev)}  ·  단꿈 손익분석기`, PAD, H - 22);

    cv.toBlob((blob) => {
      if (!blob) { alert("이미지 저장에 실패했습니다."); return; }
      const safeName = (selectedStore.name || "매장").replace(/[\\/:*?"<>|]/g, "_");
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `단꿈손익_${safeName}_${mk}.png`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }, "image/png");
  };

  // 임금명세서 이미지 (직원 1명)
  const savePayslip = (emp, share) => {
    const W = 720, PAD = 32;
    const won = (v) => `${Math.round(v).toLocaleString("ko-KR")}원`;
    const pays = paymentRows(emp);
    const deds = deductionRows(emp);
    const gross = calcBase(emp);
    const dedTotal = deds.reduce((a, r) => a + r.amount, 0);
    const net = gross - dedTotal;

    const HDR = 108, INFO = 88, SEC = 34, ROW = 30, GAP = 20, FOOT = 54;
    const listH = Math.max(pays.length, deds.length) * ROW + SEC + ROW;
    const detailH = SEC + ROW + (pays.length * ROW) + GAP + SEC + ROW + (deds.length * ROW);
    const H = HDR + INFO + GAP + listH + GAP + detailH + FOOT;

    const cv = document.createElement("canvas");
    const S = 2;
    cv.width = W * S; cv.height = H * S;
    const x = cv.getContext("2d");
    x.scale(S, S);
    const F = "'Noto Sans KR', sans-serif";

    x.fillStyle = "#f8fafc"; x.fillRect(0, 0, W, H);

    // 헤더
    const g = x.createLinearGradient(0, 0, W, HDR);
    g.addColorStop(0, "#2563eb"); g.addColorStop(1, "#3b82f6");
    x.fillStyle = g; x.fillRect(0, 0, W, HDR);
    x.fillStyle = "rgba(255,255,255,0.85)"; x.font = `400 13px ${F}`;
    x.fillText(`안녕하세요. ${emp.name || "직원"}님`, PAD, 36);
    x.fillStyle = "#fff"; x.font = `700 22px ${F}`;
    x.fillText(`${year}년 ${String(month+1).padStart(2,"0")}월 임금명세서`, PAD, 68);
    x.fillStyle = "rgba(255,255,255,0.8)"; x.font = `400 12px ${F}`;
    x.textAlign = "right"; x.fillText("실지급액", W - PAD, 40);
    x.fillStyle = "#fde047"; x.font = `700 28px ${F}`;
    x.fillText(won(net), W - PAD, 74);
    x.textAlign = "left";

    let y = HDR + 18;

    // 급여정보
    const infoItems = [
      ["성명", emp.name || "-"],
      ["생년월일", emp.birth || "-"],
      ["지급일", `매월 ${payDay}일`],
    ];
    if (emp.workDays) infoItems.push(["근무일수", `${emp.workDays}일`]);
    if (emp.payType === "hourly") infoItems.push(["근무시간", `${emp.totalHours || 0}시간`]);
    if (bankText(emp)) infoItems.push(["급여계좌", bankText(emp)]);
    const cellW = (W - PAD * 2) / infoItems.length;
    x.fillStyle = "#fff"; x.fillRect(PAD, y, W - PAD * 2, 62);
    x.strokeStyle = "#e2e8f0"; x.lineWidth = 1; x.strokeRect(PAD, y, W - PAD * 2, 62);
    infoItems.forEach(([lb, vl], i) => {
      const cx = PAD + i * cellW;
      if (i > 0) { x.beginPath(); x.moveTo(cx, y); x.lineTo(cx, y + 62); x.stroke(); }
      x.fillStyle = "#f1f5f9"; x.fillRect(cx + 1, y + 1, cellW - 1, 26);
      x.fillStyle = "#64748b"; x.font = `500 12px ${F}`;
      x.textAlign = "center"; x.fillText(lb, cx + cellW / 2, y + 18);
      x.fillStyle = "#0f172a";
      let fs = 13;
      x.font = `600 ${fs}px ${F}`;
      while (fs > 9 && x.measureText(vl).width > cellW - 10) { fs -= 1; x.font = `600 ${fs}px ${F}`; }
      x.fillText(vl, cx + cellW / 2, y + 48);
      x.textAlign = "left";
    });
    y += 62 + GAP;

    // 지급내역 / 공제내역 2단
    const colW = (W - PAD * 2 - 16) / 2;
    const drawList = (cx, title, rows, totalLabel, totalVal, accent) => {
      let ly = y;
      x.fillStyle = accent; x.fillRect(cx, ly, colW, SEC);
      x.fillStyle = "#fff"; x.font = `700 13px ${F}`;
      x.fillText(title, cx + 12, ly + 22);
      ly += SEC;
      x.fillStyle = "#fff"; x.fillRect(cx, ly, colW, rows.length * ROW + ROW);
      x.strokeStyle = "#e2e8f0"; x.strokeRect(cx, ly, colW, rows.length * ROW + ROW);
      rows.forEach((r) => {
        x.fillStyle = "#475569"; x.font = `400 12px ${F}`;
        x.fillText(r.name, cx + 12, ly + 20);
        x.fillStyle = "#0f172a"; x.font = `500 12px ${F}`;
        x.textAlign = "right"; x.fillText(won(r.amount), cx + colW - 12, ly + 20);
        x.textAlign = "left";
        x.strokeStyle = "#f1f5f9"; x.beginPath();
        x.moveTo(cx, ly + ROW); x.lineTo(cx + colW, ly + ROW); x.stroke();
        ly += ROW;
      });
      x.fillStyle = "#f8fafc"; x.fillRect(cx + 1, ly + 1, colW - 2, ROW - 2);
      x.fillStyle = "#0f172a"; x.font = `700 12px ${F}`;
      x.fillText(totalLabel, cx + 12, ly + 20);
      x.fillStyle = accent; x.font = `700 13px ${F}`;
      x.textAlign = "right"; x.fillText(won(totalVal), cx + colW - 12, ly + 20);
      x.textAlign = "left";
    };
    drawList(PAD, "지급 내역", pays, "지급액계", gross, "#0d9488");
    drawList(PAD + colW + 16, "공제 내역", deds.length ? deds : [{ name: "공제 없음", amount: 0 }], "공제액계", dedTotal, "#ef4444");
    y += listH + GAP;

    // 산출식 상세
    const drawDetail = (title, rows) => {
      x.fillStyle = "#1e293b"; x.fillRect(PAD, y, W - PAD * 2, SEC);
      x.fillStyle = "#fff"; x.font = `700 13px ${F}`;
      x.fillText(title, PAD + 12, y + 22);
      y += SEC;
      const c1 = PAD, c2 = PAD + 150;
      x.fillStyle = "#f1f5f9"; x.fillRect(PAD, y, W - PAD * 2, ROW);
      x.fillStyle = "#64748b"; x.font = `500 11px ${F}`;
      x.fillText("구분", c1 + 12, y + 19);
      x.fillText("산출식", c2 + 12, y + 19);
      x.textAlign = "right"; x.fillText("금액", W - PAD - 12, y + 19); x.textAlign = "left";
      y += ROW;
      rows.forEach((r) => {
        x.fillStyle = "#fff"; x.fillRect(PAD, y, W - PAD * 2, ROW);
        x.fillStyle = "#334155"; x.font = `500 12px ${F}`;
        x.fillText(r.name, c1 + 12, y + 19);
        x.fillStyle = "#64748b"; x.font = `400 11px ${F}`;
        x.fillText(r.formula || "-", c2 + 12, y + 19);
        x.fillStyle = "#0f172a"; x.font = `500 12px ${F}`;
        x.textAlign = "right"; x.fillText(won(r.amount), W - PAD - 12, y + 19); x.textAlign = "left";
        x.strokeStyle = "#e2e8f0"; x.beginPath();
        x.moveTo(PAD, y + ROW); x.lineTo(W - PAD, y + ROW); x.stroke();
        y += ROW;
      });
    };
    drawDetail("지급 계산 내역", pays);
    y += GAP;
    drawDetail("공제 계산 내역", deds.length ? deds : [{ name: "공제 없음", formula: "-", amount: 0 }]);

    // 푸터
    x.fillStyle = "#94a3b8"; x.font = `400 11px ${F}`;
    x.fillText(`${selectedStore.name} · 단꿈 손익분석기에서 발행`, PAD, H - 22);

    cv.toBlob(async (blob) => {
      if (!blob) { alert("이미지 생성에 실패했습니다."); return; }
      const safe = (s) => (s || "").replace(/[\\/:*?"<>|]/g, "_");
      const fname = `임금명세서_${safe(emp.name)}_${mk}.png`;
      // 보내기: 명세서가 붙은 채로 공유창을 연다
      if (share) {
        try {
          const file = new File([blob], fname, { type: "image/png" });
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({ files: [file], title: `${year}년 ${MONTHS[month]} 임금명세서`, text: `${emp.name}님 ${year}년 ${MONTHS[month]} 임금명세서입니다.` });
            return;
          }
        } catch (e) { if (e && e.name === "AbortError") return; }
      }
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fname;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }, "image/png");
  };

  const savePayslipAll = () => {
    if (!employees.length) return;
    employees.forEach((e, i) => setTimeout(() => savePayslip(e), i * 400));
  };

  const exportData = (scope) => {
    const safeName = (selectedStore.name || "매장").replace(/[\\/:*?"<>|]/g, "_");
    if (scope === "month") {
      const payload = {
        _app: "danggum-profit",
        version: 1,
        type: "month",
        store: selectedStore.name,
        month: mk,
        exportedAt: new Date().toISOString(),
        data: {
          sga,
          other,
          platforms,
          monthlyOwnerWage: { [mk]: ownerWage },
          monthlySgaAmounts: { [mk]: monthlySgaAmounts[mk] || {} },
          monthlyOtherAmounts: { [mk]: monthlyOtherAmounts[mk] || {} },
          monthlyCogs: { [mk]: monthlyCogs[mk] || {} },
          salesData: { [mk]: salesData[mk] || {} },
          deliveryData: { [mk]: deliveryData[mk] || {} },
          monthlyEmployees: { [mk]: monthlyEmployees[mk] || [] },
          monthlyGoal: { [mk]: monthlyGoal[mk] || 0 },
          inventoryItems,
          monthlyInventory: { [mk]: monthlyInventory[mk] || null },
          dailyReports: { [mk]: dailyReports[mk] || null },
        },
      };
      downloadJson(payload, `단꿈손익_${safeName}_${mk}.json`);
    } else {
      const payload = {
        _app: "danggum-profit",
        version: 1,
        type: "full",
        store: selectedStore.name,
        exportedAt: new Date().toISOString(),
        data: {
          sga,
          monthlySgaAmounts,
          other,
          monthlyOtherAmounts,
          monthlyCogs,
          salesData,
          deliveryData,
          platforms,
          monthlyGoal,
          monthlyEmployees,
          monthlyOwnerWage,
          inventoryItems,
          monthlyInventory,
          dailyReports,
          bizInfo,
        },
      };
      downloadJson(
        payload,
        `단꿈손익_${safeName}_전체_${new Date().toISOString().slice(0, 10)}.json`
      );
    }
  };
  const importData = (file) => {
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const parsed = JSON.parse(ev.target.result);
        if (!parsed || parsed._app !== "danggum-profit" || !parsed.data) {
          alert("단꿈 손익분석기 백업 파일이 아닙니다.");
          return;
        }
        const d = parsed.data;
        const label =
          parsed.type === "month" && parsed.month
            ? `'${parsed.month}' 한 달`
            : "전체";
        if (
          !window.confirm(
            `${label} 데이터를 현재 매장에 합칩니다. 같은 달은 덮어쓰여요. 계속할까요?`
          )
        )
          return;
        // 이름 기반 병합: 들어오는 항목의 옛 id를 "이름이 같은 현재 항목의 id"로 다시 매핑한다.
        // 이러면 매니저가 항목 이름/순서를 바꿔도 금액이 올바른 자리로 들어간다.
        const buildRemap = (prevDefs, incomingDefs) => {
          const byName = new Map((prevDefs || []).map((x) => [x.name, x.id]));
          const remap = {};
          const toAppend = [];
          const amountByNewId = {}; // 이름매칭된 기존 항목에 실어줄 기본 amount
          let nextId = Math.max(0, ...(prevDefs || []).map((x) => Number(x.id) || 0));
          (incomingDefs || []).forEach((item) => {
            if (byName.has(item.name)) {
              const targetId = byName.get(item.name);
              remap[item.id] = targetId;
              if (item.amount !== undefined) amountByNewId[targetId] = item.amount;
            } else {
              nextId += 1;
              remap[item.id] = nextId;
              toAppend.push({ ...item, id: nextId });
            }
          });
          return { remap, toAppend, amountByNewId };
        };
        const remapMonthly = (prevMap, incomingMap, remap) => {
          const out = { ...(prevMap || {}) };
          Object.entries(incomingMap || {}).forEach(([mkKey, byId]) => {
            const merged = { ...(out[mkKey] || {}) };
            Object.entries(byId || {}).forEach(([oldId, val]) => {
              const newId = remap[oldId] ?? oldId;
              merged[newId] = val;
            });
            out[mkKey] = merged;
          });
          return out;
        };

        // 판관비: 이름 매칭 후 금액 remap
        if (d.sga) {
          setSga((prevDefs) => {
            const { remap, toAppend, amountByNewId } = buildRemap(prevDefs, d.sga);
            if (d.monthlySgaAmounts)
              setMonthlySgaAmounts((pm) => remapMonthly(pm, d.monthlySgaAmounts, remap));
            // 이름매칭된 기존 항목의 기본 amount를 들어온 값으로 갱신 (월별에 값 없을 때 이 값이 쓰임)
            const updated = prevDefs.map((x) =>
              amountByNewId[x.id] !== undefined ? { ...x, amount: amountByNewId[x.id] } : x
            );
            return [...updated, ...toAppend];
          });
        } else if (d.monthlySgaAmounts) {
          setMonthlySgaAmounts((pm) => ({ ...pm, ...d.monthlySgaAmounts }));
        }

        // 기타비용: 이름 매칭 후 금액 remap
        if (d.other) {
          setOther((prevDefs) => {
            const { remap, toAppend, amountByNewId } = buildRemap(prevDefs, d.other);
            if (d.monthlyOtherAmounts)
              setMonthlyOtherAmounts((pm) => remapMonthly(pm, d.monthlyOtherAmounts, remap));
            const updated = prevDefs.map((x) =>
              amountByNewId[x.id] !== undefined ? { ...x, amount: amountByNewId[x.id] } : x
            );
            return [...updated, ...toAppend];
          });
        } else if (d.monthlyOtherAmounts) {
          setMonthlyOtherAmounts((pm) => ({ ...pm, ...d.monthlyOtherAmounts }));
        }

        // 플랫폼: 이름 매칭 후 배달 데이터 remap (deliveryData는 platformId를 키로 사용)
        if (d.platforms) {
          setPlatforms((prevDefs) => {
            const { remap, toAppend } = buildRemap(prevDefs, d.platforms);
            if (d.deliveryData) {
              setDeliveryData((pm) => {
                const out = { ...(pm || {}) };
                Object.entries(d.deliveryData || {}).forEach(([mkKey, byPlat]) => {
                  const merged = { ...(out[mkKey] || {}) };
                  Object.entries(byPlat || {}).forEach(([oldPid, val]) => {
                    const newPid = remap[oldPid] ?? oldPid;
                    merged[newPid] = val;
                  });
                  out[mkKey] = merged;
                });
                return out;
              });
            }
            return [...prevDefs, ...toAppend];
          });
        } else if (d.deliveryData) {
          setDeliveryData((pm) => migrateDeliv({ ...pm, ...d.deliveryData }));
        }

        if (d.monthlyCogs) setMonthlyCogs((p) => ({ ...p, ...d.monthlyCogs }));
        if (d.salesData) setSalesData((p) => ({ ...p, ...d.salesData }));
        if (d.monthlyEmployees)
          setMonthlyEmployees((p) => ({ ...p, ...d.monthlyEmployees }));
        if (d.monthlyGoal) setMonthlyGoal((p) => ({ ...p, ...d.monthlyGoal }));
        if (d.inventoryItems) setInventoryItems((p) => {
          // 이름 기준 병합: 같은 이름은 기존 id 유지, 새 이름은 추가
          const byName = new Map(p.map((x) => [invNorm(x.name), x]));
          const add = d.inventoryItems.filter((x) => !byName.has(invNorm(x.name)));
          return [...p, ...add];
        });
        if (d.monthlyInventory) setMonthlyInventory((p) => ({ ...p, ...Object.fromEntries(Object.entries(d.monthlyInventory).filter(([, v]) => v)) }));
        if (d.dailyReports) setDailyReports((p) => ({ ...p, ...Object.fromEntries(Object.entries(d.dailyReports).filter(([, v]) => v)) }));
        if (d.bizInfo) setBizInfo((p) => ({ ...p, ...d.bizInfo }));
        if (d.monthlyOwnerWage) setMonthlyOwnerWage((p) => ({ ...p, ...d.monthlyOwnerWage }));
        else if (d.ownerWage) setMonthlyOwnerWage((p) => ({ ...p, [mk]: d.ownerWage }));
        if (parsed.type === "month" && parsed.month) {
          const [yy, mm] = parsed.month.split("-").map(Number);
          if (yy && mm) {
            setYear(yy);
            setMonth(mm - 1);
          }
        }
        alert("데이터를 불러왔습니다.");
      } catch (err) {
        alert("파일을 읽지 못했습니다. JSON 백업 파일이 맞는지 확인해주세요.");
      }
    };
    reader.readAsText(file);
  };
  const prevMonth = () => {
    if(month===0){setYear(y=>y-1);setMonth(11);}else setMonth(m=>m-1);
  };
  const nextMonth = () => {
    if(month===11){setYear(y=>y+1);setMonth(0);}else setMonth(m=>m+1);
  };
  const diffBadge = (cur, prev) => {
    if(!prev) return null;
    const d=cur-prev; const r=((d/Math.abs(prev))*100).toFixed(1);
    return <span style={{fontSize:11, color:d>=0?C.profit:C.loss, marginLeft:6}}>{d>=0?"▲":"▼"}{Math.abs(r)}%</span>;
  };

  // 입력 완성도 계산
  // 오늘이 속한 달은 아직 마감 전이다. 비용은 한 달치인데 매출은 일부라 순이익이 의미가 없다
  const nowD = new Date();
  const isOngoingMonth = isOngoingMonthKey(mk, nowD);
  const dayOfMonth = isOngoingMonth ? nowD.getDate() : days;

  // 진행 중인 달: 배달 탭은 다음 달 10일에 정산자료로 채우므로 월 중에는 비어 있다.
  // 그동안은 일일 보고의 배달 매출(포스 기준)을 참고로 쓴다. 배달 탭에 값이 들어오면 그 값이 우선이다.
  const drDays = (dailyThis && dailyThis.days) || {};
  const drDayNums = Object.keys(drDays).map(Number).filter((d) => d > 0);
  const drLastDay = drDayNums.length ? Math.max(...drDayNums) : 0;
  const ongoingDelivRef = totalDelivRevenue === 0 ? drSum(drDays, "delivRev") : 0;
  const ongoingDeliv = totalDelivRevenue > 0 ? totalDelivRevenue : ongoingDelivRef;
  const ongoingRev = hallRev + ongoingDeliv;
  // 월말 예상은 보고가 들어온 마지막 날 기준 (매출 탭 「이대로면 월말」과 같은 숫자가 나오도록)
  const ongoingDay = drLastDay > 0 ? drLastDay : dayOfMonth;

  // ── 재고조사 → 기말재고 (저장하지 않고 계산해서 쓴다) ──
  const invThis = monthlyInventory[mk];
  const invPrev = monthlyInventory[prevMk];
  const invSum = invSummary(inventoryItems, invThis);
  const invDone = !!invThis && (invThis.skipped || invSum.countedItems > 0);
  const endSource = stockThis.source;   // "inventory" | "skip" | null(직접 입력)

  const completeness = {
    매출: totalRev > 0 ? 100 : 0,
    배달: totalDelivRevenue > 0 ? 100 : 0,
    인건비: employees.length > 0 ? 100 : 0,
    재고: invDone ? 100 : 0,
    비용: (totalCogs > 0 ? 50 : 0) + (totalSga > totalLaborCost ? 50 : 0),
    손익분석: 100,
  };

  // 저장 디바운스가 쓸 최신 값 (선언이 모두 끝난 뒤에 채운다)
  saveMetaRef.current = { save, mk, totalRev, netProfit, ongoingRev: isOngoingMonth ? ongoingRev : null, prevMk, prevTotalRev, prevNetProfit };

  // 충돌 배너 「내 입력 유지」 — 서버본과 다른(내가 바꾼) 필드만 보관 → 서버본 다시 로드 → 그 위에 재적용 → 자동저장
  const keepMine = () => {
    const base = savedBase.current;
    const cur = { sga, monthlySgaAmounts, other, monthlyOtherAmounts, monthlyCogs, salesData, deliveryData, platforms, monthlyGoal, monthlyEmployees, monthlyOwnerWage, vendors, dailyExpense, payDay, inventoryItems, monthlyInventory, dailyReports, bizInfo };
    const mine = {};
    if (base) STORE_FIELDS.forEach((k) => { if (!sameVal(cur[k], base[k])) mine[k] = cur[k]; });
    reapplyRef.current = Object.keys(mine).length ? mine : null;
    setSelectedStore({ ...selectedStore });
  };

  // 한줄 요약 생성
  const oneLinerSummary = (() => {
    if (totalRev === 0) return null;
    const revDiff = prevTotalRev > 0 ? totalRev - prevTotalRev : null;
    const netDiff = prevTotalRev > 0 ? netProfit - prevNetProfit : null;
    const cogsRate = pctNum(totalCogs, totalRev);
    const parts = [];
    if (revDiff !== null) parts.push(revDiff >= 0 ? `매출이 ${fmtW(Math.abs(revDiff))} 늘었고` : `매출이 ${fmtW(Math.abs(revDiff))} 줄었고`);
    if (cogsRate >= 40) parts.push("식자재비율이 위험 수준이에요");
    else if (cogsRate >= 35) parts.push("식자재비율이 높은 편이에요");
    else parts.push("식자재비율은 양호해요");
    if (netDiff !== null) parts.push(netDiff >= 0 ? `순이익은 ${fmtW(Math.abs(netDiff))} 증가했어요` : `순이익은 ${fmtW(Math.abs(netDiff))} 감소했어요`);
    else if (netProfit > 0) parts.push(`순이익 ${fmtW(netProfit)}을 달성했어요`);
    return parts.join(", ");
  })();

  return (
    <div className="dg-app" style={{ fontFamily:"'Noto Sans KR', sans-serif", background:"#0D1B2A", color:C.text, maxWidth:800, margin:"0 auto", padding:"0 24px 80px", minHeight:"100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;500;600;700&display=swap" rel="stylesheet" />

      {/* 로드 실패 — 저장 차단 */}
      {loadError && (
        <div style={{ margin:"16px 0 0", padding:"12px 16px", background:"rgba(248,113,113,0.12)", border:"1px solid rgba(248,113,113,0.5)", borderRadius:10, display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap" }}>
          <p style={{ margin:0, fontSize:12, color:"#f87171", fontWeight:700 }}>데이터를 완전히 불러오지 못했습니다. 새로고침 후 다시 시도</p>
          <button onClick={() => window.location.reload()} style={{ padding:"8px 12px", background:"#f87171", color:"#0D1B2A", border:"none", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" }}>새로고침</button>
        </div>
      )}

      {/* 저장 연속 실패 — 입력 잠금(새로고침으로만 해제) */}
      {saveLocked && (
        <>
          <div style={{ position:"fixed", inset:0, background:"rgba(13,27,42,0.6)", zIndex:9998 }} />
          <div data-save-lock style={{ position:"fixed", top:16, left:"50%", transform:"translateX(-50%)", width:"calc(100% - 32px)", maxWidth:760, zIndex:9999, padding:"14px 16px", background:"#2a1418", border:"1px solid rgba(248,113,113,0.6)", borderRadius:10, display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap", boxSizing:"border-box" }}>
            <p style={{ margin:0, fontSize:13, color:"#f87171", fontWeight:700 }}>저장되지 않습니다. 권한 또는 연결을 확인하세요</p>
            <button onClick={() => window.location.reload()} style={{ padding:"8px 12px", background:"#f87171", color:"#0D1B2A", border:"none", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" }}>새로고침</button>
          </div>
        </>
      )}

      {/* 헤더 */}
      <div style={{ padding:"28px 0 0", marginBottom:28 }}>
        <div style={{ display:"flex", alignItems:"flex-end", justifyContent:"space-between", marginBottom:20 }}>
          <div>
            <p style={{ margin:0, fontSize:11, fontWeight:600, letterSpacing:2, color:C.textHint, textTransform:"uppercase" }}>단꿈 손익분석기</p>
            <div style={{ display:"flex", alignItems:"center", gap:10, marginTop:4 }}>
              <div style={{ width:28, height:28, borderRadius:8, background:storeColor, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, fontWeight:800, color:"#fff" }}>{(branchOf(selectedStore.name)||"매").slice(0,1)}</div>
              <h1 style={{ margin:0, fontSize:20, fontWeight:700, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", maxWidth:200 }}>{selectedStore.name}</h1>
              {selectedStore.shared && <span style={{ fontSize:10, fontWeight:700, color:"#2dd4bf", background:"rgba(13,148,136,0.15)", border:"1px solid rgba(13,148,136,0.4)", borderRadius:6, padding:"2px 6px", whiteSpace:"nowrap" }}>공유</span>}
            </div>
            <button onClick={() => setSelectedStore(null)} style={{ marginTop:4, fontSize:11, color:C.textHint, background:"transparent", border:"none", cursor:"pointer", fontFamily:"inherit", padding:0, textDecoration:"underline" }}>← 매장 변경</button>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:12, paddingBottom:4 }}>
            {saveError && (
              <span style={{ fontSize:12, color:C.loss, display:"flex", alignItems:"center", gap:6 }}>
                <span style={{ width:6, height:6, borderRadius:"50%", background:C.loss, display:"inline-block" }} />
                저장 실패 · 재시도 중
              </span>
            )}
            {saving && !saveError && <span style={{ fontSize:12, color:C.textHint, display:"flex", alignItems:"center", gap:6 }}><span style={{ width:6, height:6, borderRadius:"50%", background:C.profit, display:"inline-block" }} />저장됨</span>}
            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
              <img src={user.photoURL} alt="" style={{ width:28, height:28, borderRadius:"50%" }} />
              <span style={{ fontSize:12, color:C.textSub }}>{user.displayName}</span>
              <button onClick={() => signOut(auth)} style={{ fontSize:11, color:C.textHint, background:"transparent", border:"0.5px solid #1e3448", borderRadius:6, padding:"3px 8px", cursor:"pointer", fontFamily:"inherit" }}>로그아웃</button>
            </div>
          </div>
        </div>
        <div style={{ display:"flex", gap:4, background:"#1a2e42", borderRadius:12, padding:4 }}>
          {ALL_TABS.filter(canSee).map((t) => {
            const done = completeness[t] === 100;
            return (
              <button key={t} onClick={() => setTab(t)} style={{ flex:1, padding:"9px 4px", border:"none", borderRadius:9, background:tab===t?C.bg:"transparent", boxShadow:tab===t?"0 1px 4px rgba(0,0,0,0.08)":"none", color:tab===t?C.text:C.textSub, fontWeight:tab===t?600:400, fontSize:11, cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap", position:"relative" }}>
                {t}
                {done && t!=="손익분석" && <span style={{ position:"absolute", top:4, right:4, width:5, height:5, borderRadius:"50%", background:C.profit, display:"inline-block" }} />}
              </button>
            );
          })}
        </div>
      </div>

      {/* 오프라인 배너 */}
      <OfflineBanner />

      {/* 동시 수정 감지 */}
      {conflict && (
        <div style={{ margin:"0 0 16px", padding:"12px 16px", background:"rgba(251,191,36,0.1)", border:"1px solid rgba(251,191,36,0.4)", borderRadius:10, display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap" }}>
          <p style={{ margin:0, fontSize:12, color:"#fbbf24", fontWeight:600 }}><span style={{ display:"inline-flex", width:14, height:14, borderRadius:"50%", background:"currentColor", color:"#0D1B2A", fontSize:10, fontWeight:700, alignItems:"center", justifyContent:"center", marginRight:5, flexShrink:0 }}>!</span>다른 기기에서 먼저 저장했습니다. 최신 데이터를 불러온 뒤 이어서 입력하세요.</p>
          <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
            <button onClick={keepMine} style={{ padding:"8px 12px", background:"transparent", color:"#fbbf24", border:"1px solid #fbbf24", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" }}>내 입력 유지</button>
            <button onClick={() => setSelectedStore({ ...selectedStore })} style={{ padding:"8px 12px", background:"#fbbf24", color:"#0D1B2A", border:"none", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" }}>최신 데이터 불러오기</button>
          </div>
        </div>
      )}

      {/* 데이터 가져오기 / 내보내기 — 공유받은 매장에서는 숨김 (급여·손익 전체가 담긴다) */}
      {!selectedStore.shared && (
      <div
        style={{
          display: "flex",
          gap: 8,
          marginBottom: 20,
          flexWrap: "wrap",
        }}
      >
        <button onClick={() => exportData("month")} style={IE_BTN(C.store)}>
          이번달 내보내기
        </button>
        <button onClick={() => exportData("full")} style={IE_BTN("#6366f1")}>
          전체 내보내기
        </button>
        <button onClick={exportCsv} style={IE_BTN("#22c55e")}>
          엑셀(CSV)
        </button>
        <label style={{ ...IE_BTN(C.other), cursor: "pointer" }}>
          가져오기
          <input
            type="file"
            accept=".json,application/json"
            style={{ display: "none" }}
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                importData(e.target.files[0]);
                e.target.value = "";
              }
            }}
          />
        </label>
      </div>
      )}

      {/* 공유받은 매장 — 열린 탭의 데이터만 내보내기 */}
      {selectedStore.shared && (
      <div style={{ display: "flex", gap: 8, marginBottom: 20, flexWrap: "wrap" }}>
        <button onClick={exportMyTabsCsv} style={IE_BTN("#22c55e")}>
          내 탭 내보내기
        </button>
      </div>
      )}

      {/* 온보딩 가이드 - 첫 방문 시 */}
      {totalRev === 0 && employees.length === 0 && totalCogs === 0 && (
        <div style={{ marginBottom:20, padding:"16px 20px", background:"linear-gradient(135deg,#34d39920,#34d3990a)", borderRadius:14, border:"1px solid rgba(52,211,153,0.3)" }}>
          <p style={{ margin:"0 0 10px", fontSize:13, fontWeight:700, color:"#34d399" }}>손익분석기 시작하기</p>
          <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
            {[
              ["","매출","홀·배달 한 달 매출 합계를 입력 · 지출은 비용 탭에서",tab==="매출"],
              ["","배달","채널별 배달 주문금액·수수료·광고비를 입력",tab==="배달"],
              ["","인건비","직원별 급여 · 임금명세서 · 근로계약서",tab==="인건비"],
              ["","재고","월말에 남은 식자재를 세어 붙여넣기 · 기말재고 자동 반영",tab==="재고"],
              ["","비용","식자재비·임차료 등 각종 비용 입력",tab==="비용"],
              ["","손익분석","입력 완료되면 손익 자동 계산",tab==="손익분석"],
            ].filter(([,name]) => canSee(name)).map(([icon,name,desc,active],i) => (
              <div key={name} style={{ display:"flex", alignItems:"center", gap:10, opacity:active?1:0.7 }}>
                <span style={{ fontSize:11, fontWeight:700, color:"#34d399", minWidth:16 }}>{i+1}</span>
                                <div>
                  <span style={{ fontSize:12, fontWeight:active?700:500, color:active?C.profit:C.textSub }}>{name}</span>
                  <span style={{ fontSize:11, color:active?"#cbd5e1":"#64748b", marginLeft:6 }}>{desc}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}


      {/* ════ 매출 ════ */}
      {tab==="매출" && (() => {
        return (
        <div>
          <PLBadge num="① 매출" label="홀 · 배달 매출" sub="채널별 한 달 매출 합계를 넣습니다 · 지출은 비용 탭에서" color={C.store} />

          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16 }}>
            <div style={{ display:"flex", alignItems:"center", gap:12 }}>
              <button onClick={prevMonth} style={NAV_BTN}>‹</button>
              <span style={{ fontSize:20, fontWeight:700, minWidth:100, textAlign:"center" }}>{year}년 {MONTHS[month]}</span>
              <button onClick={nextMonth} style={NAV_BTN}>›</button>
            </div>
          </div>

          <RestorePanel tabName="매출" disabled={restoreBlocked} loadHistory={loadHistory} onRestore={(h) => restoreTab("매출", h)} C={C} />

          <DailyReportSection mk={mk} year={year} month={month} MONTHS={MONTHS} days={days}
            daily={dailyThis} setDailyReports={setDailyReports}
            onHallSync={syncDailyHall} onCashSync={syncDailyCash} C={C} />

          <div style={{ marginBottom:14, padding:"18px 20px", background:"#112236", borderRadius:12, border:`1px solid ${C.store}45` }}>
            <p style={{ margin:"0 0 3px", fontSize:12, fontWeight:700, color:"#2dd4bf" }}>홀 매출 총액</p>
            <p style={{ margin:"0 0 10px", fontSize:11, color: dailyHallOn ? "#2dd4bf" : C.textHint }}>{dailyHallOn ? "일일 보고 합계가 자동으로 들어갑니다 · 직접 넣으려면 위 체크를 끄세요" : "포스 월 합계를 넣습니다 · 일일 보고를 붙여넣으면 자동으로 채워집니다"}</p>
            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
              <MoneyInput value={hallRev} onChange={(v)=>{ if (dailyHallOn) return; setSalesData(prev => ({ ...prev, [mk]: { 0:{ food:v } } })); }}
                style={{ flex:1, fontSize:22, fontWeight:700, border:"none", borderBottom:`1.5px solid ${C.store}`, background:"transparent", outline:"none", padding:"3px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
              <span style={{ fontSize:13, color:C.textSub }}>원</span>
            </div>

            <div style={{ marginTop:18, paddingTop:15, borderTop:"1px solid #1e3448" }}>
              <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, marginBottom:3, flexWrap:"wrap" }}>
                <p style={{ margin:0, fontSize:12, fontWeight:700, color:C.delivery, display:"flex", alignItems:"center", gap:6 }}>
                  배달 매출 총액
                  <span style={{ fontSize:10, fontWeight:700, color:C.textHint, background:"#0D1B2A", border:"1px solid #243d54", borderRadius:5, padding:"1px 7px" }}>자동 계산</span>
                </p>
                <button onClick={()=>setTab("배달")} style={{ ...ADD_BTN, fontSize:11, padding:"4px 10px" }}>배달 탭에서 입력 →</button>
              </div>
              <p style={{ margin:"0 0 10px", fontSize:11, color:C.textHint }}>여기서는 입력할 수 없습니다 · 배달 탭에서 채널별로 넣으면 자동으로 합산됩니다</p>
              <div onClick={()=>setTab("배달")} title="배달 탭으로 이동" style={{ display:"flex", alignItems:"baseline", gap:8, cursor:"pointer", background:"#0D1B2A", borderRadius:8, padding:"9px 12px", border:"1px dashed #243d54" }}>
                <span style={{ flex:1, fontSize:22, fontWeight:700, color: totalDelivRevenue>0 ? C.delivery : C.textHint, padding:"1px 0", display:"block" }}>
                  {totalDelivRevenue>0 ? totalDelivRevenue.toLocaleString("ko-KR") : "—"}
                </span>
                <span style={{ fontSize:13, color:C.textSub }}>원</span>
              </div>
              {totalDelivRevenue>0 && (
                <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginTop:9 }}>
                  {platforms.filter(pl => platRevenue(pl.id)>0).map(pl => (
                    <span key={pl.id} style={{ fontSize:11, color:C.textSub }}>
                      <span style={{ display:"inline-block", width:6, height:6, borderRadius:"50%", background:pl.color, marginRight:5 }} />
                      {pl.name} <strong style={{ color:C.text }}>{fmtW(platRevenue(pl.id))}</strong>
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="dg-g3" style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10 }}>
            {[[C.store,"홀 매출",hallRev],[C.delivery,"배달 매출",totalDelivRevenue],["#e2e8f0","총 매출",totalRev]].map(([clr,lbl,val]) => (
              <div key={lbl} style={{ background:"#1a2e42", borderRadius:12, padding:"14px 16px", borderTop:`3px solid ${clr}` }}>
                <p style={{ margin:0, fontSize:11, color:clr, fontWeight:600 }}>{lbl}</p>
                <p style={{ margin:"6px 0 0", fontSize:16, fontWeight:700 }}>{val.toLocaleString("ko-KR")}원</p>
                {lbl==="총 매출" && totalRev>0 && <p style={{ margin:"3px 0 0", fontSize:11, color:C.textHint }}>배달 비중 {pct(totalDelivRevenue,totalRev)}</p>}
              </div>
            ))}
          </div>
        </div>
        );
      })()}

      {/* ════ 배달 ════ */}
      {tab==="배달" && (
        <div>
          <PLBadge num="① 매출 · ③-1 배달비용" label="배달 주문금액과 수수료·광고·대행비" sub="주문금액은 ① 매출로, 나머지는 ③-1 배달비용으로 갑니다" color="#8b5cf6" />
          <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:20 }}>
            <button onClick={prevMonth} style={NAV_BTN}>‹</button>
            <span style={{ fontSize:20, fontWeight:700 }}>{year}년 {MONTHS[month]}</span>
            <button onClick={nextMonth} style={NAV_BTN}>›</button>
          </div>

          {platforms.map((plat) => {
            const pd=delivMonthData[plat.id]||{};
            const ppd=prevDelivData[plat.id]||{};
            const net=(pd.revenue||0)-(pd.fee||0)-(pd.ad||0)-(pd.agency||0)-(pd.disc||0)+(pd.adj||0);
            const netRate=pctNum(net, pd.revenue||0);
            const hasPrev=Object.keys(ppd).length>0;
            const rvNow=platRevenue(plat.id);
            const ordNow=pd.orders||0, ordPrev=ppd.orders||0;
            const avgNow=ordNow>0?rvNow/ordNow:0;
            const avgPrev=ordPrev>0?(ppd.revenue||0)/ordPrev:0;
            const shops=pd.shops||[], prevShops=ppd.shops||[];
            const unitDeliv=(+pd.unitDeliv>0)?+pd.unitDeliv:((+ppd.unitDeliv>0)?+ppd.unitDeliv:3400);
            const shopCalc=calcShops(shops, pd.fee, pd.agency, unitDeliv);
            const prevShopCalc=calcShops(prevShops, ppd.fee, ppd.agency, (+ppd.unitDeliv>0)?+ppd.unitDeliv:3400);
            const prevShopByName={}; prevShopCalc.forEach(r=>{ if(r.tot>0) prevShopByName[r.name]=r; });
            const prevShopRaw={}; prevShops.forEach(x=>{ const n=(x.name||"").trim(); if(n) prevShopRaw[n]=x; });
            const shopTotRev=shopCalc.reduce((a,r)=>a+r.tot,0);
            const sOpen=!!shopOpen[plat.id];
            const spec=shopSpecOf(plat);
            const fspec=fieldSpecOf(plat);
            const costKeys=costKeysOf(plat, pd);
            return (
              <div key={plat.id} style={{ marginBottom:16, border:"1px solid #1e3448", borderRadius:14, overflow:"hidden" }}>
                <div style={{ background:plat.color, padding:"12px 16px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                  {plat.fixed
                    ? <span style={{ fontSize:14, fontWeight:700, color:"#fff" }}>{plat.name}</span>
                    : <input value={plat.name} onChange={(e)=>renamePlatform(plat.id, e.target.value)} placeholder="플랫폼 이름"
                        title="이름을 눌러 수정할 수 있습니다"
                        style={{ fontSize:14, fontWeight:700, color:"#fff", background:"transparent", border:"none", borderBottom:"1px dashed rgba(255,255,255,0.45)", outline:"none", padding:"1px 0", fontFamily:"inherit", width:Math.max(60,(plat.name||"").length*15+20), maxWidth:200 }} />}
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    {(pd.revenue||0)>0 && <span style={{ fontSize:12, color:"rgba(255,255,255,0.9)", fontWeight:600 }}>실수익률 {pct(net, pd.revenue||0)}</span>}
                    {!plat.fixed && <button onClick={() => deletePlatform(plat.id)} style={{ background:"rgba(255,255,255,0.2)", border:"none", color:"#fff", borderRadius:6, padding:"2px 8px", cursor:"pointer", fontSize:12, fontFamily:"inherit" }}>삭제</button>}
                  </div>
                </div>
                <div style={{ padding:"16px", background:"#112236" }}>
                  {platLinkOf(plat) && (
                    <a href={platLinkOf(plat).url} target="_blank" rel="noopener noreferrer"
                      style={{ display:"inline-flex", alignItems:"center", gap:6, marginBottom:12, padding:"7px 12px", background:"#1a2e42", border:`1px solid ${C.border}`, borderRadius:8, fontSize:11, color:C.textSub, textDecoration:"none", fontWeight:600 }}>
                      {platLinkOf(plat).label} ↗
                    </a>
                  )}
                  <div className="dg-g3" style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:10 }}>
                    {[["총 주문금액","revenue",fspec.revenue],["주문건수","orders",fspec.orders]].map(([lbl,key,hint]) => (
                      <div key={key}>
                        <p style={{ margin:"0 0 2px", fontSize:11, fontWeight:600, color:C.textSub }}>{lbl}</p>
                        <p style={{ margin:"0 0 6px", fontSize:10, color:C.textHint }}>{hint}</p>
                        <div style={{ display:"flex", alignItems:"baseline", gap:4 }}>
                          <MoneyInput value={pd[key]||0} onChange={(v) => setDelivField(plat.id,key,v)} style={INP_MONEY(plat.color)} />
                          {hasPrev && ppd[key]!==undefined && <DiffBadge cur={pd[key]||0} prev={ppd[key]||0} inverse={key!=="revenue" && key!=="orders" && key!=="adj"} />}
                        </div>
                        {key==="orders" && dailyPlatCnt(plat) > 0 && (pd.orders||0) !== dailyPlatCnt(plat) && (
                          <p style={{ margin:"3px 0 0", fontSize:10, color:"#2dd4bf" }}>
                            일일 보고 합계 {dailyPlatCnt(plat).toLocaleString("ko-KR")}건
                            <button onClick={() => setDelivField(plat.id, "orders", dailyPlatCnt(plat))} style={{ marginLeft:6, background:"transparent", border:"1px solid rgba(45,212,191,0.5)", color:"#2dd4bf", fontSize:10, borderRadius:5, padding:"1px 7px", cursor:"pointer", fontFamily:"inherit" }}>적용</button>
                          </p>
                        )}
                        {hasPrev && ppd[key]>0 && <p style={{ margin:"2px 0 0", fontSize:10, color:C.textHint }}>전월 {ppd[key].toLocaleString("ko-KR")}{key==="orders"?"건":"원"}</p>}
                      </div>
                    ))}
                    <div>
                      <p style={{ margin:"0 0 2px", fontSize:11, fontWeight:600, color:C.textSub }}>주문단가</p>
                      <p style={{ margin:"0 0 6px", fontSize:10, color:C.textHint }}>주문금액 ÷ 건수 · 자동 계산</p>
                      <div style={{ display:"flex", alignItems:"baseline", gap:4 }}>
                        <span style={{ width:"100%", fontSize:15, fontWeight:700, color:ordNow>0?plat.color:C.textHint, borderBottom:`1.5px solid ${ordNow>0?plat.color:C.border}`, padding:"2px 0", display:"block" }}>
                          {ordNow>0 && rvNow>0 ? Math.round(avgNow).toLocaleString("ko-KR") : "–"}
                        </span>
                        {avgPrev>0 && ordNow>0 && Math.round(avgNow)!==Math.round(avgPrev) && (
                          <span style={{ fontSize:10, fontWeight:700, whiteSpace:"nowrap", color:avgNow>=avgPrev?C.profit:C.loss }}>
                            {avgNow>=avgPrev?"▲":"▼"}{Math.abs(Math.round(avgNow-avgPrev)).toLocaleString("ko-KR")}
                          </span>
                        )}
                      </div>
                      {avgPrev>0 && <p style={{ margin:"2px 0 0", fontSize:10, color:C.textHint }}>전월 {Math.round(avgPrev).toLocaleString("ko-KR")}원</p>}
                    </div>
                  </div>
                  <div className="dg-g5" style={{ display:"grid", gridTemplateColumns:`repeat(${costKeys.length},1fr)`, gap:10 }}>
                    {costKeys.map((key) => {
                      const lbl = key==="ad" ? (fspec.adLabel || COST_LABEL.ad) : COST_LABEL[key];
                      const hint = fspec[key] || PLAT_FIELD._default[key];
                      return (
                      <div key={key}>
                        <p style={{ margin:"0 0 2px", fontSize:11, fontWeight:600, color:C.textSub }}>{lbl}</p>
                        <p style={{ margin:"0 0 6px", fontSize:10, color:C.textHint, lineHeight:1.6 }}>{hint}</p>
                        <div style={{ display:"flex", alignItems:"baseline", gap:4 }}>
                          <MoneyInput value={pd[key]||0} onChange={(v) => setDelivField(plat.id,key,v)} style={INP_MONEY(plat.color)} />
                          {hasPrev && ppd[key]!==undefined && <DiffBadge cur={pd[key]||0} prev={ppd[key]||0} inverse={true} />}
                        </div>
                        {hasPrev && ppd[key]>0 && <p style={{ margin:"2px 0 0", fontSize:10, color:C.textHint }}>전월 {ppd[key].toLocaleString("ko-KR")}원</p>}
                      </div>
                      );
                    })}
                  </div>
                  {(pd.revenue||0)>0 && (
                    <div style={{ marginTop:12, padding:"10px 14px", background:`${plat.color}12`, borderRadius:8, display:"flex", gap:12, flexWrap:"wrap" }}>
                      {[["수수료율",pct(pd.fee||0,pd.revenue||0),C.loss],["광고비율",pct(pd.ad||0,pd.revenue||0),C.other],...(costKeys.includes("agency")?[["대행비율",pct(pd.agency||0,pd.revenue||0),"#8b5cf6"]]:[]),["실수익률",pct(net,pd.revenue||0),netRate>=15?C.profit:netRate>=10?C.other:C.loss],["실수익",fmtW(net),net>=0?C.profit:C.loss]].map(([lbl,val,clr]) => (
                        <div key={lbl}><p style={{ margin:0, fontSize:10, color:C.textHint }}>{lbl}</p><p style={{ margin:"2px 0 0", fontSize:13, fontWeight:700, color:clr }}>{val}</p></div>
                      ))}
                    </div>
                  )}
                  {/* 전월 대비 요약 */}
                  {hasPrev && (ppd.revenue||0)>0 && (pd.revenue||0)>0 && (
                    <div style={{ marginTop:10, padding:"8px 12px", background:"#1a2e42", borderRadius:8 }}>
                      <p style={{ margin:"0 0 6px", fontSize:11, fontWeight:600, color:C.textHint }}>전월 대비</p>
                      <div style={{ display:"flex", gap:16, flexWrap:"wrap" }}>
                        {(() => {
                          const curRev=pd.revenue||0, prevRev=ppd.revenue||0;
                          const curNet=(curRev-(pd.fee||0)-(pd.ad||0)-(pd.agency||0)-(pd.disc||0)+(pd.adj||0));
                          const prevNet=(prevRev-(ppd.fee||0)-(ppd.ad||0)-(ppd.agency||0)-(ppd.disc||0)+(ppd.adj||0));
                          const r=(v,b)=>b>0?(v/b*100).toFixed(1):0;
                          const items=[
                            { lbl:"주문금액", diff:curRev-prevRev, prevRate:null, curRate:null, inv:false },
                            ...(ordNow>0&&ordPrev>0?[
                              { lbl:"주문건수", diff:ordNow-ordPrev, prevRate:null, curRate:null, inv:false, unit:"건" },
                              { lbl:"주문단가", diff:Math.round(avgNow-avgPrev), prevRate:null, curRate:null, inv:false },
                            ]:[]),
                            { lbl:"수수료", diff:(pd.fee||0)-(ppd.fee||0), prevRate:r(ppd.fee||0,prevRev), curRate:r(pd.fee||0,curRev), inv:true },
                            { lbl:"광고비", diff:(pd.ad||0)-(ppd.ad||0), prevRate:r(ppd.ad||0,prevRev), curRate:r(pd.ad||0,curRev), inv:true },
                            { lbl:"대행비", diff:(pd.agency||0)-(ppd.agency||0), prevRate:r(ppd.agency||0,prevRev), curRate:r(pd.agency||0,curRev), inv:true },
                            { lbl:"부담금액", diff:(pd.adj||0)-(ppd.adj||0), prevRate:null, curRate:null, inv:false },
                            { lbl:"실수익", diff:curNet-prevNet, prevRate:r(prevNet,prevRev), curRate:r(curNet,curRev), inv:false },
                          ].filter(({diff})=>diff!==0);
                          return items.map(({lbl,diff,prevRate,curRate,inv,unit}) => {
                            const isGood = inv ? diff<0 : diff>0;
                            return (
                              <div key={lbl}>
                                <span style={{ fontSize:11, color:C.textSub }}>{lbl} </span>
                                <span style={{ fontSize:11, fontWeight:700, color:isGood?C.profit:C.loss }}>
                                  {diff>0?"▲":"▼"}{Math.abs(diff).toLocaleString("ko-KR")}{unit||"원"}
                                </span>
                                {prevRate!==null && <span style={{ fontSize:10, color:C.textHint, marginLeft:3 }}>({prevRate}%→{curRate}%)</span>}
                              </div>
                            );
                          });
                        })()}
                      </div>
                      {ordNow>0 && ordPrev>0 && (pd.revenue||0)!==(ppd.revenue||0) && (() => {
                        const byCnt=(ordNow-ordPrev)*avgPrev;
                        const byAvg=(avgNow-avgPrev)*ordNow;
                        const F=(v)=>(v>=0?"＋":"－")+Math.abs(Math.round(v)).toLocaleString("ko-KR")+"원";
                        return (
                          <div style={{ marginTop:8, paddingTop:8, borderTop:"1px solid #243d54" }}>
                            <p style={{ margin:"0 0 5px", fontSize:10, color:C.textHint }}>주문금액 증감은 어디서 왔나</p>
                            <div style={{ display:"flex", gap:14, flexWrap:"wrap" }}>
                              <span style={{ fontSize:11, color:C.textSub }}>건수 기여 <strong style={{ color:byCnt>=0?C.profit:C.loss }}>{F(byCnt)}</strong></span>
                              <span style={{ fontSize:11, color:C.textSub }}>단가 기여 <strong style={{ color:byAvg>=0?C.profit:C.loss }}>{F(byAvg)}</strong></span>
                            </div>
                            {byCnt>0 && byAvg<0 && <p style={{ margin:"5px 0 0", fontSize:10, color:C.other, lineHeight:1.6 }}>주문은 늘었는데 단가가 떨어졌습니다. 할인이나 저가 주문이 늘지 않았는지 확인하세요.</p>}
                            {byCnt<0 && byAvg>0 && <p style={{ margin:"5px 0 0", fontSize:10, color:C.textHint, lineHeight:1.6 }}>주문은 줄었지만 단가가 올랐습니다. 배달은 건당 정액비가 커서 이쪽이 유리한 경우가 많습니다.</p>}
                          </div>
                        );
                      })()}
                    </div>
                  )}
                  {/* ── 플랫폼별 샵인샵 진단 — 모든 배달 플랫폼에 표시 · 사양은 id, 없으면 이름으로 찾고 그래도 없으면 범용 안내 ── */}
                  {(
                  <div style={{ marginTop:12, border:"1px solid #1e3448", borderRadius:10, overflow:"hidden" }}>
                    <button onClick={()=>setShopOpen(o=>({...o,[plat.id]:!o[plat.id]}))} style={{ width:"100%", display:"flex", alignItems:"center", justifyContent:"space-between", padding:"10px 13px", background:sOpen?"#1a2e42":"transparent", border:"none", cursor:"pointer", fontFamily:"inherit" }}>
                      <div style={{ minWidth:0, textAlign:"left" }}>
                        <div style={{ display:"flex", alignItems:"center", gap:7, minWidth:0, flexWrap:"wrap" }}>
                          <span style={{ fontSize:12, fontWeight:700, color:C.text }}>{plat.name} 브랜드별 진단</span>
                          {shops.length>0 && <span style={{ fontSize:11, color:plat.color, fontWeight:700 }}>{shops.length}개</span>}
                          {!sOpen && shopCalc.filter(r=>r.tot>0).length>1 && (() => {
                            const v=[...shopCalc].filter(r=>r.tot>0).sort((a,b)=>b.netRate-a.netRate);
                            const gap=v[0].netRate-v[v.length-1].netRate;
                            return <span style={{ fontSize:10, fontWeight:700, color:gap>=10?C.loss:C.textHint, background:gap>=10?"rgba(248,113,113,0.15)":"transparent", borderRadius:5, padding:gap>=10?"1px 7px":0 }}>격차 {gap.toFixed(1)}%p</span>;
                          })()}
                        </div>
                        <p style={{ margin:"3px 0 0", fontSize:10, color:C.textHint, lineHeight:1.5 }}>
                          {shops.length>0
                            ? "브랜드별 주문단가·할인율·실수익률을 비교합니다"
                            : isVatMerged(plat)
                              ? `${plat.name} 부가세 자료는 사업자 전체가 합산돼 나옵니다. 브랜드를 여럿 돌린다면 여기서 쪼개 보세요`
                              : `${plat.name}는 부가세 자료가 매장별로 따로 나옵니다. 브랜드마다 플랫폼을 나눠 넣어도 됩니다`}
                        </p>
                      </div>
                      <span style={{ fontSize:11, color:C.textHint }}>{sOpen?"▲":"▼"}</span>
                    </button>

                    {sOpen && (
                      <div style={{ padding:"13px", background:"#0D1B2A", borderTop:"1px solid #1e3448" }}>
                        <div style={{ marginBottom:12, padding:"12px 14px", background:"#112236", borderRadius:9 }}>
                          <p style={{ margin:"0 0 7px", fontSize:11, fontWeight:700, color:C.text }}>무엇을 알 수 있나</p>
                          {[["어느 브랜드가 진짜 남는지","매출이 큰 브랜드가 꼭 잘 남는 건 아닙니다"],
                            ["왜 그런지","주문단가·할인율·광고비 중 어디서 새는지 한 줄로 나옵니다"],
                            ["나아지고 있는지","전월 대비 실수익률 변화를 브랜드별로 봅니다"]].map(([t,d]) => (
                            <div key={t} style={{ display:"flex", gap:7, marginBottom:4 }}>
                              <span style={{ color:plat.color, fontSize:10, lineHeight:1.7, flexShrink:0 }}>●</span>
                              <p style={{ margin:0, fontSize:10, color:C.textSub, lineHeight:1.7 }}><strong style={{ color:C.text }}>{t}</strong> — {d}</p>
                            </div>
                          ))}
                          <p style={{ margin:"8px 0 0", paddingTop:8, borderTop:"1px solid #1e3448", fontSize:10, color:C.textHint, lineHeight:1.7 }}>
                            <strong style={{ color:C.textSub }}>수수료와 대행비는 자동 배분됩니다.</strong> 위에 입력하신 {plat.name} 합계를 요율({spec.rateHint})로 나눕니다. 총액은 실측값 그대로라 합계가 어긋나지 않습니다.
                          </p>
                        </div>

                        <div style={{ marginBottom:12, padding:"13px 15px", background:`${plat.color}12`, border:`1px solid ${plat.color}44`, borderRadius:9 }}>
                          <p style={{ margin:"0 0 6px", fontSize:11, fontWeight:700, color:"#fbbf24" }}>메인 브랜드도 넣으셔야 합니다</p>
                          <p style={{ margin:"0 0 10px", fontSize:10, color:C.textSub, lineHeight:1.8 }}>
                            부가세 자료는 사업자 전체 합계입니다. 샵인샵만 넣고 메인 브랜드를 빼면
                            수수료가 남은 브랜드에 몰려서 실수익률이 실제보다 낮게 나옵니다.
                            <strong style={{ color:C.text }}> 이 매장에서 돌리는 브랜드를 전부 넣으십시오.</strong>
                          </p>
                          <p style={{ margin:"0 0 6px", fontSize:11, fontWeight:700, color:plat.color }}>어디서 가져오나</p>
                          <p style={{ margin:"0 0 9px", fontSize:10, color:C.textSub, lineHeight:1.8 }}>
                            위에 넣은 {plat.name} 숫자는 <strong style={{ color:C.text }}>사업자 전체 합계</strong>라 브랜드별로는 알 수 없습니다.
 {spec.portal}에서 브랜드를 하나씩 골라 아래 칸에 옮기면 됩니다.
                          </p>
                          <div style={{ background:"#0D1B2A", borderRadius:8, padding:"10px 12px" }}>
                            <p style={{ margin:"0 0 6px", fontSize:10, fontWeight:700, color:C.textSub }}>화면 → 입력칸 대응</p>
                            {spec.map.map(([a,b],i) => (
                              <div key={a} style={{ display:"flex", gap:8, marginBottom:i===spec.map.length-1?0:3, alignItems:"baseline" }}>
                                <span style={{ flexShrink:0, minWidth:118, fontSize:10, fontWeight:700, color:plat.color }}>{a}</span>
                                <span style={{ fontSize:10, color:C.textHint, lineHeight:1.6 }}>{b}</span>
                              </div>
                            ))}

                          </div>
                          {shops.length===0 && <p style={{ margin:"8px 0 0", fontSize:10, color:C.textHint, lineHeight:1.7 }}>브랜드가 하나뿐이면 이 진단은 쓰지 않아도 됩니다. 위에 넣은 숫자만으로 충분합니다.</p>}
                        </div>
                        {shops.length>0 && (
                        <div style={{ marginBottom:12, padding:"10px 13px", background:"#112236", borderRadius:9 }}>
                          <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
                            <span style={{ fontSize:11, color:C.textSub, fontWeight:600, whiteSpace:"nowrap" }}>건당 점주부담 배달비</span>
                            <span style={{ display:"flex", alignItems:"center", gap:6, flexShrink:0 }}>
                              <span style={{ width:96, display:"block" }}>
                                <MoneyInput value={unitDeliv} onChange={(v)=>setDelivField(plat.id,"unitDeliv",v)} style={{ fontSize:13, fontWeight:700, textAlign:"right", border:"none", borderBottom:`1.5px solid ${plat.color}`, background:"transparent", outline:"none", padding:"2px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
                              </span>
                              <span style={{ fontSize:11, color:C.textSub }}>원</span>
                            </span>
                          </div>
                          <p style={{ margin:"7px 0 0", fontSize:10, color:C.textHint, lineHeight:1.7 }}>서울·경기 상위 35% 기준값입니다. 지역·매출구간에 따라 1,900~3,400원으로 다르니 정산 상세내역에서 확인하세요. 배분 비율에만 쓰이며 총액은 위 실측값 그대로입니다.</p>
                        </div>
                        )}

                        {shops.length===0 && prevShops.filter(x=>(x.name||"").trim()).length>0 && (
                          <div style={{ marginBottom:11, padding:"11px 13px", background:`${plat.color}14`, border:`1px solid ${plat.color}55`, borderRadius:9, display:"flex", alignItems:"center", justifyContent:"space-between", gap:9, flexWrap:"wrap" }}>
                            <p style={{ margin:0, fontSize:11, color:plat.color, lineHeight:1.6 }}>전월에 브랜드 {prevShops.filter(x=>(x.name||"").trim()).length}개를 입력하셨습니다. 이름만 가져올까요?</p>
                            <button onClick={()=>copyPrevShops(plat.id)} style={{ padding:"7px 13px", background:plat.color, color:"#0D1B2A", border:"none", borderRadius:7, fontSize:11, fontWeight:700, cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" }}>가져오기</button>
                          </div>
                        )}

                        {shops.map((sh, i) => {
                          const r = shopCalc[i] || {};
                          const pv = prevShopByName[r.name];
                          const pRaw = prevShopRaw[(sh.name||"").trim()];
                          const F = (lbl,key) => {
                            const cur = Number(sh[key])||0;
                            const prv = pRaw ? (Number(pRaw[key])||0) : 0;
                            const dv = (prv>0 && cur!==prv) ? cur-prv : null;
                            const isCnt = key==="bmc"||key==="gdc"||key==="pkc";
                            const isCost = key==="disc"||key==="ad";
                            const good = isCost ? dv<0 : dv>0;
                            return (
                              <div key={key}>
                                <p style={{ margin:"0 0 3px", fontSize:10, color:C.textHint }}>{lbl}</p>
                                <div style={{ display:"flex", alignItems:"baseline", gap:4 }}>
                                  <MoneyInput value={cur} onChange={(v)=>setShopField(plat.id,i,key,v)} style={{ width:"100%", fontSize:13, fontWeight:600, border:"none", borderBottom:"1.5px solid #243d54", background:"transparent", outline:"none", padding:"2px 0", fontFamily:"inherit", color:"#f1f5f9", boxSizing:"border-box" }} />
                                  {dv!==null && <span style={{ fontSize:10, fontWeight:700, whiteSpace:"nowrap", color:good?C.profit:C.loss }}>{dv>0?"▲":"▼"}{Math.abs(dv).toLocaleString("ko-KR")}{isCnt?"":""}</span>}
                                </div>
                                {prv>0 && <p style={{ margin:"2px 0 0", fontSize:9, color:C.textHint }}>전월 {prv.toLocaleString("ko-KR")}{isCnt?"건":"원"}</p>}
                              </div>
                            );
                          };
                          const D = (cur, prev, unit, dg) => {
                            if (!pv || !prev) return null;
                            const d = cur - prev;
                            if (Math.abs(d) < (unit==="%p"?0.05:1)) return null;
                            return <span style={{ marginLeft:4, fontSize:10, fontWeight:700, color:d>=0?C.profit:C.loss }}>{d>=0?"▲":"▼"}{Math.abs(d).toLocaleString("ko-KR",{maximumFractionDigits:dg})}{unit}</span>;
                          };
                          return (
                            <div key={i} style={{ marginBottom:10, padding:"12px 13px", background:"#112236", borderRadius:9, border:"1px solid #1e3448" }}>
                              <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10 }}>
                                <input value={sh.name||""} onChange={(e)=>setShopField(plat.id,i,"name",e.target.value)} placeholder="브랜드 이름"
                                  style={{ flex:1, minWidth:0, fontSize:13, fontWeight:700, border:"none", borderBottom:`1.5px solid ${plat.color}`, background:"transparent", outline:"none", padding:"3px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
                                <button onClick={()=>{ if(window.confirm(`"${sh.name||"이 브랜드"}"를 삭제할까요?`)) deleteShop(plat.id,i); }}
                                  style={{ background:"transparent", border:"1px solid #1e3448", color:C.textHint, borderRadius:6, padding:"3px 8px", cursor:"pointer", fontSize:11, fontFamily:"inherit", flexShrink:0 }}>삭제</button>
                              </div>
                              <div style={{ display:"flex", alignItems:"center", gap:7, margin:"0 0 7px" }}>
                                <span style={{ fontSize:10, fontWeight:700, color:plat.color, background:`${plat.color}1a`, borderRadius:5, padding:"2px 8px", whiteSpace:"nowrap" }}>{spec.orderTitle}</span>
                                <span style={{ flex:1, height:1, background:"#1e3448" }} />
                              </div>
                              <div className="dg-g4" style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:8 }}>
                                {spec.orderFields.map(([k,l]) => F(l,k))}
                              </div>

                              <div style={{ display:"flex", alignItems:"center", gap:7, margin:"14px 0 3px" }}>
                                <span style={{ fontSize:10, fontWeight:700, color:"#fbbf24", background:"rgba(251,191,36,0.14)", borderRadius:5, padding:"2px 8px", whiteSpace:"nowrap" }}>{spec.costTitle}</span>
                                <span style={{ flex:1, height:1, background:"#1e3448" }} />
                              </div>
                              <p style={{ margin:"0 0 7px", fontSize:10, color:C.textHint }}>{spec.costHint}</p>
                              <div className="dg-g4" style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:8 }}>
                                {spec.costs.map(([k,l]) => F(l,k))}
                              </div>
                              {(() => {
                                const dSum=(Number(sh.dc1)||0)+(Number(sh.dc2)||0)+(Number(sh.dc3)||0);
                                return dSum>0 ? <p style={{ margin:"7px 0 0", fontSize:10, color:C.textHint }}>할인 합계 <strong style={{ color:C.textSub }}>{fmtW(dSum)}</strong></p> : null;
                              })()}
                              {r.tot>0 && (
                                <div style={{ marginTop:9, paddingTop:8, borderTop:"1px solid #1e3448" }}>
                                  <div style={{ display:"flex", gap:13, flexWrap:"wrap" }}>
                                    <span style={{ fontSize:11, color:C.textSub }}>주문 <strong style={{ color:"#f1f5f9" }}>{fmtW(r.tot)}</strong> · {r.cnt.toLocaleString("ko-KR")}건{D(r.cnt, pv&&pv.cnt, "건", 0)}</span>
                                    <span style={{ fontSize:11, color:C.textSub }}>단가 <strong style={{ color:plat.color }}>{fmtW(r.avg)}</strong>{D(Math.round(r.avg), pv&&Math.round(pv.avg), "원", 0)}</span>
                                    <span style={{ fontSize:11, color:C.textSub }}>실수익률 <strong style={{ color:r.netRate>=60?C.profit:r.netRate>=55?C.other:C.loss }}>{r.netRate.toFixed(1)}%</strong>{D(r.netRate, pv&&pv.netRate, "%p", 1)}</span>
                                  </div>
                                  {pv && <p style={{ margin:"5px 0 0", fontSize:10, color:C.textHint }}>전월 {fmtW(pv.tot)} · {pv.cnt.toLocaleString("ko-KR")}건 · 단가 {fmtW(pv.avg)} · 실수익률 {pv.netRate.toFixed(1)}%</p>}
                                </div>
                              )}
                            </div>
                          );
                        })}

                        {shops.length>0 && (pd.revenue||0)>0 && (() => {
                          // 두 숫자는 기준이 다르다 — 브랜드 금액은 할인 전 주문금액, 위 카드는 할인 차감된 결제금액
                          // 그래서 정확히 맞출 수는 없고, 브랜드를 빠뜨렸는지만 느슨하게 본다
                          const ratio = shopTotRev / (pd.revenue || 1);
                          const missing = ratio < 0.85;     // 15% 넘게 모자라면 빠진 브랜드가 있다고 본다
                          return (
                            <div style={{ marginBottom:10, padding:"11px 13px", borderRadius:9,
                              background: missing ? "rgba(251,191,36,0.10)" : "#0D1B2A",
                              border: `1px solid ${missing ? "rgba(251,191,36,0.4)" : C.border}` }}>
                              <p style={{ margin:0, fontSize:11, fontWeight:700, color: missing ? "#fbbf24" : C.textSub }}>
                                {missing ? "빠진 브랜드가 있어 보입니다" : `브랜드 ${shops.filter(x=>(x.name||"").trim()).length}개 · 주문금액 합계 ${fmtW(shopTotRev)}`}
                              </p>
                              <p style={{ margin:"3px 0 0", fontSize:10, color:C.textHint, lineHeight:1.7 }}>
                                {missing
                                  ? `브랜드 합계 ${fmtW(shopTotRev)}인데 ${plat.name} 부가세 자료의 매출은 ${fmtW(pd.revenue||0)}입니다. 이 매장에서 돌리는 브랜드를 전부 넣으셔야 배분이 맞습니다.`
                                  : `브랜드 금액은 할인 전 주문금액이고, ${plat.name} 부가세 자료의 매출은 할인이 빠진 결제금액입니다. 그래서 두 숫자에 차이가 있습니다.`}
                              </p>
                            </div>
                          );
                        })()}
                        <button onClick={()=>addShop(plat.id)} style={{ width:"100%", padding:"12px", border:`2px dashed ${shops.length===0?plat.color+"66":"#1e3448"}`, borderRadius:9, background:shops.length===0?`${plat.color}0d`:"transparent", color:shops.length===0?plat.color:C.textHint, fontSize:12, cursor:"pointer", fontFamily:"inherit", fontWeight:700 }}>
                          + {plat.name} 브랜드 추가{shops.length===0 && " — 여기부터 시작하세요"}
                        </button>

                        {shopCalc.filter(r=>r.tot>0).length>1 && shopTotRev>0 && (
                          <div style={{ marginTop:14 }}>
                            <p style={{ margin:"0 0 3px", fontSize:12, fontWeight:700 }}>브랜드별 비교</p>
                            <p style={{ margin:"0 0 9px", fontSize:10, color:C.textHint, lineHeight:1.7 }}>
                              실수익률 순 · 수수료+배달비와 대행은 요율·건수 기준 배분값<br />
                              <strong style={{ color:"#a78bfa" }}>수수료+배달비</strong>는 중개이용료 + 결제수수료 + 배민배달 배달비(부가세 포함),
                              <strong style={{ color:"#a78bfa" }}> 대행</strong>은 가게배달 대행사 비용입니다. 둘을 더한 것이 배달 한 건에 드는 돈입니다.
                            </p>
                            <div style={{ overflowX:"auto" }}>
                              <table style={{ width:"100%", borderCollapse:"collapse", minWidth:500 }}>
                                <thead>
                                  <tr style={{ borderBottom:"2px solid #1e3448" }}>
                                    <th style={{...TH_S, paddingLeft:2}}>브랜드</th>
                                    <th style={{...TH_S, textAlign:"right"}}>주문단가</th>
                                    <th style={{...TH_S, textAlign:"right"}}>수수료+배달비</th>
                                    <th style={{...TH_S, textAlign:"right"}}>대행</th>
                                    <th style={{...TH_S, textAlign:"right", color:"#8b5cf6"}}>배달비용 합계</th>
                                    <th style={{...TH_S, textAlign:"right"}}>할인율</th>
                                    <th style={{...TH_S, textAlign:"right"}}>광고</th>
                                    <th style={{...TH_S, textAlign:"right"}}>실수익률</th>
                                    <th style={{...TH_S, textAlign:"right"}}>전월비</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {[...shopCalc].filter(r=>r.tot>0).sort((a,b)=>b.netRate-a.netRate).map((r,i) => (
                                    <tr key={i} style={{ borderBottom:"1px solid #1e3448" }}>
                                      <td style={{...TD_S, paddingLeft:2, color:"#f1f5f9", fontWeight:600, whiteSpace:"nowrap" }}>{r.name}</td>
                                      <td style={{...TD_S, textAlign:"right", color:plat.color, fontWeight:700, whiteSpace:"nowrap" }}>{Math.round(r.avg).toLocaleString("ko-KR")}원</td>
                                      <td style={{...TD_S, textAlign:"right", color:C.textSub }}>{(r.fee/r.tot*100).toFixed(1)}%</td>
                                      <td style={{...TD_S, textAlign:"right", color:C.textSub }}>{(r.ag/r.tot*100).toFixed(1)}%</td>
                                      <td style={{...TD_S, textAlign:"right", color:"#a78bfa", fontWeight:700 }}>{((r.fee+r.ag)/r.tot*100).toFixed(1)}%</td>
                                      <td style={{...TD_S, textAlign:"right", color:r.disc/r.tot>=0.12?C.loss:C.textSub }}>{(r.disc/r.tot*100).toFixed(1)}%</td>
                                      <td style={{...TD_S, textAlign:"right", color:r.ad/r.tot>=0.05?C.other:C.textSub }}>{(r.ad/r.tot*100).toFixed(1)}%</td>
                                      <td style={{...TD_S, textAlign:"right", fontWeight:700, fontSize:14, color:r.netRate>=60?C.profit:r.netRate>=55?C.other:C.loss }}>{r.netRate.toFixed(1)}%</td>
                                      <td style={{...TD_S, textAlign:"right", fontSize:11, whiteSpace:"nowrap" }}>{(() => {
                                        const pv2 = prevShopByName[r.name];
                                        if (!pv2) return <span style={{ color:C.textHint }}>–</span>;
                                        const d = r.netRate - pv2.netRate;
                                        if (Math.abs(d) < 0.05) return <span style={{ color:C.textHint }}>—</span>;
                                        return <span style={{ color:d>=0?C.profit:C.loss, fontWeight:700 }}>{d>=0?"▲":"▼"}{Math.abs(d).toFixed(1)}%p</span>;
                                      })()}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            {(() => {
                              const v = [...shopCalc].filter(r=>r.tot>0).sort((a,b)=>b.netRate-a.netRate);
                              const hi=v[0], lo=v[v.length-1];
                              const gap=hi.netRate-lo.netRate;
                              const causes=[];
                              if (lo.avg < hi.avg*0.9) causes.push(`주문단가가 ${Math.round(hi.avg-lo.avg).toLocaleString("ko-KR")}원 낮고`);
                              if (lo.disc/lo.tot > hi.disc/hi.tot + 0.03) causes.push(`할인율이 ${((lo.disc/lo.tot-hi.disc/hi.tot)*100).toFixed(1)}%p 높으며`);
                              if (lo.ad/lo.tot > hi.ad/hi.tot + 0.015) causes.push(`광고비율이 ${((lo.ad/lo.tot-hi.ad/hi.tot)*100).toFixed(1)}%p 높습니다`);
                              // 배달비용(수수료+대행)도 원인이 될 수 있다
                              const loD=(lo.fee+lo.ag)/lo.tot, hiD=(hi.fee+hi.ag)/hi.tot;
                              if (loD > hiD + 0.02) causes.push(`배달비용이 ${((loD-hiD)*100).toFixed(1)}%p 높습니다`);
                              return (
                                <div style={{ marginTop:11, padding:"11px 13px", background:gap>=10?"rgba(248,113,113,0.08)":"rgba(251,191,36,0.08)", border:`1px solid ${gap>=10?"rgba(248,113,113,0.3)":"rgba(251,191,36,0.3)"}`, borderRadius:9 }}>
                                  <p style={{ margin:0, fontSize:11, fontWeight:700, color:gap>=10?C.loss:C.other }}>
                                    {hi.name} {hi.netRate.toFixed(1)}% vs {lo.name} {lo.netRate.toFixed(1)}% · 차이 {gap.toFixed(1)}%p
                                  </p>
                                  {causes.length>0 && (
                                    <p style={{ margin:"5px 0 0", fontSize:11, color:C.textSub, lineHeight:1.7 }}>{lo.name}는 {causes.join(", ")}{causes[causes.length-1].endsWith("니다")?"":"."}</p>
                                  )}
                                  <p style={{ margin:"5px 0 0", fontSize:10, color:C.textHint, lineHeight:1.7 }}>배달은 건당 정액비(배달비 {unitDeliv.toLocaleString("ko-KR")}원)가 커서 단가가 낮을수록 수수료율이 올라갑니다. 단가부터 확인하세요.</p>
                                </div>
                              );
                            })()}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  )}
                </div>
              </div>
            );
          })}

          <div style={{ display:"flex", gap:8, marginBottom:20 }}>
            <input value={newPlatform} onChange={(e) => setNewPlatform(e.target.value)} onKeyDown={(e) => e.key==="Enter"&&addPlatform()} placeholder="플랫폼 추가 (예: 요기요, 땡겨요, 배달특급)" style={{ flex:1, fontSize:13, padding:"10px 14px", border:"1px solid #1e3448", borderRadius:10, background:"#112236", color:"#f1f5f9", fontFamily:"inherit", outline:"none" }} />
            <button onClick={addPlatform} style={{ padding:"10px 18px", background:storeColor, color:"#fff", border:"none", borderRadius:10, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>+ 추가</button>
          </div>

          {totalDelivRevenue>0 && (
            <div style={{ padding:"18px 20px", background:"#1a2e42", borderRadius:14, border:"1px solid #1e3448" }}>
              <p style={{ margin:"0 0 12px", fontSize:14, fontWeight:700 }}>배달 전체 합계</p>
              <div className="dg-g3" style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8 }}>
                {(() => {
                  const totOrd=platforms.reduce((a,p)=>a+(delivMonthData[p.id]?.orders||0),0);
                  const base=[["총 주문금액",fmtW(totalDelivRevenue),"#e2e8f0"]];
                  if (totOrd>0) base.push(["총 주문건수",totOrd.toLocaleString("ko-KR")+"건","#e2e8f0"],["평균 주문단가",Math.round(totalDelivRevenue/totOrd).toLocaleString("ko-KR")+"원",C.delivery]);
                  base.push(["수수료",fmtW(totalDelivFee),C.loss],["광고비",fmtW(totalDelivAd),C.other],["대행비",fmtW(totalDelivAgency),"#8b5cf6"]);
                  if (totalDelivAdj>0) base.push(["부담금액 (차감)","−"+fmtW(totalDelivAdj),C.profit]);
                  base.push(["실수익",fmtW(totalDelivNet),totalDelivNet>=0?C.profit:C.loss]);
                  return base.map(([lbl,val,clr]) => (
                    <div key={lbl} style={{ background:"#112236", borderRadius:10, padding:"10px 12px" }}>
                      <p style={{ margin:0, fontSize:10, color:C.textSub, fontWeight:600 }}>{lbl}</p>
                      <p style={{ margin:"4px 0 0", fontSize:13, fontWeight:700, color:clr }}>{val}</p>
                    </div>
                  ));
                })()}
              </div>
            </div>
          )}
        </div>
      )}

      {/* ════ 인건비 ════ */}
      {tab==="인건비" && (
        <div>
          <PLBadge num="③ 판관비" label="인건비" sub="직원별 급여 · 사장님 인건비(선택) · 임금명세서 · 근로계약서" color={C.labor} />
          <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:20 }}>
            <button onClick={prevMonth} style={NAV_BTN}>‹</button>
            <span style={{ fontSize:20, fontWeight:700 }}>{year}년 {MONTHS[month]}</span>
            <button onClick={nextMonth} style={NAV_BTN}>›</button>
          </div>

          {/* 전월 명단 안내: 이 달에 아직 입력이 없을 때 */}
          {monthlyEmployees[mk] === undefined && (() => {
            const found = findPrevEmployees();
            if (!found) return null;
            const fm = Number(found.key.split("-")[1]);
            return (
              <div style={{ marginBottom:16, padding:"12px 16px", background:"rgba(167,139,250,0.08)", border:"1px solid rgba(167,139,250,0.3)", borderRadius:12, display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, flexWrap:"wrap" }}>
                <p style={{ margin:0, fontSize:12, color:C.labor, lineHeight:1.6 }}>
                  이번 달 직원 입력이 아직 없습니다. 입력을 시작하면 {fm}월 명단({found.list.length}명)을 자동으로 가져옵니다.
                </p>
                <button onClick={() => { const copied = copyPrevEmployees(); if (copied.length) setMonthlyEmployees(prev => prev[mk] !== undefined ? prev : ({...prev, [mk]: copied})); }} style={{ padding:"8px 14px", background:C.labor, color:"#fff", border:"none", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" }}>지금 가져오기</button>
              </div>
            );
          })()}

          {/* 사장님 인건비 - 접을 수 있는 작은 섹션 */}
          <BizInfoSection biz={bizInfo} setBizInfo={setBizInfo} C={C} />

          {justAdded && employees.some((x) => x.id === justAdded) && (
            <div style={{ marginBottom:14, padding:"12px 16px", background:`${C.labor}12`, border:`1px solid ${C.labor}45`, borderRadius:12, display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
              <div style={{ flex:"1 1 180px", minWidth:0 }}>
                <p style={{ margin:0, fontSize:12, fontWeight:700, color:C.text }}>{(employees.find((x)=>x.id===justAdded)||{}).name}님을 등록했습니다</p>
                <p style={{ margin:"2px 0 0", fontSize:11, color:C.textSub }}>이어서 근로계약서를 쓰시겠습니까</p>
              </div>
              <div style={{ display:"flex", gap:6 }}>
                <button onClick={()=>{ setContractEmp(justAdded); setJustAdded(null); }} style={{ padding:"8px 14px", background:C.labor, color:"#fff", border:"none", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>계약서 쓰기</button>
                <button onClick={()=>setJustAdded(null)} style={{ padding:"8px 10px", background:"transparent", color:C.textHint, border:"1px solid #243d54", borderRadius:8, fontSize:12, cursor:"pointer", fontFamily:"inherit" }}>나중에</button>
              </div>
            </div>
          )}

          {contractEmp && (() => {
            const ce = employees.find((x) => x.id === contractEmp);
            if (!ce) return null;
            return <ContractModal emp={ce} biz={bizInfo} setBizInfo={setBizInfo} updateEmployee={updateEmployee}
                     payDay={payDay} storeName={selectedStore.name} year={year} month={month} C={C} onClose={()=>setContractEmp(null)} />;
          })()}

          <OwnerWageSection
            mk={mk} MONTHS={MONTHS} month={month} year={year}
            ownerWage={ownerWage} setOwnerWage={setOwnerWage} explicit={ownerWageExplicit}
            totalRev={totalRev} C={C} labor={C.labor} pct={pct}
          />

          {/* 직원 인건비 */}
          <CostSection title="직원 인건비" color="#0d9488" desc="시급제·월급제 선택 / 공제방식 선택 → 사업주 실부담액 자동 계산">
            {employees.length > 0 && (
              <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, marginBottom:12, padding:"10px 13px", background:"#1a2e42", borderRadius:10, flexWrap:"wrap" }}>
                <span style={{ fontSize:12, color:C.textSub, display:"flex", alignItems:"center", gap:7 }}>
                  급여 지급일
                  <input type="number" value={payDay} onChange={e=>setPayDay(Math.min(31,Math.max(1,Number(e.target.value)||1)))}
                    style={{ width:46, fontSize:13, fontWeight:700, textAlign:"center", border:"none", borderBottom:`1.5px solid ${C.labor}`, background:"transparent", color:"#f1f5f9", outline:"none", fontFamily:"inherit" }} />
                  일
                  <span style={{ fontSize:11, color:C.textHint }}>· 임금명세서에 표시됩니다</span>
                </span>
                <button onClick={savePayslipAll} style={{ fontSize:12, fontWeight:700, color:"#fff", background:C.labor, border:"none", borderRadius:9, padding:"8px 13px", cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" }}>전체 명세서 발행</button>
              </div>
            )}
            {employees.length>0 && (
              <div style={{ marginBottom:16 }}>
                <div className="dg-t">
                <table className="dg-emp" style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead>
                    <tr style={{ borderBottom:`2px solid ${C.border}` }}>
                      <th style={TH_S}>이름</th>
                      <th style={{...TH_S, textAlign:"right"}}>기본급</th>
                      <th style={{...TH_S, textAlign:"right"}}>실지급액</th>
                      <th style={{...TH_S, textAlign:"right"}}>사업주부담</th>
                      <th style={{...TH_S, width:28}} />
                    </tr>
                  </thead>
                  <tbody>
                    {employees.map(e => {
                      const base=calcBase(e);
                      const net=calcNetPay(e);
                      const employer=calcEmployerCost(e);
                      const isInsurance = e.deductionType==="insurance";
                      const isEditEmp=editingEmployee===e.id;
                      return (
                        <tr key={e.id} className={isEditEmp ? "dg-emp-edit" : undefined} {...(isEditEmp ? { "data-emp-edit": "1" } : {})} style={{ borderBottom:"1px solid #1e3448" }}>
                          {isEditEmp ? (
                            <>
                              <td className="c-name" style={TD_S}>
                                <input value={e.name} onChange={ev=>updateEmployee(e.id,"name",ev.target.value)} onKeyDown={ev=>ev.key==="Enter"&&setEditingEmployee(null)} style={{...INP_S,width:"100%",display:"block",boxSizing:"border-box"}} />
                                <input value={e.birth||""} onChange={ev=>updateEmployee(e.id,"birth",ev.target.value)} placeholder="생년월일 90.01.15" style={{...INP_S,width:"100%",marginTop:4,fontSize:11,display:"block",boxSizing:"border-box"}} />
                                <div style={{display:"flex",gap:6,marginTop:4}}>
                                  <select value={e.payType} onChange={ev=>updateEmployee(e.id,"payType",ev.target.value)} style={{fontSize:10,border:"1px solid #1e3448",background:"#112236",borderRadius:4,padding:"1px 4px",fontFamily:"inherit",outline:"none",cursor:"pointer"}}>
                                    <option value="hourly" style={{ background:"#112236", color:"#f1f5f9" }}>시급</option>
                                    <option value="monthly" style={{ background:"#112236", color:"#f1f5f9" }}>월급</option>
                                  </select>
                                  <select value={e.deductionType} onChange={ev=>updateEmployee(e.id,"deductionType",ev.target.value)} style={{fontSize:10,border:"1px solid #1e3448",background:"#112236",borderRadius:4,padding:"1px 4px",fontFamily:"inherit",outline:"none",cursor:"pointer"}}>
                                    <option value="none" style={{ background:"#112236", color:"#f1f5f9" }}>공제없음</option>
                                    <option value="withholding" style={{ background:"#112236", color:"#f1f5f9" }}>3.3%</option>
                                    <option value="insurance">4대보험</option>
                                  </select>
                                </div>
                                <span style={{display:"flex",gap:6,marginTop:5}}>
                                  <input value={bankOf(e).name} onChange={ev=>updateEmployee(e.id,"bankName",ev.target.value)} placeholder="은행" style={{width:52,boxSizing:"border-box",fontSize:10,border:"none",borderBottom:"1px solid #243d54",background:"transparent",outline:"none",padding:"2px 0",fontFamily:"inherit",color:"#94a3b8"}} />
                                  <input value={bankOf(e).no} onChange={ev=>updateEmployee(e.id,"bankAccount",ev.target.value)} placeholder="계좌번호" style={{flex:1,minWidth:0,boxSizing:"border-box",fontSize:10,border:"none",borderBottom:"1px solid #243d54",background:"transparent",outline:"none",padding:"2px 0",fontFamily:"inherit",color:"#94a3b8"}} />
                                </span>
                                <input value={e.phone||""} onChange={ev=>updateEmployee(e.id,"phone",ev.target.value)} placeholder="연락처" style={{marginTop:4,width:"100%",boxSizing:"border-box",fontSize:10,border:"none",borderBottom:"1px solid #243d54",background:"transparent",outline:"none",padding:"2px 0",fontFamily:"inherit",color:"#94a3b8"}} />
                                <input value={e.address||""} onChange={ev=>updateEmployee(e.id,"address",ev.target.value)} placeholder="주소 · 계약서" style={{marginTop:4,width:"100%",boxSizing:"border-box",fontSize:10,border:"none",borderBottom:"1px solid #243d54",background:"transparent",outline:"none",padding:"2px 0",fontFamily:"inherit",color:"#94a3b8"}} />
                                <input value={e.email||""} onChange={ev=>updateEmployee(e.id,"email",ev.target.value)} placeholder="이메일 · 계약서" style={{marginTop:4,width:"100%",boxSizing:"border-box",fontSize:10,border:"none",borderBottom:"1px solid #243d54",background:"transparent",outline:"none",padding:"2px 0",fontFamily:"inherit",color:"#94a3b8"}} />
                                {e.deductionType==="insurance" && (
                                  <div style={{marginTop:5, display:"flex", flexDirection:"column", gap:4}}>
                                    <span style={{fontSize:10,color:C.textSub}}>소득세 <strong style={{color:C.labor}}>{incomeTaxOf(e).toLocaleString("ko-KR")}</strong>{e.incomeTaxManual?" (직접)":" (자동)"}</span>
                                    {!e.incomeTaxManual ? (
                                      <span style={{display:"flex",gap:5,alignItems:"center",flexWrap:"wrap"}}>
                                        <select value={e.dependents||1} onChange={ev=>updateEmployee(e.id,"dependents",ev.target.value)} style={{fontSize:10,border:"1px solid #1e3448",background:"#112236",color:"#f1f5f9",borderRadius:4,padding:"1px 3px",fontFamily:"inherit",outline:"none",cursor:"pointer"}}>
                                          {[1,2,3,4].map(n=><option key={n} value={n} style={{background:"#112236"}}>가족 {n}{n===4?"+":""}</option>)}
                                        </select>
                                        <select value={e.children||0} onChange={ev=>updateEmployee(e.id,"children",ev.target.value)} style={{fontSize:10,border:"1px solid #1e3448",background:"#112236",color:"#f1f5f9",borderRadius:4,padding:"1px 3px",fontFamily:"inherit",outline:"none",cursor:"pointer"}}>
                                          {[0,1,2,3].map(n=><option key={n} value={n} style={{background:"#112236"}}>자녀 {n}</option>)}
                                        </select>
                                        <button onClick={()=>{ updateEmployee(e.id,"incomeTax",incomeTaxOf(e)); updateEmployee(e.id,"incomeTaxManual",true); }} style={{...ADD_BTN,fontSize:9,padding:"2px 6px"}}>직접</button>
                                      </span>
                                    ) : (
                                      <span style={{display:"flex",gap:5,alignItems:"center"}}>
                                        <input type="number" value={e.incomeTax||0} onChange={ev=>updateEmployee(e.id,"incomeTax",ev.target.value)} style={{...INP_S,width:80,fontSize:11}} />
                                        <button onClick={()=>updateEmployee(e.id,"incomeTaxManual",false)} style={{...ADD_BTN,fontSize:9,padding:"2px 6px"}}>자동</button>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </td>
                              <td className="c-base" data-label="기본급" style={{...TD_S,textAlign:"right"}}>
                                {e.payType==="hourly" ? (
                                  <div style={{display:"flex",flexDirection:"column",gap:5,alignItems:"flex-end"}}>
                                    <span style={{display:"flex",alignItems:"center",gap:4}}>
                                      <input type="number" value={e.hourlyWage||""} onChange={ev=>updateEmployee(e.id,"hourlyWage",ev.target.value)} placeholder="시급"
                                        style={{width:66,fontSize:12,textAlign:"right",border:"none",borderBottom:`1px solid ${C.labor}`,background:"transparent",outline:"none",padding:"1px 0",fontFamily:"inherit",color:"#f1f5f9"}} />
                                      <span style={{fontSize:10,color:C.textHint,whiteSpace:"nowrap"}}>원 ×</span>
                                      <input type="number" value={e.totalHours||""} onChange={ev=>updateEmployee(e.id,"totalHours",ev.target.value)} placeholder="시간"
                                        style={{width:44,fontSize:12,textAlign:"right",border:"none",borderBottom:`1px solid ${C.labor}`,background:"transparent",outline:"none",padding:"1px 0",fontFamily:"inherit",color:"#f1f5f9"}} />
                                      <span style={{fontSize:10,color:C.textHint}}>h</span>
                                    </span>
                                    <label style={{display:"flex",alignItems:"center",gap:4,cursor:"pointer"}}>
                                      <input type="checkbox" checked={!!e.holidayPay} onChange={ev=>updateEmployee(e.id,"holidayPay",ev.target.checked)} style={{width:12,height:12,accentColor:C.labor,cursor:"pointer"}} />
                                      <span style={{fontSize:10,color:C.textSub,whiteSpace:"nowrap"}}>주휴</span>
                                      {e.holidayPay && (
                                        <>
                                          <input type="number" inputMode="decimal" step="any" value={e.holidayHours ?? ""} placeholder={String(suggestHolidayHours(e))}
                                            onChange={ev=>updateEmployee(e.id,"holidayHours",ev.target.value)}
                                            style={{width:44,fontSize:12,textAlign:"right",border:"none",borderBottom:`1px solid ${C.labor}`,background:"transparent",outline:"none",padding:"1px 0",fontFamily:"inherit",color:"#f1f5f9"}} />
                                          <span style={{fontSize:10,color:C.textHint,whiteSpace:"nowrap"}}>h · {calcHolidayPay(e).toLocaleString("ko-KR")}원</span>
                                        </>
                                      )}
                                    </label>
                                    <span style={{fontSize:11,color:C.textSub}}>기본급 <strong style={{color:"#f1f5f9"}}>{calcBase(e).toLocaleString("ko-KR")}원</strong></span>
                                  </div>
                                ) : (
                                  <input type="number" value={e.monthlySalary||""} onChange={ev=>updateEmployee(e.id,"monthlySalary",ev.target.value)} placeholder="월급"
                                    style={{width:110,fontSize:13,textAlign:"right",border:"none",borderBottom:`1px solid ${C.labor}`,background:"transparent",outline:"none",padding:"2px 0",fontFamily:"inherit",color:"#f1f5f9"}} />
                                )}
                              </td>
                              <td className="c-net" data-label="실지급액" style={{...TD_S,textAlign:"right",fontSize:12,color:C.textSub}}>{net.toLocaleString("ko-KR")}원</td>
                              <td className="c-emp" data-label="사업주부담" style={{...TD_S,textAlign:"right",fontWeight:700,color:C.labor}}>{employer.toLocaleString("ko-KR")}원</td>
                              <td className="c-act" style={{...TD_S,textAlign:"center"}}><button onClick={()=>setEditingEmployee(null)} style={DONE_BTN} title="완료 (행 밖을 눌러도 닫힙니다)">✓</button></td>
                            </>
                          ) : (
                            <>
                              <td className="c-name" style={{...TD_S,cursor:"pointer"}} onClick={()=>setEditingEmployee(e.id)}>
                                <span style={{fontWeight:600}}>{e.name}</span>
                                <span style={{marginLeft:5,fontSize:10,color:C.textHint}}>{e.deductionType==="insurance"?"4대":e.deductionType==="withholding"?"3.3%":""}</span>
                                {calcHolidayPay(e)>0 && <span style={{marginLeft:4,fontSize:10,color:"#2dd4bf"}}>주휴</span>}
                                {!e.signedAt && (!e.birth || !e.address) && <span style={{marginLeft:4,fontSize:10,color:"#fbbf24"}}>계약서 정보 부족</span>}
                                {(bankOf(e).no || e.phone) && (
                                  <div style={{marginTop:3,fontSize:11,display:"flex",alignItems:"center",gap:5,flexWrap:"wrap"}}>
                                    {bankOf(e).no && (
                                      <>
                                        <span style={{color:"#fbbf24"}}>{bankText(e)}</span>
                                        <button onClick={(ev)=>{ ev.stopPropagation(); copyAccount(bankOf(e).no, e.id); }}
                                          style={{fontSize:10, padding:"1px 7px", borderRadius:5, border:`1px solid ${copiedId===e.id?"#2dd4bf":"rgba(251,191,36,0.45)"}`, background:"transparent", color:copiedId===e.id?"#2dd4bf":"#fbbf24", cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap"}}>
                                          {copiedId===e.id ? "복사됨" : "복사"}
                                        </button>
                                      </>
                                    )}
                                    {bankOf(e).no && e.phone && <span style={{color:"#334155"}}>·</span>}
                                    {e.phone && <span style={{color:C.textSub}}>{e.phone}</span>}
                                  </div>
                                )}
                              </td>
                              <td className="c-base" data-label="기본급" style={{...TD_S,textAlign:"right",cursor:"pointer",fontSize:12,color:C.textSub}} onClick={()=>setEditingEmployee(e.id)}>
                                {base.toLocaleString("ko-KR")}원
                              </td>
                              <td className="c-net" data-label="실지급액" style={{...TD_S,textAlign:"right",fontSize:12}}>
                                {net.toLocaleString("ko-KR")}원
                              </td>
                              <td className="c-emp" data-label="사업주부담" style={{...TD_S,textAlign:"right",fontWeight:700,color:isInsurance?C.labor:C.textHint,fontSize:isInsurance?13:11}}>
                                {isInsurance ? `${employer.toLocaleString("ko-KR")}원` : "=기본급"}
                              </td>
                              <td className="c-act" style={{...TD_S,textAlign:"center",whiteSpace:"nowrap"}}>
                                <button onClick={()=>savePayslip(e)} style={{...ADD_BTN, fontSize:11, padding:"4px 8px", marginRight:4}}>명세서</button>
                                {navigator.canShare && <button onClick={()=>savePayslip(e, true)} style={{...ADD_BTN, fontSize:11, padding:"4px 8px", marginRight:4, color:C.labor, borderColor:`${C.labor}55`}}>보내기</button>}
                                <button onClick={()=>setContractEmp(e.id)}
                                  style={{...ADD_BTN, fontSize:11, padding:"4px 8px", marginRight:4,
                                    color: e.signedAt ? C.profit : C.textSub,
                                    borderColor: e.signedAt ? `${C.profit}55` : C.border}}>
                                  계약서{e.signedAt ? " ✓" : ""}
                                </button>
                                <button onClick={()=>deleteEmployee(e.id)} style={DEL_BTN}>✕</button>
                              </td>
                            </>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                </div>
              </div>
            )}

            {/* 직원 추가 폼 */}
            <div style={{ background:"#1a2e42", borderRadius:12, padding:"16px" }}>
              <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:12 }}>
                <p style={{ margin:0, fontSize:12, fontWeight:600, color:C.textSub }}>직원 추가</p>
                <span style={{ fontSize:11, color:C.labor, fontWeight:600, background:`${C.labor}15`, padding:"3px 8px", borderRadius:6 }}>
                  {year}년 최저시급 {minWageOf(year).toLocaleString("ko-KR")}원
                </span>
              </div>
              {/* 급여 유형 토글 */}
              <div style={{ display:"flex", gap:6, marginBottom:14 }}>
                {[["hourly","시급제"],["monthly","월급제"]].map(([v,lbl]) => (
                  <button key={v} onClick={()=>setNewEmployee(p=>({...p,payType:v}))} style={{ padding:"6px 14px", border:`1.5px solid ${newEmployee.payType===v?"#0d9488":C.border}`, borderRadius:8, background:newEmployee.payType===v?"#0d948810":"transparent", color:newEmployee.payType===v?"#0d9488":C.textSub, fontSize:12, fontWeight:600, cursor:"pointer", fontFamily:"inherit" }}>{lbl}</button>
                ))}
              </div>

              <div className="dg-gemp" style={{ display:"grid", gridTemplateColumns:newEmployee.payType==="hourly"?"2fr 1.3fr 1fr 1fr 1fr 1fr":"2fr 1.3fr 1fr 1fr 1fr", gap:10, marginBottom:10 }}>
                <div>
                  <p style={{ margin:"0 0 4px", fontSize:11, color:C.textHint }}>이름</p>
                  <input value={newEmployee.name} onChange={e=>setNewEmployee(p=>({...p,name:e.target.value}))} placeholder="홍길동" style={{ width:"100%", fontSize:13, fontWeight:600, border:"none", borderBottom:`1.5px solid ${C.border}`, background:"transparent", outline:"none", padding:"4px 0", fontFamily:"inherit", color:"#f1f5f9", boxSizing:"border-box" }} />
                </div>
                <div>
                  <p style={{ margin:"0 0 4px", fontSize:11, color:C.textHint }}>생년월일</p>
                  <input value={newEmployee.birth} onChange={e=>setNewEmployee(p=>({...p,birth:e.target.value}))} placeholder="90.01.15" style={{ width:"100%", fontSize:13, fontWeight:600, border:"none", borderBottom:`1.5px solid ${C.border}`, background:"transparent", outline:"none", padding:"4px 0", fontFamily:"inherit", color:"#f1f5f9", boxSizing:"border-box" }} />
                </div>
                {newEmployee.payType==="hourly" ? (
                  <>
                    <div>
                      <p style={{ margin:"0 0 4px", fontSize:11, color:C.textHint }}>시급(원)</p>
                      <MoneyInput value={Number(newEmployee.hourlyWage)||0} onChange={v=>setNewEmployee(p=>({...p,hourlyWage:String(v)}))} placeholder={minWageOf(year).toLocaleString("ko-KR")} style={{ width:"100%", fontSize:13, fontWeight:600, border:"none", borderBottom:`1.5px solid ${C.border}`, background:"transparent", outline:"none", padding:"4px 0", fontFamily:"inherit", color:"#f1f5f9", boxSizing:"border-box" }} />
                    </div>
                    <div>
                      <p style={{ margin:"0 0 4px", fontSize:11, color:C.textHint }}>월 총근무(h)</p>
                      <input type="number" value={newEmployee.totalHours} onChange={e=>setNewEmployee(p=>({...p,totalHours:e.target.value}))} placeholder="200" style={{ width:"100%", fontSize:13, fontWeight:600, border:"none", borderBottom:`1.5px solid ${C.border}`, background:"transparent", outline:"none", padding:"4px 0", fontFamily:"inherit", color:"#f1f5f9", boxSizing:"border-box" }} />
                    </div>
                  </>
                ) : (
                  <div>
                    <p style={{ margin:"0 0 4px", fontSize:11, color:C.textHint }}>월 급여(원)</p>
                    <MoneyInput value={Number(newEmployee.monthlySalary)||0} onChange={v=>setNewEmployee(p=>({...p,monthlySalary:String(v)}))} placeholder="3,000,000" style={{ width:"100%", fontSize:13, fontWeight:600, border:"none", borderBottom:`1.5px solid ${C.border}`, background:"transparent", outline:"none", padding:"4px 0", fontFamily:"inherit", color:"#f1f5f9", boxSizing:"border-box" }} />
                  </div>
                )}
                <div>
                  <p style={{ margin:"0 0 4px", fontSize:11, color:C.textHint }}>근무일(참고)</p>
                  <input type="number" value={newEmployee.workDays} onChange={e=>setNewEmployee(p=>({...p,workDays:e.target.value}))} placeholder="25" style={{ width:"100%", fontSize:13, fontWeight:600, border:"none", borderBottom:`1.5px solid ${C.border}`, background:"transparent", outline:"none", padding:"4px 0", fontFamily:"inherit", color:"#f1f5f9", boxSizing:"border-box" }} />
                </div>
                <div>
                  <p style={{ margin:"0 0 4px", fontSize:11, color:C.textHint }}>공제</p>
                  <select value={newEmployee.deductionType} onChange={e=>setNewEmployee(p=>({...p,deductionType:e.target.value}))} style={{ width:"100%", fontSize:12, border:"none", borderBottom:`1.5px solid ${C.border}`, background:"transparent", outline:"none", padding:"4px 0", fontFamily:"inherit", color:"#f1f5f9" }}>
                    <option value="none" style={{ background:"#112236", color:"#f1f5f9" }}>없음</option>
                    <option value="withholding" style={{ background:"#112236", color:"#f1f5f9" }}>원천징수 3.3%</option>
                    <option value="insurance" style={{ background:"#112236", color:"#f1f5f9" }}>4대보험</option>
                  </select>
                </div>
              </div>

              {/* 소득세 (4대보험 선택 시) — 간이세액표 자동 · 직접 입력 가능 */}
              {newEmployee.deductionType === "insurance" && (() => {
                const tmp = { payType:newEmployee.payType, hourlyWage:Number(newEmployee.hourlyWage)||0, totalHours:Number(newEmployee.totalHours)||0, monthlySalary:Number(newEmployee.monthlySalary)||0, holidayPay:!!newEmployee.holidayPay, deductionType:"insurance", dependents:newEmployee.dependents, children:newEmployee.children, incomeTaxManual:newEmployee.incomeTaxManual, incomeTax:newEmployee.incomeTax };
                const auto = simpleIncomeTax(calcBase(tmp), newEmployee.dependents||1, newEmployee.children||0);
                const shown = newEmployee.incomeTaxManual ? (Number(newEmployee.incomeTax)||0) : auto;
                const SEL = { fontSize:12, border:"none", borderBottom:`1.5px solid ${C.border}`, background:"transparent", outline:"none", padding:"3px 0", fontFamily:"inherit", color:"#f1f5f9", cursor:"pointer" };
                return (
                <div style={{ marginBottom:10, padding:"10px 12px", background:"#112236", borderRadius:8, border:"1px solid #1e3448" }}>
                  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap" }}>
                    <span style={{ fontSize:11, fontWeight:700, color:C.textSub }}>소득세 <span style={{ fontWeight:400, color:C.textHint }}>간이세액표로 자동 계산</span></span>
                    <span className="dg-num" style={{ fontSize:14, fontWeight:700, color:C.labor }}>{shown.toLocaleString("ko-KR")}원 <span style={{ fontSize:10, fontWeight:400, color:C.textHint }}>+ 지방소득세 {Math.round(shown*0.1).toLocaleString("ko-KR")}원</span></span>
                  </div>
                  {!newEmployee.incomeTaxManual ? (
                    <div style={{ display:"flex", gap:16, marginTop:8, flexWrap:"wrap" }}>
                      <label style={{ fontSize:11, color:C.textSub, display:"flex", alignItems:"center", gap:6 }}>
                        공제대상 가족
                        <select value={newEmployee.dependents||1} onChange={e=>setNewEmployee(p=>({...p,dependents:Number(e.target.value)}))} style={SEL}>
                          {[1,2,3,4].map(n => <option key={n} value={n} style={{ background:"#112236" }}>{n}명{n===1?" (본인만)":n===4?" 이상":""}</option>)}
                        </select>
                      </label>
                      <label style={{ fontSize:11, color:C.textSub, display:"flex", alignItems:"center", gap:6 }}>
                        8~20세 자녀
                        <select value={newEmployee.children||0} onChange={e=>setNewEmployee(p=>({...p,children:Number(e.target.value)}))} style={SEL}>
                          {[0,1,2,3].map(n => <option key={n} value={n} style={{ background:"#112236" }}>{n}명</option>)}
                        </select>
                      </label>
                      <button onClick={()=>setNewEmployee(p=>({...p,incomeTaxManual:true,incomeTax:String(auto)}))} style={{ ...ADD_BTN, fontSize:10, padding:"3px 8px", marginLeft:"auto" }}>직접 입력</button>
                    </div>
                  ) : (
                    <div style={{ display:"flex", alignItems:"center", gap:8, marginTop:8, flexWrap:"wrap" }}>
                      <span style={{ width:140 }}><MoneyInput value={Number(newEmployee.incomeTax)||0} onChange={v=>setNewEmployee(p=>({...p,incomeTax:String(v)}))} style={INP_MONEY(C.labor)} /></span>
                      <span style={{ fontSize:11, color:C.textSub }}>원</span>
                      <button onClick={()=>setNewEmployee(p=>({...p,incomeTaxManual:false}))} style={{ ...ADD_BTN, fontSize:10, padding:"3px 8px", marginLeft:"auto" }}>자동 계산으로</button>
                    </div>
                  )}
                  <p style={{ margin:"7px 0 0", fontSize:10, color:C.textHint, lineHeight:1.6 }}>
                    가족 수는 본인 포함 기본공제 대상(배우자·부양가족). 식대 등 비과세는 반영하지 않으며, 연말정산에서 정산됩니다. 세무사가 정해준 금액이 있으면 「직접 입력」하세요.
                  </p>
                </div>
                );
              })()}

              {/* 주휴수당 — 만근한 주에만 발생하므로 시간을 직접 넣는다 */}
              {newEmployee.payType === "hourly" && (() => {
                const sug = suggestHolidayHours({ payType:"hourly", hourlyWage:Number(newEmployee.hourlyWage)||0, totalHours:Number(newEmployee.totalHours)||0 });
                const hrs = newEmployee.holidayHours === "" ? sug : (Number(newEmployee.holidayHours) || 0);
                return (
                  <div style={{ marginBottom:10 }}>
                    <label style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer" }}>
                      <input type="checkbox" checked={!!newEmployee.holidayPay}
                        onChange={e=>setNewEmployee(p=>({...p, holidayPay:e.target.checked, holidayHours: e.target.checked && p.holidayHours==="" ? String(sug) : p.holidayHours}))}
                        style={{ width:15, height:15, accentColor:C.labor, cursor:"pointer" }} />
                      <span style={{ fontSize:12, color:C.textSub }}>주휴수당 포함</span>
                    </label>
                    {newEmployee.holidayPay && (
                      <div style={{ marginTop:8, padding:"10px 12px", background:"#0D1B2A", borderRadius:9, border:"1px solid #1e3448" }}>
                        <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
                          <span style={{ fontSize:11, color:C.textSub, fontWeight:600 }}>주휴시간</span>
                          <input type="number" inputMode="decimal" step="any" value={newEmployee.holidayHours}
                            onChange={e=>setNewEmployee(p=>({...p, holidayHours:e.target.value}))}
                            placeholder={String(sug)}
                            style={{ width:70, fontSize:13, fontWeight:700, border:"none", borderBottom:`1.5px solid ${C.labor}`, background:"transparent", outline:"none", padding:"2px 0", fontFamily:"inherit", color:"#f1f5f9", textAlign:"right" }} />
                          <span style={{ fontSize:11, color:C.textHint }}>시간</span>
                          <span className="dg-num" style={{ marginLeft:"auto", fontSize:13, fontWeight:700, color:"#2dd4bf" }}>
                            {Math.round(hrs * (Number(newEmployee.hourlyWage)||0)).toLocaleString("ko-KR")}원
                          </span>
                        </div>
                        <p style={{ margin:"6px 0 0", fontSize:10, color:C.textHint, lineHeight:1.7 }}>
                          만근 기준 <strong style={{ color:C.textSub }}>{sug}시간</strong>을 기본으로 넣었습니다.
                          주휴수당은 그 주를 개근해야 발생합니다. 결근한 주가 있으면 그만큼 빼고 넣으십시오.
                          한 주 빠지면 <strong style={{ color:C.textSub }}>{Math.max(0, Math.round((sug - sug/WEEKS_PER_MONTH)*10)/10)}시간</strong>입니다.
                        </p>
                      </div>
                    )}
                  </div>
                );
              })()}

              {/* 계좌번호 — 명세서에 찍히고 이체할 때 바로 쓴다 */}
              <div style={{ marginBottom:10 }}>
                <p style={{ margin:"0 0 4px", fontSize:11, color:C.textHint }}>급여 계좌 · 연락처 <span style={{ color:"#334155" }}>· 계좌는 명세서에 표시됩니다</span></p>
                <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}>
                  <input value={newEmployee.bankName} onChange={e=>setNewEmployee(p=>({...p,bankName:e.target.value}))}
                    placeholder="은행"
                    style={{ flex:"0 1 78px", minWidth:0, boxSizing:"border-box", fontSize:13, border:"none", borderBottom:"1.5px solid #243d54", background:"transparent", outline:"none", padding:"3px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
                  <input value={newEmployee.bankAccount} onChange={e=>setNewEmployee(p=>({...p,bankAccount:e.target.value}))}
                    placeholder="계좌번호"
                    style={{ flex:"2 1 160px", minWidth:0, boxSizing:"border-box", fontSize:13, border:"none", borderBottom:"1.5px solid #243d54", background:"transparent", outline:"none", padding:"3px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
                  <input value={newEmployee.phone} onChange={e=>setNewEmployee(p=>({...p,phone:e.target.value}))}
                    placeholder="010-0000-0000"
                    style={{ flex:"1 1 130px", minWidth:0, boxSizing:"border-box", fontSize:13, border:"none", borderBottom:"1.5px solid #243d54", background:"transparent", outline:"none", padding:"3px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
                </div>
                <p style={{ margin:"10px 0 4px", fontSize:11, color:C.textHint }}>주소 · 이메일 <span style={{ color:"#334155" }}>· 근로계약서에 들어갑니다</span></p>
                <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}>
                  <input value={newEmployee.address} onChange={e=>setNewEmployee(p=>({...p,address:e.target.value}))}
                    placeholder="경남 김해시 ..."
                    style={{ flex:"2 1 180px", minWidth:0, boxSizing:"border-box", fontSize:13, border:"none", borderBottom:"1.5px solid #243d54", background:"transparent", outline:"none", padding:"3px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
                  <input value={newEmployee.email} onChange={e=>setNewEmployee(p=>({...p,email:e.target.value}))}
                    placeholder="staff@example.com"
                    style={{ flex:"1 1 150px", minWidth:0, boxSizing:"border-box", fontSize:13, border:"none", borderBottom:"1.5px solid #243d54", background:"transparent", outline:"none", padding:"3px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
                </div>
              </div>

              {/* 미리보기 */}
              {(() => {
                const base = newEmployee.payType==="hourly"
                  ? (Number(newEmployee.hourlyWage)||0)*(Number(newEmployee.totalHours)||0)
                  : (Number(newEmployee.monthlySalary)||0);
                if (!base) return null;
                const tempEmp = { payType:newEmployee.payType, hourlyWage:Number(newEmployee.hourlyWage)||0, totalHours:Number(newEmployee.totalHours)||0, monthlySalary:Number(newEmployee.monthlySalary)||0, deductionType:newEmployee.deductionType, holidayPay:!!newEmployee.holidayPay, holidayHours:newEmployee.holidayHours, dependents:newEmployee.dependents||1, children:newEmployee.children||0, incomeTaxManual:!!newEmployee.incomeTaxManual, incomeTax:Number(newEmployee.incomeTax)||0 };
                const hol = calcHolidayPay(tempEmp);
                const empNet = calcNetPay(tempEmp);
                const empCost = calcEmployerCost(tempEmp);
                return (
                  <div style={{ marginBottom:10, padding:"10px 14px", background:`${C.labor}10`, borderRadius:8, display:"flex", gap:16, flexWrap:"wrap" }}>
                    <div><p style={{ margin:0, fontSize:10, color:C.textHint }}>세전</p><p style={{ margin:"2px 0 0", fontSize:13, fontWeight:700 }}>{(base + hol).toLocaleString("ko-KR")}원</p></div>
                    {hol > 0 && <div><p style={{ margin:0, fontSize:10, color:C.textHint }}>주휴수당</p><p style={{ margin:"2px 0 0", fontSize:13, fontWeight:700, color:"#2dd4bf" }}>{hol.toLocaleString("ko-KR")}원</p></div>}
                    <div><p style={{ margin:0, fontSize:10, color:C.textHint }}>직원 실수령</p><p style={{ margin:"2px 0 0", fontSize:13, fontWeight:700, color:"#2dd4bf" }}>{empNet.toLocaleString("ko-KR")}원</p></div>
                    <div><p style={{ margin:0, fontSize:10, color:C.textHint }}>사업주 총부담 (손익 반영)</p><p style={{ margin:"2px 0 0", fontSize:13, fontWeight:700, color:C.labor }}>{empCost.toLocaleString("ko-KR")}원</p></div>
                    {newEmployee.deductionType==="insurance" && <div><p style={{ margin:0, fontSize:10, color:C.textHint }}>사업주 부담 4대보험</p><p style={{ margin:"2px 0 0", fontSize:13, fontWeight:700, color:C.loss }}>{(empCost-base-hol).toLocaleString("ko-KR")}원</p></div>}
                  </div>
                );
              })()}

              <button onClick={addEmployee} style={{ width:"100%", padding:"10px", background:"#0d9488", color:"#fff", border:"none", borderRadius:10, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>+ 직원 추가</button>

              {/* 공제 안내 */}
              <div style={{ marginTop:12, padding:"10px 14px", background:"#1a2e42", borderRadius:8, fontSize:11, color:C.textHint, lineHeight:1.7 }}>
                <strong style={{color:C.textSub}}>공제 방식 안내</strong><br />
                • <strong>없음</strong>: 세전=실지급=사업주부담<br />
                • <strong>원천징수 3.3%</strong>: 실지급=세전×96.7% / 사업주부담=세전100% (세금은 사업주가 세무서 납부)<br />
                • <strong>4대보험</strong>: 실지급=세전×90.6% / 사업주부담=세전×110.5% (사업주 부담 4대보험 포함)<br />
                • <strong>주휴수당</strong>: 주휴시간 × 시급 · 만근 기준 시간을 기본으로 넣어드리니 결근이 있으면 줄여서 넣으세요
              </div>
            </div>
          </CostSection>

          {/* 인건비 합계 */}
          <div style={{ background:`${C.labor}10`, borderRadius:14, padding:"20px", border:`1px solid ${C.labor}30` }}>
            <p style={{ margin:"0 0 14px", fontSize:14, fontWeight:700 }}>인건비 합계</p>
            <div className="dg-g3" style={{ display:"grid", gridTemplateColumns:`repeat(${[totalEmployeeCost>0, ownerWage>0, true].filter(Boolean).length},1fr)`, gap:12, marginBottom:14 }}>
              {[["직원 인건비",totalEmployeeCost,"#0d9488"],["사장님 인건비",ownerWage,C.labor],["총 인건비",totalLaborCost,"#e2e8f0"]].filter(([,val])=>val>0).map(([lbl,val,clr]) => (
                <div key={lbl} style={{ background:"#112236", borderRadius:10, padding:"14px 16px", borderTop:`3px solid ${clr}` }}>
                  <p style={{ margin:0, fontSize:11, color:C.textSub, fontWeight:600 }}>{lbl}</p>
                  <p style={{ margin:"6px 0 0", fontSize:18, fontWeight:700, color:clr }}>{val.toLocaleString("ko-KR")}원</p>
                </div>
              ))}
            </div>
            <div style={{ display:"flex", justifyContent:"space-between", padding:"10px 14px", background:"#112236", borderRadius:8 }}>
              <span style={{ fontSize:13, color:C.textSub }}>인건비율 (총매출 대비)</span>
              <span style={{ fontSize:16, fontWeight:700, color:pctNum(totalLaborCost,totalRev)>35?C.loss:pctNum(totalLaborCost,totalRev)>25?C.other:C.profit }}>
                {pct(totalLaborCost,totalRev)}
              </span>
            </div>
            <p style={{ margin:"10px 0 0", fontSize:11, color:C.textHint }}>이 금액은 비용 탭 ③ 판관비의 "인건비" 항목에 자동 반영됩니다.</p>
          </div>
        </div>
      )}

      {/* ════ 재고 ════ */}
      {tab==="재고" && (
        <>
        <RestorePanel tabName="재고" disabled={restoreBlocked} loadHistory={loadHistory} onRestore={(h) => restoreTab("재고", h)} C={C} />
        <InventoryTab
          mk={mk} year={year} month={month} MONTHS={MONTHS}
          prevMonth={prevMonth} nextMonth={nextMonth} NAV_BTN={NAV_BTN}
          items={inventoryItems} setItems={setInventoryItems}
          monthly={monthlyInventory} setMonthly={setMonthlyInventory}
          invThis={invThis} invPrev={invPrev} invSum={invSum}
          totalCogs={totalCogs} days={days} beginStock={cogs.begin||0} C={C}
        />
        </>
      )}

      {/* ════ 비용 ════ */}
      {tab==="비용" && (
        <div>
          <div style={{ marginBottom:20, padding:"13px 16px", background:"rgba(129,140,248,0.08)", border:"1px solid rgba(129,140,248,0.3)", borderRadius:11 }}>
            <p style={{ margin:0, fontSize:12, fontWeight:700, color:"#818cf8" }}>번호는 손익계산서 순서입니다</p>
            <p style={{ margin:"6px 0 0", fontSize:11, color:C.textSub, lineHeight:1.9 }}>
              이 탭에서는 <strong style={{ color:C.text }}>② 매출원가 · ③ 판매비와 관리비 · ⑤ 기타 비용</strong>을 입력합니다.<br />
              ① 매출은 매출·배달 탭, ③-1 배달 비용은 배달 탭, 인건비는 인건비 탭에서 입력합니다.<br />
              ④ 영업이익과 ⑥ 월 순이익은 자동으로 계산됩니다.
            </p>
          </div>
          <CostSection title="② 매출원가" color="#0d9488" desc="식자재비 = 기초재고 + 당기매입 − 기말재고">
            <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:16 }}>
              <button onClick={prevMonth} style={NAV_BTN}>‹</button>
              <span style={{ fontSize:14, fontWeight:600, minWidth:90, textAlign:"center" }}>{year}년 {MONTHS[month]}</span>
              <button onClick={nextMonth} style={NAV_BTN}>›</button>
            </div>
            <div className="dg-g3" style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10 }}>
              {[["기초재고","begin","전월 기말재고 자동반영","#6366f1"],["기말재고","end","월말 남은 재고 (차감) · 재고 탭에서 세면 자동","#ef4444"],["기타 식자재","other","포장비·일회용품 등","#f59e0b"]].map(([lbl,key,hint,clr]) => {
                const isBegin = key==="begin";
                const isEnd = key==="end";
                // 기초재고: 전월 기말재고와 비교 / 기말재고: 전월 기말재고와 비교 / 나머지: 같은 항목끼리
                const prevVal = isBegin ? prevCogs.end : prevCogs[key];
                return (
                  <div key={key} style={{ background:"#112236", borderRadius:10, padding:"12px 14px", borderLeft:`3px solid ${clr}` }}>
                    <p style={{ margin:"0 0 2px", fontSize:12, fontWeight:600, color:clr }}>
                      {lbl}

                    </p>
                    <p style={{ margin:"0 0 8px", fontSize:11, color:C.textHint }}>{hint}</p>
                    {isBegin ? (
                      // 기초재고: 읽기전용, 전월 기말재고 자동반영
                      <div>
                        <div style={{ display:"flex", alignItems:"baseline", gap:4 }}>
                          <span style={{ fontSize:15, fontWeight:700, color:clr }}>{(cogs.begin||0).toLocaleString("ko-KR")}</span>
                          {prevCogs.end > 0 && <DiffBadge cur={cogs.begin||0} prev={prevCogs.end} inverse={false} />}
                        </div>
                        {prevCogs.end > 0
                          ? <p style={{ margin:"4px 0 0", fontSize:10, color:C.textHint }}>← 전월 기말재고 {prevCogs.end.toLocaleString("ko-KR")}원</p>
                          : <p style={{ margin:"4px 0 0", fontSize:10, color:C.textHint }}>전월 기말재고 없음</p>
                        }
                      </div>
                    ) : (isEnd && (endSource === "inventory" || endSource === "skip")) ? (
                      // 기말재고: 재고조사 탭이 관리 중 — 여기서는 읽기전용
                      <div>
                        <div style={{ display:"flex", alignItems:"baseline", gap:4 }}>
                          <span style={{ fontSize:15, fontWeight:700, color:clr }}>{(cogs.end||0).toLocaleString("ko-KR")}</span>
                          {prevVal!==undefined && prevVal>0 && <DiffBadge cur={cogs.end||0} prev={prevVal} inverse={false} />}
                        </div>
                        <p style={{ margin:"4px 0 0", fontSize:10, color:"#2dd4bf" }}>
                          {endSource==="skip" ? "재고조사 탭 · 이번 달 실사 안 함 (기초와 동일)" : "재고조사 탭에서 자동 반영"}
                          <button onClick={()=>setTab("재고")} style={{ marginLeft:6, background:"transparent", border:"none", color:"#2dd4bf", fontSize:10, cursor:"pointer", fontFamily:"inherit", textDecoration:"underline", padding:0 }}>이동 →</button>
                        </p>
                      </div>
                    ) : (
                      <div>
                        <div style={{ display:"flex", alignItems:"baseline", gap:4 }}>
                          <MoneyInput value={cogs[key]||0} onChange={(v) => setCogs(key,v)} style={{ width:"100%", fontSize:15, fontWeight:600, border:"none", borderBottom:`1.5px solid ${clr}`, background:"transparent", outline:"none", padding:"2px 0", fontFamily:"inherit", color:"#f1f5f9", boxSizing:"border-box" }} />
                          {prevVal!==undefined && prevVal>0 && <DiffBadge cur={cogs[key]||0} prev={prevVal} inverse={isEnd?false:true} />}
                        </div>
                        {prevVal!==undefined && prevVal>0 && <p style={{ margin:"3px 0 0", fontSize:10, color:C.textHint }}>전월 {prevVal.toLocaleString("ko-KR")}원</p>}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            {(() => {
              const monthExp = dailyExpMonth[0] || {};
              const foodVendors = vendors.filter(v=>v.kind==="food"||v.kind==="drink");
              const ROW2 = { display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, padding:"8px 0", borderBottom:"0.5px solid #1e3448" };
              const NUM2 = { flex:"1 1 auto", minWidth:0, fontSize:14, fontWeight:600, textAlign:"right", border:"none", background:"transparent", outline:"none", padding:"3px 0", fontFamily:"inherit", color:"#f1f5f9" };
              const foodSum = dailyExpSum.food + dailyExpSum.drink;
              return (
                <div style={{ marginTop:10, background:"#112236", borderRadius:10, padding:"13px 15px", borderLeft:"3px solid #2dd4bf" }}>
                  <p style={{ margin:"0 0 2px", fontSize:12, fontWeight:700, color:"#2dd4bf" }}>당기매입 식자재 — 거래처별</p>
                  <p style={{ margin:"0 0 9px", fontSize:10, color:C.textHint, lineHeight:1.7 }}>세금계산서·카드내역으로 월말에 정리합니다. 거래처를 나누지 않으려면 아래 「거래처 미분류」 한 칸에 총액을 넣으세요.</p>
                  {foodVendors.map((v,i) => {
                    const kd = EXPENSE_KINDS.find(k=>k.id===v.kind) || EXPENSE_KINDS[0];
                    return (
                      <div key={v.id} style={{ ...ROW2, borderBottom: i===foodVendors.length-1 ? "none" : ROW2.borderBottom }}>
                        {editVendor===v.id ? (
                          <span style={{ display:"flex", gap:4, flex:"0 0 180px", alignItems:"center" }}>
                            <input autoFocus value={v.name} onChange={e=>updateVendor(v.id,"name",e.target.value)} onKeyDown={e=>e.key==="Enter"&&setEditVendor(null)}
                              style={{ flex:1, minWidth:0, fontSize:12, border:"none", borderBottom:`1.5px solid ${kd.color}`, background:"transparent", outline:"none", padding:"2px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
                            <select value={v.kind} onChange={e=>updateVendor(v.id,"kind",e.target.value)}
                              style={{ fontSize:10, border:"1px solid #1e3448", background:"#112236", color:"#f1f5f9", borderRadius:4, padding:"2px 3px", fontFamily:"inherit", outline:"none", cursor:"pointer" }}>
                              {EXPENSE_KINDS.map(k => <option key={k.id} value={k.id} style={{ background:"#112236", color:"#f1f5f9" }}>{k.name}</option>)}
                            </select>
                            <button onClick={()=>setEditVendor(null)} style={{ ...DONE_BTN, fontSize:10, padding:"2px 6px" }}>✓</button>
                          </span>
                        ) : (
                          <span onClick={()=>setEditVendor(v.id)} style={{ fontSize:12, color:C.textSub, flex:"0 0 110px", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", cursor:"pointer" }}>{v.name}</span>
                        )}
                        <MoneyInput value={Number(monthExp[v.id])||0} onChange={(val)=>setDailyExpVal(0,v.id,val)} style={{ ...NUM2, borderBottom:`1.5px solid ${kd.color}` }} />
                        <button onClick={()=>{ if(window.confirm(`"${v.name}" 거래처를 삭제하면 입력된 금액도 사라집니다.\n계속할까요?`)) deleteVendor(v.id); }} style={{ ...DEL_BTN, flexShrink:0 }}>✕</button>
                      </div>
                    );
                  })}
                  <div style={{ ...ROW2, borderBottom:"none", marginTop:4, paddingTop:9, borderTop:"1px solid #1e3448" }}>
                    <span style={{ fontSize:12, color:C.textHint, flex:"0 0 110px", whiteSpace:"nowrap" }}>거래처 미분류</span>
                    <MoneyInput value={cogs.purchase||0} onChange={(v) => setCogs("purchase",v)} style={{ ...NUM2, borderBottom:`1.5px solid ${C.borderLight}` }} />
                  </div>
                  <div style={{ marginTop:10, paddingTop:10, borderTop:"1px solid #1e3448", display:"flex", gap:6, flexWrap:"wrap" }}>
                    <input value={newVendor.name} onChange={e=>setNewVendor(p=>({...p,name:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&addVendor()} placeholder="거래처 추가"
                      style={{ flex:"1 1 120px", minWidth:0, fontSize:12, padding:"7px 10px", border:"1px solid #1e3448", borderRadius:8, background:"#0D1B2A", color:"#f1f5f9", fontFamily:"inherit", outline:"none" }} />
                    <select value={newVendor.kind==="sga"?"food":newVendor.kind} onChange={e=>setNewVendor(p=>({...p,kind:e.target.value}))}
                      style={{ fontSize:12, padding:"7px 8px", border:"1px solid #1e3448", borderRadius:8, background:"#0D1B2A", color:"#f1f5f9", fontFamily:"inherit", outline:"none", cursor:"pointer" }}>
                      {EXPENSE_KINDS.filter(k=>k.id!=="sga").map(k => <option key={k.id} value={k.id} style={{ background:"#112236", color:"#f1f5f9" }}>{k.name}</option>)}
                    </select>
                    <button onClick={()=>{ if(newVendor.kind==="sga") setNewVendor(p=>({...p,kind:"food"})); setTimeout(addVendor,0); }}
                      style={{ padding:"7px 14px", background:"#2dd4bf", color:"#0D1B2A", border:"none", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>추가</button>
                  </div>

                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:9, paddingTop:9, borderTop:"1px solid #1e3448" }}>
                    <span style={{ fontSize:12, fontWeight:700, color:C.text }}>당기매입 합계</span>
                    <span style={{ fontSize:15, fontWeight:700, color:"#2dd4bf" }}>{fmtW(foodSum + (cogs.purchase||0))}</span>
                  </div>
                  {foodItemRows.length > 1 && (
                    <div style={{ marginTop:11, paddingTop:10, borderTop:"0.5px solid #1e3448" }}>
                      <p style={{ margin:"0 0 7px", fontSize:10, fontWeight:700, color:C.textHint }}>거래처별 비중</p>
                      {foodItemRows.map(([nm, amt]) => (
                        <div key={nm} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
                          <span style={{ fontSize:11, color:C.textSub, minWidth:80, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{nm}</span>
                          <div style={{ flex:1, height:5, background:"#0D1B2A", borderRadius:3, overflow:"hidden" }}>
                            <div style={{ height:"100%", background:"#2dd4bf", borderRadius:3, width:`${foodSum>0?Math.round((amt/foodSum)*100):0}%` }} />
                          </div>
                          <span style={{ fontSize:11, color:C.text, minWidth:62, textAlign:"right" }}>{fmtW(amt)}</span>
                          <span style={{ fontSize:10, color:C.textHint, minWidth:32, textAlign:"right" }}>{foodSum>0?Math.round((amt/foodSum)*100):0}%</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })()}
            <div style={{ marginTop:12, padding:"12px 16px", background:"rgba(13,148,136,0.1)", borderRadius:10, border:"1px solid rgba(52,211,153,0.3)", display:"flex", justifyContent:"space-between", alignItems:"center", gap:10, flexWrap:"wrap" }}>
              <span style={{ fontSize:12, color:"#34d399", lineHeight:1.7 }}>기초 {fmtW(cogs.begin||0)} + 당기매입 {fmtW((cogs.purchase||0)+dailyExpSum.food+dailyExpSum.drink)} − 기말 {fmtW(cogs.end||0)}</span>
              <div style={{ display:"flex", alignItems:"center", gap:6, flexShrink:0 }}>
                <span className="dg-num" style={{ fontSize:14, fontWeight:700, color:"#34d399" }}>식자재비 총 {fmtW(totalCogs)}</span>
                {prevTotalCogs>0 && <DiffBadge cur={totalCogs} prev={prevTotalCogs} inverse={true} />}
              </div>
            </div>
          </CostSection>

          <CostSection title="③ 판매비와 관리비" color="#6366f1" desc="항목명 또는 금액을 클릭해 수정하세요">
            {zeroToggle("top")}
            <div className="dg-t">
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr style={{ borderBottom:`2px solid ${C.border}` }}>
                  <th style={TH_S}>항목</th>
                  <th style={{...TH_S, textAlign:"right"}}>월 금액</th>
                  <th style={{...TH_S, textAlign:"right"}}>전월</th>
                  <th style={{...TH_S, textAlign:"right"}}>매출 비율</th>
                  <th style={{...TH_S, width:64}} />
                </tr>
              </thead>
              <tbody>
                {sga.filter(c => !hideZeroSga || c.name==="인건비" || editingRow===c.id || (getSgaAmt(c,mk)??0)>0 || (getSgaAmt(c,prevMk)??0)>0).map((c) => {
                  const isLaborItem = c.name==="인건비";
                  const currAmt = isLaborItem ? totalLaborCost : (getSgaAmt(c,mk)??0);
                  const prevAmt = isLaborItem ? undefined : getSgaAmt(c,prevMk);
                  return (
                    <tr key={c.id} style={{ borderBottom:"1px solid #1e3448", background:isLaborItem?`${C.labor}08`:"transparent" }}>
                      {editingRow===c.id && !isLaborItem ? (
                        <>
                          <td style={TD_S}><input autoFocus value={c.name} onChange={e=>updateSga(c.id,"name",e.target.value)} onKeyDown={e=>e.key==="Enter"&&setEditingRow(null)} style={INP_S} /></td>
                          <td style={TD_S}>
                            <MoneyInput value={currAmt} onChange={(v)=>setCurrSgaAmt(c.id,v)} onKeyDown={(e)=>e.key==="Enter"&&setEditingRow(null)} style={{...INP_S,textAlign:"right",width:"100%"}} />
                          </td>
                          <td style={{...TD_S,textAlign:"right",fontSize:11,color:C.textHint}}>{prevAmt!==undefined?prevAmt.toLocaleString("ko-KR"):"–"}</td>
                          <td style={{...TD_S,textAlign:"right",color:C.textHint,fontSize:12}}>{pct(currAmt,totalRev)}</td>
                          <td style={{...TD_S,textAlign:"center"}}><button onClick={()=>setEditingRow(null)} style={DONE_BTN}>✓</button></td>
                        </>
                      ) : (
                        <>
                          <td style={{...TD_S, cursor:isLaborItem?"default":"pointer"}} onClick={()=>!isLaborItem&&setEditingRow(c.id)}>
                            {c.name}
                            {isLaborItem && <span style={{ marginLeft:6, fontSize:10, color:C.labor, fontWeight:600 }}>인건비 탭에서 관리</span>}
                          </td>
                          <td style={{...TD_S, textAlign:"right", cursor:isLaborItem?"default":"pointer", color:isLaborItem?C.labor:C.text, fontWeight:isLaborItem?700:400}} onClick={()=>!isLaborItem&&setEditingRow(c.id)}>
                            <span>{currAmt.toLocaleString("ko-KR")}원</span>
                            {!isLaborItem && prevAmt!==undefined && <DiffBadge cur={currAmt} prev={prevAmt} inverse={true} />}
                          </td>
                          <td style={{...TD_S, textAlign:"right", fontSize:11, color:C.textHint}}>
                            {prevAmt!==undefined ? prevAmt.toLocaleString("ko-KR") : "–"}
                          </td>
                          <td style={{...TD_S,textAlign:"right",color:C.textHint,fontSize:12}}>{pct(currAmt,totalRev)}</td>
                          <td style={{...TD_S,textAlign:"center",whiteSpace:"nowrap"}}>
                            {isLaborItem
                              ? <button onClick={()=>setTab("인건비")} style={{...ADD_BTN,fontSize:11,padding:"4px 8px"}}>이동 →</button>
                              : <button onClick={()=>{
                                  const usedInOtherMonth = Object.entries(monthlySgaAmounts).some(([k,v]) => k!==mk && v?.[c.id] > 0);
                                  if (usedInOtherMonth) {
                                    if (!window.confirm(`"${c.name}" 항목을 완전히 삭제하면 다른 달의 데이터도 모두 사라집니다.\n계속할까요?`)) return;
                                  }
                                  setSga(p=>p.filter(x=>x.id!==c.id));
                                  setMonthlySgaAmounts(prev => {
                                    const next = {...prev};
                                    Object.keys(next).forEach(k => { if(next[k]) { next[k]={...next[k]}; delete next[k][c.id]; } });
                                    return next;
                                  });
                                }} style={DEL_BTN}>✕</button>
                            }
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
                {vendors.filter(v=>v.kind==="sga").map(v => {
                  const amt = Number((dailyExpMonth[0]||{})[v.id])||0;
                  return (
                    <tr key={v.id} style={{ borderBottom:"1px solid #1e3448", background:"rgba(129,140,248,0.06)" }}>
                      <td style={TD_S}>
                        {editVendor===v.id ? (
                          <span style={{ display:"flex", gap:4, alignItems:"center" }}>
                            <input autoFocus value={v.name} onChange={e=>updateVendor(v.id,"name",e.target.value)} onKeyDown={e=>e.key==="Enter"&&setEditVendor(null)} style={{...INP_S, width:110}} />
                            <select value={v.kind} onChange={e=>updateVendor(v.id,"kind",e.target.value)} style={{ fontSize:10, border:"1px solid #1e3448", background:"#112236", color:"#f1f5f9", borderRadius:4, padding:"2px 3px", fontFamily:"inherit", outline:"none", cursor:"pointer" }}>
                              {EXPENSE_KINDS.map(k => <option key={k.id} value={k.id} style={{ background:"#112236", color:"#f1f5f9" }}>{k.name}</option>)}
                            </select>
                            <button onClick={()=>setEditVendor(null)} style={{ ...DONE_BTN, fontSize:10, padding:"2px 6px" }}>✓</button>
                          </span>
                        ) : (
                          <span onClick={()=>setEditVendor(v.id)} style={{ cursor:"pointer" }}>
                            <span style={{ color:"#818cf8", fontWeight:600 }}>{v.name}</span>
                            <span style={{ marginLeft:6, fontSize:10, color:C.textHint }}>거래처</span>
                          </span>
                        )}
                      </td>
                      <td style={TD_S}>
                        <MoneyInput value={amt} onChange={(val)=>setDailyExpVal(0,v.id,val)} style={{...INP_S, textAlign:"right", width:"100%", borderBottom:"1.5px solid #818cf8"}} />
                      </td>
                      <td style={{...TD_S, textAlign:"right", fontSize:11, color:C.textHint}}>–</td>
                      <td style={{...TD_S, textAlign:"right", color:C.textHint, fontSize:12}}>{pct(amt, totalRev)}</td>
                      <td style={{...TD_S, textAlign:"center", whiteSpace:"nowrap"}}>
                        <button onClick={()=>{ if(window.confirm(`"${v.name}" 거래처를 삭제하면 입력된 금액도 사라집니다.\n계속할까요?`)) deleteVendor(v.id); }} style={DEL_BTN}>✕</button>
                      </td>
                    </tr>
                  );
                })}
                <tr style={{ background:"#1a2e42" }}>
                  <td style={TD_S}><input value={newSga.name} onChange={e=>setNewSga(p=>({...p,name:e.target.value}))} placeholder="새 항목명" style={{...INP_S,width:"100%"}} /></td>
                  <td style={TD_S}>
                    <MoneyInput value={Number(newSga.amount)||0} onChange={v=>setNewSga(p=>({...p,amount:String(v)}))} style={{...INP_S,textAlign:"right",width:"100%"}} />
                  </td>
                  <td colSpan={3} style={{...TD_S,textAlign:"right"}}>
                    <button onClick={()=>{ if(!newSga.name)return; const newId = Date.now(); setSga(p=>[...p,{id:newId,name:newSga.name,amount:0}]); setMonthlySgaAmounts(prev=>({...prev,[mk]:{...(prev[mk]||{}),[newId]:Number(newSga.amount)||0}})); setNewSga({name:"",amount:""}); }} style={ADD_BTN}>+ 추가</button>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            {zeroToggle("bottom")}
            <div style={{ display:"flex", justifyContent:"flex-end", gap:10, marginTop:10, padding:"10px 14px", background:"#1a2e42", borderRadius:8 }}>
              <span style={{ fontSize:12, color:C.textSub }}>판관비 합계</span>
              <span style={{ fontSize:16, fontWeight:700 }}>{fmtW(totalSga)}</span>
            </div>
          </CostSection>

          <CostSection title="⑤ 기타 비용" color="#f59e0b" desc="이자·세금 등 영업 외 비용 (월별 독립 입력)">
            {/* 부가세 추정 참고 박스 */}
            {totalRev > 0 && (
              <div style={{ marginBottom:16, padding:"14px 16px", background:"rgba(251,191,36,0.08)", borderRadius:12, border:"1px solid rgba(251,191,36,0.3)" }}>
                <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:8 }}>
                  <p style={{ margin:0, fontSize:12, fontWeight:700, color:"#fbbf24" }}>부가세 추정 (참고용)</p>
                  <span style={{ fontSize:10, color:"#fbbf24", background:"rgba(251,191,36,0.15)", padding:"2px 7px", borderRadius:4 }}>일반과세자 기준</span>
                </div>
                {(() => {
                  const delivCost = totalDelivCost;
                  const tf = Math.min(100, Math.max(0, cogs.taxfree || 0));            // 면세 식자재 비중 %
                  const cogsTaxable = totalCogs * (1 - tf/100);
                  const cogsFree = totalCogs * (tf/100);
                  const inCogs = Math.round(cogsTaxable / 11);
                  const inDeemed = Math.round(cogsFree * 8 / 108);                     // 의제매입세액 (개인 음식점 8/108)
                  const inDeliv = Math.round(delivCost / 11);
                  const vatSgaItems = sga.filter(c => c.name !== "인건비" && isVatDeductible(c) && (getSgaAmt(c, mk) ?? 0) > 0);
                  const sgaBase = vatSgaItems.reduce((a, c) => a + (getSgaAmt(c, mk) ?? 0), 0) + (dailyExpSum.sga || 0);
                  const inSga = Math.round(sgaBase / 11);
                  const outVat = Math.round(totalRev / 11);
                  const inVat = inCogs + inDeemed + inDeliv + inSga;
                  const cc = cardCreditOf(year);
                  const cardSales = cogs.cardSales || 0;
                  const cardCredit = Math.round(cardSales * cc.rate);
                  const pay = outVat - inVat - cardCredit;
                  const noTf = tf === 0 && totalCogs > 0;
                  return (
                    <>
                      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
                        <div style={{ background:"#112236", borderRadius:8, padding:"10px 12px" }}>
                          <p style={{ margin:0, fontSize:10, color:C.textHint }}>매출 부가세</p>
                          <p style={{ margin:"4px 0 0", fontSize:14, fontWeight:700, color:C.other, whiteSpace:"nowrap" }}>{outVat.toLocaleString("ko-KR")}원</p>
                          <p style={{ margin:"3px 0 0", fontSize:9, color:C.textHint }}>총매출 ÷ 11</p>
                        </div>
                        <div style={{ background:"#112236", borderRadius:8, padding:"10px 12px" }}>
                          <p style={{ margin:0, fontSize:10, color:C.textHint }}>매입 부가세</p>
                          <p style={{ margin:"4px 0 0", fontSize:14, fontWeight:700, color:C.profit, whiteSpace:"nowrap" }}>{inVat.toLocaleString("ko-KR")}원</p>
                          <p style={{ margin:"3px 0 0", fontSize:9, color:C.textHint }}>식자재 + 배달 + 판관비</p>
                        </div>
                      </div>

                      <div style={{ marginTop:8, padding:"11px 14px", background:"rgba(251,191,36,0.14)", border:"1px solid rgba(251,191,36,0.4)", borderRadius:8, display:"flex", justifyContent:"space-between", alignItems:"center", gap:8 }}>
                        <span style={{ fontSize:12, color:"#fbbf24", fontWeight:700 }}>
                          예상 납부액
                          {cardCredit>0 && <span style={{ display:"block", fontSize:10, fontWeight:400, opacity:0.85, marginTop:2 }}>카드 발행세액공제 −{cardCredit.toLocaleString("ko-KR")}원 반영</span>}
                        </span>
                        <span style={{ fontSize:17, fontWeight:700, color:pay>=0?"#fbbf24":C.profit, whiteSpace:"nowrap" }}>{pay>=0 ? pay.toLocaleString("ko-KR")+"원" : "환급 "+Math.abs(pay).toLocaleString("ko-KR")+"원"}</span>
                      </div>
                      {pay > 0 && (
                        <p style={{ margin:"7px 0 0", fontSize:11, color:C.textSub, lineHeight:1.8 }}>
                          이 <strong style={{ color:"#fbbf24" }}>{fmtMan(pay)}원은 내 돈이 아니라 맡아둔 돈</strong>입니다. 매달 별도 통장에 떼어두세요. 신고 때 목돈이 아니라, 매달 이만큼씩 이미 나간 겁니다.
                        </p>
                      )}

                      {cardSales===0 && totalRev>0 && (
                        <p style={{ margin:"8px 0 0", fontSize:11, color:C.loss, lineHeight:1.7 }}>
                          카드·현금영수증 발급금액이 0원입니다. 아래에서 입력하면 <strong>발행세액공제({(cc.rate*100).toFixed(1)}%)</strong>가 반영됩니다. 그대로 두면 납부액이 실제보다 <strong>많게</strong> 나옵니다.
                        </p>
                      )}
                      {noTf && (
                        <p style={{ margin:"8px 0 0", fontSize:11, color:C.loss, lineHeight:1.7 }}>
                          면세 식자재 비중이 0%입니다. 농축수산물을 쓰신다면 아래에서 비중을 입력하세요. 그대로 두면 납부액이 실제보다 <strong>적게</strong> 나옵니다.
                        </p>
                      )}

                      <button onClick={()=>setVatOpen(o=>!o)} style={{ marginTop:9, width:"100%", padding:"8px", background:"transparent", border:"1px solid rgba(251,191,36,0.3)", borderRadius:8, color:"#fbbf24", fontSize:11, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                        {vatOpen ? "계산 상세 접기 ▲" : "계산 상세 · 설정 열기 ▼"}
                      </button>

                      {vatOpen && (
                        <div style={{ marginTop:9, padding:"13px", background:"#112236", borderRadius:9 }}>
                          <div style={{ marginBottom:12 }}>
                            <div style={{ display:"flex", alignItems:"center", gap:9, flexWrap:"wrap" }}>
                              <span style={{ fontSize:11, fontWeight:700, color:C.textSub, whiteSpace:"nowrap" }}>면세 식자재 비중</span>
                              <span style={{ display:"flex", alignItems:"center", gap:5, flexShrink:0 }}>
                                <span style={{ width:64, display:"block" }}>
                                  <MoneyInput value={tf} onChange={(v)=>setCogs("taxfree", Math.min(100, v))} style={{ fontSize:13, fontWeight:700, textAlign:"right", border:"none", borderBottom:"1.5px solid #fbbf24", background:"transparent", outline:"none", padding:"2px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
                                </span>
                                <span style={{ fontSize:11, color:C.textSub }}>%</span>
                              </span>
                            </div>
                            <p style={{ margin:"6px 0 0", fontSize:10, color:C.textHint, lineHeight:1.7 }}>
                              농축수산물·쌀 등 <strong style={{color:C.textSub}}>계산서(면세)로 산 식자재 비중</strong>입니다. 이 금액은 부가세가 없어 ÷11이 아니라 의제매입세액 8/108로 공제됩니다.
                              쭈꾸미·아구 같은 수산물 비중이 크면 30~50%까지 올라갑니다.
                            </p>
                          </div>

                          <div style={{ borderTop:"1px solid #1e3448", paddingTop:11, marginBottom:12 }}>
                            <div style={{ display:"flex", alignItems:"center", gap:9, flexWrap:"wrap" }}>
                              <span style={{ fontSize:11, fontWeight:700, color:C.textSub, whiteSpace:"nowrap" }}>카드·현금영수증 발급금액</span>
                              <span style={{ display:"flex", alignItems:"center", gap:5, flexShrink:0 }}>
                                <span style={{ width:120, display:"block" }}>
                                  <MoneyInput value={cardSales} onChange={(v)=>setCogs("cardSales", v)} style={{ fontSize:13, fontWeight:700, textAlign:"right", border:"none", borderBottom:"1.5px solid #fbbf24", background:"transparent", outline:"none", padding:"2px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
                                </span>
                                <span style={{ fontSize:11, color:C.textSub }}>원</span>
                              </span>
                              {cardCredit>0 && <span style={{ fontSize:11, fontWeight:700, color:C.profit, whiteSpace:"nowrap" }}>→ 공제 {cardCredit.toLocaleString("ko-KR")}원</span>}
                            </div>
                            <p style={{ margin:"6px 0 0", fontSize:10, color:C.textHint, lineHeight:1.7 }}>
                              이번 달 카드·현금영수증으로 <strong style={{color:C.textSub}}>발급한 매출</strong>입니다. 포스와 배달앱 정산서에서 확인합니다.
                              {year}년 기준 <strong style={{color:C.textSub}}>{(cc.rate*100).toFixed(1)}% · 연 {(cc.cap/10000).toLocaleString("ko-KR")}만원 한도</strong>로 납부세액에서 직접 빼줍니다.
                              법인사업자와 직전연도 공급가액 10억원 초과 개인은 대상이 아닙니다.
                            </p>
                          </div>

                          <div style={{ borderTop:"1px solid #1e3448", paddingTop:11 }}>
                            <p style={{ margin:"0 0 7px", fontSize:11, fontWeight:700, color:C.textSub }}>매입세액 계산 내역</p>
                            {[
                              ["식자재 (과세분)", cogsTaxable, inCogs, "÷ 11"],
                              tf>0 ? ["식자재 (면세분)", cogsFree, inDeemed, "× 8/108"] : null,
                              delivCost>0 ? ["배달 수수료·광고·대행비", delivCost, inDeliv, "÷ 11"] : null,
                              sgaBase>0 ? ["판관비 (과세 항목)", sgaBase, inSga, "÷ 11"] : null,
                            ].filter(Boolean).map(([lbl, base, vat, formula]) => (
                              <div key={lbl} style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", gap:8, padding:"5px 0", fontSize:11 }}>
                                <span style={{ color:C.textSub, minWidth:0 }}>{lbl} <span style={{ fontSize:10, color:C.textHint }}>{Math.round(base).toLocaleString("ko-KR")} {formula}</span></span>
                                <span style={{ color:C.profit, fontWeight:700, whiteSpace:"nowrap" }}>{vat.toLocaleString("ko-KR")}원</span>
                              </div>
                            ))}
                            <div style={{ display:"flex", justifyContent:"space-between", padding:"8px 0 0", marginTop:5, borderTop:"1px solid #1e3448", fontSize:12, fontWeight:700 }}>
                              <span style={{ color:C.text }}>매입세액 합계</span>
                              <span style={{ color:C.profit }}>{inVat.toLocaleString("ko-KR")}원</span>
                            </div>
                            <div style={{ marginTop:9, paddingTop:9, borderTop:"1px solid #1e3448", fontSize:11 }}>
                              {[["매출세액", outVat, C.other, ""],
                                ["매입세액", -inVat, C.profit, ""],
                                cardCredit>0 ? ["신용카드 발행세액공제", -cardCredit, C.profit, `${cardSales.toLocaleString("ko-KR")} × ${(cc.rate*100).toFixed(1)}%`] : null,
                              ].filter(Boolean).map(([lbl,v,clr,note]) => (
                                <div key={lbl} style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", gap:8, padding:"4px 0" }}>
                                  <span style={{ color:C.textSub }}>{lbl}{note && <span style={{ fontSize:10, color:C.textHint }}> {note}</span>}</span>
                                  <span style={{ color:clr, fontWeight:700, whiteSpace:"nowrap" }}>{v>=0?"":"−"}{Math.abs(v).toLocaleString("ko-KR")}원</span>
                                </div>
                              ))}
                              <div style={{ display:"flex", justifyContent:"space-between", padding:"8px 0 0", marginTop:4, borderTop:"1px solid #1e3448", fontSize:13, fontWeight:700 }}>
                                <span style={{ color:C.text }}>예상 납부액</span>
                                <span style={{ color:pay>=0?"#fbbf24":C.profit }}>{pay>=0 ? pay.toLocaleString("ko-KR")+"원" : "환급 "+Math.abs(pay).toLocaleString("ko-KR")+"원"}</span>
                              </div>
                            </div>
                          </div>

                          <div style={{ borderTop:"1px solid #1e3448", marginTop:11, paddingTop:11 }}>
                            <p style={{ margin:"0 0 3px", fontSize:11, fontWeight:700, color:C.textSub }}>판관비 매입세액 대상</p>
                            <p style={{ margin:"0 0 8px", fontSize:10, color:C.textHint, lineHeight:1.6 }}>세금계산서를 받은 항목만 체크하세요. 인건비·보험료·감가상각비·수도요금은 대상이 아닙니다.</p>
                            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))", gap:"5px 10px" }}>
                              {sga.filter(c => c.name !== "인건비").map(c => {
                                const amt = getSgaAmt(c, mk) ?? 0;
                                const on = isVatDeductible(c);
                                return (
                                  <label key={c.id} style={{ display:"flex", alignItems:"center", gap:6, cursor:"pointer", opacity: amt>0 ? 1 : 0.45 }}>
                                    <input type="checkbox" checked={on} onChange={(e)=>setSgaVat(c.id, e.target.checked)} style={{ width:13, height:13, accentColor:"#fbbf24", cursor:"pointer", flexShrink:0 }} />
                                    <span style={{ fontSize:11, color: on ? C.text : C.textHint, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{c.name}</span>
                                  </label>
                                );
                              })}
                            </div>
                            {(dailyExpSum.sga||0)>0 && <p style={{ margin:"8px 0 0", fontSize:10, color:C.textHint }}>거래처로 입력한 판관비성 지출 {fmtW(dailyExpSum.sga)}는 전액 과세로 계산됩니다.</p>}
                          </div>
                        </div>
                      )}

                      <p style={{ margin:"9px 0 0", fontSize:10, color:"#fbbf24", lineHeight:1.8 }}>
                        ※ 일반과세자·개인사업자 기준 추정입니다. 의제매입세액과 카드 발행세액공제는 한도·요건이 있고, 전자신고 세액공제(1만원)와 예정고지 기납부세액은 반영되지 않았습니다.
                        <strong> 신고와 납부는 반드시 세무사를 통해 하세요.</strong>
                      </p>
                    </>
                  );
                })()}
              </div>
            )}
            <div className="dg-t">
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr style={{ borderBottom:`2px solid ${C.border}` }}>
                  <th style={TH_S}>항목</th>
                  <th style={{...TH_S,textAlign:"right"}}>금액</th>
                  <th style={{...TH_S,textAlign:"right"}}>전월</th>
                  <th style={{...TH_S,width:40}} />
                </tr>
              </thead>
              <tbody>
                {other.map((c) => {
                  const currAmt = getOtherAmt(c,mk)??0;
                  const prevAmt = getOtherAmt(c,prevMk);
                  return (
                    <tr key={c.id} style={{ borderBottom:"1px solid #1e3448" }}>
                      {editingRow===`o${c.id}` ? (
                        <>
                          <td style={TD_S}><input autoFocus value={c.name} onChange={e=>setOther(p=>p.map(x=>x.id===c.id?{...x,name:e.target.value}:x))} onKeyDown={e=>e.key==="Enter"&&setEditingRow(null)} style={{...INP_S,width:"100%"}} /></td>
                          <td style={TD_S}><MoneyInput value={currAmt} onChange={v=>setCurrOtherAmt(c.id,v)} onKeyDown={e=>e.key==="Enter"&&setEditingRow(null)} style={{...INP_S,textAlign:"right",width:"100%"}} /></td>
                          <td style={{...TD_S,textAlign:"right",fontSize:11,color:C.textHint}}>{prevAmt!==undefined?prevAmt.toLocaleString("ko-KR"):"–"}</td>
                          <td style={{...TD_S,textAlign:"center"}}><button onClick={()=>setEditingRow(null)} style={DONE_BTN}>✓</button></td>
                        </>
                      ) : (
                        <>
                          <td style={{...TD_S,cursor:"pointer"}} onClick={()=>setEditingRow(`o${c.id}`)}>{c.name}</td>
                          <td style={{...TD_S,textAlign:"right",cursor:"pointer"}} onClick={()=>setEditingRow(`o${c.id}`)}>
                            <span>{currAmt.toLocaleString("ko-KR")}원</span>
                            {prevAmt!==undefined && <DiffBadge cur={currAmt} prev={prevAmt} inverse={true} />}
                          </td>
                          <td style={{...TD_S,textAlign:"right",fontSize:11,color:C.textHint}}>{prevAmt!==undefined?prevAmt.toLocaleString("ko-KR"):"–"}</td>
                          <td style={{...TD_S,textAlign:"center"}}><button onClick={()=>setOther(p=>p.filter(x=>x.id!==c.id))} style={DEL_BTN}>✕</button></td>
                        </>
                      )}
                    </tr>
                  );
                })}
                <tr style={{ background:"#1a2e42" }}>
                  <td style={TD_S}><input value={newOther.name} onChange={e=>setNewOther(p=>({...p,name:e.target.value}))} placeholder="새 항목명" style={{...INP_S,width:"100%"}} /></td>
                  <td style={TD_S}><MoneyInput value={Number(newOther.amount)||0} onChange={v=>setNewOther(p=>({...p,amount:String(v)}))} style={{...INP_S,textAlign:"right",width:"100%"}} /></td>
                  <td colSpan={2} style={{...TD_S,textAlign:"right"}}><button onClick={()=>{ if(!newOther.name)return; const newId=Date.now(); setOther(p=>[...p,{id:newId,name:newOther.name,amount:0}]); setCurrOtherAmt(newId, Number(newOther.amount)||0); setNewOther({name:"",amount:""}); }} style={ADD_BTN}>+ 추가</button></td>
                </tr>
              </tbody>
            </table>
            </div>
            <div style={{ display:"flex", justifyContent:"flex-end", gap:10, marginTop:12, padding:"10px 14px", background:"#1a2e42", borderRadius:8 }}>
              <span style={{ fontSize:12, color:C.textSub }}>기타비용 합계</span>
              <span style={{ fontSize:16, fontWeight:700 }}>{fmtW(totalOther)}</span>
            </div>
          </CostSection>
        </div>
      )}

      {/* ════ 손익분석 ════ */}
      {tab==="손익분석" && (
        <div>
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:24 }}>
            <div style={{ display:"flex", alignItems:"center", gap:12 }}>
              <button onClick={prevMonth} style={NAV_BTN}>‹</button>
              <span style={{ fontSize:20, fontWeight:700 }}>{year}년 {MONTHS[month]}</span>
              <button onClick={nextMonth} style={NAV_BTN}>›</button>
            </div>
            <button onClick={saveImage} style={{ fontSize:12, fontWeight:700, color:"#2dd4bf", background:"rgba(13,148,136,0.12)", border:"1px solid rgba(13,148,136,0.4)", borderRadius:9, padding:"8px 12px", cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" }}>이미지 저장</button>
          </div>

          {/* 아직 마감 전인 달 — 비용은 한 달치인데 매출은 일부라 순이익을 보여주면 안 된다 */}
          {ongoingRev > 0 && isOngoingMonth ? (() => {
            const paceRev = ongoingDay > 0 ? Math.round(ongoingRev / ongoingDay * days) : 0;
            return (
              <div style={{ borderRadius:16, padding:"24px 28px", marginBottom:16, background:`linear-gradient(135deg,${C.store}18,${C.store}06)`, border:`1px solid ${C.store}40` }}>
                <p style={{ margin:0, fontSize:12, fontWeight:600, color:C.store, letterSpacing:1 }}>{MONTHS[month]} 진행 중 · {ongoingDay}일차</p>
                <p className="dg-num" style={{ margin:"6px 0 4px", fontSize:32, fontWeight:700, color:C.text, letterSpacing:"-1px" }}>{ongoingRev.toLocaleString("ko-KR")}원</p>
                <div style={{ display:"flex", gap:16, flexWrap:"wrap", marginTop:8 }}>
                  <span style={{ fontSize:12, color:C.textSub }}>홀 {fmtMan(hallRev)}</span>
                  <span style={{ fontSize:12, color:C.textSub }}>배달 {fmtMan(ongoingDeliv)}{ongoingDelivRef > 0 ? " (포스 기준, 참고)" : ""}</span>
                  {paceRev > 0 && <span style={{ fontSize:12, color:C.store }}>이대로면 월말 {fmtMan(paceRev)}</span>}
                </div>
                <p style={{ margin:"12px 0 0", fontSize:11, color:C.textHint, lineHeight:1.7, borderTop:`1px solid ${C.border}`, paddingTop:10 }}>
                  순이익은 달이 끝나야 나옵니다. 인건비·임차료는 한 달치가 잡혀 있는데 매출은 {ongoingDay}일치라 지금 계산하면 적자로 보입니다.
                  {prevNetProfit !== 0 && ` 지난달 순이익은 ${fmtW(prevNetProfit)}이었습니다.`}
                </p>
              </div>
            );
          })() : totalRev === 0 ? (
            <div style={{ borderRadius:16, padding:"24px 28px", marginBottom:16, background:"#112236", border:`1px solid ${C.border}` }}>
              <p style={{ margin:0, fontSize:12, fontWeight:600, color:C.textHint, letterSpacing:1 }}>{MONTHS[month]} 손익</p>
              <p style={{ margin:"8px 0 4px", fontSize:24, fontWeight:700, color:C.textSub }}>아직 입력 전입니다</p>
              <p style={{ margin:"6px 0 0", fontSize:12, color:C.textHint, lineHeight:1.7 }}>
                매출을 넣으면 순이익이 계산됩니다.
                지금은 지난달에서 이어진 인건비·판관비만 잡혀 있어 숫자가 맞지 않습니다.
              </p>
              <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginTop:14 }}>
                {[["매출","매출"],["배달","배달"],["재고","재고"],["비용","비용"]].filter(([t])=>canSee(t)).map(([t,l]) => (
                  <button key={t} onClick={()=>setTab(t)} style={{ fontSize:12, padding:"7px 14px", borderRadius:8, border:`1px solid ${C.border}`, background:"#1a2e42", color:C.textSub, cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>{l} 탭 →</button>
                ))}
              </div>
            </div>
          ) : (
          <div style={{ borderRadius:16, padding:"24px 28px", marginBottom:16, background:netProfit>=0?"linear-gradient(135deg,#34d39920,#34d39908)":"linear-gradient(135deg,#f8717120,#f8717108)", border:`1px solid ${netProfit>=0?"rgba(52,211,153,0.3)":"rgba(248,113,113,0.3)"}` }}>
            <p style={{ margin:0, fontSize:12, fontWeight:600, color:netProfit>=0?C.profit:C.loss, letterSpacing:1 }}>이번달 순이익</p>
            <p style={{ margin:"6px 0 4px", fontSize:36, fontWeight:700, color:pC(netProfit), letterSpacing:"-1px" }}>{netProfit>=0?"+":""}{netProfit.toLocaleString("ko-KR")}원</p>
            <div style={{ display:"flex", gap:16, flexWrap:"wrap", marginTop:8 }}>
              <span style={{ fontSize:12, color:pC(netProfit), opacity:0.8 }}>순이익률 {pct(netProfit,totalRev)}</span>
              <span style={{ fontSize:12, color:pC(opProfit), opacity:0.8 }}>영업이익 {opProfit>=0?"+":""}{opProfit.toLocaleString("ko-KR")}원</span>
              <span style={{ fontSize:12, color:C.textHint }}>총매출 {totalRev.toLocaleString("ko-KR")}원</span>
              {prevTotalRev>0 && diffBadge(netProfit,prevNetProfit)}
            </div>
            {/* 한줄 요약 */}
            {oneLinerSummary && (
              <p style={{ margin:"12px 0 0", fontSize:12, color:C.textSub, lineHeight:1.6, borderTop:`1px solid ${C.border}`, paddingTop:10 }}>
                {oneLinerSummary}
              </p>
            )}
            {/* 사장님 인건비 미반영 경고 — 이 순이익에는 본인 몫이 안 빠져 있다 */}
            {totalRev > 0 && (ownerWage||0) === 0 && netProfit > 0 && (
              <p style={{ margin:"10px 0 0", fontSize:11, color:C.other, lineHeight:1.7, borderTop:`1px solid ${C.border}`, paddingTop:10 }}>
                <span style={{ display:"inline-flex", width:14, height:14, borderRadius:"50%", background:"currentColor", color:"#0D1B2A", fontSize:10, fontWeight:700, alignItems:"center", justifyContent:"center", marginRight:5 }}>!</span>
                이 순이익에는 <strong>사장님 인건비가 빠져 있습니다.</strong> 본인 몫 월급을 인건비 탭에 넣어야 진짜 남는 장사인지 보입니다.
              </p>
            )}
          </div>
          )}

          {/* ── 순이익이 왜 늘었나·줄었나 ── */}
          {totalRev > 0 && !isOngoingMonth && hasPrevMonth && netDeltaParts.length > 0 && Math.round(netDelta) !== 0 && (() => {
            const up = netDelta >= 0;
            const maxAbs = Math.max(...netDeltaParts.map(p => Math.abs(p.effect)), 1);
            const top = netDeltaParts[0];
            const topUp = top.effect >= 0;
            const advice = { rev:"매출 자체가 줄었으니 유입부터 확인하세요.", cogs:"매입 단가나 로스를 먼저 점검하세요.", sga:"비용 탭에서 어느 항목이 늘었는지 확인하세요.", deliv:"수수료·광고비 비중이 커졌습니다. 배달 탭을 확인하세요.", other:"이자·세금 등 영업 외 비용이 늘었습니다." };
            return (
              <div style={{ marginBottom:16, padding:"18px 20px", background:"#1a2e42", borderRadius:14, border:`1px solid ${up?"#34d39933":"#f8717133"}` }}>
                <p style={{ margin:0, fontSize:13, fontWeight:700 }}>
                  순이익이 <span style={{ color:up?C.profit:C.loss }}>{fmtW(Math.abs(netDelta))} {up?"늘어난":"줄어든"}</span> 이유
                </p>
                <p style={{ margin:"4px 0 14px", fontSize:11, color:C.textHint }}>전월 대비 · 각 항목의 기여도를 더하면 정확히 증감액이 됩니다</p>

                {netDeltaParts.map(p => {
                  const good = p.effect >= 0;
                  const moved = p.cur - p.prev;
                  return (
                    <div key={p.key} style={{ marginBottom:10 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", gap:8, marginBottom:4, flexWrap:"wrap" }}>
                        <span style={{ fontSize:12, color:C.textSub }}>
                          {p.label}
                          <span style={{ fontSize:10, color:C.textHint, marginLeft:6 }}>
                            {fmtMan(p.prev)} → {fmtMan(p.cur)} {moved>0?"↑":"↓"}
                          </span>
                        </span>
                        <span className="dg-num" style={{ fontSize:13, fontWeight:700, color:good?C.profit:C.loss }}>
                          {good?"+":"−"}{fmtW(Math.abs(p.effect))}
                        </span>
                      </div>
                      <div style={{ height:6, background:"#0D1B2A", borderRadius:3, overflow:"hidden" }}>
                        <div style={{ height:"100%", background:good?C.profit:C.loss, borderRadius:3, width:`${(Math.abs(p.effect)/maxAbs)*100}%` }} />
                      </div>
                    </div>
                  );
                })}

                <p style={{ margin:"12px 0 0", paddingTop:10, borderTop:`1px solid ${C.border}`, fontSize:12, color:C.textSub, lineHeight:1.8 }}>
                  가장 큰 원인은 <strong style={{ color:topUp?C.profit:C.loss }}>{top.label}</strong>입니다. 순이익을 {fmtW(Math.abs(top.effect))} {topUp?"끌어올렸습니다":"깎았습니다"}.
                  {!topUp && ` ${advice[top.key]}`}
                </p>
              </div>
            );
          })()}

          {isFinite(bep) && bep > 0 && totalRev > 0 && !isOngoingMonth && (() => {
            const rate = (totalRev/bep)*100;
            const over = totalRev >= bep;
            const gap = Math.abs(totalRev - bep);
            const avgDaily = avgDailyHall + avgDailyDeliv;
            return (
            <div style={{ marginBottom:16, padding:"14px 18px", background:"#1a2e42", borderRadius:14 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", gap:8, marginBottom:8, flexWrap:"wrap" }}>
                <p style={{ margin:0, fontSize:13, fontWeight:700 }}>손익분기점 달성 현황</p>
                <span className="dg-num" style={{ fontSize:13, fontWeight:700, color:over?C.profit:rate>=80?C.other:"#6366f1" }}>{rate.toFixed(1)}%</span>
              </div>
              {/* 100% 지점을 눈금으로 표시하고, 초과분은 그 위로 채운다 */}
              <div style={{ position:"relative", height:8, background:C.border, borderRadius:4, overflow:"hidden", marginBottom:6 }}>
                <div style={{ height:"100%", background:over?C.profit:rate>=80?C.other:"#6366f1", borderRadius:4, width:`${Math.min(100,(rate/Math.max(rate,120))*100)}%`, transition:"width 0.3s" }} />
                <div style={{ position:"absolute", top:0, bottom:0, left:`${(100/Math.max(rate,120))*100}%`, width:2, background:"#f1f5f9", opacity:0.55 }} />
              </div>
              <div style={{ display:"flex", justifyContent:"space-between", gap:10, fontSize:11, color:C.textHint, flexWrap:"wrap" }}>
                <span>손익분기 매출 {fmtW(bep)}</span>
                <span style={{ color:over?C.profit:C.loss, fontWeight:600 }}>
                  {over ? `여유 ${fmtW(gap)}` : `${fmtW(gap)} 부족`}
                </span>
              </div>
              {over ? (
                <p style={{ margin:"6px 0 0", fontSize:11, color:C.profit, lineHeight:1.7 }}>
                  매출이 지금보다 {fmtW(gap)} 줄어도 적자로 넘어가지 않습니다{avgDaily>0 ? ` (약 ${Math.floor(gap/avgDaily)}일치 매출)` : ""}.
                </p>
              ) : avgDaily>0 ? (
                <p style={{ margin:"6px 0 0", fontSize:11, color:"#6366f1", lineHeight:1.7 }}>
                  일평균 {fmtW(avgDaily)} 유지 시 약 {Math.ceil(gap/avgDaily)}일 후 달성 예상
                </p>
              ) : null}
              <p style={{ margin:"8px 0 0", fontSize:10, color:C.textHint, lineHeight:1.7 }}>
                고정비(판관비+기타) {fmtW(fixedCost)} ÷ (1 − 변동비율 {(varRate*100).toFixed(1)}%) · 식자재비와 배달비용은 매출 따라 움직이는 변동비로 계산합니다.
              </p>

              {/* 목표 순이익 역산 — 얼마 남기려면 얼마 팔아야 하나 */}
              <div style={{ marginTop:12, paddingTop:11, borderTop:`1px solid ${C.border}` }}>
                <p style={{ margin:"0 0 3px", fontSize:12, fontWeight:700 }}>얼마 팔아야 얼마 남나</p>
                <p style={{ margin:"0 0 9px", fontSize:10, color:C.textHint }}>지금 비용 구조 기준 · 만원 남길 때마다 매출 {fmtW(Math.round(1/(1-varRate)*10000))}이 필요합니다</p>
                {(() => {
                  // 매장 상태에 맞는 계단만 보여준다: 마지막 달성 1개(현 위치) + 다음 목표 2개
                  const LADDER = [1000000,3000000,5000000,7000000,10000000,15000000,20000000,30000000,50000000];
                  const done = LADDER.filter(t => netProfit >= t);
                  const todo = LADDER.filter(t => netProfit < t);
                  const visible = [...done.slice(-1), ...todo.slice(0,2)];
                  return visible.map((t) => {
                    const need = revForProfit(t);
                    if (!isFinite(need)) return null;
                    const reached = netProfit >= t;
                    const isNext = t === todo[0];
                    return (
                      <div key={t} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:8, padding:"5px 0", opacity:reached?0.55:1 }}>
                        <span style={{ fontSize:11, color:reached?C.textHint:isNext?C.text:C.textSub, fontWeight:isNext?700:400 }}>
                          {reached?"✓ ":""}순이익 {fmtMan(t)}원
                          {reached && <span style={{ marginLeft:6, fontSize:10, color:C.textHint }}>달성</span>}
                          {isNext && <span style={{ marginLeft:6, fontSize:10, fontWeight:700, color:"#6366f1", background:"rgba(99,102,241,0.15)", borderRadius:4, padding:"1px 6px" }}>다음 목표</span>}
                        </span>
                        <span className="dg-num" style={{ fontSize:11, fontWeight:isNext?700:400, color:reached?C.textHint:isNext?"#6366f1":C.textSub }}>
                          매출 {fmtW(need)}
                          {!reached && totalRev>0 && <span style={{ color:C.textHint, fontWeight:400 }}> (+{fmtMan(need-totalRev)})</span>}
                        </span>
                      </div>
                    );
                  });
                })()}
              </div>
            </div>
            );
          })()}

          {totalRev>0 && !isOngoingMonth && prevTotalRev>0 && (
            <div className="dg-g3" style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10, marginBottom:16 }}>
              {[["총 매출",totalRev,prevTotalRev],["영업이익",opProfit,prevOpProfit],["순이익",netProfit,prevNetProfit]].map(([lbl,cur,prev]) => {
                const diff=cur-prev;
                return (
                  <div key={lbl} style={{ background:"#1a2e42", borderRadius:12, padding:"14px 16px" }}>
                    <p style={{ margin:0, fontSize:11, color:C.textSub, fontWeight:600 }}>{lbl}</p>
                    <p style={{ margin:"4px 0 2px", fontSize:15, fontWeight:700 }}>{cur.toLocaleString("ko-KR")}원</p>
                    <p style={{ margin:0, fontSize:11, color:diff>=0?C.profit:C.loss }}>{diff>=0?"▲":"▼"}{Math.abs(diff).toLocaleString("ko-KR")}원 전월비</p>
                  </div>
                );
              })}
            </div>
          )}

          <div style={{ marginBottom:16, padding:"16px 20px", background:"#1a2e42", borderRadius:14 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:10, marginBottom:8, flexWrap:"wrap" }}>
                <p style={{ margin:0, fontSize:13, fontWeight:700 }}>목표 매출 달성 현황</p>
                <span style={{ display:"flex", alignItems:"center", gap:8 }}>
                  <span style={{ width:130, display:"block" }}>
                    <MoneyInput value={goal} onChange={(v) => setMonthlyGoal(p=>({...p,[mk]:v}))} placeholder="목표 입력"
                      style={{ fontSize:13, fontWeight:700, textAlign:"right", border:"none", borderBottom:`1.5px solid ${storeColor}`, background:"transparent", outline:"none", padding:"2px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
                  </span>
                  {goal>0 && <span style={{ fontSize:13, fontWeight:700, color:totalRev>=goal?C.profit:storeColor, whiteSpace:"nowrap" }}>{Math.round((totalRev/goal)*100)}%</span>}
                </span>
              </div>
              {goal>0 && (<>
              <div style={{ height:8, background:`${storeColor}22`, borderRadius:4, overflow:"hidden" }}>
                <div style={{ height:"100%", background:storeColor, borderRadius:4, width:`${Math.min(100,(totalRev/goal)*100)}%` }} />
              </div>
              <div style={{ display:"flex", justifyContent:"space-between", marginTop:6, fontSize:11, color:C.textHint }}>
                <span>현재 {totalRev.toLocaleString("ko-KR")}원</span>
                <span>목표 {goal.toLocaleString("ko-KR")}원</span>
              </div>
              {totalRev<goal && <p style={{ margin:"6px 0 0", fontSize:12, color:C.loss }}>목표까지 {(goal-totalRev).toLocaleString("ko-KR")}원 남았어요</p>}
              </>)}
            </div>

          {/* ── 월별 추세 차트 ── */}
          {(() => {
            // 최근 12개월 데이터 수집 — 손익분석 탭과 반드시 같은 공식을 쓴다
            const expSumOf = (k2) => {
              const out = { food:0, drink:0, sga:0 };
              Object.values(dailyExpense[k2] || {}).forEach((day) => {
                Object.entries(day || {}).forEach(([vid, v]) => {
                  const kd = (vendors.find((x) => x.id === vid) || {}).kind || "food";
                  out[kd] = (out[kd] || 0) + (Number(v) || 0);
                });
              });
              return out;
            };
            const chartMonths = [];
            for (let i=11; i>=0; i--) {
              const d = new Date(year, month-i, 1);
              const y = d.getFullYear();
              const m = d.getMonth();
              const k = `${y}-${String(m+1).padStart(2,"0")}`;
              const sd = salesData[k] || {};
              const hall = Object.values(sd).reduce((a,v)=>a+(v.food||0),0);
              const delivD = deliveryData[k] || {};
              const deliv = platforms.reduce((a,p)=>a+(delivD[p.id]?.revenue||0),0);
              const delivFee = platforms.reduce((a,p)=>a+(delivD[p.id]?.fee||0)+(delivD[p.id]?.ad||0)+(delivD[p.id]?.agency||0)+(delivD[p.id]?.disc||0)-(delivD[p.id]?.adj||0),0);
              const totalR = hall + deliv;
              const ex = expSumOf(k);
              const cg = monthlyCogs[k] || {};
              // 기초·기말재고는 재고 실사 결과를 반영해 계산한다 (손익분석 카드와 같은 기준)
              const st2 = resolveStock(monthlyCogs, monthlyInventory, inventoryItems, k);
              const cogsAmt = Math.max(0, st2.begin + (cg.purchase||0) + ex.food + ex.drink - st2.end) + (cg.other||0);
              const sgaAmt = sga.reduce((a,c)=>{
                if(c.name==="인건비") return a + (monthlyEmployees[k]||[]).reduce((s,e)=>s+calcEmployerCost(e),0) + ownerWageAt(monthlyOwnerWage, k);
                return a + (getSgaAmt(c, k) ?? 0);
              },0) + ex.sga;
              const otherAmt = other.reduce((a,c)=>a+(monthlyOtherAmounts[k]?.[c.id]??0),0);
              const opP = totalR - cogsAmt - sgaAmt - delivFee;
              const netP = opP - otherAmt;
              const cogsRate = totalR>0 ? cogsAmt/totalR*100 : 0;
              const isCurrent = d.getMonth()===month && d.getFullYear()===year;
              // 오늘이 속한 달은 아직 마감 전이라 배달·비용이 덜 들어가 있다. 추이에서 뺀다
              const now = new Date();
              const isOngoing = y === now.getFullYear() && m === now.getMonth();
              chartMonths.push({ label:(m===0?`${String(y).slice(2)}.1월`:`${m+1}월`), hall, deliv, totalR, opP, netP, cogsRate, hasData: totalR>0, isCurrent, isOngoing });
            }
            // 데이터 있고 마감된 달만 표시
            const visibleMonths = chartMonths.filter(m=>m.hasData && !m.isOngoing);
            if (visibleMonths.length === 0) return null;
            const maxRev = Math.max(...visibleMonths.map(m=>m.totalR), 1);
            const maxProfit = Math.max(...visibleMonths.map(m=>Math.max(Math.abs(m.opP),Math.abs(m.netP))), 1);
            const SLOT = `${100/12}%`;   // 12개월 기준 칸 폭 · 왼쪽부터 채운다
            // 매출·손익 차트 아래 월 라벨 (식자재비율 차트와 같은 형식)
            const MonthLabels = () => (
              <div style={{ display:"flex", gap:4, marginTop:4 }}>
                {visibleMonths.map((m,i) => (
                  <div key={i} style={{ width:SLOT, textAlign:"center", fontSize:10, color: m.isCurrent ? C.text : C.textHint, fontWeight: m.isCurrent ? 700 : 400 }}>{m.label}</div>
                ))}
              </div>
            );

            // 연속 악화 감지 — 한 달 등락은 흔하지만, 두 달 연속 같은 방향이면 추세다
            // 마지막 달부터 거꾸로 같은 방향이 몇 번 이어졌는지 센다. 표시에는 출발점이 된 달까지 넣어
            // 「N개월 연속」과 보이는 숫자의 하락 횟수가 일치하게 한다 (예: 3개월 연속 = 숫자 4개)
            const streakOf = (vals, up) => {
              let n = 0;
              for (let i = vals.length - 1; i > 0; i--) {
                if (up ? vals[i] > vals[i - 1] : vals[i] < vals[i - 1]) n++; else break;
              }
              return n;
            };
            const TREND_MIN = 2;
            const trendWarns = [];
            const netRs = visibleMonths.map(m => m.totalR>0 ? m.netP/m.totalR*100 : 0);
            const cgRs = visibleMonths.map(m => m.cogsRate);
            const revs = visibleMonths.map(m => m.totalR);
            const sNet = streakOf(netRs, false), sCg = streakOf(cgRs, true), sRev = streakOf(revs, false);
            if (sNet >= TREND_MIN) trendWarns.push(`순이익률이 ${sNet}개월 연속 하락 중입니다 (${netRs.slice(-sNet-1).map(v=>v.toFixed(1)+"%").join(" → ")})`);
            if (sCg >= TREND_MIN) trendWarns.push(`식자재비율이 ${sCg}개월 연속 상승 중입니다 (${cgRs.slice(-sCg-1).map(v=>v.toFixed(1)+"%").join(" → ")})`);
            if (sRev >= TREND_MIN) trendWarns.push(`매출이 ${sRev}개월 연속 감소 중입니다 (${revs.slice(-sRev-1).map(v=>fmtMan(v)).join(" → ")})`);

            return (
              <div style={{ marginBottom:16 }}>
                {trendWarns.length > 0 && (
                  <div style={{ marginBottom:12, padding:"12px 16px", background:"#f8717115", borderRadius:12, border:"1px solid #f8717140" }}>
                    <p style={{ margin:"0 0 4px", fontSize:13, fontWeight:700, color:C.loss }}>추세 경고</p>
                    {trendWarns.map((w,i) => (
                      <p key={i} style={{ margin:"3px 0 0", fontSize:12, color:C.textSub, lineHeight:1.7 }}>· {w}</p>
                    ))}
                    <p style={{ margin:"6px 0 0", fontSize:10, color:C.textHint, lineHeight:1.7 }}>한 달 등락은 흔하지만 두 달 연속 같은 방향이면 추세입니다. 원인을 찾아 끊어야 합니다.</p>
                  </div>
                )}
                <div style={{ background:"#1a2e42", borderRadius:14, padding:"16px 18px", marginBottom:12 }}>
                  <div style={{ display:"flex", alignItems:"baseline", justifyContent:"space-between", marginBottom:14 }}>
                    <p style={{ margin:0, fontSize:13, fontWeight:700 }}>월별 추이</p>
                    <span style={{ fontSize:10, color:C.textHint }}>{visibleMonths.length}개월</span>
                  </div>

                  {/* 매출 */}
                  <div style={{ marginBottom:16 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:6, flexWrap:"wrap" }}>
                      <span style={{ fontSize:11, fontWeight:700, color:C.textSub }}>매출</span>
                      {[[C.store,"홀"],[C.delivery,"배달"]].map(([clr,lbl])=>(
                        <span key={lbl} style={{ display:"flex", alignItems:"center", gap:4, fontSize:10, color:C.textHint }}>
                          <span style={{ width:7, height:7, borderRadius:2, background:clr, display:"inline-block" }} />{lbl}
                        </span>
                      ))}
                    </div>
                    <div style={{ display:"flex", alignItems:"flex-end", height:64 }}>
                      {visibleMonths.map((m,i) => (
                        <div key={i} style={{ width:SLOT, flexShrink:0, display:"flex", flexDirection:"column", justifyContent:"flex-end", height:"100%" }}>
                          <div style={{ width:"72%", maxWidth:24, margin:"0 auto", display:"flex", flexDirection:"column", justifyContent:"flex-end", height:"100%" }}>
                            <div style={{ background:C.delivery, height:`${Math.max(1,(m.deliv/maxRev)*100)}%`, opacity:0.9 }} />
                            <div style={{ background:C.store, borderRadius:"3px 3px 0 0", height:`${Math.max(1,(m.hall/maxRev)*100)}%`, opacity:0.9 }} />
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{ display:"flex", marginTop:5 }}>
                      {visibleMonths.map((m,i) => (
                        <span key={i} style={{ width:SLOT, flexShrink:0, textAlign:"center", fontSize:9, color:C.textHint }}>
                          {visibleMonths.length<=6 && m.totalR>=10000 ? `${Math.round(m.totalR/10000).toLocaleString("ko-KR")}만` : ""}
                        </span>
                      ))}
                    </div>
                    <MonthLabels />
                  </div>

                  {/* 손익 */}
                  <div style={{ marginBottom:16, paddingTop:14, borderTop:"1px solid #243d54" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:6, flexWrap:"wrap" }}>
                      <span style={{ fontSize:11, fontWeight:700, color:C.textSub }}>손익</span>
                      {[[C.profit,"영업이익"],["#06b6d4","순이익"]].map(([clr,lbl])=>(
                        <span key={lbl} style={{ display:"flex", alignItems:"center", gap:4, fontSize:10, color:C.textHint }}>
                          <span style={{ width:7, height:7, borderRadius:2, background:clr, display:"inline-block" }} />{lbl}
                        </span>
                      ))}
                    </div>
                    <div style={{ display:"flex", alignItems:"flex-end", height:56 }}>
                      {visibleMonths.map((m,i) => (
                        <div key={i} style={{ width:SLOT, flexShrink:0, display:"flex", alignItems:"flex-end", justifyContent:"center", gap:2, height:"100%" }}>
                          <div style={{ width:9, background:m.opP>=0?C.profit:C.loss, borderRadius:"3px 3px 0 0", height:`${Math.max(2, Math.abs(m.opP)/maxProfit*100)}%`, opacity:0.9 }} />
                          <div style={{ width:9, background:m.netP>=0?"#06b6d4":C.loss, borderRadius:"3px 3px 0 0", height:`${Math.max(2, Math.abs(m.netP)/maxProfit*100)}%`, opacity:0.9 }} />
                        </div>
                      ))}
                    </div>
                    {/* 순이익 금액 라벨 — 매출 차트의 금액 라벨과 같은 자리 */}
                    <div style={{ display:"flex" }}>
                      {visibleMonths.map((m,i) => (
                        <span key={i} className="dg-num" style={{ width:SLOT, flexShrink:0, textAlign:"center", fontSize:9, fontWeight:m.isCurrent?700:400, color:m.netP>=0?(m.isCurrent?"#06b6d4":C.textHint):C.loss, marginTop:3 }}>
                          {m.netP<0?"−":""}{fmtMan(Math.abs(m.netP))}
                        </span>
                      ))}
                    </div>
                    <MonthLabels />
                  </div>

                  {/* 식자재비율 */}
                  <div style={{ paddingTop:14, borderTop:"1px solid #243d54" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:6, flexWrap:"wrap" }}>
                      <span style={{ fontSize:11, fontWeight:700, color:C.textSub }}>식자재비율</span>
                      <span style={{ fontSize:10, color:C.textHint }}>적정 30~35%</span>
                    </div>
                    <div style={{ display:"flex", alignItems:"flex-end", height:50 }}>
                      {visibleMonths.map((m,i) => {
                        const clr = m.cogsRate>=40?C.loss:m.cogsRate>=35?C.other:C.profit;
                        const h = Math.min(100, Math.max(8, ((m.cogsRate-20)/25)*100));
                        return (
                          <div key={i} style={{ width:SLOT, flexShrink:0, display:"flex", flexDirection:"column", justifyContent:"flex-end", alignItems:"center", height:"100%" }}>
                            <span style={{ fontSize:visibleMonths.length>8?8:9, color:clr, fontWeight:700, marginBottom:2 }}>{m.cogsRate>0?(visibleMonths.length>8?m.cogsRate.toFixed(0):`${m.cogsRate.toFixed(0)}%`):""}</span>
                            <div style={{ width:"72%", maxWidth:24, background:clr, borderRadius:"3px 3px 0 0", height:`${m.cogsRate>0?h:0}%`, opacity:0.9 }} />
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* 공통 월 라벨 */}
                  <div style={{ display:"flex", marginTop:7, paddingTop:7, borderTop:"1px solid #243d54" }}>
                    {visibleMonths.map((m,i) => (
                      <span key={i} style={{ width:SLOT, flexShrink:0, textAlign:"center", fontSize:visibleMonths.length>8?9:10, color:m.isCurrent?storeColor:C.textHint, fontWeight:m.isCurrent?700:400, whiteSpace:"nowrap" }}>{m.label}</span>
                    ))}
                  </div>
                </div>
              </div>
            );
          })()}

          {/* 마감 전인 달은 여기부터 숨긴다 — 재고 실사·배달 정산 전이라 비율과 손익이 틀린다 */}
          {!isOngoingMonth && (<>
          <div className="dg-g2" style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:10, marginBottom:16 }}>
            {[
              // warn/danger: 넘으면 나쁜 지표 (비용) · goal: 넘어야 좋은 지표 (수익)
              { label:"식자재비율", num:pctNum(totalCogs,totalRev), prev:pctNum(prevTotalCogs,prevTotalRev), warn:35, danger:40, hint:"적정 30~35% · 40% 넘으면 위험", color:"#2dd4bf" },
              { label:"인건비율", num:pctNum(totalLaborCost,totalRev), prev:pctNum(prevLaborCost,prevTotalRev), warn:30, danger:35, hint:"참고 20~25% · 업종·배달 비중 따라 다름", color:C.labor },
              // neutral: 기준선을 정하지 않은 지표 — 경고 없이 값과 전월 변화만 보여준다 (낮을수록 좋은 쪽으로 판정)
              { label:"배달비용률", num:pctNum(totalDelivCost,totalDelivRevenue), prev:pctNum(prevTotalDelivCost,prevDelivRevenue), neutral:true, scale:50, show:totalDelivRevenue>0, prevOk:prevDelivRevenue>0, hint:"배달 매출 대비 · 수수료·배달비·광고·할인", color:"#8b5cf6" },
              { label:"순이익률", num:pctNum(netProfit,totalRev), prev:pctNum(prevNetProfit,prevTotalRev), goal:15, hint:"현실적 목표 15~20% · 본인 월급 반영 후 기준", color:"#ec4899" },
            ]
            // 진행 중인 달은 비용이 한 달치라 이익률·인건비율이 크게 왜곡된다. 식자재비율만 남긴다
            .filter(({label}) => !isOngoingMonth || label === "식자재비율")
            .map(({label,num,prev,warn,danger,goal,hint,color,neutral,scale,show,prevOk}) => {
              const isGoal = goal !== undefined;
              // 비용 지표는 낮을수록 좋다 — 하한 미달은 경고 대상이 아니다
              const isDanger = neutral ? false : isGoal ? num < 0 : num >= danger;
              const isWarn   = neutral ? false : isGoal ? (num >= 0 && num < goal) : (num >= warn && num < danger);
              const sc = neutral ? color : isDanger ? C.loss : isWarn ? C.other : C.profit;
              const badge = isDanger ? (isGoal ? "적자" : "위험") : isWarn ? (isGoal ? "목표 미달" : "경고") : null;
              const scaleMax = neutral ? scale : isGoal ? Math.max(goal*2, 20) : danger*1.25;
              // 전월 대비: 비용은 내려가야 좋고, 수익은 올라가야 좋다
              const d = (hasPrevMonth && prevOk !== false) ? num - prev : null;
              const dGood = d === null ? null : (isGoal ? d >= 0 : d <= 0);
              return (
                <div key={label} style={{ background:"#1a2e42", borderRadius:12, padding:"14px 16px", borderTop:`3px solid ${isDanger?C.loss:isWarn?C.other:color}` }}>
                  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:6, marginBottom:2 }}>
                    <p style={{ margin:0, fontSize:11, color:C.textSub, fontWeight:600 }}>{label}</p>
                    {badge && <span style={{ fontSize:10, fontWeight:700, color:isDanger?C.loss:C.other, background:isDanger?"#f8717120":"#fbbf2420", padding:"1px 6px", borderRadius:4, whiteSpace:"nowrap" }}>{badge}</span>}
                  </div>
                  <div style={{ display:"flex", alignItems:"baseline", gap:6, flexWrap:"wrap" }}>
                    <p style={{ margin:"4px 0 2px", fontSize:20, fontWeight:700, color:sc }}>{(show === undefined ? totalRev>0 : show) ? num.toFixed(1)+"%" : "–"}</p>
                    {d !== null && Math.abs(d) >= 0.05 && (
                      <span className="dg-num" style={{ fontSize:11, fontWeight:700, color:dGood?C.profit:C.loss }}>
                        {d>0?"▲":"▼"}{Math.abs(d).toFixed(1)}%p
                      </span>
                    )}
                  </div>
                  <p style={{ margin:0, fontSize:10, color:C.textHint }}>{hint}</p>
                  <div style={{ marginTop:6, height:3, borderRadius:2, background:`${color}22` }}>
                    <div style={{ height:"100%", borderRadius:2, background:sc, width:`${Math.min(100,Math.max(0,(num/scaleMax)*100))}%` }} />
                  </div>
                </div>
              );
            })}
          </div>

          {/* 식자재비율 경고 메시지 */}
          {totalRev>0 && pctNum(totalCogs,totalRev)>=35 && (
            <div style={{ marginBottom:16, padding:"12px 16px", background:pctNum(totalCogs,totalRev)>=40?"#f8717118":"#fbbf2418", borderRadius:12, border:`1px solid ${pctNum(totalCogs,totalRev)>=40?"#f8717140":"#fbbf2440"}` }}>
              <p style={{ margin:0, fontSize:13, fontWeight:700, color:pctNum(totalCogs,totalRev)>=40?C.loss:C.other }}>
                {pctNum(totalCogs,totalRev)>=40?"식자재비율 위험":"식자재비율 경고"}
              </p>
              <p style={{ margin:"4px 0 0", fontSize:12, color:C.textSub }}>
                식자재비율이 {pct(totalCogs,totalRev)}로 {pctNum(totalCogs,totalRev)>=40?"40%를 넘었습니다. 즉각적인 원가 점검이 필요해요.":"적정 상단(35%)을 넘었어요. 식재료 낭비나 구매 단가를 점검해보세요."}
              </p>
              <p style={{ margin:"4px 0 0", fontSize:11, color:C.textHint }}>
                적정 수준(35% 이하)으로 낮추면 월 {fmtW(Math.round((pctNum(totalCogs,totalRev)-35)*totalRev/100))} 절감 가능
              </p>
            </div>
          )}

          <div style={{ marginBottom:16, padding:"18px 20px", background:"#1a2e42", borderRadius:14 }}>
            <p style={{ margin:"0 0 14px", fontSize:13, fontWeight:700 }}>매출 채널 믹스</p>
            {totalRev>0 && (
              <div style={{ display:"flex", gap:2, height:10, borderRadius:5, overflow:"hidden", marginBottom:10 }}>
                {[[hallRev,C.store],[totalDelivRevenue,"#8b5cf6"]].filter(([v])=>v>0).map(([v,clr],i) => <div key={i} style={{ flex:v, background:clr }} />)}
              </div>
            )}
            <div style={{ display:"flex", gap:16, flexWrap:"wrap" }}>
              {[["홀",hallRev,C.store],["플랫폼배달",totalDelivRevenue,"#8b5cf6"]].map(([lbl,val,clr]) =>
                val>0 && <div key={lbl} style={{ display:"flex", alignItems:"center", gap:6 }}>
                  <span style={{ width:10, height:10, borderRadius:2, background:clr, display:"inline-block" }} />
                  <span style={{ fontSize:11, color:C.textSub }}>{lbl}</span>
                  <span style={{ fontSize:11, fontWeight:700, color:clr }}>{pct(val,totalRev)}</span>
                </div>
              )}
            </div>
            {totalRev>0 && pctNum(totalDelivRevenue,totalRev)>50 && <p style={{ margin:"10px 0 0", fontSize:12, color:C.loss }}><span style={{ display:"inline-flex", width:14, height:14, borderRadius:"50%", background:"currentColor", color:"#0D1B2A", fontSize:10, fontWeight:700, alignItems:"center", justifyContent:"center", marginRight:5, flexShrink:0 }}>!</span>배달 플랫폼 의존도가 높아요 ({pct(totalDelivRevenue,totalRev)}). 홀 매출 강화를 고려해보세요.</p>}
            {/* 만원의 경제학 — 채널별 공헌이익 비교 */}
            {totalRev>0 && totalDelivRevenue>0 && hallRev>0 && (() => {
              const cogsR = totalCogs/totalRev;                       // 식자재는 채널 공통 비율로 본다
              const delivR = totalDelivCost/totalDelivRevenue;        // 배달비용은 배달 매출에만 붙는다
              const hallKeep = Math.round(10000*(1-cogsR));
              const delivKeep = Math.round(10000*(1-cogsR-delivR));
              const diffKeep = hallKeep - delivKeep;
              return (
                <div style={{ marginTop:12, paddingTop:11, borderTop:`1px solid ${C.border}` }}>
                  <p style={{ margin:"0 0 3px", fontSize:12, fontWeight:700 }}>매출 1만원당 남는 돈, 채널마다 다릅니다</p>
                  <p style={{ margin:"0 0 9px", fontSize:10, color:C.textHint }}>이달 평균 · 식자재만 뺀 기준 · 인건비·임차료 빼기 전 · 주문 건마다는 다릅니다</p>
                  {[["홀 매출 1만원당", hallKeep, C.store, `식자재 ${fmtW(10000-hallKeep)} 차감`],
                    ["배달 매출 1만원당", delivKeep, "#8b5cf6", `식자재 ${fmtW(Math.round(10000*cogsR))} + 수수료·배달비·광고 ${fmtW(Math.round(10000*delivR))} 차감`]].map(([lbl,keep,clr,desc]) => (
                    <div key={lbl} style={{ marginBottom:7 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", gap:8, marginBottom:3 }}>
                        <span style={{ fontSize:11, color:clr, fontWeight:700 }}>{lbl}</span>
                        <span style={{ fontSize:11 }}>
                          <span className="dg-num" style={{ fontWeight:700, color:C.profit }}>{keep.toLocaleString("ko-KR")}원 남음</span>
                          <span style={{ color:C.textHint, marginLeft:6, fontSize:10 }}>{desc}</span>
                        </span>
                      </div>
                      <div style={{ height:6, background:"#0D1B2A", borderRadius:3, overflow:"hidden" }}>
                        <div style={{ height:"100%", background:clr, borderRadius:3, width:`${Math.max(0,keep/100)}%` }} />
                      </div>
                    </div>
                  ))}
                  {diffKeep > 0 && (
                    <p style={{ margin:"7px 0 0", fontSize:11, color:C.textSub, lineHeight:1.8 }}>
                      배달은 매출 1만원당 평균 <strong style={{ color:C.loss }}>{fmtW(diffKeep)}씩 덜 남습니다.</strong> 이번 달 배달 매출 {fmtMan(totalDelivRevenue)}원 중 <strong style={{ color:C.loss }}>{fmtW(Math.round(totalDelivRevenue*diffKeep/10000))}</strong>이 채널 비용입니다. 같은 손님이 홀·포장으로 오게 만드는 것 자체가 수익 개선입니다.
                    </p>
                  )}
                </div>
              );
            })()}
          </div>

          {totalDelivRevenue>0 && (
            <div style={{ marginBottom:16, padding:"18px 20px", background:"#1a2e42", borderRadius:14 }}>
              <p style={{ margin:"0 0 14px", fontSize:13, fontWeight:700 }}>배달 플랫폼별 수익률</p>
              {platforms.filter(p=>(delivMonthData[p.id]?.revenue||0)>0).map(plat => {
                const pd=delivMonthData[plat.id]||{};
                const net=(pd.revenue||0)-(pd.fee||0)-(pd.ad||0)-(pd.agency||0)-(pd.disc||0)+(pd.adj||0);
                const rate=pctNum(net,pd.revenue||0);
                return (
                  <div key={plat.id} style={{ marginBottom:12 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                      <span style={{ fontSize:12, fontWeight:600, color:plat.color }}>{plat.name}</span>
                      <span style={{ fontSize:12, fontWeight:700, color:rate>=15?C.profit:rate>=10?C.other:C.loss }}>{pct(net,pd.revenue||0)} 실수익률</span>
                    </div>
                    <div style={{ height:6, background:`${plat.color}22`, borderRadius:3, overflow:"hidden" }}>
                      <div style={{ height:"100%", background:plat.color, borderRadius:3, width:`${Math.max(0,Math.min(100,rate*3))}%` }} />
                    </div>
                    <div style={{ display:"flex", gap:10, marginTop:4, fontSize:11, color:C.textHint }}>
                      <span>주문 {(pd.revenue||0).toLocaleString("ko-KR")}원</span>
                      <span>수수료 {pct(pd.fee||0,pd.revenue||0)}</span>
                      {(pd.ad||0)>0 && <span>광고 {pct(pd.ad||0,pd.revenue||0)}</span>}
                      {(pd.agency||0)>0 && <span>대행비 {pct(pd.agency||0,pd.revenue||0)}</span>}
                      <span style={{ color:net>=0?C.profit:C.loss }}>실수익 {net.toLocaleString("ko-KR")}원</span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <div style={{ border:"1px solid #1e3448", borderRadius:14, overflow:"hidden", marginBottom:16 }}>
            <div style={{ background:"#1e293b", padding:"14px 20px", display:"flex", justifyContent:"space-between" }}>
              <span style={{ fontSize:14, fontWeight:600, color:"#f8fafc" }}>{year}년 {MONTHS[month]} 손익계산서</span>
              <span style={{ fontSize:11, color:"#94a3b8" }}>단위: 원</span>
            </div>
            <PLGroup num="①" label="매출" total={totalRev} color={C.store} prev={hasPrevMonth?prevTotalRev:null} />
            <PLSub label="홀 매출" amount={hallRev} ratio={pct(hallRev,totalRev)} dot={C.store} prev={hasPrevMonth?prevRev.food:null} />
            <PLSub label="배달 플랫폼 주문금액" amount={totalDelivRevenue} ratio={pct(totalDelivRevenue,totalRev)} dot="#8b5cf6" prev={hasPrevMonth?prevDelivRevenue:null} />
            <PLGroup num="②" label="매출원가" total={totalCogs} color="#ef4444" neg prev={hasPrevMonth?prevTotalCogs:null} />
            <PLSub label="식재료비 (기초+매입-기말)" amount={cogsFood} ratio={pct(cogsFood,totalRev)} dot="#ef4444" neg prev={hasPrevMonth?prevCogsFood:null} />
            <PLSub label="기타 식자재" amount={cogsOther} ratio={pct(cogsOther,totalRev)} dot="#f87171" neg prev={hasPrevMonth?(prevCogs.other||0):null} />
            <PLGroup num="③" label="판매비와 관리비" total={totalSga} color="#6366f1" neg prev={hasPrevMonth?prevTotalSga:null} />
            {totalLaborCost>0 && <>
              <PLSub label="인건비 (직원)" amount={totalEmployeeCost} ratio={pct(totalEmployeeCost,totalRev)} dot={C.labor} neg prev={hasPrevMonth?prevMonthEmployees.reduce((a,e)=>a+calcEmployerCost(e),0):null} />
              <PLSub label="인건비 (사장님)" amount={ownerWage} ratio={pct(ownerWage,totalRev)} dot={C.labor} />
            </>}
            {sga.filter(c=>c.name!=="인건비").map(c => {
              const amt=getSgaAmt(c,mk)??0;
              return amt>0 ? <PLSub key={c.id} label={c.name} amount={amt} ratio={pct(amt,totalRev)} dot="#818cf8" neg prev={hasPrevMonth?(getSgaAmt(c,prevMk)??0):null} /> : null;
            })}
            {totalDelivCost>0 && <PLGroup num="③-1" label="배달 수수료·광고·대행·할인" total={totalDelivCost} color="#8b5cf6" neg prev={hasPrevMonth?prevTotalDelivCost:null} />}
            {platforms.filter(p=>(delivMonthData[p.id]?.fee||0)+(delivMonthData[p.id]?.ad||0)+(delivMonthData[p.id]?.agency||0)+(delivMonthData[p.id]?.disc||0)-(delivMonthData[p.id]?.adj||0)>0).map(plat => {
              const pd=delivMonthData[plat.id]||{}; const total=(pd.fee||0)+(pd.ad||0)+(pd.agency||0)+(pd.disc||0)-(pd.adj||0);
              const ppd2=prevDelivData[plat.id]||{}; const ptot=(ppd2.fee||0)+(ppd2.ad||0)+(ppd2.agency||0)+(ppd2.disc||0)-(ppd2.adj||0);
              return <PLSub key={plat.id} label={`${plat.name} 수수료+광고+대행비`} amount={total} ratio={pct(total,totalRev)} dot={plat.color} neg prev={hasPrevMonth?ptot:null} />;
            })}
            <div style={{ padding:"14px 20px", background:opProfit>=0?"#34d39914":"#f8717114", borderTop:`2px solid ${C.border}`, display:"flex", justifyContent:"space-between" }}>
              <span style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                <span style={{ fontSize:11, fontWeight:700, color:"#0D1B2A", background:pC(opProfit), borderRadius:6, padding:"3px 9px", whiteSpace:"nowrap" }}>④ 영업이익</span>
                <span style={{ fontSize:11, color:C.textHint }}>{totalDelivCost>0?"① − ② − ③ − ③-1":"① − ② − ③"}</span>
              </span>
              <div style={{ textAlign:"right", flexShrink:0 }}>
                <p className="dg-num" style={{ margin:0, fontSize:16, fontWeight:700, color:pC(opProfit) }}>{opProfit>=0?"+":""}{opProfit.toLocaleString("ko-KR")}원</p>
                <p style={{ margin:"2px 0 0", fontSize:11, color:pC(opProfit) }}>
                  {pct(opProfit,totalRev)}
                  {hasPrevMonth && Math.round(opProfit-prevOpProfit)!==0 && (
                    <span className="dg-num" style={{ marginLeft:8, fontWeight:700, color:opProfit>=prevOpProfit?C.profit:C.loss }}>
                      {opProfit>=prevOpProfit?"▲":"▼"}{Math.abs(Math.round(opProfit-prevOpProfit)).toLocaleString("ko-KR")} 전월비
                    </span>
                  )}
                </p>
              </div>
            </div>
            <PLGroup num="⑤" label="기타 비용" total={totalOther} color="#f59e0b" neg prev={hasPrevMonth?prevTotalOther:null} />
            {other.map(c => { const amt=getOtherAmt(c,mk)??0; return amt>0?<PLSub key={c.id} label={c.name} amount={amt} ratio={pct(amt,totalRev)} dot="#fbbf24" neg prev={hasPrevMonth?(getOtherAmt(c,prevMk)??0):null} />:null; })}
            <div style={{ padding:"18px 20px", background:netProfit>=0?"#34d39914":"#f8717114", borderTop:`2px solid ${C.border}`, display:"flex", justifyContent:"space-between" }}>
              <span style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                <span style={{ fontSize:12, fontWeight:700, color:"#0D1B2A", background:pC(netProfit), borderRadius:7, padding:"4px 11px", whiteSpace:"nowrap" }}>⑥ 월 순이익</span>
                <span style={{ fontSize:11, color:C.textHint }}>④ − ⑤</span>
              </span>
              <div style={{ textAlign:"right", flexShrink:0 }}>
                <p className="dg-num" style={{ margin:0, fontSize:22, fontWeight:700, color:pC(netProfit) }}>{netProfit>=0?"+":""}{netProfit.toLocaleString("ko-KR")}원</p>
                <p style={{ margin:"2px 0 0", fontSize:12, color:pC(netProfit) }}>
                  {pct(netProfit,totalRev)}
                  {hasPrevMonth && Math.round(netDelta)!==0 && (
                    <span className="dg-num" style={{ marginLeft:8, fontWeight:700, color:netDelta>=0?C.profit:C.loss }}>
                      {netDelta>=0?"▲":"▼"}{Math.abs(Math.round(netDelta)).toLocaleString("ko-KR")} 전월비
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>

          <div className="dg-g2" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
            {[
              { label:"손익분기점", val:isFinite(bep)?fmtW(bep):"—",
                cur:isFinite(bep)?bep:null, prev:prevBep, lowerIsBetter:true,
                sub:(() => {
                  if (!isFinite(bep)||bep<=0) return "–";
                  const rate = (totalRev/bep)*100;
                  if (totalRev>=bep) return `달성 ${rate.toFixed(0)}% · 여유 ${fmtW(totalRev-bep)}`;
                  const remain = bep - totalRev;
                  const avgDaily = (avgDailyHall+avgDailyDeliv);
                  if (avgDaily>0) return `${rate.toFixed(0)}% · 약 ${Math.ceil(remain/avgDaily)}일 후 달성 예상`;
                  return `${rate.toFixed(0)}% · ${fmtW(remain)} 부족`;
                })(),
                color:"#6366f1" },
              { label:"일평균 매출 (홀)", val:fmtW(avgDailyHall), cur:avgDailyHall, prev:prevAvgDailyHall, sub:`월 매출 ÷ ${days}일`, color:C.store },
              { label:"일평균 매출 (배달·포장)", val:fmtW(avgDailyDeliv), cur:avgDailyDeliv, prev:prevAvgDailyDeliv, sub:`월 매출 ÷ ${days}일`, color:C.delivery },
            ].map(({label,val,sub,color,cur,prev,lowerIsBetter}) => {
              const d = (hasPrevMonth && cur!=null && prev) ? Math.round(cur) - Math.round(prev) : null;
              // 손익분기점은 낮아질수록 좋고, 매출은 오를수록 좋다
              const good = d===null ? null : (lowerIsBetter ? d<0 : d>0);
              return (
              <div key={label} style={{ background:"#1a2e42", borderRadius:12, padding:"16px 18px", borderLeft:`3px solid ${color}` }}>
                <p style={{ margin:0, fontSize:12, color:C.textSub, fontWeight:600 }}>{label}</p>
                <div style={{ display:"flex", alignItems:"baseline", gap:7, flexWrap:"wrap" }}>
                  <p className="dg-num" style={{ margin:"6px 0 3px", fontSize:18, fontWeight:700, color }}>{val}</p>
                  {d !== null && d !== 0 && (
                    <span className="dg-num" style={{ fontSize:11, fontWeight:700, color:good?C.profit:C.loss }}>
                      {d>0?"▲":"▼"}{Math.abs(d).toLocaleString("ko-KR")}
                    </span>
                  )}
                </div>
                <p style={{ margin:0, fontSize:11, color:C.textHint }}>{sub}</p>
                {d !== null && prev > 0 && (
                  <p style={{ margin:"3px 0 0", fontSize:10, color:C.textHint }}>전월 {fmtW(prev)}</p>
                )}
              </div>
              );
            })}
          </div>

          {/* 배달 플랫폼 수익성 비교 */}
          {platforms.filter(p=>(delivMonthData[p.id]?.revenue||0)>0).length>1 && (() => {
            const rows = platforms.filter(p=>(delivMonthData[p.id]?.revenue||0)>0).map(p=>{
              const pd=delivMonthData[p.id]||{};
              const net=(pd.revenue||0)-(pd.fee||0)-(pd.ad||0)-(pd.agency||0)-(pd.disc||0)+(pd.adj||0);
              return { plat:p, net, rate:pctNum(net,pd.revenue||0), revenue:pd.revenue||0 };
            }).sort((a,b)=>b.net-a.net);
            const totalNet = rows.reduce((a,r)=>a+r.net,0);
            const maxNet = Math.max(...rows.map(r=>r.net), 1);
            const bestRate = [...rows].sort((a,b)=>b.rate-a.rate)[0];
            const top = rows[0];
            return (
            <div style={{ marginBottom:16, padding:"18px 20px", background:"#1a2e42", borderRadius:14 }}>
              <p style={{ margin:0, fontSize:13, fontWeight:700 }}>플랫폼별 실수익 기여</p>
              <p style={{ margin:"4px 0 14px", fontSize:11, color:C.textHint }}>실수익 금액 순 · 비율이 높아도 금액이 작으면 기여는 작습니다</p>
              {rows.map(({plat,rate,revenue,net},i)=>(
                <div key={plat.id} style={{ padding:"9px 0", borderBottom:i<rows.length-1?"1px solid #1e3448":"none" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:5, flexWrap:"wrap" }}>
                    <span style={{ fontSize:12, fontWeight:700, color:C.textHint, minWidth:16 }}>{i+1}</span>
                    <span style={{ fontSize:13, fontWeight:700, color:plat.color, minWidth:64 }}>{plat.name}</span>
                    <span className="dg-num" style={{ fontSize:13, fontWeight:700, color:C.profit }}>{fmtW(net)}</span>
                    <span style={{ fontSize:11, color:C.textHint }}>기여 {totalNet>0?((net/totalNet)*100).toFixed(1):0}%</span>
                    <span style={{ marginLeft:"auto", fontSize:11, color:rate>=70?C.profit:rate>=60?C.other:C.loss, fontWeight:700, whiteSpace:"nowrap" }}>실수익률 {rate.toFixed(1)}%</span>
                  </div>
                  <div style={{ height:6, background:`${plat.color}22`, borderRadius:3, overflow:"hidden" }}>
                    <div style={{ height:"100%", background:plat.color, borderRadius:3, width:`${Math.max(1,(net/maxNet)*100)}%` }} />
                  </div>
                  <p style={{ margin:"4px 0 0", fontSize:10, color:C.textHint }}>주문금액 {fmtW(revenue)}</p>
                </div>
              ))}
              {bestRate && top && bestRate.plat.id !== top.plat.id && (
                <p style={{ margin:"12px 0 0", paddingTop:10, borderTop:`1px solid ${C.border}`, fontSize:11, color:C.textSub, lineHeight:1.8 }}>
                  실수익률만 보면 <strong style={{ color:bestRate.plat.color }}>{bestRate.plat.name}</strong>이 {bestRate.rate.toFixed(1)}%로 가장 높지만, 실수익 금액은 {fmtW(bestRate.net)}으로 <strong style={{ color:top.plat.color }}>{top.plat.name}</strong>({fmtW(top.net)})에 못 미칩니다. 비율이 좋은 채널은 <strong style={{ color:C.text }}>키울 여지</strong>로 보시면 됩니다.
                </p>
              )}
            </div>
            );
          })()}
          </>)}
        </div>
      )}

      <div style={{ marginTop:40, paddingTop:20, borderTop:`1px solid ${C.border}` }}>
        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
          
        </div>
      </div>
    </div>
  );
}


// ══ 재고조사 탭 ══════════════════════════════════════════════════
function InventoryTab({
  mk, year, month, MONTHS, prevMonth, nextMonth, NAV_BTN,
  items, setItems, monthly, setMonthly, invThis, invPrev, invSum,
  totalCogs, days, beginStock, C,
}) {
  const [pasteText, setPasteText] = useState("");
  const [preview, setPreview] = useState(null);       // { rows:[{name,qty,unit,cat,itemId,isNew}], bad:[], zeroMissing }
  const [priceText, setPriceText] = useState("");
  const [priceOpen, setPriceOpen] = useState(false);
  const [priceMsg, setPriceMsg] = useState(null);
  const [catFilter, setCatFilter] = useState("all");
  const [invSort, setInvSort] = useState("order");   // order(세는 순서) | amount(금액순)
  const [editing, setEditing] = useState(null);
  // 품목 편집도 행 밖을 누르거나 Esc로 닫는다
  useEffect(() => {
    if (!editing) return;
    const onDown = (ev) => { if (!ev.target.closest || !ev.target.closest("[data-item-edit]")) setEditing(null); };
    const onKey = (ev) => { if (ev.key === "Escape") setEditing(null); };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("touchstart", onDown, { passive: true });
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("touchstart", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [editing]);
  const [newItem, setNewItem] = useState({ name:"", unit:"", cat:"food" });

  const qtyOf = (id, inv) => Number((inv && inv.qty && inv.qty[id]) || 0);
  const skipped = !!(invThis && invThis.skipped);
  const catColor = (c) => (INV_CATS.find((x) => x.id === c) || INV_CATS[0]).color;

  // ── 이번 달 실사 데이터 갱신 헬퍼 ──
  const updInv = (fn) => setMonthly((prev) => {
    const cur = prev[mk] || { qty: {}, amt: {}, skipped: false };
    return { ...prev, [mk]: fn({ ...cur, qty: { ...(cur.qty || {}) }, amt: { ...(cur.amt || {}) } }) };
  });
  const setQty = (id, v) => updInv((inv) => ({ ...inv, qty: { ...inv.qty, [id]: Math.max(0, Number(v) || 0) }, skipped: false, countedAt: Date.now() }));
  const setAmt = (id, v) => updInv((inv) => {
    const amt = { ...inv.amt };
    if (v === "" || v === null || v === undefined || Number(v) === 0) delete amt[id]; else amt[id] = Math.max(0, Number(v) || 0);
    return { ...inv, amt };
  });
  const toggleSkip = () => updInv((inv) => ({ ...inv, skipped: !inv.skipped, countedAt: Date.now() }));

  // ── 품목 마스터 ──
  const updItem = (id, field, val) => {
    if (field === "price") { setPrice(id, val); return; }
    setItems((p) => p.map((x) => x.id === id ? { ...x, [field]: val } : x));
  };
  // 단가는 품목 마스터와 이번 달 스냅샷에 함께 기록한다 (지난달 스냅샷은 그대로 남아 비교가 된다)
  const setPrice = (id, val) => {
    const price = Math.max(0, Number(val) || 0);
    // 이 품목의 단가가 기록된 가장 최근 달. 그보다 과거 달을 고칠 때는 마스터(최신 단가)를 건드리지 않는다
    const latest = Object.entries(monthly || {})
      .filter(([, inv]) => inv && inv.price && inv.price[id] !== undefined && inv.price[id] !== null)
      .map(([k]) => k).sort().pop();
    if (!latest || mk >= latest) {
      setItems((p) => p.map((x) => x.id === id ? { ...x, price } : x));
    }
    setMonthly((prev) => {
      const cur = prev[mk] || { qty: {}, amt: {}, skipped: false };
      return { ...prev, [mk]: { ...cur, price: { ...(cur.price || {}), [id]: price } } };
    });
  };
  // 이번 달 실사만 초기화 — 품목·단가는 그대로 둔다
  const clearMonth = () => {
    const cnt = invSum.countedItems;
    if (!window.confirm(`${MONTHS[month]} 실사 수량을 모두 지웁니다.\n품목 목록과 단가는 그대로 남습니다.${cnt > 0 ? `\n지금 ${cnt}개 품목에 수량이 들어 있습니다.` : ""}\n계속할까요?`)) return;
    setMonthly((prev) => {
      const next = { ...prev };
      delete next[mk];
      return next;
    });
  };
  // 품목 마스터 통째 삭제 — 모든 달의 기록이 사라진다
  const clearAllItems = () => {
    if (!window.confirm(`품목 ${items.length}개를 전부 지웁니다.\n단가와 모든 달의 실사 수량도 함께 사라집니다.\n되돌릴 수 없습니다. 계속할까요?`)) return;
    if (!window.confirm("정말 지울까요?\n다시 붙여넣어 처음부터 만들어야 합니다.")) return;
    setItems([]);
    setMonthly({});
  };
  const delItem = (id) => {
    const it = items.find((x) => x.id === id);
    if (!window.confirm(`"${it ? it.name : "이 품목"}"을 목록에서 지울까요?\n모든 달의 수량 기록도 함께 사라집니다.`)) return;
    setItems((p) => p.filter((x) => x.id !== id));
    setMonthly((prev) => {
      const next = {};
      Object.entries(prev).forEach(([k, inv]) => {
        const q = { ...(inv.qty || {}) }, a = { ...(inv.amt || {}) };
        delete q[id]; delete a[id];
        next[k] = { ...inv, qty: q, amt: a };
      });
      return next;
    });
  };
  const addItem = () => {
    const nm = newItem.name.trim();
    if (!nm) return;
    if (items.some((x) => invNorm(x.name) === invNorm(nm))) { alert("같은 이름의 품목이 이미 있습니다."); return; }
    setItems((p) => [...p, { id: `inv_${Date.now()}`, name: nm, unit: newItem.unit.trim(), cat: newItem.cat, price: 0, order: p.length }]);
    setNewItem({ name:"", unit:"", cat:"food" });
  };

  // ── 붙여넣기 → 미리보기 ──
  const buildPreview = () => {
    const { rows, bad } = parseInventoryText(pasteText);
    const byName = new Map(items.map((x) => [invNorm(x.name), x]));
    const seen = new Set();
    const mapped = rows.map((r) => {
      const hit = byName.get(invNorm(r.name));
      seen.add(invNorm(r.name));
      return { ...r, itemId: hit ? hit.id : null, isNew: !hit, cat: hit ? hit.cat : invCatOf(r.name), unit: r.unit || (hit ? hit.unit : "") };
    });
    const missing = items.filter((x) => !seen.has(invNorm(x.name)));
    setPreview({ rows: mapped, bad, missing, zeroMissing: true });
  };
  const applyPreview = () => {
    if (!preview) return;
    // 1) 새 품목 등록
    const newItems = [];
    const rowsWithId = preview.rows.map((r) => {
      if (r.itemId) return r;
      const id = `inv_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`;
      newItems.push({ id, name: r.name, unit: r.unit, cat: r.cat, price: 0, order: items.length + newItems.length });
      return { ...r, itemId: id };
    });
    setItems((p) => {
      const merged = [...p, ...newItems];
      // 붙여넣은 순서대로 order를 다시 매긴다 (창고 도는 동선이 곧 화면 순서)
      const pos = new Map(rowsWithId.map((r, i) => [r.itemId, i]));
      return merged.map((x) => {
        const r = rowsWithId.find((rr) => rr.itemId === x.id);
        const unit = r && !x.unit && r.unit ? r.unit : x.unit;
        const order = pos.has(x.id) ? pos.get(x.id) : 10000 + merged.indexOf(x);
        return { ...x, unit, order };
      });
    });
    // 2) 이번 달 수량
    updInv((inv) => {
      const qty = { ...inv.qty };
      if (preview.zeroMissing) {
        // 실사했는데 목록에 없는 품목 = 실제로 0개. 손도 안 댄 "미입력"과 구분하기 위해 0을 명시한다
        items.forEach((x) => { qty[x.id] = 0; });
      }
      rowsWithId.forEach((r) => { qty[r.itemId] = r.qty; });
      return { ...inv, qty, skipped: false, countedAt: Date.now() };
    });
    setPreview(null); setPasteText("");
  };
  const copyPrevQty = () => {
    if (!invPrev || !invPrev.qty) return;
    updInv((inv) => ({ ...inv, qty: { ...invPrev.qty }, skipped: false, countedAt: Date.now() }));
  };
  const applyPrices = () => {
    const { rows, bad } = parsePriceText(priceText);
    let hit = 0;
    const applied = {};
    setItems((p) => p.map((x) => {
      const r = rows.find((rr) => invNorm(rr.name) === invNorm(x.name));
      if (!r) return x;
      hit += 1; applied[x.id] = r.price;
      return { ...x, price: r.price };
    }));
    setMonthly((prev) => {
      const cur = prev[mk] || { qty: {}, amt: {}, skipped: false };
      return { ...prev, [mk]: { ...cur, price: { ...(cur.price || {}), ...applied } } };
    });
    setPriceMsg(`${hit}개 품목에 단가를 넣었습니다${bad.length ? ` · 읽지 못한 줄 ${bad.length}개` : ""}${rows.length - hit > 0 ? ` · 이름이 안 맞는 줄 ${rows.length - hit}개` : ""}`);
    setPriceText("");
  };

  // ── 표 데이터 ──
  const rows = items
    .map((it) => ({
      it, q: qtyOf(it.id, invThis), pq: qtyOf(it.id, invPrev),
      amt: invItemAmount(it, invThis), hasVal: invHasValue(it, invThis),
      pamt: invPrev ? invItemAmount(it, invPrev) : 0,
      price: invPriceOf(it, invThis),
      pprice: invPrev && invPrev.price && invPrev.price[it.id] !== undefined ? Number(invPrev.price[it.id]) || 0 : null,
      direct: invThis && invThis.amt && invThis.amt[it.id] !== undefined ? invThis.amt[it.id] : "",
    }))
    .filter((r) => catFilter === "all" || r.it.cat === catFilter)
    .sort((a, b) => invSort === "amount"
      ? (b.amt - a.amt) || (b.q - a.q) || a.it.name.localeCompare(b.it.name, "ko")
      : (a.it.order ?? 0) - (b.it.order ?? 0));   // 붙여넣은 순서 = 창고 도는 순서

  // ── 통찰 ──
  const dailyCogs = days > 0 && totalCogs > 0 ? totalCogs / days : 0;
  const turnoverDays = dailyCogs > 0 ? invSum.endStock / dailyCogs : null;
  const counted = (id) => !!(invThis && invThis.qty && invThis.qty[id] !== undefined && invThis.qty[id] !== null);
  const spikes = items.map((it) => ({ it, q: qtyOf(it.id, invThis), pq: qtyOf(it.id, invPrev), has: counted(it.id) }))
    .filter(({ q, pq, has }) => has && pq > 0 && (q >= pq * 2 || (q === 0 && pq >= 3)))
    .sort((a, b) => Math.abs(b.q - b.pq) - Math.abs(a.q - a.pq)).slice(0, 5);
  const unpricedTop = rows.filter((r) => r.q > 0 && !r.hasVal).sort((a, b) => b.q - a.q).slice(0, 5);
  // 단가가 오른 품목 — 원가 압박의 조기 신호
  const priceUps = items
    .map((it) => ({ it, cur: invPriceOf(it, invThis), prev: invPrev && invPrev.price && invPrev.price[it.id] != null ? Number(invPrev.price[it.id]) || 0 : null }))
    .filter(({ cur, prev }) => prev > 0 && cur > prev)
    .map((r) => ({ ...r, pct: (r.cur - r.prev) / r.prev * 100 }))
    .sort((a, b) => b.pct - a.pct).slice(0, 5);

  const INP = { fontSize:13, border:"none", borderBottom:"1.5px solid #243d54", background:"transparent", outline:"none", padding:"2px 0", fontFamily:"inherit", color:"#f1f5f9", width:"100%", boxSizing:"border-box" };
  const SEL = { fontSize:11, border:"1px solid #1e3448", background:"#112236", color:"#f1f5f9", borderRadius:4, padding:"2px 4px", fontFamily:"inherit", outline:"none", cursor:"pointer" };

  return (
    <div>
      <PLBadge num="② 매출원가" label="재고조사" sub="월말에 남은 걸 세어 붙여넣으면 기말재고가 자동으로 잡힙니다" color="#2dd4bf" />
      <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:16 }}>
        <button onClick={prevMonth} style={NAV_BTN}>‹</button>
        <span style={{ fontSize:20, fontWeight:700 }}>{year}년 {MONTHS[month]}</span>
        <button onClick={nextMonth} style={NAV_BTN}>›</button>
      </div>

      {/* ── 이번 달 상태 ── */}
      <div style={{ marginBottom:16, padding:"16px 18px", background:"#112236", borderRadius:14, border:`1px solid ${skipped ? "rgba(251,191,36,0.4)" : invDoneLocal(invThis, invSum) ? "rgba(45,212,191,0.4)" : "#1e3448"}` }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10, flexWrap:"wrap" }}>
          <div>
            <p style={{ margin:0, fontSize:11, color:C.textHint }}>{MONTHS[month]} 말 재고 금액 (식자재+음료 → 기말재고)</p>
            <p className="dg-num" style={{ margin:"4px 0 0", fontSize:26, fontWeight:700, color: skipped ? C.textHint : "#2dd4bf" }}>
              {skipped ? "실사 안 함" : fmtW(invSum.endStock)}
            </p>
            {!skipped && invSum.supply > 0 && <p style={{ margin:"2px 0 0", fontSize:11, color:C.textHint }}>+ 포장·소모품 {fmtW(invSum.supply)} (원가 차감엔 미포함)</p>}
          </div>
          <label style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer", padding:"8px 12px", background:"#0D1B2A", borderRadius:9, border:"1px solid #1e3448" }}>
            <input type="checkbox" checked={skipped} onChange={toggleSkip} style={{ width:15, height:15, accentColor:"#fbbf24", cursor:"pointer" }} />
            <span style={{ fontSize:12, color:skipped ? "#fbbf24" : C.textSub, fontWeight:600 }}>이번 달 실사 안 함</span>
          </label>
        </div>
        {skipped ? (
          <p style={{ margin:"10px 0 0", fontSize:11, color:"#fbbf24", lineHeight:1.7 }}>기말재고를 기초재고({fmtW(beginStock)})와 같게 둡니다. 이번 달 식자재비는 매입액 그대로 잡힙니다.</p>
        ) : invSum.countedItems > 0 ? (
          <div style={{ marginTop:12, display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8 }} className="dg-g3">
            {[["세운 품목", `${invSum.countedItems}개`, C.text],
              ["금액 잡힌 품목", `${invSum.priced}개`, invSum.coverage >= 0.5 ? C.profit : C.other],
              ["단가 없는 품목", `${invSum.unpriced}개`, invSum.unpriced > 0 ? C.other : C.textHint]].map(([l, v, clr]) => (
              <div key={l} style={{ background:"#0D1B2A", borderRadius:8, padding:"8px 10px" }}>
                <p style={{ margin:0, fontSize:10, color:C.textHint }}>{l}</p>
                <p style={{ margin:"3px 0 0", fontSize:14, fontWeight:700, color:clr }}>{v}</p>
              </div>
            ))}
          </div>
        ) : (
          <p style={{ margin:"10px 0 0", fontSize:11, color:C.textHint, lineHeight:1.7 }}>아직 이번 달 실사가 없습니다. 아래에 재고 목록을 붙여넣거나, 지난달 수량을 가져와 바뀐 것만 고치세요.</p>
        )}
        {!skipped && invSum.countedItems > 0 && invSum.unpriced > 0 && (
          <p style={{ margin:"10px 0 0", fontSize:11, color:C.other, lineHeight:1.7 }}>
            <span style={{ display:"inline-flex", width:14, height:14, borderRadius:"50%", background:"currentColor", color:"#0D1B2A", fontSize:10, fontWeight:700, alignItems:"center", justifyContent:"center", marginRight:5 }}>!</span>
            단가가 없는 품목 {invSum.unpriced}개는 금액에 안 잡혀 있어 <strong>실제 재고보다 적게</strong> 나옵니다. 금액 큰 것부터 단가를 넣으세요 — 전부 넣을 필요는 없습니다.
          </p>
        )}
      </div>

      {/* ── 붙여넣기 ── */}
      {!skipped && (
      <div style={{ marginBottom:16, padding:"16px 18px", background:"#1a2e42", borderRadius:14 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:10, marginBottom:6, flexWrap:"wrap" }}>
          <p style={{ margin:0, fontSize:13, fontWeight:700 }}>재고 목록 붙여넣기</p>
          {invPrev && invPrev.qty && Object.keys(invPrev.qty).length > 0 && (
            <button onClick={copyPrevQty} style={{ ...ADD_BTN, fontSize:11 }}>지난달 수량 가져오기</button>
          )}
        </div>
        <p style={{ margin:"0 0 10px", fontSize:11, color:C.textHint, lineHeight:1.7 }}>한 줄에 하나씩 <strong style={{ color:C.textSub }}>이름 수량 단위</strong>. 직원이 카톡으로 보낸 그대로 붙여도 됩니다. 단위는 없어도 되고, 처음 보는 이름은 새 품목으로 등록됩니다.</p>
        <textarea value={pasteText} onChange={(e) => setPasteText(e.target.value)} placeholder={"삼겹살 5kg\n순대 29팩\n콜라 1박스\n소스용기 9줄"} rows={6}
          style={{ width:"100%", boxSizing:"border-box", fontSize:13, lineHeight:1.6, padding:"10px 12px", border:"1px solid #1e3448", borderRadius:10, background:"#0D1B2A", color:"#f1f5f9", fontFamily:"inherit", outline:"none", resize:"vertical" }} />
        <div style={{ display:"flex", gap:8, marginTop:8 }}>
          <button onClick={buildPreview} disabled={!pasteText.trim()} style={{ padding:"10px 16px", background:"#2dd4bf", color:"#0D1B2A", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit", opacity: pasteText.trim() ? 1 : 0.5 }}>미리보기</button>
          {preview && <button onClick={() => setPreview(null)} style={{ ...ADD_BTN }}>취소</button>}
        </div>

        {preview && (
          <div style={{ marginTop:12, padding:"12px 14px", background:"#112236", borderRadius:10, border:"1px solid rgba(45,212,191,0.4)" }}>
            <div style={{ display:"flex", gap:14, flexWrap:"wrap", marginBottom:8, fontSize:12 }}>
              <span style={{ color:C.text }}>읽음 <strong>{preview.rows.length}줄</strong></span>
              <span style={{ color:"#2dd4bf" }}>새 품목 <strong>{preview.rows.filter((r) => r.isNew).length}개</strong></span>
              {preview.bad.length > 0 && <span style={{ color:C.loss }}>못 읽음 <strong>{preview.bad.length}줄</strong></span>}
              {preview.missing.length > 0 && <span style={{ color:C.other }}>목록에 없는 기존 품목 <strong>{preview.missing.length}개</strong></span>}
            </div>
            {preview.bad.length > 0 && (
              <p style={{ margin:"0 0 8px", fontSize:11, color:C.loss, lineHeight:1.6 }}>못 읽은 줄: {preview.bad.slice(0, 5).join(" / ")}{preview.bad.length > 5 ? " …" : ""} — "이름 수량" 순서인지 확인하세요.</p>
            )}
            {preview.missing.length > 0 && (
              <label style={{ display:"flex", alignItems:"center", gap:7, marginBottom:8, cursor:"pointer" }}>
                <input type="checkbox" checked={preview.zeroMissing} onChange={(e) => setPreview((p) => ({ ...p, zeroMissing: e.target.checked }))} style={{ width:14, height:14, accentColor:"#2dd4bf", cursor:"pointer" }} />
                <span style={{ fontSize:11, color:C.textSub }}>붙여넣기에 없는 품목({preview.missing.slice(0, 3).map((x) => x.name).join(", ")}{preview.missing.length > 3 ? " 등" : ""})은 수량 0으로</span>
              </label>
            )}
            <div className="dg-t" style={{ maxHeight:260, overflowY:"auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse" }}>
                <thead><tr style={{ borderBottom:"1px solid #1e3448" }}>
                  <th style={TH_S}>품목</th><th style={{ ...TH_S, textAlign:"right" }}>수량</th><th style={TH_S}>단위</th><th style={TH_S}>분류</th><th style={TH_S}></th>
                </tr></thead>
                <tbody>
                  {preview.rows.map((r, i) => (
                    <tr key={i} style={{ borderBottom:"0.5px solid #1e3448" }}>
                      <td style={{ ...TD_S, color:C.text }}>{r.name}</td>
                      <td style={{ ...TD_S, textAlign:"right" }}>{r.qty}</td>
                      <td style={{ ...TD_S, color:C.textHint }}>{r.unit || "–"}</td>
                      <td style={TD_S}>
                        <select value={r.cat} onChange={(e) => setPreview((p) => ({ ...p, rows: p.rows.map((x, j) => j === i ? { ...x, cat: e.target.value } : x) }))} style={SEL}>
                          {INV_CATS.map((c) => <option key={c.id} value={c.id} style={{ background:"#112236" }}>{c.name}</option>)}
                        </select>
                      </td>
                      <td style={{ ...TD_S, fontSize:10, color: r.isNew ? "#2dd4bf" : C.textHint }}>{r.isNew ? "새 품목" : ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button onClick={applyPreview} style={{ marginTop:10, width:"100%", padding:"11px", background:"#2dd4bf", color:"#0D1B2A", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
              {MONTHS[month]} 실사로 확정
            </button>
          </div>
        )}
      </div>
      )}

      {/* ── 통찰 ── */}
      {!skipped && invSum.countedItems > 0 && (
        <div style={{ marginBottom:16, padding:"16px 18px", background:"#1a2e42", borderRadius:14 }}>
          <p style={{ margin:"0 0 10px", fontSize:13, fontWeight:700 }}>재고가 말해주는 것</p>
          <div className="dg-g2" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
            <div style={{ background:"#112236", borderRadius:10, padding:"12px 14px", borderLeft:"3px solid #2dd4bf" }}>
              <p style={{ margin:0, fontSize:11, color:C.textSub, fontWeight:600 }}>창고에 묶인 돈</p>
              <p className="dg-num" style={{ margin:"4px 0 2px", fontSize:18, fontWeight:700, color:"#2dd4bf" }}>{fmtW(invSum.total)}</p>
              <p style={{ margin:0, fontSize:10, color:C.textHint }}>식자재·음료·포장재 전부 · 팔리기 전엔 현금이 아닙니다</p>
            </div>
            <div style={{ background:"#112236", borderRadius:10, padding:"12px 14px", borderLeft:`3px solid ${turnoverDays === null ? C.border : turnoverDays > 14 ? C.loss : turnoverDays > 10 ? C.other : C.profit}` }}>
              <p style={{ margin:0, fontSize:11, color:C.textSub, fontWeight:600 }}>재고 회전일수</p>
              <p className="dg-num" style={{ margin:"4px 0 2px", fontSize:18, fontWeight:700, color: turnoverDays === null ? C.textHint : turnoverDays > 14 ? C.loss : turnoverDays > 10 ? C.other : C.profit }}>
                {turnoverDays === null ? "–" : `${turnoverDays.toFixed(1)}일치`}
              </p>
              <p style={{ margin:0, fontSize:10, color:C.textHint }}>{turnoverDays === null ? "이번 달 식자재비가 잡히면 계산됩니다" : "지금 재고로 며칠 장사할 수 있나 · 냉동 위주면 길어도 괜찮습니다"}</p>
            </div>
          </div>
          {turnoverDays !== null && turnoverDays > 14 && (
            <p style={{ margin:"10px 0 0", fontSize:11, color:C.loss, lineHeight:1.7 }}>2주치가 넘습니다. 신선 식자재가 섞여 있다면 폐기가 나고 있을 가능성이 큽니다. 발주 주기를 짧게 가져가세요.</p>
          )}
          {spikes.length > 0 && (
            <div style={{ marginTop:12, paddingTop:10, borderTop:`1px solid ${C.border}` }}>
              <p style={{ margin:"0 0 6px", fontSize:11, fontWeight:700, color:C.textSub }}>지난달과 크게 달라진 품목</p>
              {spikes.map(({ it, q, pq }) => (
                <p key={it.id} style={{ margin:"3px 0 0", fontSize:11, color:C.textSub }}>
                  <strong style={{ color:C.text }}>{it.name}</strong> {pq}{it.unit} → <strong style={{ color: q > pq ? C.other : C.loss }}>{q}{it.unit}</strong>
                  <span style={{ color:C.textHint, marginLeft:6 }}>{q > pq ? "갑자기 늘었습니다 — 과다 발주?" : "다 떨어졌습니다 — 누락 아닌지?"}</span>
                </p>
              ))}
            </div>
          )}
          {priceUps.length > 0 && (
            <div style={{ marginTop:12, paddingTop:10, borderTop:`1px solid ${C.border}` }}>
              <p style={{ margin:"0 0 6px", fontSize:11, fontWeight:700, color:C.loss }}>지난달보다 단가가 오른 품목</p>
              {priceUps.map(({ it, cur, prev, pct }) => (
                <p key={it.id} style={{ margin:"3px 0 0", fontSize:11, color:C.textSub }}>
                  <strong style={{ color:C.text }}>{it.name}</strong> {prev.toLocaleString("ko-KR")} → <strong style={{ color:C.loss }}>{cur.toLocaleString("ko-KR")}원</strong>
                  <span style={{ marginLeft:6, fontWeight:700, color:C.loss }}>+{pct.toFixed(1)}%</span>
                </p>
              ))}
              <p style={{ margin:"6px 0 0", fontSize:10, color:C.textHint, lineHeight:1.6 }}>매입 단가가 오르면 식자재비율이 따라 오릅니다. 메뉴 가격이나 거래처를 검토할 시점입니다.</p>
            </div>
          )}
          {unpricedTop.length > 0 && (
            <div style={{ marginTop:12, paddingTop:10, borderTop:`1px solid ${C.border}` }}>
              <p style={{ margin:"0 0 6px", fontSize:11, fontWeight:700, color:C.other }}>단가 넣으면 정확도가 확 오르는 품목</p>
              <p style={{ margin:0, fontSize:11, color:C.textSub, lineHeight:1.7 }}>
                {unpricedTop.map((r) => `${r.it.name} ${r.q}${r.it.unit}`).join(" · ")}
                <span style={{ color:C.textHint }}> — 수량이 많은 순. 아래 표에서 단가 칸을 채우세요.</span>
              </p>
            </div>
          )}
        </div>
      )}

      {/* ── 품목 표 ── */}
      <div style={{ marginBottom:16 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:8, marginBottom:8, flexWrap:"wrap" }}>
          <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
            {[["all","전체"], ...INV_CATS.map((c) => [c.id, c.name])].map(([v, l]) => (
              <button key={v} onClick={() => setCatFilter(v)} style={{ fontSize:11, padding:"5px 10px", borderRadius:7, border:`1px solid ${catFilter === v ? "#2dd4bf" : C.border}`, background: catFilter === v ? "rgba(45,212,191,0.15)" : "transparent", color: catFilter === v ? "#2dd4bf" : C.textSub, cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>
                {l}{v !== "all" && <span style={{ marginLeft:4, opacity:0.7 }}>{items.filter((x) => x.cat === v).length}</span>}
              </button>
            ))}
          </div>
          <span style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
            <span style={{ display:"flex", gap:5 }}>
              {[["order","세는 순서"],["amount","금액 큰 순"]].map(([v, l]) => (
                <button key={v} onClick={() => setInvSort(v)} style={{ fontSize:10, padding:"4px 9px", borderRadius:6, border:`1px solid ${invSort === v ? "#2dd4bf" : C.border}`, background: invSort === v ? "rgba(45,212,191,0.15)" : "transparent", color: invSort === v ? "#2dd4bf" : C.textSub, cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>{l}</button>
              ))}
            </span>
            {items.length > 0 && (
              <span style={{ display:"flex", gap:6 }}>
                <button onClick={clearMonth} style={{ ...ADD_BTN, fontSize:10, padding:"4px 9px" }}>이번 달 수량 지우기</button>
                <button onClick={clearAllItems} style={{ ...ADD_BTN, fontSize:10, padding:"4px 9px", color:C.loss, borderColor:"rgba(248,113,113,0.4)" }}>품목 전체 삭제</button>
              </span>
            )}
          </span>
        </div>

        {items.length === 0 ? (
          <div style={{ padding:"28px 20px", textAlign:"center", background:"#112236", borderRadius:14, border:"1px dashed #243d54" }}>
            <p style={{ margin:0, fontSize:13, color:C.textSub }}>아직 품목이 없습니다</p>
            <p style={{ margin:"6px 0 0", fontSize:11, color:C.textHint, lineHeight:1.7 }}>위에 재고 목록을 붙여넣으면 품목이 자동으로 만들어집니다.<br />세는 순서 그대로 적으면 다음 달부터 그 순서로 보입니다.</p>
          </div>
        ) : (
          <div className="dg-t">
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr style={{ borderBottom:`2px solid ${C.border}` }}>
                  <th style={TH_S}>품목</th>
                  <th style={{ ...TH_S, textAlign:"right" }}>수량</th>
                  <th style={{ ...TH_S, textAlign:"right" }}>단가</th>
                  <th style={{ ...TH_S, textAlign:"right" }}>금액</th>
                  <th style={{ ...TH_S, width:28 }} />
                </tr>
              </thead>
              <tbody>
                {rows.map(({ it, q, pq, amt, pamt, price, pprice, hasVal, direct }) => {
                  const isEdit = editing === it.id;
                  return (
                    <tr key={it.id} {...(isEdit ? { "data-item-edit": "1" } : {})} style={{ borderBottom:"1px solid #1e3448", opacity: q === 0 && !isEdit ? 0.55 : 1 }}>
                      <td style={{ ...TD_S, minWidth:150 }}>
                        {isEdit ? (
                          <div style={{ display:"flex", flexDirection:"column", gap:4 }}>
                            <input autoFocus value={it.name} onChange={(e) => updItem(it.id, "name", e.target.value)} onKeyDown={(e) => e.key === "Enter" && setEditing(null)} style={{ ...INP, display:"block" }} />
                            <div style={{ display:"flex", gap:5, alignItems:"center" }}>
                              <select value={it.cat} onChange={(e) => updItem(it.id, "cat", e.target.value)} style={SEL}>
                                {INV_CATS.map((c) => <option key={c.id} value={c.id} style={{ background:"#112236" }}>{c.name}</option>)}
                              </select>
                              <input value={it.unit || ""} onChange={(e) => updItem(it.id, "unit", e.target.value)} placeholder="단위" style={{ ...INP, width:56, fontSize:11 }} />
                              <button onClick={() => setEditing(null)} style={DONE_BTN}>✓</button>
                            </div>
                          </div>
                        ) : (
                          <span onClick={() => setEditing(it.id)} style={{ cursor:"pointer" }}>
                            <span style={{ display:"inline-block", width:6, height:6, borderRadius:"50%", background:catColor(it.cat), marginRight:6, verticalAlign:"middle" }} />
                            <span style={{ color:C.text, fontWeight:500 }}>{it.name}</span>
                            {it.unit && <span style={{ marginLeft:5, fontSize:10, color:C.textHint }}>{it.unit}</span>}
                          </span>
                        )}
                      </td>
                      <td style={{ ...TD_S, textAlign:"right", width:72 }}>
                        <input type="number" inputMode="decimal" step="any" value={q || ""} placeholder="0" onChange={(e) => setQty(it.id, e.target.value)}
                          style={{ ...INP, textAlign:"right", width:60, fontWeight:700, borderBottomColor: q > 0 ? "#2dd4bf" : "#243d54" }} />
                        {pq > 0 && (
                          <div className="dg-num" style={{ fontSize:10, marginTop:2, whiteSpace:"nowrap" }}>
                            <span style={{ color:C.textHint }}>전월 {pq}</span>
                            {counted(it.id) && q !== pq && (
                              <span style={{ marginLeft:4, fontWeight:700, color: q > pq ? "#60a5fa" : "#fbbf24" }}>
                                {q > pq ? "▲" : "▼"}{Math.abs(Math.round((q - pq) * 10) / 10)}
                              </span>
                            )}
                            {counted(it.id) && q === pq && <span style={{ marginLeft:4, color:"#334155" }}>동일</span>}
                            {!counted(it.id) && <span style={{ marginLeft:4, color:"#334155" }}>미입력</span>}
                          </div>
                        )}
                      </td>
                      <td style={{ ...TD_S, textAlign:"right", width:120 }}>
                        <MoneyInput value={price || 0} onChange={(v) => updItem(it.id, "price", v)} placeholder="단가"
                          style={{ ...INP, textAlign:"right", fontSize:12, borderBottomColor: price > 0 ? "#a78bfa" : "#243d54" }} />
                        {pprice > 0 && price > 0 && pprice !== price && (
                          <div className="dg-num" style={{ fontSize:10, marginTop:2, whiteSpace:"nowrap" }}>
                            <span style={{ color:C.textHint }}>전월 {pprice.toLocaleString("ko-KR")}</span>
                            <span style={{ marginLeft:4, fontWeight:700, color: price > pprice ? C.loss : C.profit }}>
                              {price > pprice ? "▲" : "▼"}{Math.abs(price - pprice).toLocaleString("ko-KR")} ({Math.abs((price - pprice) / pprice * 100).toFixed(0)}%)
                            </span>
                          </div>
                        )}
                        {pprice > 0 && price > 0 && pprice === price && (
                          <div style={{ fontSize:10, color:"#334155", marginTop:2 }}>전월 동일</div>
                        )}
                      </td>
                      <td style={{ ...TD_S, textAlign:"right", width:120 }}>
                        {direct !== "" ? (
                          <span style={{ display:"flex", alignItems:"baseline", justifyContent:"flex-end", gap:4 }}>
                            <MoneyInput value={Number(direct) || 0} onChange={(v) => setAmt(it.id, v)} style={{ ...INP, textAlign:"right", fontSize:12, borderBottomColor:"#fbbf24", width:96 }} />
                            <button title="직접 금액 지우기" onClick={() => setAmt(it.id, "")} style={{ ...DEL_BTN, fontSize:10 }}>✕</button>
                          </span>
                        ) : hasVal ? (
                          <span style={{ display:"inline-block", textAlign:"right" }}>
                            <span className="dg-num" style={{ fontSize:13, fontWeight:700, color:"#2dd4bf" }}>{amt.toLocaleString("ko-KR")}원</span>
                            {pamt > 0 && amt !== pamt && (
                              <div className="dg-num" style={{ fontSize:10, color:C.textHint, marginTop:2 }}>
                                전월 {pamt.toLocaleString("ko-KR")} <span style={{ fontWeight:700, color: amt > pamt ? "#60a5fa" : "#fbbf24" }}>{amt > pamt ? "▲" : "▼"}{Math.abs(amt - pamt).toLocaleString("ko-KR")}</span>
                              </div>
                            )}
                          </span>
                        ) : q > 0 ? (
                          <button onClick={() => setAmt(it.id, 10000)} style={{ ...ADD_BTN, fontSize:10, padding:"3px 8px", color:C.other, borderColor:"rgba(251,191,36,0.4)" }}>금액 직접</button>
                        ) : (
                          <span style={{ fontSize:11, color:"#334155" }}>–</span>
                        )}
                      </td>
                      <td style={{ ...TD_S, textAlign:"center" }}><button onClick={() => delItem(it.id)} style={DEL_BTN}>✕</button></td>
                    </tr>
                  );
                })}
                <tr style={{ background:"#1a2e42" }}>
                  <td style={TD_S}>
                    <div style={{ display:"flex", gap:5, alignItems:"center", flexWrap:"wrap" }}>
                      <input value={newItem.name} onChange={(e) => setNewItem((p) => ({ ...p, name: e.target.value }))} onKeyDown={(e) => e.key === "Enter" && addItem()} placeholder="품목 직접 추가" style={{ ...INP, width:130 }} />
                      <input value={newItem.unit} onChange={(e) => setNewItem((p) => ({ ...p, unit: e.target.value }))} placeholder="단위" style={{ ...INP, width:50, fontSize:11 }} />
                      <select value={newItem.cat} onChange={(e) => setNewItem((p) => ({ ...p, cat: e.target.value }))} style={SEL}>
                        {INV_CATS.map((c) => <option key={c.id} value={c.id} style={{ background:"#112236" }}>{c.name}</option>)}
                      </select>
                    </div>
                  </td>
                  <td colSpan={4} style={{ ...TD_S, textAlign:"right" }}><button onClick={addItem} style={ADD_BTN}>+ 추가</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        {items.length > 0 && (
          <div style={{ display:"flex", justifyContent:"space-between", gap:10, marginTop:10, padding:"10px 14px", background:"#1a2e42", borderRadius:8, flexWrap:"wrap" }}>
            <span style={{ fontSize:11, color:C.textHint }}>
              {INV_CATS.map((c) => `${c.name} ${fmtMan(invSum[c.id])}`).join(" · ")}
            </span>
            <span style={{ fontSize:13, fontWeight:700 }}>재고 합계 <span className="dg-num" style={{ color:"#2dd4bf" }}>{fmtW(invSum.total)}</span></span>
          </div>
        )}
      </div>

      {/* ── 단가 일괄 등록 ── */}
      {items.length > 0 && (
        <div style={{ marginBottom:16, border:"1px solid #1e3448", borderRadius:12, overflow:"hidden" }}>
          <button onClick={() => setPriceOpen((o) => !o)} style={{ width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center", padding:"11px 14px", background: priceOpen ? "#1a2e42" : "transparent", border:"none", cursor:"pointer", fontFamily:"inherit" }}>
            <span style={{ fontSize:12, fontWeight:700, color:C.text }}>단가 한꺼번에 넣기 <span style={{ fontWeight:400, color:C.textHint, marginLeft:6 }}>거래처 단가표·영수증을 "이름 단가"로 붙여넣기</span></span>
            <span style={{ fontSize:11, color:C.textHint }}>{priceOpen ? "▲" : "▼"}</span>
          </button>
          {priceOpen && (
            <div style={{ padding:"12px 14px", background:"#0D1B2A", borderTop:"1px solid #1e3448" }}>
              <textarea value={priceText} onChange={(e) => setPriceText(e.target.value)} placeholder={"삼겹살 14500\n순대 3200\n쌀 58000"} rows={4}
                style={{ width:"100%", boxSizing:"border-box", fontSize:13, lineHeight:1.6, padding:"10px 12px", border:"1px solid #1e3448", borderRadius:10, background:"#112236", color:"#f1f5f9", fontFamily:"inherit", outline:"none", resize:"vertical" }} />
              <div style={{ display:"flex", gap:8, alignItems:"center", marginTop:8, flexWrap:"wrap" }}>
                <button onClick={applyPrices} disabled={!priceText.trim()} style={{ padding:"9px 14px", background:"#a78bfa", color:"#0D1B2A", border:"none", borderRadius:9, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit", opacity: priceText.trim() ? 1 : 0.5 }}>단가 적용</button>
                {priceMsg && <span style={{ fontSize:11, color:C.textSub }}>{priceMsg}</span>}
              </div>
              <p style={{ margin:"8px 0 0", fontSize:10, color:C.textHint, lineHeight:1.7 }}>단가는 <strong style={{ color:C.textSub }}>세는 단위 기준</strong>입니다(팩당·줄당·kg당). 이름이 목록과 정확히 같아야 들어갑니다. 단가를 바꾸면 이번 달부터 새 단가로 계산됩니다.</p>
            </div>
          )}
        </div>
      )}

      <p style={{ margin:0, fontSize:10, color:C.textHint, lineHeight:1.7 }}>
        식자재·음료 재고 합계가 비용 탭 ② 매출원가의 기말재고로 자동 들어가고, 다음 달 기초재고가 됩니다. 포장·소모품은 별도로만 보여줍니다.
      </p>
    </div>
  );
}
const invDoneLocal = (inv, sum) => !!inv && (inv.skipped || (sum && sum.countedItems > 0));


// ══ 일일 보고 붙여넣기 (매출 탭) ══════════════════════════════════
function DailyReportSection({ mk, year, month, MONTHS, days, daily, setDailyReports, onHallSync, onCashSync, C }) {
  const [text, setText] = useState("");
  const [preview, setPreview] = useState(null);   // { reports:[{...,mk}], bad:[] }
  const [listOpen, setListOpen] = useState(false);
  const dmap = (daily && daily.days) || {};
  const useHall = !daily || daily.useHall !== false;
  const dayNums = Object.keys(dmap).map(Number).sort((a, b) => a - b);
  const n = dayNums.length;
  const sumHall = drSum(dmap, "hall"), sumDeliv = drSum(dmap, "delivRev"), sumTotal = drSum(dmap, "total");
  const sumTables = drSum(dmap, "tables"), sumCnt = drSum(dmap, "delivCnt"), sumCash = drSum(dmap, "cashExp");
  const dailyAvg = n > 0 ? sumTotal / n : 0;
  const forecast = dailyAvg * days;
  const WD = ["일","월","화","수","목","금","토"];
  const byWd = [0,1,2,3,4,5,6].map((w) => {
    const vals = dayNums.filter((d) => new Date(year, month, d).getDay() === w).map((d) => dmap[d].total || 0);
    return vals.length ? vals.reduce((a, b) => a + b, 0) / vals.length : 0;
  });
  const wdMax = Math.max(...byWd, 1);
  const platTot = ["baemin","coupang","yogiyo","ddangyo"].map((pid) => [pid, drPlatSum(dmap, pid)]).filter(([, v]) => v > 0);
  const platAll = platTot.reduce((a, [, v]) => a + v, 0);
  const PLAT_NAME = { baemin:"배민", coupang:"쿠팡이츠", yogiyo:"요기요", ddangyo:"땡겨요" };

  const buildPreview = () => {
    const { reports, bad } = parseDailyReports(text);
    const mapped = reports.map((r) => ({ ...r, mk: `${year}-${String(r.month).padStart(2, "0")}` }));
    setPreview({ reports: mapped, bad });
  };
  const applyPreview = () => {
    if (!preview) return;
    const touched = {};
    setDailyReports((prev) => {
      const next = { ...prev };
      preview.reports.forEach((r) => {
        const cur = next[r.mk] || { useHall: true, days: {} };
        const { mk: _m, month: _mo, ...rest } = r;
        next[r.mk] = { ...cur, days: { ...(cur.days || {}), [r.day]: rest } };
        touched[r.mk] = next[r.mk];
      });
      // 확정 직후 홀 매출·현금지출을 그 달에 반영한다 (저장값에 쓰므로 대시보드·차트도 같은 숫자를 본다)
      Object.entries(touched).forEach(([k, v]) => {
        if (v.useHall !== false) onHallSync(k, drSum(v.days, "hall"));
        onCashSync(k, drSum(v.days, "cashExp"));
      });
      return next;
    });
    setPreview(null); setText("");
  };
  const toggleHall = () => {
    const nextUse = !useHall;
    setDailyReports((prev) => ({ ...prev, [mk]: { ...(prev[mk] || { days: {} }), useHall: nextUse } }));
    if (nextUse) onHallSync(mk, sumHall);
  };
  const clearMonth = () => {
    if (!window.confirm(`${MONTHS[month]} 일일 보고 ${n}일치를 지웁니다. 홀 매출 자동 반영도 풀립니다. 계속할까요?`)) return;
    setDailyReports((prev) => { const nx = { ...prev }; delete nx[mk]; return nx; });
  };

  return (
    <div style={{ marginBottom:14 }}>
      {/* 붙여넣기 */}
      <div style={{ padding:"16px 18px", background:"#1a2e42", borderRadius:14, marginBottom:12 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:10, marginBottom:6, flexWrap:"wrap" }}>
          <p style={{ margin:0, fontSize:13, fontWeight:700 }}>일일 매출 보고 붙여넣기</p>
          {n > 0 && <button onClick={clearMonth} style={{ ...ADD_BTN, fontSize:10, padding:"4px 9px" }}>{MONTHS[month]} 보고 지우기</button>}
        </div>
        <p style={{ margin:"0 0 10px", fontSize:11, color:C.textHint, lineHeight:1.7 }}>
          매니저가 카톡으로 보낸 보고를 그대로 붙여넣으십시오. 하루치든 한 달치든 한 번에 됩니다. 같은 날짜는 덮어씁니다.
          현금으로 산 게 있으면 보고에 <strong style={{ color:C.textSub }}>현금지출: 23,000 (얼음, 양파)</strong> 한 줄을 넣으면 비용 탭에 자동으로 잡힙니다.
        </p>
        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={5}
          placeholder={"9월 1일 매장명\n일매출: 3,000,000\n매장매출: 1,000,000\n테이블수: 50\n배달매출: 2,000,000\n배달건수: 80\n배민: 50건\n쿠팡: 30건\n현금지출: 20,000 (얼음)"}
          style={{ width:"100%", boxSizing:"border-box", fontSize:13, lineHeight:1.6, padding:"10px 12px", border:"1px solid #1e3448", borderRadius:10, background:"#0D1B2A", color:"#f1f5f9", fontFamily:"inherit", outline:"none", resize:"vertical" }} />
        <div style={{ display:"flex", gap:8, marginTop:8 }}>
          <button onClick={buildPreview} disabled={!text.trim()} style={{ padding:"10px 16px", background:C.store, color:"#fff", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit", opacity: text.trim() ? 1 : 0.5 }}>미리보기</button>
          {preview && <button onClick={() => setPreview(null)} style={ADD_BTN}>취소</button>}
        </div>

        {preview && (
          <div style={{ marginTop:12, padding:"12px 14px", background:"#112236", borderRadius:10, border:`1px solid ${C.store}66` }}>
            <div style={{ display:"flex", gap:14, flexWrap:"wrap", marginBottom:8, fontSize:12 }}>
              <span style={{ color:C.text }}>읽음 <strong>{preview.reports.length}일</strong></span>
              {preview.bad.length > 0 && <span style={{ color:C.loss }}>못 읽음 <strong>{preview.bad.length}건</strong></span>}
              {[...new Set(preview.reports.map((r) => r.mk))].filter((k) => k !== mk).length > 0 && (
                <span style={{ color:C.other }}>다른 달 포함 ({[...new Set(preview.reports.map((r) => r.mk))].filter((k) => k !== mk).join(", ")})</span>
              )}
            </div>
            {preview.bad.length > 0 && <p style={{ margin:"0 0 8px", fontSize:11, color:C.loss }}>못 읽은 부분: {preview.bad.slice(0, 3).join(" / ")}</p>}
            <div className="dg-t" style={{ maxHeight:220, overflowY:"auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse" }}>
                <thead><tr style={{ borderBottom:"1px solid #1e3448" }}>
                  <th style={TH_S}>날짜</th><th style={{ ...TH_S, textAlign:"right" }}>총매출</th><th style={{ ...TH_S, textAlign:"right" }}>홀</th><th style={{ ...TH_S, textAlign:"right" }}>배달</th><th style={{ ...TH_S, textAlign:"right" }}>건수</th><th style={{ ...TH_S, textAlign:"right" }}>현금지출</th>
                </tr></thead>
                <tbody>
                  {preview.reports.map((r, i) => (
                    <tr key={i} style={{ borderBottom:"0.5px solid #1e3448" }}>
                      <td style={{ ...TD_S, color:C.text }}>{r.month}/{r.day}</td>
                      <td style={{ ...TD_S, textAlign:"right" }}>{r.total.toLocaleString("ko-KR")}</td>
                      <td style={{ ...TD_S, textAlign:"right" }}>{r.hall.toLocaleString("ko-KR")}</td>
                      <td style={{ ...TD_S, textAlign:"right" }}>{r.delivRev.toLocaleString("ko-KR")}</td>
                      <td style={{ ...TD_S, textAlign:"right" }}>{r.delivCnt}</td>
                      <td style={{ ...TD_S, textAlign:"right", color: r.cashExp > 0 ? C.other : C.textHint }}>{r.cashExp > 0 ? r.cashExp.toLocaleString("ko-KR") : "–"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button onClick={applyPreview} style={{ marginTop:10, width:"100%", padding:"11px", background:C.store, color:"#fff", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>확정 · 홀 매출과 현금지출에 반영</button>
          </div>
        )}
      </div>

      {/* 이달 현황 + 통찰 */}
      {n > 0 && (
        <div style={{ padding:"16px 18px", background:"#112236", borderRadius:14, border:`1px solid ${C.store}45` }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10, flexWrap:"wrap", marginBottom:12 }}>
            <div>
              <p style={{ margin:0, fontSize:11, color:C.textHint }}>{MONTHS[month]} 일일 보고 · {n}일 입력 · {dayNums[dayNums.length-1]}일까지</p>
              <p className="dg-num" style={{ margin:"3px 0 0", fontSize:22, fontWeight:700, color:C.text }}>{fmtW(sumTotal)}</p>
              <p style={{ margin:"2px 0 0", fontSize:11, color:C.textSub }}>홀 {fmtMan(sumHall)} · 배달 {fmtMan(sumDeliv)} (포스 기준, 참고) · 배달 {sumCnt}건{sumCash>0 ? ` · 현금지출 ${fmtMan(sumCash)}` : ""}</p>
            </div>
            <label style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer", padding:"8px 12px", background:"#0D1B2A", borderRadius:9, border:"1px solid #1e3448" }}>
              <input type="checkbox" checked={useHall} onChange={toggleHall} style={{ width:15, height:15, accentColor:C.store, cursor:"pointer" }} />
              <span style={{ fontSize:12, color: useHall ? "#2dd4bf" : C.textSub, fontWeight:600 }}>홀 매출은 보고 합계로</span>
            </label>
          </div>

          <div className="dg-g3" style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8, marginBottom:12 }}>
            <div style={{ background:"#0D1B2A", borderRadius:8, padding:"9px 11px" }}>
              <p style={{ margin:0, fontSize:10, color:C.textHint }}>이대로면 월말</p>
              <p className="dg-num" style={{ margin:"3px 0 0", fontSize:14, fontWeight:700, color:C.store }}>{fmtMan(forecast)}원</p>
              <p style={{ margin:"2px 0 0", fontSize:9, color: n < 5 ? C.other : C.textHint }}>{n}일 평균 {fmtMan(dailyAvg)} × {days}일{n < 5 ? " · 일수가 적어 참고만" : ""}</p>
            </div>
            <div style={{ background:"#0D1B2A", borderRadius:8, padding:"9px 11px" }}>
              <p style={{ margin:0, fontSize:10, color:C.textHint }}>테이블 단가</p>
              <p className="dg-num" style={{ margin:"3px 0 0", fontSize:14, fontWeight:700, color:C.text }}>{sumTables>0 ? Math.round(sumHall/sumTables).toLocaleString("ko-KR")+"원" : "–"}</p>
              <p style={{ margin:"2px 0 0", fontSize:9, color:C.textHint }}>홀 ÷ 테이블 {sumTables}</p>
            </div>
            <div style={{ background:"#0D1B2A", borderRadius:8, padding:"9px 11px" }}>
              <p style={{ margin:0, fontSize:10, color:C.textHint }}>배달 단가</p>
              <p className="dg-num" style={{ margin:"3px 0 0", fontSize:14, fontWeight:700, color:C.delivery }}>{sumCnt>0 ? Math.round(sumDeliv/sumCnt).toLocaleString("ko-KR")+"원" : "–"}</p>
              <p style={{ margin:"2px 0 0", fontSize:9, color:C.textHint }}>배달 ÷ {sumCnt}건</p>
            </div>
          </div>

          {/* 요일별 평균 */}
          <div style={{ marginBottom:10 }}>
            <p style={{ margin:"0 0 6px", fontSize:11, fontWeight:700, color:C.textSub }}>요일별 평균 매출</p>
            <div style={{ display:"flex", alignItems:"flex-end", gap:6, height:52 }}>
              {byWd.map((v, w) => (
                <div key={w} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"flex-end", height:"100%" }}>
                  <span style={{ fontSize:9, color:C.textHint, marginBottom:2 }}>{v>0 ? fmtMan(v) : ""}</span>
                  <div style={{ width:"70%", height:`${v>0 ? Math.max(6,(v/wdMax)*100) : 0}%`, background: w===0||w===6 ? C.delivery : C.store, borderRadius:"3px 3px 0 0", opacity:0.9 }} />
                </div>
              ))}
            </div>
            <div style={{ display:"flex", gap:6, marginTop:3 }}>
              {WD.map((d, w) => <span key={w} style={{ flex:1, textAlign:"center", fontSize:10, color: w===0||w===6 ? C.delivery : C.textHint }}>{d}</span>)}
            </div>
          </div>

          {platAll > 0 && (
            <p style={{ margin:"0 0 6px", fontSize:11, color:C.textSub }}>
              배달 건수 비중 · {platTot.map(([pid, v]) => `${PLAT_NAME[pid]} ${Math.round(v/platAll*100)}%`).join(" · ")}
              <span style={{ color:C.textHint, marginLeft:6 }}>배달 탭 주문건수 칸에서 「적용」하면 들어갑니다</span>
            </p>
          )}

          <button onClick={() => setListOpen((o) => !o)} style={{ ...ADD_BTN, fontSize:11, marginTop:4 }}>{listOpen ? "일별 내역 접기 ▴" : `일별 내역 ${n}일 펼치기 ▾`}</button>
          {listOpen && (
            <div className="dg-t" style={{ marginTop:8 }}>
              <table style={{ width:"100%", borderCollapse:"collapse" }}>
                <thead><tr style={{ borderBottom:"1px solid #1e3448" }}>
                  <th style={TH_S}>날짜</th><th style={{ ...TH_S, textAlign:"right" }}>총매출</th><th style={{ ...TH_S, textAlign:"right" }}>홀</th><th style={{ ...TH_S, textAlign:"right" }}>배달</th><th style={{ ...TH_S, textAlign:"right" }}>건수</th><th style={{ ...TH_S, textAlign:"right" }}>현금지출</th>
                </tr></thead>
                <tbody>
                  {dayNums.map((d) => { const r = dmap[d]; const w = new Date(year, month, d).getDay(); return (
                    <tr key={d} style={{ borderBottom:"0.5px solid #1e3448" }}>
                      <td style={{ ...TD_S, color: w===0||w===6 ? C.delivery : C.text }}>{d}일 ({WD[w]})</td>
                      <td style={{ ...TD_S, textAlign:"right" }}>{(r.total||0).toLocaleString("ko-KR")}</td>
                      <td style={{ ...TD_S, textAlign:"right" }}>{(r.hall||0).toLocaleString("ko-KR")}</td>
                      <td style={{ ...TD_S, textAlign:"right" }}>{(r.delivRev||0).toLocaleString("ko-KR")}</td>
                      <td style={{ ...TD_S, textAlign:"right" }}>{r.delivCnt||0}</td>
                      <td style={{ ...TD_S, textAlign:"right", color: r.cashExp>0 ? C.other : C.textHint }}>{r.cashExp>0 ? `${r.cashExp.toLocaleString("ko-KR")}${r.cashMemo ? ` (${r.cashMemo})` : ""}` : "–"}</td>
                    </tr>
                  ); })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ══ 홈 화면 설치 배너 ═══════════════════════════════════════════
// 안드로이드 크롬: beforeinstallprompt를 받아 버튼 한 번으로 설치. 아이폰: 사파리 안내만.
// 이미 앱으로 열렸거나(standalone) 사용자가 닫았으면 안 보인다.
const isStandalone = () => (typeof window !== "undefined") && (window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true);
// 크롬은 설치 신호를 페이지 로드 직후 한 번만 보낸다. React가 그려지기 전에 놓치지 않도록 모듈 로드 시점부터 잡아둔다
let dgInstallEvt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); dgInstallEvt = e; });
}
// 서비스워커가 새 빌드를 받으면 알려준다. 앱을 지웠다 깔 필요 없이 새로고침만 하면 된다
function UpdateBanner() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    let reg;
    const onFound = () => {
      const w = reg && reg.installing;
      if (!w) return;
      w.addEventListener("statechange", () => {
        // 이미 제어 중인 워커가 있는데 새 워커가 설치됐다 = 새 버전이 받아졌다
        if (w.state === "installed" && navigator.serviceWorker.controller) setReady(true);
      });
    };
    navigator.serviceWorker.getRegistration().then((r) => {
      if (!r) return;
      reg = r;
      r.addEventListener("updatefound", onFound);
      r.update().catch(() => {});
    }).catch(() => {});
    const t = setInterval(() => { if (reg) reg.update().catch(() => {}); }, 60 * 60 * 1000);
    return () => clearInterval(t);
  }, []);
  if (!ready) return null;
  return (
    <div style={{ margin:"12px 0 14px", padding:"11px 14px", background:"rgba(251,191,36,0.12)", border:"1px solid rgba(251,191,36,0.4)", borderRadius:12, display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
      <div style={{ flex:"1 1 180px", minWidth:0 }}>
        <p style={{ margin:0, fontSize:12, fontWeight:700, color:"#f1f5f9" }}>새 버전이 있습니다</p>
        <p style={{ margin:"2px 0 0", fontSize:11, color:"#94a3b8" }}>새로고침하면 바뀐 기능이 바로 보입니다</p>
      </div>
      <button onClick={() => window.location.reload()} style={{ padding:"8px 14px", background:"#fbbf24", color:"#0D1B2A", border:"none", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>새로고침</button>
    </div>
  );
}

// 설치 안내가 안 보이던 경우를 막는다 (v2.8.6)
// · 카톡·네이버·인스타 등 앱 안의 브라우저: 설치 자체가 안 된다 → 크롬/사파리로 여는 버튼 + 주소 복사
// · 아이폰: 사파리뿐 아니라 크롬도 공유 → 홈 화면에 추가 안내
// · 안드로이드: 설치 신호가 안 오면(조건 미충족) 크롬 메뉴 안내로 대신
// · 「나중에」는 7일 동안만 숨긴다
const DG_UA = typeof navigator !== "undefined" ? navigator.userAgent : "";
const dgIsIOS = /iphone|ipad|ipod/i.test(DG_UA);
const dgIsAndroid = /android/i.test(DG_UA);
const dgIsKakao = /KAKAOTALK/i.test(DG_UA);
const dgIsInApp = dgIsKakao || /NAVER\(inapp|Instagram|FBAN|FBAV|Line\/|BAND\/|DaumApps|everytimeApp|; wv\)/i.test(DG_UA);
function dgOpenExternal() {
  const url = window.location.href;
  if (dgIsKakao) { window.location.href = "kakaotalk://web/openExternal?url=" + encodeURIComponent(url); return; }
  if (dgIsAndroid) { window.location.href = `intent://${url.replace(/^https?:\/\//, "")}#Intent;scheme=https;package=com.android.chrome;end`; return; }
}
function InstallBanner() {
  const [evt, setEvt] = useState(() => dgInstallEvt);
  const [hide, setHide] = useState(() => {
    try { const t = Number(localStorage.getItem("dg_install_hide_at") || 0); return t > 0 && Date.now() - t < 7 * 86400000; } catch { return false; }
  });
  const [waited, setWaited] = useState(false);   // 안드로이드: 설치 신호를 잠깐 기다린 뒤에만 메뉴 안내를 보인다
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); dgInstallEvt = e; setEvt(e); };
    const onInstalled = () => { setEvt(null); setHide(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    const t = setTimeout(() => setWaited(true), 3000);
    return () => { clearTimeout(t); window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);
  if (hide || isStandalone()) return null;

  let title = "홈 화면에 앱으로 설치", desc = "", action = null;
  const copyUrl = async () => { try { await navigator.clipboard.writeText(window.location.href); setCopied(true); setTimeout(() => setCopied(false), 2000); } catch {} };
  const btn = { padding:"8px 14px", background:"#2dd4bf", color:"#0D1B2A", border:"none", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" };
  const btn2 = { ...btn, background:"transparent", color:"#2dd4bf", border:"1px solid rgba(45,212,191,0.5)" };

  if (dgIsInApp) {
    title = dgIsKakao ? "카톡 안에서는 앱 설치가 안 됩니다" : "이 화면에서는 앱 설치가 안 됩니다";
    desc = dgIsIOS
      ? (dgIsKakao ? "사파리로 열어서 공유 → 「홈 화면에 추가」를 누르세요" : "오른쪽 위·아래 메뉴에서 「사파리로 열기」 후 공유 → 「홈 화면에 추가」")
      : "크롬으로 열면 설치 버튼이 나옵니다";
    action = (
      <>
        {(dgIsKakao || dgIsAndroid) && <button onClick={dgOpenExternal} style={btn}>{dgIsIOS ? "사파리로 열기" : "크롬으로 열기"}</button>}
        <button onClick={copyUrl} style={btn2}>{copied ? "복사됨" : "주소 복사"}</button>
      </>
    );
  } else if (evt) {
    desc = "아이콘으로 바로 열리고 주소창 없이 앱처럼 씁니다";
    const install = async () => { evt.prompt(); try { await evt.userChoice; } catch {} setEvt(null); };
    action = <button onClick={install} style={btn}>설치</button>;
  } else if (dgIsIOS) {
    desc = /crios/i.test(DG_UA) ? "오른쪽 위 공유 버튼 → 「홈 화면에 추가」를 누르세요" : "사파리 아래 공유 버튼 → 「홈 화면에 추가」를 누르세요";
  } else if (dgIsAndroid && waited) {
    desc = /SamsungBrowser/i.test(DG_UA) ? "아래 메뉴(≡) → 「현재 페이지 추가」 → 「홈 화면」을 누르세요" : "크롬 오른쪽 위 메뉴(⋮) → 「홈 화면에 추가」 또는 「앱 설치」를 누르세요";
  } else {
    return null;   // PC 사파리·파이어폭스 등 설치를 지원하지 않는 브라우저, 또는 안드로이드에서 신호 대기 중
  }
  const dismiss = () => { setHide(true); try { localStorage.setItem("dg_install_hide_at", String(Date.now())); } catch {} };
  return (
    <div style={{ margin:"12px 0 14px", padding:"11px 14px", background:"rgba(45,212,191,0.10)", border:"1px solid rgba(45,212,191,0.35)", borderRadius:12, display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
      <div style={{ flex:"1 1 200px", minWidth:0 }}>
        <p style={{ margin:0, fontSize:12, fontWeight:700, color:"#f1f5f9" }}>{title}</p>
        <p style={{ margin:"2px 0 0", fontSize:11, color:"#94a3b8", lineHeight:1.5 }}>{desc}</p>
      </div>
      <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
        {action}
        <button onClick={dismiss} style={{ padding:"8px 10px", background:"transparent", color:"#94a3b8", border:"1px solid #243d54", borderRadius:8, fontSize:12, cursor:"pointer", fontFamily:"inherit" }}>나중에</button>
      </div>
    </div>
  );
}



// 사업장 정보 — 근로계약서에 쓰인다. 매장에 한 번 넣으면 전 직원이 함께 쓴다
function BizInfoSection({ biz, setBizInfo, C }) {
  const [open, setOpen] = useState(false);
  const ready = biz.bizNo && biz.ceo && biz.address;
  const set = (k, v) => setBizInfo((p) => ({ ...p, [k]: v }));
  const LBL = { margin:"0 0 3px", fontSize:10, color:C.textHint };
  const INP = { width:"100%", boxSizing:"border-box", fontSize:13, border:"none", borderBottom:"1.5px solid #243d54", background:"transparent", outline:"none", padding:"3px 0", fontFamily:"inherit", color:"#f1f5f9" };
  return (
    <div style={{ marginBottom:14, border:`1px solid ${ready ? "#1e3448" : "rgba(251,191,36,0.35)"}`, borderRadius:12, overflow:"hidden" }}>
      <button onClick={()=>setOpen(o=>!o)} style={{ width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 16px", background: open ? "#1a2e42" : "transparent", border:"none", cursor:"pointer", fontFamily:"inherit" }}>
        <span style={{ fontSize:13, fontWeight:700, color:C.text }}>
          사업장 정보 <span style={{ fontWeight:400, fontSize:11, color: ready ? C.textHint : "#fbbf24", marginLeft:6 }}>{ready ? `${biz.ceo} · ${biz.bizNo}` : "근로계약서를 쓰려면 먼저 채워주세요"}</span>
        </span>
        <span style={{ fontSize:11, color:C.textHint }}>{open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div style={{ padding:"14px 16px", background:"#0D1B2A", borderTop:"1px solid #1e3448" }}>
          <div className="dg-g2" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
            <div><p style={LBL}>사업자등록번호</p><input value={biz.bizNo} onChange={(e)=>set("bizNo", e.target.value)} placeholder="000-00-00000" style={INP} /></div>
            <div><p style={LBL}>대표자명</p><input value={biz.ceo} onChange={(e)=>set("ceo", e.target.value)} placeholder="홍길동" style={INP} /></div>
          </div>
          <div className="dg-g2" style={{ display:"grid", gridTemplateColumns:"2fr 1fr", gap:12, marginBottom:14 }}>
            <div><p style={LBL}>사업장 주소</p><input value={biz.address} onChange={(e)=>set("address", e.target.value)} placeholder="경남 김해시 ..." style={INP} /></div>
            <div><p style={LBL}>매장 연락처</p><input value={biz.phone} onChange={(e)=>set("phone", e.target.value)} placeholder="055-000-0000" style={INP} /></div>
          </div>

          <p style={{ margin:"0 0 8px", fontSize:11, fontWeight:700, color:C.textSub }}>계약 기본값 <span style={{ fontWeight:400, color:C.textHint }}>· 직원마다 다르면 계약서에서 고칩니다</span></p>
          <div className="dg-g2" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
            <div><p style={LBL}>근무장소</p><input value={biz.workPlace} onChange={(e)=>set("workPlace", e.target.value)} placeholder="매장 주소 또는 매장명" style={INP} /></div>
            <div><p style={LBL}>업무내용</p><input value={biz.jobDesc} onChange={(e)=>set("jobDesc", e.target.value)} placeholder="주방업무 및 매장업무 전반" style={INP} /></div>
          </div>
          <div className="dg-g2" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:14 }}>
            <div><p style={LBL}>근무시간</p><input value={biz.workTime} onChange={(e)=>set("workTime", e.target.value)} placeholder="09:00~18:00" style={INP} /></div>
            <div><p style={LBL}>휴게시간</p><input value={biz.restTime} onChange={(e)=>set("restTime", e.target.value)} placeholder="12:00~13:00" style={INP} /></div>
          </div>

          <p style={{ margin:"0 0 8px", fontSize:11, fontWeight:700, color:C.textSub }}>수습기간 <span style={{ fontWeight:400, color:C.textHint }}>· 기본값입니다. 직원마다 계약서에서 고칠 수 있습니다</span></p>
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:14, flexWrap:"wrap" }}>
            <select value={biz.probation} onChange={(e)=>set("probation", Number(e.target.value))} style={{ fontSize:13, border:"none", borderBottom:`1.5px solid ${C.labor}`, background:"transparent", color:"#f1f5f9", padding:"3px 4px", fontFamily:"inherit", outline:"none", cursor:"pointer" }}>
              {[0,1,2,3].map((n)=><option key={n} value={n} style={{background:"#112236"}}>{n===0?"없음":`${n}개월`}</option>)}
            </select>
            {biz.probation > 0 && <span style={{ fontSize:12, color:C.textSub }}>· 수습 중 급여 90%</span>}
          </div>

          <p style={{ margin:"0 0 8px", fontSize:11, fontWeight:700, color:C.textSub }}>선택 조항</p>
          {[["clauseDamage","손해배상 조항"],["clauseResign","퇴직 1개월 전 사직 통보"]].map(([k,l]) => (
            <label key={k} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6, cursor:"pointer" }}>
              <input type="checkbox" checked={!!biz[k]} onChange={(e)=>set(k, e.target.checked)} style={{ width:14, height:14, accentColor:C.labor, cursor:"pointer" }} />
              <span style={{ fontSize:12, color:C.textSub }}>{l}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

// ══ 근로계약서 ═════════════════════════════════════════════════
// 사업장 정보 + 근로조건 + 쌍방 서명 → 이미지 저장 · 직원 이메일로 발송
// 전자문서로 만든 근로계약서도 효력이 인정되지만, 직원이 지정한 곳(이메일)으로 보내야 교부가 끝난다
function ContractModal({ emp, biz, setBizInfo, updateEmployee, payDay, storeName, year, month, C, onClose }) {
  // 이미 서명한 계약서가 있으면 보기 화면부터 연다
  const signed = !!(emp.sigOwner && emp.sigEmp && emp.signedAt);
  const [step, setStep] = useState(signed ? "done" : "edit");   // edit | review | sign | done
  const [sigOwner, setSigOwner] = useState(emp.sigOwner || null);
  const [sigEmp, setSigEmp] = useState(emp.sigEmp || null);
  const [sending, setSending] = useState(false);
  const [preview, setPreview] = useState(null);
  const c = contractOf(emp, biz);
  const bizReady = biz.bizNo && biz.ceo && biz.address;
  const condReady = c.startDate && c.workPlace && c.jobDesc && c.workTime && (c.workType === "fixed" ? !!c.workDays : !!c.daysPerWeek);

  const setBiz = (k, v) => setBizInfo((p) => ({ ...p, [k]: v }));
  const setCond = (k, v) => updateEmployee(emp.id, k, v);
  const toggleDay = (d) => {
    const cur = (c.workDays || "").split(",").map((x) => x.trim()).filter(Boolean);
    const next = cur.includes(d) ? cur.filter((x) => x !== d) : [...cur, d];
    setCond("cDays", WD_LIST.filter((x) => next.includes(x)).join(","));
  };

  const LBL = { margin:"0 0 3px", fontSize:10, color:C.textHint };
  const INP = { width:"100%", boxSizing:"border-box", fontSize:13, border:"none", borderBottom:"1.5px solid #243d54", background:"transparent", outline:"none", padding:"3px 0", fontFamily:"inherit", color:"#f1f5f9" };

  // 서명 dataURL을 미리 Image로 만들어 둔다 (canvas.drawImage는 로드 완료 전에는 아무것도 안 그린다)
  const imgRef = useRef({ owner: null, emp: null });
  useEffect(() => {
    ["owner", "emp"].forEach((k) => {
      const src = k === "owner" ? sigOwner : sigEmp;
      if (!src) { imgRef.current[k] = null; return; }
      const im = new Image();
      im.onload = () => { imgRef.current[k] = im; };
      im.src = src;
    });
  }, [sigOwner, sigEmp]);

  // ── 계약서 이미지 ──
  const buildImage = () => {
    const W = 800, PAD = 44;
    const A4H = Math.round(W * 297 / 210);   // A4 세로 비율 (210×297mm) · 출력 대비
    const cv = document.createElement("canvas");
    const S = 2; cv.width = W * S;
    const F = "'Noto Sans KR', sans-serif";
    // 높이는 그리면서 정한다 — 일단 넉넉히
    cv.height = 1500 * S;
    const x = cv.getContext("2d");
    x.scale(S, S);
    x.fillStyle = "#fff"; x.fillRect(0, 0, W, 1500);

    x.fillStyle = "#0f172a"; x.font = `700 24px ${F}`; x.textAlign = "center";
    x.fillText("표준 근로계약서", W / 2, 58);
    x.font = `400 12px ${F}`; x.fillStyle = "#64748b";
    x.fillText(c.endDate ? "(기간의 정함이 있는 경우)" : "(기간의 정함이 없는 경우)", W / 2, 78);
    x.textAlign = "left";

    let y = 104;
    x.strokeStyle = "#cbd5e1"; x.lineWidth = 1;
    x.beginPath(); x.moveTo(PAD, y); x.lineTo(W - PAD, y); x.stroke();
    y += 24;

    x.fillStyle = "#0f172a"; x.font = `400 13px ${F}`;
    const intro = `${biz.ceo || "(사업주)"}(이하 "사업주"라 함)과(와) ${emp.name}(이하 "근로자"라 함)은 다음과 같이 근로계약을 체결한다.`;
    x.fillText(intro, PAD, y); y += 30;

    // 조항
    const prob = Number(c.probation) || 0;
    const probRate = 90;
    const items = [
      ["1. 근로계약기간", (c.endDate ? `${c.startDate} 부터 ${c.endDate} 까지` : `${c.startDate} 부터 (기간의 정함 없음)`)
        + (prob > 0 ? `\n수습기간 ${prob}개월 (수습기간 중 급여의 ${probRate}% 지급)` : "")],
      ["2. 근 무 장 소", c.workPlace],
      ["3. 업무의 내용", `${c.jobDesc}\n업무상 필요에 따라 근무장소 및 담당업무를 변경할 수 있다`],
      ["4. 소정근로시간", `${c.workTime}${c.restTime ? `\n휴게시간 ${c.restTime}` : ""}`],
      ["5. 근무일/휴일", `${workDayText(c)}\n휴무 요일은 근무표에 따라 정한다`],
    ];
    // 임금
    const payLines = [];
    if (emp.payType === "hourly") {
      payLines.push(`시급 ${(emp.hourlyWage || 0).toLocaleString("ko-KR")}원`);
      if (emp.totalHours) payLines.push(`월 소정근로 ${emp.totalHours}시간`);
      const hol = calcHolidayPay(emp);
      if (hol > 0) payLines.push(`주휴수당 별도 지급`);
    } else {
      payLines.push(`월급 ${(emp.monthlySalary || 0).toLocaleString("ko-KR")}원`);
    }
    payLines.push(`임금지급일 매월 ${payDay}일`);
    payLines.push(bankText(emp) ? `지급방법 근로자 명의 예금통장에 입금 (${bankText(emp)})` : `지급방법 근로자 명의 예금통장에 입금`);
    items.push(["6. 임　　　금", payLines.join("\n")]);
    items.push(["7. 연 차 유 급 휴 가", "연차유급휴가는 근로기준법에서 정하는 바에 따라 부여한다"]);
    items.push(["8. 사회보험 적용", emp.deductionType === "insurance" ? "고용보험 · 산재보험 · 국민연금 · 건강보험 적용" : "관계 법령에 따라 적용"]);
    if (biz.clauseDamage) items.push(["9. 손 해 배 상", "근로자의 귀책사유로 사용자에게 손해가 발생한 경우 근로자는 그 손해를 배상하여야 한다"]);
    if (biz.clauseResign) items.push([`${biz.clauseDamage ? 10 : 9}. 사 직 절 차`, "근로자는 퇴직 희망일 최소 1개월 전에 사직 의사를 밝히고 업무 인수인계를 성실히 수행한다"]);
    const n1 = 9 + (biz.clauseDamage ? 1 : 0) + (biz.clauseResign ? 1 : 0);
    items.push([`${n1}. 근로계약서 교부`, "사용자는 근로계약을 체결함과 동시에 본 계약서를 근로자의 교부요구와 관계없이 근로자에게 교부한다"]);
    items.push([`${n1 + 1}. 기　　　타`, "이 계약에 정함이 없는 사항은 근로기준법령에 의한다"]);

    items.forEach(([lb, vl]) => {
      x.fillStyle = "#0f172a"; x.font = `700 13px ${F}`;
      x.fillText(lb, PAD, y);
      x.font = `400 13px ${F}`; x.fillStyle = "#1e293b";
      const lines = String(vl).split("\n");
      lines.forEach((ln, i) => {
        // 긴 줄은 접는다
        const maxW = W - PAD * 2 - 150;
        let cur = "", out = [];
        ln.split(" ").forEach((w) => {
          const t = cur ? `${cur} ${w}` : w;
          if (x.measureText(t).width > maxW && cur) { out.push(cur); cur = w; } else cur = t;
        });
        if (cur) out.push(cur);
        out.forEach((o, j) => { x.fillText(o, PAD + 150, y + (i + j) * 19); });
        if (out.length > 1) y += (out.length - 1) * 19;
      });
      y += lines.length * 19 + 9;
    });

    // 서명란을 아래쪽으로 내려 A4 한 장의 균형을 맞춘다 (조항이 길면 그대로 이어 붙는다)
    const sigBlockH = 150 + 26 + 32 + 10 + 30;
    const wantY = A4H - sigBlockH - 56;
    if (wantY > y + 10) y = wantY;
    else y += 10;
    x.strokeStyle = "#e2e8f0"; x.beginPath(); x.moveTo(PAD, y); x.lineTo(W - PAD, y); x.stroke();
    y += 26;

    // 체결일 — 한 번 서명했으면 그날로 고정한다
    const today = emp.signedAt ? new Date(emp.signedAt) : new Date();
    x.fillStyle = "#0f172a"; x.font = `400 13px ${F}`; x.textAlign = "center";
    x.fillText(`${today.getFullYear()}년 ${today.getMonth() + 1}월 ${today.getDate()}일`, W / 2, y);
    x.textAlign = "left";
    y += 32;

    // 서명란 2단
    const colW = (W - PAD * 2 - 24) / 2;
    const BOXH = 150;
    const sigBox = (bx, title, rows, sig) => {
      x.fillStyle = "#f8fafc"; x.fillRect(bx, y, colW, BOXH);
      x.strokeStyle = "#e2e8f0"; x.strokeRect(bx, y, colW, BOXH);
      x.fillStyle = "#475569"; x.font = `700 12px ${F}`;
      x.fillText(title, bx + 12, y + 20);
      x.font = `400 11px ${F}`; x.fillStyle = "#334155";
      rows.forEach((r, i) => x.fillText(r, bx + 12, y + 40 + i * 16));
      // 서명 이미지 (미리 로드해둔 것)
      if (sig) { try { x.drawImage(sig, bx + colW - 130, y + BOXH - 56, 116, 46); } catch {} }
      x.fillStyle = "#94a3b8"; x.font = `400 10px ${F}`;
      x.fillText("(서명)", bx + colW - 140, y + BOXH - 8);
    };
    sigBox(PAD, "사업주", [
      `사업체명  ${storeName}`,
      `사업자번호  ${biz.bizNo}`,
      `주　　소  ${(biz.address || "").slice(0, 22)}`,
      `연 락 처  ${biz.phone || "-"}`,
      `대 표 자  ${biz.ceo}`,
    ], imgRef.current.owner);
    sigBox(PAD + colW + 24, "근로자", [
      `성　　명  ${emp.name}`,
      `생년월일  ${emp.birth || "-"}`,
      `주　　소  ${(emp.address || "-").slice(0, 22)}`,
      `연 락 처  ${emp.phone || "-"}`,
      `이 메 일  ${emp.email || "-"}`,
    ], imgRef.current.emp);
    y += BOXH + 20;

    // A4 한 장에 맞춘다. 내용이 짧으면 아래 여백, 길면 살짝 줄여서 담는다
    const out = document.createElement("canvas");
    out.width = W * S; out.height = A4H * S;
    const o = out.getContext("2d");
    o.fillStyle = "#fff"; o.fillRect(0, 0, W * S, A4H * S);
    if (y <= A4H) {
      o.drawImage(cv, 0, 0, W * S, y * S, 0, 0, W * S, y * S);
    } else {
      const k = A4H / y;                       // 넘치면 비율 유지하며 축소
      const w2 = Math.round(W * k);
      o.drawImage(cv, 0, 0, W * S, y * S, Math.round((W - w2) / 2) * S, 0, w2 * S, A4H * S);
    }
    return out;
  };

  // 서명을 직원 데이터에 저장한다 (계약서는 퇴직 후 3년 보관 의무가 있다)
  const confirmSign = () => {
    if (!sigOwner || !sigEmp) return;
    const shrink = (dataUrl) => new Promise((res) => {
      const im = new Image();
      im.onload = () => {
        const cv = document.createElement("canvas");
        cv.width = 240; cv.height = 96;
        const x = cv.getContext("2d");
        x.fillStyle = "#fff"; x.fillRect(0, 0, 240, 96);
        x.drawImage(im, 0, 0, 240, 96);
        res(cv.toDataURL("image/png"));
      };
      im.onerror = () => res(dataUrl);
      im.src = dataUrl;
    });
    Promise.all([shrink(sigOwner), shrink(sigEmp)]).then(([o, e]) => {
      updateEmployee(emp.id, "sigOwner", o);
      updateEmployee(emp.id, "sigEmp", e);
      updateEmployee(emp.id, "signedAt", new Date().toISOString().slice(0, 10));
      setSigOwner(o); setSigEmp(e);
      setStep("done");
    });
  };

  // 보기 화면용 미리보기 이미지
  useEffect(() => {
    if (step !== "done" && step !== "review") return;
    setPreview(null);
    const t = setTimeout(() => { try { setPreview(buildImage().toDataURL("image/png")); } catch {} }, 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [step, sigOwner, sigEmp]);

  const download = () => {
    const cv = buildImage();
    const a = document.createElement("a");
    a.href = cv.toDataURL("image/png");
    a.download = `근로계약서_${(emp.name || "직원").replace(/[^\w가-힣]/g, "")}_${year}${String(month + 1).padStart(2, "0")}.png`;
    a.click();
  };

  const mailTexts = () => {
    const subject = `[${storeName}] 근로계약서`;
    const body =
      `${emp.name}님\n\n근로계약서를 보내드립니다. 확인 부탁드립니다.\n\n` +
      `· 계약기간: ${c.startDate}${c.endDate ? ` ~ ${c.endDate}` : " 부터 (기간의 정함 없음)"}\n` +
      `· 근무장소: ${c.workPlace}\n· 업무내용: ${c.jobDesc}\n` +
      `· 근무일/시간: ${workDayText(c)} ${c.workTime}\n\n${storeName}`;
    return { subject, body };
  };

  // 공유 시트 — 계약서 이미지가 붙은 채로 카톡·메일·문자 중에 골라 보낸다
  const shareContract = async () => {
    setSending(true);
    const { subject, body } = mailTexts();
    try {
      const cv = buildImage();
      const blob = await new Promise((res) => cv.toBlob(res, "image/png"));
      const file = new File([blob], `근로계약서_${(emp.name||"직원").replace(/[^\w가-힣]/g,"")}.png`, { type: "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: subject, text: body });
        setSending(false);
        return;
      }
    } catch (e) {
      // 사용자가 공유를 취소한 경우엔 메일 앱까지 열지 않는다
      if (e && e.name === "AbortError") { setSending(false); return; }
    }
    // 공유가 안 되는 기기: 이미지를 저장하고 메일 앱을 연다
    download();
    const href = `mailto:${emp.email || ""}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setTimeout(() => {
      const a = document.createElement("a");
      a.href = href; a.rel = "noopener";
      document.body.appendChild(a); a.click(); a.remove();
      setSending(false);
    }, 700);
  };
  const sendMail = shareContract;

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000, padding:16 }}>
      <div style={{ background:"#112236", borderRadius:16, padding:"22px", maxWidth:520, width:"100%", maxHeight:"88vh", overflowY:"auto" }}>
        <p style={{ margin:"0 0 4px", fontSize:16, fontWeight:700 }}>근로계약서 · {emp.name}</p>
        {step !== "done" && (
          <p style={{ margin:"0 0 16px", fontSize:11, color:C.textSub, lineHeight:1.6 }}>
            전자문서로 만든 근로계약서도 효력이 인정됩니다. 다만 <strong style={{ color:C.textSub }}>직원에게 교부해야 합니다</strong>.
          </p>
        )}
        {step === "done" && <div style={{ height:12 }} />}

        {step === "edit" ? (
          <>
            {/* 사업장 정보 — 아직 안 채웠을 때만 여기서 받는다 (평소엔 인건비 탭 상단에서 관리) */}
            {!bizReady && (
            <div style={{ marginBottom:14, padding:"12px 14px", background:"#0D1B2A", borderRadius:10, border:"1px solid rgba(251,191,36,0.4)" }}>
              <p style={{ margin:"0 0 8px", fontSize:11, fontWeight:700, color:"#fbbf24" }}>사업장 정보 <span style={{ fontWeight:400, color:C.textHint }}>· 한 번 넣으면 전 직원이 함께 씁니다</span></p>
              <div className="dg-g2" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                <div><p style={LBL}>사업자등록번호</p><input value={biz.bizNo} onChange={(e)=>setBiz("bizNo", e.target.value)} placeholder="000-00-00000" style={INP} /></div>
                <div><p style={LBL}>대표자명</p><input value={biz.ceo} onChange={(e)=>setBiz("ceo", e.target.value)} placeholder="홍길동" style={INP} /></div>
              </div>
              <div style={{ marginTop:10 }}><p style={LBL}>사업장 주소</p><input value={biz.address} onChange={(e)=>setBiz("address", e.target.value)} placeholder="경남 김해시 ..." style={INP} /></div>
            </div>
            )}

            {(!emp.birth || !emp.address) && (
              <p style={{ margin:"0 0 12px", padding:"10px 12px", background:"rgba(251,191,36,0.10)", border:"1px solid rgba(251,191,36,0.35)", borderRadius:9, fontSize:11, color:"#fbbf24", lineHeight:1.7 }}>
                {!emp.birth && !emp.address ? "생년월일과 주소가 비어 있습니다." : !emp.birth ? "생년월일이 비어 있습니다." : "주소가 비어 있습니다."}
                {" "}직원 줄을 눌러 채워주시면 계약서에 들어갑니다.
              </p>
            )}

            {/* 근로조건 */}
            <div style={{ marginBottom:14, padding:"12px 14px", background:"#0D1B2A", borderRadius:10, border:"1px solid #1e3448" }}>
              <p style={{ margin:"0 0 8px", fontSize:11, fontWeight:700, color:C.textSub }}>근로조건</p>
              <div className="dg-g2" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
                <div><p style={LBL}>계약 시작일</p><input type="date" value={c.startDate} onChange={(e)=>setCond("cStart", e.target.value)} style={INP} /></div>
                <div><p style={LBL}>계약 종료일 <span style={{color:"#334155"}}>(없으면 비움)</span></p><input type="date" value={c.endDate} onChange={(e)=>setCond("cEnd", e.target.value)} style={INP} /></div>
              </div>
              <div style={{ marginBottom:10 }}><p style={LBL}>근무장소</p><input value={c.workPlace} onChange={(e)=>setCond("cPlace", e.target.value)} placeholder={biz.workPlace || "매장 주소 또는 매장명"} style={INP} /></div>
              <div style={{ marginBottom:10 }}><p style={LBL}>업무내용</p><input value={c.jobDesc} onChange={(e)=>setCond("cJob", e.target.value)} placeholder={biz.jobDesc || "조리 및 홀 서빙"} style={INP} /></div>
              <p style={LBL}>근무형태</p>
              <div style={{ display:"flex", gap:6, marginBottom:10 }}>
                {[["shift","교대 · 근무표"],["fixed","요일 고정"]].map(([v,l]) => {
                  const on = c.workType === v;
                  return <button key={v} onClick={()=>setCond("cType", v)} style={{ fontSize:11, padding:"6px 12px", borderRadius:7, border:`1px solid ${on ? C.labor : C.border}`, background:on?`${C.labor}25`:"transparent", color:on?"#c4b5fd":C.textHint, cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>{l}</button>;
                })}
              </div>
              {c.workType === "fixed" ? (
                <div style={{ display:"flex", gap:5, flexWrap:"wrap", marginBottom:10 }}>
                  {WD_LIST.map((d) => {
                    const on = (c.workDays||"").split(",").map((x)=>x.trim()).includes(d);
                    return <button key={d} onClick={()=>toggleDay(d)} style={{ fontSize:11, width:30, padding:"5px 0", borderRadius:6, border:`1px solid ${on ? C.labor : C.border}`, background:on?`${C.labor}25`:"transparent", color:on?"#c4b5fd":C.textHint, cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>{d}</button>;
                  })}
                </div>
              ) : (
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10 }}>
                  <span style={{ fontSize:12, color:C.textSub }}>주</span>
                  <select value={c.daysPerWeek} onChange={(e)=>setCond("cDpw", e.target.value)} style={{ fontSize:13, border:"none", borderBottom:`1.5px solid ${C.labor}`, background:"transparent", color:"#f1f5f9", padding:"3px 4px", fontFamily:"inherit", outline:"none", cursor:"pointer" }}>
                    {[1,2,3,4,5,6].map((n)=><option key={n} value={n} style={{background:"#112236"}}>{n}</option>)}
                  </select>
                  <span style={{ fontSize:12, color:C.textSub }}>일 근무 · 휴무는 근무표에 따름</span>
                </div>
              )}
              <p style={{ margin:"0 0 10px", fontSize:11, color:"#2dd4bf", lineHeight:1.6 }}>{workDayText(c)}</p>
              <div className="dg-g2" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
                <div><p style={LBL}>근무시간</p><input value={c.workTime} onChange={(e)=>setCond("cTime", e.target.value)} placeholder="09:00~18:00" style={INP} /></div>
                <div><p style={LBL}>휴게시간</p><input value={c.restTime} onChange={(e)=>setCond("cRest", e.target.value)} placeholder="12:00~13:00" style={INP} /></div>
              </div>
              <p style={LBL}>수습기간 <span style={{ color:"#334155" }}>· 직원마다 다르게 정할 수 있습니다</span></p>
              <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                <select value={c.probation} onChange={(e)=>setCond("cProb", e.target.value)}
                  style={{ fontSize:13, border:"none", borderBottom:`1.5px solid ${C.labor}`, background:"transparent", color:"#f1f5f9", padding:"3px 4px", fontFamily:"inherit", outline:"none", cursor:"pointer" }}>
                  {[0,1,2,3].map((n)=><option key={n} value={n} style={{background:"#112236"}}>{n===0?"없음":`${n}개월`}</option>)}
                </select>
                {c.probation > 0 && <span style={{ fontSize:12, color:C.textSub }}>· 수습 중 급여 90%</span>}
              </div>

              <button onClick={()=>setBizInfo((p)=>({ ...p, workPlace:c.workPlace, jobDesc:c.jobDesc, workType:c.workType, daysPerWeek:c.daysPerWeek, workDays:c.workDays, workTime:c.workTime, restTime:c.restTime }))}
                style={{ ...ADD_BTN, fontSize:10, marginTop:10 }}>이 조건을 매장 기본값으로</button>
            </div>

            <p style={{ margin:"0 0 12px", fontSize:11, color:C.textHint, lineHeight:1.7 }}>
              임금, 주휴수당, 지급일, 계좌는 인건비 탭에 넣은 값이 그대로 들어갑니다.
              다음 화면에서 계약서를 먼저 확인하고, 그다음 서명합니다.
            </p>

            <button onClick={()=>setStep("review")} disabled={!bizReady || !condReady}
              style={{ width:"100%", padding:"12px", background:(bizReady&&condReady)?C.labor:"#243d54", color:"#fff", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:(bizReady&&condReady)?"pointer":"not-allowed", fontFamily:"inherit" }}>
              {bizReady ? (condReady ? "계약서 확인 →" : "근로조건을 채워주세요") : "사업장 정보를 채워주세요"}
            </button>
          </>
        ) : step === "review" ? (
          <>
            <p style={{ margin:"0 0 12px", fontSize:12, color:C.textSub, lineHeight:1.7 }}>
              내용을 확인하십시오. <strong style={{ color:C.text }}>직원분도 함께 읽어보셔야 합니다.</strong>
              고칠 곳이 있으면 수정으로 돌아가시고, 맞으면 서명으로 넘어갑니다.
            </p>
            {preview ? (
              <img src={preview} alt="근로계약서 미리보기" style={{ width:"100%", borderRadius:10, border:"1px solid #243d54", display:"block", marginBottom:12 }} />
            ) : (
              <div style={{ padding:"48px 0", textAlign:"center", color:C.textHint, fontSize:12 }}>계약서를 그리는 중...</div>
            )}
            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
              <button onClick={()=>setStep("edit")} style={{ ...ADD_BTN, flex:"0 0 auto" }}>← 수정</button>
              <button onClick={()=>setStep("sign")} disabled={!preview}
                style={{ flex:"1 1 180px", padding:"12px", background:preview?C.labor:"#243d54", color:"#fff", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:preview?"pointer":"not-allowed", fontFamily:"inherit" }}>
                내용 확인했습니다 · 서명하기 →
              </button>
            </div>
          </>
        ) : step === "sign" ? (
          <>
            <p style={{ margin:"0 0 10px", fontSize:12, color:C.textSub, lineHeight:1.7 }}>
              두 분이 차례로 서명합니다. 직원분께 폰을 건네주시면 됩니다.
            </p>
            <SignPad label="사업주 서명" value={sigOwner} onChange={setSigOwner} C={C} />
            <SignPad label="근로자 서명" value={sigEmp} onChange={setSigEmp} C={C} />



            <div style={{ display:"flex", gap:8, marginTop:14, flexWrap:"wrap" }}>
              <button onClick={()=>setStep("edit")} style={{ ...ADD_BTN, flex:"0 0 auto" }}>← 수정</button>
              <button onClick={confirmSign} disabled={!sigOwner||!sigEmp}
                style={{ flex:"1 1 180px", padding:"12px", background:(sigOwner&&sigEmp)?C.labor:"#243d54", color:"#fff", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:(sigOwner&&sigEmp)?"pointer":"not-allowed", fontFamily:"inherit" }}>
                서명 완료 · 계약서 만들기
              </button>
            </div>
          </>
        ) : null}

        {step === "done" && (
          <>
            <div style={{ marginBottom:12, padding:"10px 14px", background:`${C.profit}12`, border:`1px solid ${C.profit}40`, borderRadius:10 }}>
              <p style={{ margin:0, fontSize:12, fontWeight:700, color:C.profit }}>{emp.signedAt} 체결</p>
              <p style={{ margin:"2px 0 0", fontSize:11, color:C.textSub, lineHeight:1.6 }}>
                서명이 끝났습니다. 직원에게 보내면 교부까지 완료됩니다.
              </p>
            </div>

            {preview ? (
              <img src={preview} alt="근로계약서" style={{ width:"100%", borderRadius:10, border:"1px solid #243d54", display:"block", marginBottom:12 }} />
            ) : (
              <div style={{ padding:"40px 0", textAlign:"center", color:C.textHint, fontSize:12 }}>계약서를 그리는 중...</div>
            )}

            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
              <button onClick={download} style={{ flex:"1 1 130px", padding:"12px", background:"#1a2e42", color:"#f1f5f9", border:"1px solid #243d54", borderRadius:10, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>이미지 저장</button>
              <button onClick={sendMail} disabled={sending} style={{ flex:"1 1 150px", padding:"12px", background:C.labor, color:"#fff", border:"none", borderRadius:10, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                {sending ? "준비 중..." : "직원에게 보내기"}
              </button>
            </div>
            <p style={{ margin:"10px 0 0", fontSize:10, color:C.textHint, lineHeight:1.7 }}>
              계약서가 붙은 채로 공유창이 열립니다. 메일이나 카톡을 골라 보내시면 됩니다.
            </p>
            <button onClick={()=>{ if(!window.confirm("서명을 지우고 다시 작성합니다. 계속할까요?")) return;
                updateEmployee(emp.id,"sigOwner",""); updateEmployee(emp.id,"sigEmp",""); updateEmployee(emp.id,"signedAt","");
                setSigOwner(null); setSigEmp(null); setPreview(null); setStep("edit"); }}
              style={{ ...ADD_BTN, width:"100%", marginTop:10, fontSize:11 }}>새로 작성 (서명 다시)</button>
          </>
        )}

        <button onClick={onClose} style={{ width:"100%", marginTop:12, padding:"11px", background:"#1a2e42", border:"1px solid #243d54", borderRadius:10, color:C.textSub, fontSize:13, cursor:"pointer", fontFamily:"inherit" }}>닫기</button>
      </div>
    </div>
  );
}

// 손가락·마우스로 서명하는 칸
function SignPad({ label, value, onChange, C }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  useEffect(() => {
    const cv = ref.current; if (!cv) return;
    const S = 2;
    cv.width = cv.offsetWidth * S; cv.height = cv.offsetHeight * S;
    const x = cv.getContext("2d");
    x.scale(S, S);
    x.lineWidth = 2.2; x.lineCap = "round"; x.lineJoin = "round"; x.strokeStyle = "#0f172a";
    x.fillStyle = "#fff"; x.fillRect(0, 0, cv.offsetWidth, cv.offsetHeight);
  }, []);
  const pos = (e) => {
    const cv = ref.current, r = cv.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - r.left, y: t.clientY - r.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; last.current = pos(e); };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const x = ref.current.getContext("2d"); const p = pos(e);
    x.beginPath(); x.moveTo(last.current.x, last.current.y); x.lineTo(p.x, p.y); x.stroke();
    last.current = p;
  };
  const end = () => { if (!drawing.current) return; drawing.current = false; onChange(ref.current.toDataURL("image/png")); };
  const clear = () => {
    const cv = ref.current, x = cv.getContext("2d");
    x.fillStyle = "#fff"; x.fillRect(0, 0, cv.offsetWidth, cv.offsetHeight);
    onChange(null);
  };
  return (
    <div style={{ marginBottom:12 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:5 }}>
        <span style={{ fontSize:11, fontWeight:700, color: value ? "#2dd4bf" : C.textSub }}>{label}{value ? " ✓" : ""}</span>
        <button onClick={clear} style={{ ...ADD_BTN, fontSize:10, padding:"3px 9px" }}>지우기</button>
      </div>
      <canvas ref={ref}
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        style={{ width:"100%", height:110, background:"#fff", borderRadius:9, border:`1px solid ${value ? "#2dd4bf" : "#243d54"}`, touchAction:"none", display:"block" }} />
    </div>
  );
}

// 되돌리기 — 저장 직전 보관본(data/main/history) 중 이 탭 데이터가 있는 시점을 골라 탭 필드만 복원
function RestorePanel({ tabName, disabled, loadHistory, onRestore, C }) {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState(null);
  const [err, setErr] = useState("");
  const fields = TAB_OWN_FIELDS[tabName] || [];
  const pad = (n) => String(n).padStart(2, "0");
  const fmt = (ms) => { const d = new Date(ms); return `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`; };
  const count = (v) => (Array.isArray(v) ? v.length : v && typeof v === "object" ? Object.keys(v).length : 0);
  const desc = (h) => tabName === "재고"
    ? `품목 ${count(h.inventoryItems)}개 · 재고조사 ${count(h.monthlyInventory)}개월`
    : `매출 ${count(h.salesData)}개월 · 일일 보고 ${count(h.dailyReports)}개월`;
  const toggle = async () => {
    if (open) { setOpen(false); return; }
    setOpen(true); setList(null); setErr("");
    try {
      const all = await loadHistory();
      setList(all.filter((h) => fields.some((k) => h[k] !== undefined)));
    } catch (e) {
      setErr(e && e.code === "permission-denied" ? "보관본을 볼 권한이 없습니다" : "보관본을 불러오지 못했습니다");
    }
  };
  const pick = (h) => {
    if (disabled) return;
    if (!window.confirm(`${fmt(h.savedAt)} 저장본으로 ${tabName} 탭 데이터(모든 달)를 되돌립니다.\n지금 데이터는 보관본으로 남습니다. 계속할까요?`)) return;
    if (onRestore(h)) setOpen(false);
  };
  const btn = { padding: "6px 10px", background: "transparent", color: C.textSub, border: "1px solid #243d54", borderRadius: 8, fontSize: 11, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" };
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button onClick={toggle} disabled={disabled && !open} style={{ ...btn, opacity: disabled && !open ? 0.5 : 1 }}>{open ? "되돌리기 닫기" : "되돌리기"}</button>
      </div>
      {open && (
        <div style={{ marginTop: 8, padding: "12px 14px", background: "#112236", border: "1px solid #243d54", borderRadius: 10 }}>
          <p style={{ margin: "0 0 8px", fontSize: 11, color: C.textHint }}>저장 직전 버전이 자동으로 보관됩니다(최근 {HISTORY_KEEP}개). 시점을 고르면 {tabName} 탭 데이터만 그때 값으로 바뀌고 자동저장됩니다.</p>
          {err && <p style={{ margin: 0, fontSize: 12, color: C.loss }}>{err}</p>}
          {!err && list === null && <p style={{ margin: 0, fontSize: 12, color: C.textHint }}>불러오는 중...</p>}
          {!err && list && list.length === 0 && <p style={{ margin: 0, fontSize: 12, color: C.textHint }}>되돌릴 보관본이 아직 없습니다</p>}
          {!err && list && list.map((h) => (
            <div key={h.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, padding: "7px 0", borderTop: "1px solid #1e3448", flexWrap: "wrap" }}>
              <div style={{ minWidth: 0 }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: "#f1f5f9" }}>{fmt(h.savedAt)}</span>
                <span style={{ fontSize: 11, color: C.textHint, marginLeft: 8 }}>{h.savedBy || "-"}</span>
                <div style={{ fontSize: 11, color: C.textSub, marginTop: 2 }}>{desc(h)}</div>
              </div>
              <button onClick={() => pick(h)} disabled={disabled} style={{ ...btn, color: "#fbbf24", borderColor: "rgba(251,191,36,0.5)", opacity: disabled ? 0.5 : 1 }}>이 시점으로</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// 사장님 인건비 - 접이식 소형 섹션
function OwnerWageSection({ mk, MONTHS, month, year, ownerWage, setOwnerWage, explicit, totalRev, C, labor, pct }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ marginBottom:20 }}>
      <button onClick={() => setOpen(p=>!p)} style={{ width:"100%", display:"flex", alignItems:"center", justifyContent:"space-between", padding:"10px 14px", background:open?`${labor}10`:C.bgSub, border:`1px solid ${open?labor:C.border}`, borderRadius:10, cursor:"pointer", fontFamily:"inherit" }}>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          <span style={{ fontSize:13, fontWeight:600, color:C.textSub }}>사장님 인건비 <span style={{ fontSize:11, color:C.textHint, fontWeight:400 }}>(기회비용)</span></span>
          <span style={{ fontSize:11, color:C.textHint, background:"#112236", padding:"1px 7px", borderRadius:10, border:"1px solid #1e3448" }}>{year}년 {MONTHS[month]}</span>
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          {ownerWage>0 && <span style={{ fontSize:13, fontWeight:700, color:labor }}>{ownerWage.toLocaleString("ko-KR")}원</span>}
          <span style={{ fontSize:12, color:C.textHint }}>{open?"▲":"▼"}</span>
        </div>
      </button>
      {open && (
        <div style={{ marginTop:4, padding:"14px 16px", background:`${labor}08`, border:`1px solid ${labor}25`, borderRadius:10 }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <MoneyInput value={ownerWage} onChange={setOwnerWage} placeholder="예: 3,000,000" style={{ flex:1, fontSize:18, fontWeight:700, border:"none", borderBottom:`1.5px solid ${labor}`, background:"transparent", outline:"none", padding:"3px 0", fontFamily:"inherit", color:"#f1f5f9" }} />
            <span style={{ fontSize:13, color:C.textSub }}>원 / 월</span>
          </div>
          {ownerWage>0 && <p style={{ margin:"6px 0 0", fontSize:11, color:labor }}>→ 매출 대비 {pct(ownerWage,totalRev)}</p>}
          <p style={{ margin:"6px 0 0", fontSize:10, color:C.textHint }}>
            {explicit
              ? `${MONTHS[month]} 값으로 저장됩니다 · 다음 달부터는 이 값을 자동으로 이어받습니다`
              : ownerWage>0
                ? `이전 달 값을 이어받은 금액입니다 · 바꾸려면 여기서 수정하세요 (${MONTHS[month]}부터 적용)`
                : "한 번 넣어두면 매달 자동으로 이어집니다"}
          </p>
          <p style={{ margin:"8px 0 0", fontSize:11, color:C.textHint }}>순이익이 이 금액보다 작으면 취업보다 못한 장사입니다.</p>
        </div>
      )}
    </div>
  );
}

// 손익계산서 위치 배지
function PLBadge({ num, label, sub, color }) {
  return (
    <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:14, flexWrap:"wrap" }}>
      <span style={{ fontSize:11, fontWeight:700, color:"#0D1B2A", background:color, borderRadius:6, padding:"3px 9px", whiteSpace:"nowrap" }}>{num}</span>
      <span style={{ fontSize:13, fontWeight:700, color:"#f1f5f9" }}>{label}</span>
      {sub && <span style={{ fontSize:11, color:"#64748b" }}>{sub}</span>}
    </div>
  );
}

function CostSection({ title, color, desc, children }) {
  // 제목이 손익계산서 번호(①~⑨)로 시작하면 배지 형태로 표시
  const isNum = /^[①②③④⑤⑥⑦⑧⑨]/.test(title || "");
  return (
    <div style={{ marginBottom:28 }}>
      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:14, flexWrap:"wrap" }}>
        {isNum ? (
          <span style={{ fontSize:11, fontWeight:700, color:"#0D1B2A", background:color, borderRadius:6, padding:"3px 9px", whiteSpace:"nowrap" }}>{title}</span>
        ) : (
          <>
            <span style={{ width:4, height:22, background:color, borderRadius:2, display:"inline-block", flexShrink:0 }} />
            <span style={{ fontSize:13, fontWeight:700, color:"#f1f5f9" }}>{title}</span>
          </>
        )}
        {desc && <span style={{ fontSize:11, color:"#64748b", lineHeight:1.6 }}>{desc}</span>}
      </div>
      {children}
    </div>
  );
}

// 손익계산서 우측 정렬 컬럼 폭 — 금액이 세로로 딱 맞게 떨어지도록 고정한다
const PL_AMT_W = 116, PL_DIFF_W = 92, PL_RATIO_W = 46;

function PLGroup({ num, label, total, color, neg, prev }) {
  const d = (prev === undefined || prev === null || prev === 0) ? null : Math.round(total) - Math.round(prev);
  // 매출은 늘면 좋고(neg=false), 비용은 줄면 좋다(neg=true)
  const good = d === null ? null : (neg ? d < 0 : d > 0);
  return (
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:10, padding:"11px 20px", background:`${color}0d`, borderTop:"0.5px solid #1e3448" }}>
      <span style={{ display:"flex", alignItems:"center", gap:8, minWidth:0 }}>
        <span style={{ fontSize:11, fontWeight:700, color:"#0D1B2A", background:color, borderRadius:6, padding:"3px 9px", whiteSpace:"nowrap" }}>{num} {label}</span>
      </span>
      <span style={{ display:"flex", alignItems:"baseline", flexShrink:0 }}>
        <span className="dg-num" style={{ minWidth:PL_AMT_W, textAlign:"right", fontWeight:700, fontSize:13, color }}>{neg?"−":""}{Math.round(total).toLocaleString("ko-KR")}원</span>
        <span className="dg-num" style={{ minWidth:PL_DIFF_W, textAlign:"right", fontSize:11, fontWeight:700, color:d?(good?"#34d399":"#f87171"):"transparent" }}>
          {d ? `${d>0?"▲":"▼"}${Math.abs(d).toLocaleString("ko-KR")}` : "–"}
        </span>
      </span>
    </div>
  );
}

function PLSub({ label, amount, ratio, dot, prev, neg }) {
  if (!amount) return null;
  const d = (prev === undefined || prev === null || prev === 0) ? null : Math.round(amount) - Math.round(prev);
  const good = d === null ? null : (neg ? d < 0 : d > 0);
  return (
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:8, padding:"7px 20px 7px 42px", borderTop:"0.5px solid #1e3448" }}>
      <span style={{ fontSize:12, color:"#94a3b8", display:"flex", alignItems:"center", gap:6, minWidth:0 }}>
        <span style={{ width:5, height:5, borderRadius:"50%", background:dot, display:"inline-block", opacity:0.7, flexShrink:0 }} />
        {label}
      </span>
      <span style={{ display:"flex", alignItems:"baseline", flexShrink:0 }}>
        <span className="dg-num" style={{ minWidth:PL_AMT_W, textAlign:"right", fontSize:12, color:"#94a3b8" }}>{Math.round(amount).toLocaleString("ko-KR")}원</span>
        <span className="dg-num" style={{ minWidth:PL_DIFF_W, textAlign:"right", fontSize:10, fontWeight:700, color:d?(good?"#34d399":"#f87171"):"#334155" }}>
          {d ? `${d>0?"▲":"▼"}${Math.abs(d).toLocaleString("ko-KR")}` : "–"}
        </span>
        <span style={{ minWidth:PL_RATIO_W, textAlign:"right", fontSize:11, color:"#64748b" }}>{ratio}</span>
      </span>
    </div>
  );
}

const NAV_BTN = { background:"#1a2e42", border:"1px solid #1e3448", borderRadius:8, padding:"6px 14px", cursor:"pointer", fontSize:16, color:"#f1f5f9", fontFamily:"inherit", fontWeight:600 };
const TH_S = { padding:"8px 8px 8px 12px", textAlign:"left", fontSize:11, color:"#94a3b8", fontWeight:600, letterSpacing:"0.5px" };
const TD_S = { padding:"10px 8px 10px 12px", fontSize:13, color:C.textSub };
const INP_S = { fontSize:13, border:"none", borderBottom:"1.5px solid #243d54", background:"transparent", padding:"2px 0", outline:"none", fontFamily:"inherit", color:"#f1f5f9" };
const DEL_BTN = { background:"transparent", border:"none", cursor:"pointer", fontSize:12, color:"#64748b", padding:"3px 6px", borderRadius:4 };
const DONE_BTN = { background:"rgba(13,148,136,0.1)", border:"1px solid rgba(52,211,153,0.3)", cursor:"pointer", fontSize:12, color:"#34d399", padding:"3px 8px", borderRadius:6, fontFamily:"inherit", fontWeight:600 };
const ADD_BTN = { background:"#1a2e42", border:"1px solid #243d54", cursor:"pointer", fontSize:12, color:"#f1f5f9", padding:"5px 12px", borderRadius:7, fontFamily:"inherit", fontWeight:500, whiteSpace:"nowrap" };
const INP_MONEY = (color) => ({ width:"100%", fontSize:14, fontWeight:600, border:"none", borderBottom:`1.5px solid ${color||"#243d54"}`, background:"transparent", outline:"none", padding:"2px 0", fontFamily:"inherit", color:"#f1f5f9", boxSizing:"border-box" });
